import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

export type BasisType = {
  __typename?: 'BasisType';
  basisTypeKey: Scalars['Int']['output'];
  basisTypePrices?: Maybe<Array<Maybe<BasisTypePrice>>>;
  currentPrice?: Maybe<BasisTypePrice>;
  description?: Maybe<Scalars['String']['output']>;
  indexContracts?: Maybe<Array<Maybe<IndexContract>>>;
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  swapDeals?: Maybe<Array<Maybe<SwapDeal>>>;
};


export type BasisTypeBasisTypePricesArgs = {
  order?: InputMaybe<Array<BasisTypePriceSortInput>>;
  where?: InputMaybe<BasisTypePriceFilterInput>;
};

export type BasisTypeFilterInput = {
  and?: InputMaybe<Array<BasisTypeFilterInput>>;
  basisTypeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  basisTypePrices?: InputMaybe<ListFilterInputTypeOfBasisTypePriceFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  indexContracts?: InputMaybe<ListFilterInputTypeOfIndexContractFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BasisTypeFilterInput>>;
  swapDeals?: InputMaybe<ListFilterInputTypeOfSwapDealFilterInput>;
};

export type BasisTypeInput = {
  basisTypePrices?: InputMaybe<Array<InputMaybe<BasisTypePriceInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  indexContracts?: InputMaybe<Array<InputMaybe<IndexContractInput>>>;
  isArchived: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  swapDeals?: InputMaybe<Array<InputMaybe<SwapDealInput>>>;
};

export type BasisTypePrice = {
  __typename?: 'BasisTypePrice';
  basisType?: Maybe<BasisType>;
  basisTypeKey: Scalars['Int']['output'];
  basisTypePriceKey: Scalars['Int']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  price: Scalars['Float']['output'];
};

export type BasisTypePriceFilterInput = {
  and?: InputMaybe<Array<BasisTypePriceFilterInput>>;
  basisType?: InputMaybe<BasisTypeFilterInput>;
  basisTypeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  basisTypePriceKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  effectiveDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<BasisTypePriceFilterInput>>;
  price?: InputMaybe<ComparableDoubleOperationFilterInput>;
};

export type BasisTypePriceInput = {
  basisType?: InputMaybe<BasisTypeInput>;
  basisTypeKey: Scalars['Int']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  price: Scalars['Float']['input'];
};

export type BasisTypePriceSortInput = {
  basisType?: InputMaybe<BasisTypeSortInput>;
  basisTypeKey?: InputMaybe<SortEnumType>;
  basisTypePriceKey?: InputMaybe<SortEnumType>;
  effectiveDate?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
};

export type BasisTypeSortInput = {
  basisTypeKey?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkPostingConflictInfo = {
  __typename?: 'BulkPostingConflictInfo';
  cost: Scalars['Decimal']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  effectiveEndDate: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  postingKey: Scalars['Int']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type BulkPostingValidationResult = {
  __typename?: 'BulkPostingValidationResult';
  conflicts?: Maybe<Array<Maybe<BulkPostingConflictInfo>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
};

export enum BusinessType {
  Agriculture = 'AGRICULTURE',
  EndUser = 'END_USER',
  Industry = 'INDUSTRY',
  Retailer = 'RETAILER',
  Wholesaler = 'WHOLESALER'
}

export type BusinessTypeOperationFilterInput = {
  eq?: InputMaybe<BusinessType>;
  in?: InputMaybe<Array<BusinessType>>;
  neq?: InputMaybe<BusinessType>;
  nin?: InputMaybe<Array<BusinessType>>;
};

export type Carrier = {
  __typename?: 'Carrier';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  carrierKey: Scalars['Int']['output'];
  carrierPointToPointRateDateSpans?: Maybe<Array<Maybe<CarrierPointToPointRateDateSpan>>>;
  carrierRates?: Maybe<Array<Maybe<CarrierRate>>>;
  carrierType: CarrierType;
  city?: Maybe<Scalars['String']['output']>;
  contacts: Array<Contact>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fuelSurcharges?: Maybe<Array<Maybe<FuelSurcharge>>>;
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orderTripNumberFillers?: Maybe<Array<Maybe<OrderTripNumberFiller>>>;
  orders?: Maybe<Array<Maybe<Order>>>;
  phone?: Maybe<Scalars['String']['output']>;
  primaryLocations?: Maybe<Array<Maybe<Location>>>;
  secondaryLocations?: Maybe<Array<Maybe<Location>>>;
  state?: Maybe<Scalars['String']['output']>;
  userCarriers?: Maybe<Array<Maybe<UserCarrier>>>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CarrierFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CarrierFilterInput>>;
  carrierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  carrierPointToPointRateDateSpans?: InputMaybe<ListFilterInputTypeOfCarrierPointToPointRateDateSpanFilterInput>;
  carrierRates?: InputMaybe<ListFilterInputTypeOfCarrierRateFilterInput>;
  carrierType?: InputMaybe<CarrierTypeOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  contacts?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  fuelSurcharges?: InputMaybe<ListFilterInputTypeOfFuelSurchargeFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CarrierFilterInput>>;
  orderTripNumberFillers?: InputMaybe<ListFilterInputTypeOfOrderTripNumberFillerFilterInput>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  primaryLocations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  secondaryLocations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  userCarriers?: InputMaybe<ListFilterInputTypeOfUserCarrierFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type CarrierInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  carrierPointToPointRateDateSpans?: InputMaybe<Array<InputMaybe<CarrierPointToPointRateDateSpanInput>>>;
  carrierRates?: InputMaybe<Array<InputMaybe<CarrierRateInput>>>;
  carrierType: CarrierType;
  city?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<ContactInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fuelSurcharges?: InputMaybe<Array<InputMaybe<FuelSurchargeInput>>>;
  isArchived: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderTripNumberFillers?: InputMaybe<Array<InputMaybe<OrderTripNumberFillerInput>>>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primaryLocations?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  secondaryLocations?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  userCarriers?: InputMaybe<Array<InputMaybe<UserCarrierInput>>>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierPointToPointRate = {
  __typename?: 'CarrierPointToPointRate';
  carrierPointToPointRateDateSpan?: Maybe<CarrierPointToPointRateDateSpan>;
  carrierPointToPointRateDateSpanKey: Scalars['Int']['output'];
  carrierPointToPointRateKey: Scalars['Int']['output'];
  destinationCity?: Maybe<City>;
  destinationCityKey: Scalars['Int']['output'];
  miles: Scalars['Int']['output'];
  originCity?: Maybe<City>;
  originCityKey: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  tolls: Scalars['Float']['output'];
};

export type CarrierPointToPointRateDateSpan = {
  __typename?: 'CarrierPointToPointRateDateSpan';
  carrier?: Maybe<Carrier>;
  carrierKey: Scalars['Int']['output'];
  carrierPointToPointRateDateSpanKey: Scalars['Int']['output'];
  carrierPointToPointRates?: Maybe<Array<Maybe<CarrierPointToPointRate>>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
};

export type CarrierPointToPointRateDateSpanFilterInput = {
  and?: InputMaybe<Array<CarrierPointToPointRateDateSpanFilterInput>>;
  carrier?: InputMaybe<CarrierFilterInput>;
  carrierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  carrierPointToPointRateDateSpanKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  carrierPointToPointRates?: InputMaybe<ListFilterInputTypeOfCarrierPointToPointRateFilterInput>;
  endDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CarrierPointToPointRateDateSpanFilterInput>>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type CarrierPointToPointRateDateSpanInput = {
  carrier?: InputMaybe<CarrierInput>;
  carrierKey: Scalars['Int']['input'];
  carrierPointToPointRates?: InputMaybe<Array<InputMaybe<CarrierPointToPointRateInput>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CarrierPointToPointRateDateSpanSortInput = {
  carrier?: InputMaybe<CarrierSortInput>;
  carrierKey?: InputMaybe<SortEnumType>;
  carrierPointToPointRateDateSpanKey?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

export type CarrierPointToPointRateFilterInput = {
  and?: InputMaybe<Array<CarrierPointToPointRateFilterInput>>;
  carrierPointToPointRateDateSpan?: InputMaybe<CarrierPointToPointRateDateSpanFilterInput>;
  carrierPointToPointRateDateSpanKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  carrierPointToPointRateKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  destinationCity?: InputMaybe<CityFilterInput>;
  destinationCityKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  miles?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CarrierPointToPointRateFilterInput>>;
  originCity?: InputMaybe<CityFilterInput>;
  originCityKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  rate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  tolls?: InputMaybe<ComparableDoubleOperationFilterInput>;
};

export type CarrierPointToPointRateInput = {
  carrierPointToPointRateDateSpan?: InputMaybe<CarrierPointToPointRateDateSpanInput>;
  carrierPointToPointRateDateSpanKey: Scalars['Int']['input'];
  destinationCity?: InputMaybe<CityInput>;
  destinationCityKey: Scalars['Int']['input'];
  miles: Scalars['Int']['input'];
  originCity?: InputMaybe<CityInput>;
  originCityKey: Scalars['Int']['input'];
  rate: Scalars['Float']['input'];
  tolls: Scalars['Float']['input'];
};

export type CarrierPointToPointRateSortInput = {
  carrierPointToPointRateDateSpan?: InputMaybe<CarrierPointToPointRateDateSpanSortInput>;
  carrierPointToPointRateDateSpanKey?: InputMaybe<SortEnumType>;
  carrierPointToPointRateKey?: InputMaybe<SortEnumType>;
  destinationCity?: InputMaybe<CitySortInput>;
  destinationCityKey?: InputMaybe<SortEnumType>;
  miles?: InputMaybe<SortEnumType>;
  originCity?: InputMaybe<CitySortInput>;
  originCityKey?: InputMaybe<SortEnumType>;
  rate?: InputMaybe<SortEnumType>;
  tolls?: InputMaybe<SortEnumType>;
};

export type CarrierRate = {
  __typename?: 'CarrierRate';
  basePercent: Scalars['Float']['output'];
  carrier?: Maybe<Carrier>;
  carrierKey: Scalars['Int']['output'];
  carrierRateBands?: Maybe<Array<Maybe<CarrierRateBand>>>;
  carrierRateKey: Scalars['Int']['output'];
  default: Scalars['Boolean']['output'];
  endDate: Scalars['DateTime']['output'];
  fuelPercent: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type CarrierRateBand = {
  __typename?: 'CarrierRateBand';
  carrierRate?: Maybe<CarrierRate>;
  carrierRateBandKey: Scalars['Int']['output'];
  carrierRateKey: Scalars['Int']['output'];
  mileageFrom: Scalars['Int']['output'];
  mileageTo: Scalars['Int']['output'];
  ratePerGallon: Scalars['Float']['output'];
};

export type CarrierRateBandFilterInput = {
  and?: InputMaybe<Array<CarrierRateBandFilterInput>>;
  carrierRate?: InputMaybe<CarrierRateFilterInput>;
  carrierRateBandKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  carrierRateKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  mileageFrom?: InputMaybe<ComparableInt32OperationFilterInput>;
  mileageTo?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CarrierRateBandFilterInput>>;
  ratePerGallon?: InputMaybe<ComparableDoubleOperationFilterInput>;
};

export type CarrierRateBandInput = {
  carrierRate?: InputMaybe<CarrierRateInput>;
  carrierRateKey: Scalars['Int']['input'];
  mileageFrom: Scalars['Int']['input'];
  mileageTo: Scalars['Int']['input'];
  ratePerGallon: Scalars['Float']['input'];
};

export type CarrierRateBandSortInput = {
  carrierRate?: InputMaybe<CarrierRateSortInput>;
  carrierRateBandKey?: InputMaybe<SortEnumType>;
  carrierRateKey?: InputMaybe<SortEnumType>;
  mileageFrom?: InputMaybe<SortEnumType>;
  mileageTo?: InputMaybe<SortEnumType>;
  ratePerGallon?: InputMaybe<SortEnumType>;
};

export type CarrierRateFilterInput = {
  and?: InputMaybe<Array<CarrierRateFilterInput>>;
  basePercent?: InputMaybe<ComparableDoubleOperationFilterInput>;
  carrier?: InputMaybe<CarrierFilterInput>;
  carrierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  carrierRateBands?: InputMaybe<ListFilterInputTypeOfCarrierRateBandFilterInput>;
  carrierRateKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  endDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  fuelPercent?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<CarrierRateFilterInput>>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

/** A connection to a list of items. */
export type CarrierRateGetAllConnection = {
  __typename?: 'CarrierRateGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CarrierRateGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<CarrierRate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CarrierRateGetAllEdge = {
  __typename?: 'CarrierRateGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CarrierRate>;
};

export type CarrierRateInput = {
  basePercent: Scalars['Float']['input'];
  carrier?: InputMaybe<CarrierInput>;
  carrierKey: Scalars['Int']['input'];
  carrierRateBands?: InputMaybe<Array<InputMaybe<CarrierRateBandInput>>>;
  default: Scalars['Boolean']['input'];
  endDate: Scalars['DateTime']['input'];
  fuelPercent: Scalars['Float']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CarrierRateSortInput = {
  basePercent?: InputMaybe<SortEnumType>;
  carrier?: InputMaybe<CarrierSortInput>;
  carrierKey?: InputMaybe<SortEnumType>;
  carrierRateKey?: InputMaybe<SortEnumType>;
  default?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  fuelPercent?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

export type CarrierSearch = {
  __typename?: 'CarrierSearch';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  carrierKey: Scalars['Int']['output'];
  carrierPointToPointRateDateSpans?: Maybe<Array<Maybe<CarrierPointToPointRateDateSpan>>>;
  carrierRates?: Maybe<Array<Maybe<CarrierRate>>>;
  carrierType: CarrierType;
  city?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fuelSurcharges?: Maybe<Array<Maybe<FuelSurcharge>>>;
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orderTripNumberFillers?: Maybe<Array<Maybe<OrderTripNumberFiller>>>;
  orders?: Maybe<Array<Maybe<Order>>>;
  phone?: Maybe<Scalars['String']['output']>;
  primaryLocations?: Maybe<Array<Maybe<Location>>>;
  secondaryLocations?: Maybe<Array<Maybe<Location>>>;
  state?: Maybe<Scalars['String']['output']>;
  userCarriers?: Maybe<Array<Maybe<UserCarrier>>>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CarrierSearchSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  carrierKey?: InputMaybe<SortEnumType>;
  carrierType?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export type CarrierSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  carrierKey?: InputMaybe<SortEnumType>;
  carrierType?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export enum CarrierType {
  Mileage = 'MILEAGE',
  PointToPoint = 'POINT_TO_POINT'
}

export type CarrierTypeOperationFilterInput = {
  eq?: InputMaybe<CarrierType>;
  in?: InputMaybe<Array<CarrierType>>;
  neq?: InputMaybe<CarrierType>;
  nin?: InputMaybe<Array<CarrierType>>;
};

export type City = {
  __typename?: 'City';
  cityKey: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  stateKey: Scalars['Int']['output'];
};

export type CityFilterInput = {
  and?: InputMaybe<Array<CityFilterInput>>;
  cityKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CityFilterInput>>;
  state?: InputMaybe<StateFilterInput>;
  stateKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CityInput = {
  cityKey: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StateInput>;
  stateKey: Scalars['Int']['input'];
};

export type CitySortInput = {
  cityKey?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  state?: InputMaybe<StateSortInput>;
  stateKey?: InputMaybe<SortEnumType>;
};

export type ComparableDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableDoubleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type ComparableInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type ComparableNullableOfDateTimeOffsetOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComparableNullableOfDoubleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type ComparableNullableOfInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  carrier?: Maybe<Carrier>;
  carrierKey?: Maybe<Scalars['Int']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  contactKey: Scalars['Int']['output'];
  default: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locationContacts?: Maybe<Array<Maybe<Location>>>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  supplierKey?: Maybe<Scalars['Int']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  terminal?: Maybe<Terminal>;
  terminalKey?: Maybe<Scalars['Int']['output']>;
};

export type ContactFilterInput = {
  and?: InputMaybe<Array<ContactFilterInput>>;
  carrier?: InputMaybe<CarrierFilterInput>;
  carrierKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cellPhone?: InputMaybe<StringOperationFilterInput>;
  contactKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  deleted?: InputMaybe<BooleanOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  homePhone?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  locationContacts?: InputMaybe<ListFilterInputTypeOfLocationContactFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tasks?: InputMaybe<ListFilterInputTypeOfTaskFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ContactInput = {
  carrier?: InputMaybe<CarrierInput>;
  carrierKey?: InputMaybe<Scalars['Int']['input']>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  default: Scalars['Boolean']['input'];
  deleted: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationContacts?: InputMaybe<Array<InputMaybe<LocationContactInput>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<SupplierInput>;
  supplierKey?: InputMaybe<Scalars['Int']['input']>;
  tasks?: InputMaybe<Array<InputMaybe<TaskInput>>>;
  terminal?: InputMaybe<TerminalInput>;
  terminalKey?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContactMethod {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Fax = 'FAX',
  Phone = 'PHONE'
}

export type ContactMethodOperationFilterInput = {
  eq?: InputMaybe<ContactMethod>;
  in?: InputMaybe<Array<ContactMethod>>;
  neq?: InputMaybe<ContactMethod>;
  nin?: InputMaybe<Array<ContactMethod>>;
};

export type ContactSortInput = {
  carrier?: InputMaybe<CarrierSortInput>;
  carrierKey?: InputMaybe<SortEnumType>;
  cellPhone?: InputMaybe<SortEnumType>;
  contactKey?: InputMaybe<SortEnumType>;
  default?: InputMaybe<SortEnumType>;
  deleted?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  homePhone?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export enum ContractPeriod {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type ContractPeriodOperationFilterInput = {
  eq?: InputMaybe<ContractPeriod>;
  in?: InputMaybe<Array<ContractPeriod>>;
  neq?: InputMaybe<ContractPeriod>;
  nin?: InputMaybe<Array<ContractPeriod>>;
};

export enum ContractType {
  DayOf = 'DAY_OF',
  DayPrior = 'DAY_PRIOR'
}

export type ContractTypeOperationFilterInput = {
  eq?: InputMaybe<ContractType>;
  in?: InputMaybe<Array<ContractType>>;
  neq?: InputMaybe<ContractType>;
  nin?: InputMaybe<Array<ContractType>>;
};

export type ContractVolume = {
  __typename?: 'ContractVolume';
  april: Scalars['Int']['output'];
  august: Scalars['Int']['output'];
  contractVolumeKey: Scalars['Int']['output'];
  contractVolumeTerminals?: Maybe<Array<Maybe<ContractVolumeTerminal>>>;
  contractVolumeType: ContractVolumeType;
  december: Scalars['Int']['output'];
  february: Scalars['Int']['output'];
  january: Scalars['Int']['output'];
  july: Scalars['Int']['output'];
  june: Scalars['Int']['output'];
  march: Scalars['Int']['output'];
  may: Scalars['Int']['output'];
  november: Scalars['Int']['output'];
  october: Scalars['Int']['output'];
  september: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  supplier?: Maybe<Supplier>;
  supplierKey: Scalars['Int']['output'];
};

export type ContractVolumeFilterInput = {
  and?: InputMaybe<Array<ContractVolumeFilterInput>>;
  april?: InputMaybe<ComparableInt32OperationFilterInput>;
  august?: InputMaybe<ComparableInt32OperationFilterInput>;
  contractVolumeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  contractVolumeTerminals?: InputMaybe<ListFilterInputTypeOfContractVolumeTerminalFilterInput>;
  contractVolumeType?: InputMaybe<ContractVolumeTypeOperationFilterInput>;
  december?: InputMaybe<ComparableInt32OperationFilterInput>;
  february?: InputMaybe<ComparableInt32OperationFilterInput>;
  january?: InputMaybe<ComparableInt32OperationFilterInput>;
  july?: InputMaybe<ComparableInt32OperationFilterInput>;
  june?: InputMaybe<ComparableInt32OperationFilterInput>;
  march?: InputMaybe<ComparableInt32OperationFilterInput>;
  may?: InputMaybe<ComparableInt32OperationFilterInput>;
  november?: InputMaybe<ComparableInt32OperationFilterInput>;
  october?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ContractVolumeFilterInput>>;
  september?: InputMaybe<ComparableInt32OperationFilterInput>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type ContractVolumeGetAllConnection = {
  __typename?: 'ContractVolumeGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContractVolumeGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContractVolume>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContractVolumeGetAllEdge = {
  __typename?: 'ContractVolumeGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContractVolume>;
};

export type ContractVolumeInput = {
  april: Scalars['Int']['input'];
  august: Scalars['Int']['input'];
  contractVolumeTerminals?: InputMaybe<Array<InputMaybe<ContractVolumeTerminalInput>>>;
  contractVolumeType: ContractVolumeType;
  december: Scalars['Int']['input'];
  february: Scalars['Int']['input'];
  january: Scalars['Int']['input'];
  july: Scalars['Int']['input'];
  june: Scalars['Int']['input'];
  march: Scalars['Int']['input'];
  may: Scalars['Int']['input'];
  november: Scalars['Int']['input'];
  october: Scalars['Int']['input'];
  september: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  supplier?: InputMaybe<SupplierInput>;
  supplierKey: Scalars['Int']['input'];
};

export type ContractVolumeSortInput = {
  april?: InputMaybe<SortEnumType>;
  august?: InputMaybe<SortEnumType>;
  contractVolumeKey?: InputMaybe<SortEnumType>;
  contractVolumeType?: InputMaybe<SortEnumType>;
  december?: InputMaybe<SortEnumType>;
  february?: InputMaybe<SortEnumType>;
  january?: InputMaybe<SortEnumType>;
  july?: InputMaybe<SortEnumType>;
  june?: InputMaybe<SortEnumType>;
  march?: InputMaybe<SortEnumType>;
  may?: InputMaybe<SortEnumType>;
  november?: InputMaybe<SortEnumType>;
  october?: InputMaybe<SortEnumType>;
  september?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierKey?: InputMaybe<SortEnumType>;
};

export type ContractVolumeTerminal = {
  __typename?: 'ContractVolumeTerminal';
  contractVolume?: Maybe<Supplier>;
  contractVolumeKey: Scalars['Int']['output'];
  terminal?: Maybe<Terminal>;
  terminalKey: Scalars['Int']['output'];
};

export type ContractVolumeTerminalFilterInput = {
  and?: InputMaybe<Array<ContractVolumeTerminalFilterInput>>;
  contractVolume?: InputMaybe<ContractVolumeFilterInput>;
  contractVolumeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ContractVolumeTerminalFilterInput>>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ContractVolumeTerminalInput = {
  contractVolume?: InputMaybe<ContractVolumeInput>;
  contractVolumeKey: Scalars['Int']['input'];
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
};

export enum ContractVolumeType {
  Combine = 'COMBINE',
  Index = 'INDEX',
  Posting = 'POSTING'
}

export type ContractVolumeTypeOperationFilterInput = {
  eq?: InputMaybe<ContractVolumeType>;
  in?: InputMaybe<Array<ContractVolumeType>>;
  neq?: InputMaybe<ContractVolumeType>;
  nin?: InputMaybe<Array<ContractVolumeType>>;
};

export type Customer = {
  __typename?: 'Customer';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  businessType: BusinessType;
  city?: Maybe<Scalars['String']['output']>;
  creditLimit: Scalars['Float']['output'];
  creditNotes?: Maybe<Scalars['String']['output']>;
  customerKey: Scalars['Int']['output'];
  customerTags?: Maybe<Array<CustomerTag>>;
  dbaName?: Maybe<Scalars['String']['output']>;
  deliveryTime?: Maybe<DeliveryTime>;
  deliveryTimeKey?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  locations: Array<Location>;
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  quickBooksName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  userCustomerExclusions?: Maybe<Array<Maybe<UserCustomerExclusion>>>;
  userCustomerPermissions?: Maybe<Array<Maybe<UserCustomerPermission>>>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CustomerFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CustomerFilterInput>>;
  businessType?: InputMaybe<BusinessTypeOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  creditLimit?: InputMaybe<ComparableDoubleOperationFilterInput>;
  creditNotes?: InputMaybe<StringOperationFilterInput>;
  customerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerTags?: InputMaybe<ListFilterInputTypeOfCustomerTagFilterInput>;
  dbaName?: InputMaybe<StringOperationFilterInput>;
  deliveryTime?: InputMaybe<DeliveryTimeFilterInput>;
  deliveryTimeKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  directions?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  locations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  quickBooksName?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  userCustomerExclusions?: InputMaybe<ListFilterInputTypeOfUserCustomerExclusionFilterInput>;
  userCustomerPermissions?: InputMaybe<ListFilterInputTypeOfUserCustomerPermissionFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type CustomerGetAllConnection = {
  __typename?: 'CustomerGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Customer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerGetAllEdge = {
  __typename?: 'CustomerGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Customer>;
};

export type CustomerInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  businessType: BusinessType;
  city?: InputMaybe<Scalars['String']['input']>;
  creditLimit: Scalars['Float']['input'];
  creditNotes?: InputMaybe<Scalars['String']['input']>;
  customerTags?: InputMaybe<Array<InputMaybe<CustomerTagInput>>>;
  dbaName?: InputMaybe<Scalars['String']['input']>;
  deliveryTime?: InputMaybe<DeliveryTimeInput>;
  deliveryTimeKey?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  isArchived: Scalars['Boolean']['input'];
  locations?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  quickBooksName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  userCustomerExclusions?: InputMaybe<Array<InputMaybe<UserCustomerExclusionInput>>>;
  userCustomerPermissions?: InputMaybe<Array<InputMaybe<UserCustomerPermissionInput>>>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  businessType?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  creditLimit?: InputMaybe<SortEnumType>;
  creditNotes?: InputMaybe<SortEnumType>;
  customerKey?: InputMaybe<SortEnumType>;
  dbaName?: InputMaybe<SortEnumType>;
  deliveryTime?: InputMaybe<DeliveryTimeSortInput>;
  deliveryTimeKey?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  directions?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  quickBooksName?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export type CustomerTag = {
  __typename?: 'CustomerTag';
  customer?: Maybe<Customer>;
  customerKey: Scalars['Int']['output'];
  tag?: Maybe<Tag>;
  tagKey: Scalars['Int']['output'];
};

export type CustomerTagFilterInput = {
  and?: InputMaybe<Array<CustomerTagFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerTagFilterInput>>;
  tag?: InputMaybe<TagFilterInput>;
  tagKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerTagInput = {
  customer?: InputMaybe<CustomerInput>;
  customerKey: Scalars['Int']['input'];
  tag?: InputMaybe<TagInput>;
  tagKey: Scalars['Int']['input'];
};

/** A connection to a list of items. */
export type CustomersWithFilterConnection = {
  __typename?: 'CustomersWithFilterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersWithFilterEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Customer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomersWithFilterEdge = {
  __typename?: 'CustomersWithFilterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Customer>;
};

export type DeliveryTime = {
  __typename?: 'DeliveryTime';
  code?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<Customer>>>;
  deliveryTimeKey: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
};

export type DeliveryTimeFilterInput = {
  and?: InputMaybe<Array<DeliveryTimeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  customers?: InputMaybe<ListFilterInputTypeOfCustomerFilterInput>;
  deliveryTimeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryTimeFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
};

export type DeliveryTimeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customers?: InputMaybe<Array<InputMaybe<CustomerInput>>>;
  deliveryTimeKey: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
};

export type DeliveryTimeSortInput = {
  code?: InputMaybe<SortEnumType>;
  deliveryTimeKey?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
};

export type DirectMarkup = {
  __typename?: 'DirectMarkup';
  directMarkupKey: Scalars['Int']['output'];
  directMarkupType: DirectMarkupType;
  isArchived: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
  locationKey: Scalars['Int']['output'];
  markup: Scalars['Float']['output'];
  supplier?: Maybe<Supplier>;
  supplierKey: Scalars['Int']['output'];
  terminal?: Maybe<Terminal>;
  terminalKey: Scalars['Int']['output'];
};

export type DirectMarkupFilterInput = {
  and?: InputMaybe<Array<DirectMarkupFilterInput>>;
  directMarkupKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  directMarkupType?: InputMaybe<DirectMarkupTypeOperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  markup?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<DirectMarkupFilterInput>>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DirectMarkupInput = {
  directMarkupType: DirectMarkupType;
  isArchived: Scalars['Boolean']['input'];
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  markup: Scalars['Float']['input'];
  supplier?: InputMaybe<SupplierInput>;
  supplierKey: Scalars['Int']['input'];
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
};

export type DirectMarkupSortInput = {
  directMarkupKey?: InputMaybe<SortEnumType>;
  directMarkupType?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationKey?: InputMaybe<SortEnumType>;
  markup?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export enum DirectMarkupType {
  Both = 'BOTH',
  Index = 'INDEX',
  Posting = 'POSTING'
}

export type DirectMarkupTypeOperationFilterInput = {
  eq?: InputMaybe<DirectMarkupType>;
  in?: InputMaybe<Array<DirectMarkupType>>;
  neq?: InputMaybe<DirectMarkupType>;
  nin?: InputMaybe<Array<DirectMarkupType>>;
};

export type DispatchedShippedOrder = {
  __typename?: 'DispatchedShippedOrder';
  actualGallons?: Maybe<Scalars['Int']['output']>;
  assessment: Scalars['Float']['output'];
  businessType?: Maybe<Scalars['String']['output']>;
  carrierKey: Scalars['Int']['output'];
  carrierName?: Maybe<Scalars['String']['output']>;
  customerKey: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  delivered: Scalars['Float']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  fOB: Scalars['Float']['output'];
  freight: Scalars['Float']['output'];
  gallons: Scalars['Int']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  locationKey: Scalars['Int']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  manifest?: Maybe<Scalars['String']['output']>;
  markup: Scalars['Float']['output'];
  misc?: Maybe<Scalars['Float']['output']>;
  orderKey: Scalars['Int']['output'];
  otherCharge?: Maybe<Scalars['Float']['output']>;
  otherCost?: Maybe<Scalars['Float']['output']>;
  patCost?: Maybe<Scalars['Float']['output']>;
  product: Scalars['Float']['output'];
  state?: Maybe<Scalars['String']['output']>;
  supplierKey: Scalars['Int']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  terminalKey: Scalars['Int']['output'];
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type DispatchedShippedOrderFilterInput = {
  actualGallons?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<DispatchedShippedOrderFilterInput>>;
  assessment?: InputMaybe<ComparableDoubleOperationFilterInput>;
  businessType?: InputMaybe<StringOperationFilterInput>;
  carrierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  carrierName?: InputMaybe<StringOperationFilterInput>;
  customerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  delivered?: InputMaybe<ComparableDoubleOperationFilterInput>;
  deliveryDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  fOB?: InputMaybe<ComparableDoubleOperationFilterInput>;
  freight?: InputMaybe<ComparableDoubleOperationFilterInput>;
  gallons?: InputMaybe<ComparableInt32OperationFilterInput>;
  invoiceNumber?: InputMaybe<StringOperationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  manifest?: InputMaybe<StringOperationFilterInput>;
  markup?: InputMaybe<ComparableDoubleOperationFilterInput>;
  misc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  or?: InputMaybe<Array<DispatchedShippedOrderFilterInput>>;
  orderKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  otherCharge?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  otherCost?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  patCost?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  product?: InputMaybe<ComparableDoubleOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  supplierName?: InputMaybe<StringOperationFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  terminalName?: InputMaybe<StringOperationFilterInput>;
};

export type DispatchedShippedOrderSortInput = {
  actualGallons?: InputMaybe<SortEnumType>;
  assessment?: InputMaybe<SortEnumType>;
  businessType?: InputMaybe<SortEnumType>;
  carrierKey?: InputMaybe<SortEnumType>;
  carrierName?: InputMaybe<SortEnumType>;
  customerKey?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  delivered?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  fOB?: InputMaybe<SortEnumType>;
  freight?: InputMaybe<SortEnumType>;
  gallons?: InputMaybe<SortEnumType>;
  invoiceNumber?: InputMaybe<SortEnumType>;
  locationKey?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  manifest?: InputMaybe<SortEnumType>;
  markup?: InputMaybe<SortEnumType>;
  misc?: InputMaybe<SortEnumType>;
  orderKey?: InputMaybe<SortEnumType>;
  otherCharge?: InputMaybe<SortEnumType>;
  otherCost?: InputMaybe<SortEnumType>;
  patCost?: InputMaybe<SortEnumType>;
  product?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  supplierKey?: InputMaybe<SortEnumType>;
  supplierName?: InputMaybe<SortEnumType>;
  terminalKey?: InputMaybe<SortEnumType>;
  terminalName?: InputMaybe<SortEnumType>;
};

export type FileNumber = {
  __typename?: 'FileNumber';
  fileNumberKey: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  number?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  supplier?: Maybe<Supplier>;
  supplierKey: Scalars['Int']['output'];
  terminal?: Maybe<Terminal>;
  terminalKey: Scalars['Int']['output'];
};

export type FileNumberFilterInput = {
  and?: InputMaybe<Array<FileNumberFilterInput>>;
  fileNumberKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FileNumberFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type FileNumberInput = {
  isArchived: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  supplier?: InputMaybe<SupplierInput>;
  supplierKey: Scalars['Int']['input'];
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
};

export type FileNumberSortInput = {
  fileNumberKey?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export type FlatCarrierRate = {
  __typename?: 'FlatCarrierRate';
  carrierRateKey: Scalars['Int']['output'];
  ratePerGallon: Scalars['Float']['output'];
  rateType: CarrierType;
  toll: Scalars['Float']['output'];
};

export type FlatContractVolume = {
  __typename?: 'FlatContractVolume';
  contractVolumeKey: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  terminals?: Maybe<Scalars['String']['output']>;
};

export type FlatContractVolumeFilterInput = {
  and?: InputMaybe<Array<FlatContractVolumeFilterInput>>;
  contractVolumeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<FlatContractVolumeFilterInput>>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  supplier?: InputMaybe<StringOperationFilterInput>;
  terminals?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type FlatContractVolumeGetAllConnection = {
  __typename?: 'FlatContractVolumeGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FlatContractVolumeGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FlatContractVolume>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FlatContractVolumeGetAllEdge = {
  __typename?: 'FlatContractVolumeGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FlatContractVolume>;
};

export type FlatContractVolumeSortInput = {
  contractVolumeKey?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SortEnumType>;
  terminals?: InputMaybe<SortEnumType>;
};

export type FlatDirectMarkup = {
  __typename?: 'FlatDirectMarkup';
  directMarkupKey: Scalars['Int']['output'];
  directMarkupType: DirectMarkupType;
  isArchived: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  markup: Scalars['Float']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
};

export type FlatDirectMarkupFilterInput = {
  and?: InputMaybe<Array<FlatDirectMarkupFilterInput>>;
  directMarkupKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  directMarkupType?: InputMaybe<DirectMarkupTypeOperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  markup?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<FlatDirectMarkupFilterInput>>;
  supplier?: InputMaybe<StringOperationFilterInput>;
  terminal?: InputMaybe<StringOperationFilterInput>;
};

export type FlatDirectMarkupSortInput = {
  directMarkupKey?: InputMaybe<SortEnumType>;
  directMarkupType?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  markup?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<SortEnumType>;
};

export type FlatFileNumber = {
  __typename?: 'FlatFileNumber';
  fileNumberKey: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  number?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
};

export type FlatFileNumberFilterInput = {
  and?: InputMaybe<Array<FlatFileNumberFilterInput>>;
  fileNumberKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FlatFileNumberFilterInput>>;
  supplier?: InputMaybe<StringOperationFilterInput>;
  terminal?: InputMaybe<StringOperationFilterInput>;
};

export type FlatFileNumberSortInput = {
  fileNumberKey?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<SortEnumType>;
};

export type FlatIndexContract = {
  __typename?: 'FlatIndexContract';
  accountInfo?: Maybe<Scalars['String']['output']>;
  effectiveDate: Scalars['DateTime']['output'];
  effectiveEndDate: Scalars['DateTime']['output'];
  indexContractKey: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  supplierKey: Scalars['Int']['output'];
  terminal?: Maybe<Scalars['String']['output']>;
  terminalKey: Scalars['Int']['output'];
};

export type FlatIndexContractFilterInput = {
  accountInfo?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<FlatIndexContractFilterInput>>;
  effectiveDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  effectiveEndDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  indexContractKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FlatIndexContractFilterInput>>;
  supplier?: InputMaybe<StringOperationFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  terminal?: InputMaybe<StringOperationFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type FlatIndexContractSortInput = {
  accountInfo?: InputMaybe<SortEnumType>;
  effectiveDate?: InputMaybe<SortEnumType>;
  effectiveEndDate?: InputMaybe<SortEnumType>;
  indexContractKey?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SortEnumType>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<SortEnumType>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export type FlatPosting = {
  __typename?: 'FlatPosting';
  archivedDate?: Maybe<Scalars['DateTime']['output']>;
  cost: Scalars['Float']['output'];
  currentPrice?: Maybe<Scalars['Float']['output']>;
  currentPriceEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  effectiveDate: Scalars['DateTime']['output'];
  effectiveEndDate: Scalars['DateTime']['output'];
  /** @deprecated Use IsArchived instead. This will be removed after migration. */
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  postingKey: Scalars['Int']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  supplierKey: Scalars['Int']['output'];
  terminal?: Maybe<Scalars['String']['output']>;
  terminalKey: Scalars['Int']['output'];
};

export type FlatPostingFilterInput = {
  and?: InputMaybe<Array<FlatPostingFilterInput>>;
  archivedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  cost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  currentPrice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  currentPriceEffectiveDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  effectiveDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  effectiveEndDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FlatPostingFilterInput>>;
  postingKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  supplier?: InputMaybe<StringOperationFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  terminal?: InputMaybe<StringOperationFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type FlatPostingGetAllConnection = {
  __typename?: 'FlatPostingGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FlatPostingGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FlatPosting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FlatPostingGetAllEdge = {
  __typename?: 'FlatPostingGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FlatPosting>;
};

export type FlatPostingSortInput = {
  archivedDate?: InputMaybe<SortEnumType>;
  cost?: InputMaybe<SortEnumType>;
  currentPrice?: InputMaybe<SortEnumType>;
  currentPriceEffectiveDate?: InputMaybe<SortEnumType>;
  effectiveDate?: InputMaybe<SortEnumType>;
  effectiveEndDate?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  postingKey?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SortEnumType>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<SortEnumType>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export type FlatPrePurchaseAgreement = {
  __typename?: 'FlatPrePurchaseAgreement';
  endShipDate: Scalars['DateTime']['output'];
  prePurchaseAgreementKey: Scalars['Int']['output'];
  startShipDate: Scalars['DateTime']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  supplierAgreement?: Maybe<Scalars['String']['output']>;
  supplierKey: Scalars['Int']['output'];
  terminal?: Maybe<Scalars['String']['output']>;
  terminalKey: Scalars['Int']['output'];
};

export type FlatPrePurchaseAgreementFilterInput = {
  and?: InputMaybe<Array<FlatPrePurchaseAgreementFilterInput>>;
  endShipDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<FlatPrePurchaseAgreementFilterInput>>;
  prePurchaseAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  startShipDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  supplier?: InputMaybe<StringOperationFilterInput>;
  supplierAgreement?: InputMaybe<StringOperationFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  terminal?: InputMaybe<StringOperationFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type FlatPrePurchaseAgreementGetAllConnection = {
  __typename?: 'FlatPrePurchaseAgreementGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FlatPrePurchaseAgreementGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FlatPrePurchaseAgreement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FlatPrePurchaseAgreementGetAllEdge = {
  __typename?: 'FlatPrePurchaseAgreementGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FlatPrePurchaseAgreement>;
};

export type FlatPrePurchaseAgreementSortInput = {
  endShipDate?: InputMaybe<SortEnumType>;
  prePurchaseAgreementKey?: InputMaybe<SortEnumType>;
  startShipDate?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SortEnumType>;
  supplierAgreement?: InputMaybe<SortEnumType>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<SortEnumType>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export type FlatSalesAgreement = {
  __typename?: 'FlatSalesAgreement';
  agreementName?: Maybe<Scalars['String']['output']>;
  customerKeys?: Maybe<Array<Scalars['Int']['output']>>;
  endShipDate: Scalars['DateTime']['output'];
  locationKeys?: Maybe<Array<Scalars['Int']['output']>>;
  salesAgreementKey: Scalars['Int']['output'];
  startShipDate: Scalars['DateTime']['output'];
  stateKeys?: Maybe<Array<Scalars['Int']['output']>>;
  supplier?: Maybe<Scalars['String']['output']>;
  supplierKey?: Maybe<Scalars['Int']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
  terminalKey?: Maybe<Scalars['Int']['output']>;
};

export type FlatSalesAgreementFilterInput = {
  agreementName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<FlatSalesAgreementFilterInput>>;
  customerKeys?: InputMaybe<ListComparableInt32OperationFilterInput>;
  endShipDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  locationKeys?: InputMaybe<ListComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<FlatSalesAgreementFilterInput>>;
  salesAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  startShipDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  stateKeys?: InputMaybe<ListComparableInt32OperationFilterInput>;
  supplier?: InputMaybe<StringOperationFilterInput>;
  supplierKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  terminal?: InputMaybe<StringOperationFilterInput>;
  terminalKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type FlatSalesAgreementGetAllConnection = {
  __typename?: 'FlatSalesAgreementGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FlatSalesAgreementGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FlatSalesAgreement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FlatSalesAgreementGetAllEdge = {
  __typename?: 'FlatSalesAgreementGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FlatSalesAgreement>;
};

export type FlatSalesAgreementSortInput = {
  agreementName?: InputMaybe<SortEnumType>;
  endShipDate?: InputMaybe<SortEnumType>;
  salesAgreementKey?: InputMaybe<SortEnumType>;
  startShipDate?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SortEnumType>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<SortEnumType>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export type FlatSwapDeal = {
  __typename?: 'FlatSwapDeal';
  basisType?: Maybe<Scalars['String']['output']>;
  dealNumber: Scalars['Int']['output'];
  effectiveEndDate: Scalars['DateTime']['output'];
  effectiveStartDate: Scalars['DateTime']['output'];
  monthlyVolume: Scalars['Int']['output'];
  salesAgreements?: Maybe<Scalars['String']['output']>;
  sglCost: Scalars['Float']['output'];
  suppliers?: Maybe<Scalars['String']['output']>;
  swapDealKey: Scalars['Int']['output'];
};

export type FlatSwapDealFilterInput = {
  and?: InputMaybe<Array<FlatSwapDealFilterInput>>;
  basisType?: InputMaybe<StringOperationFilterInput>;
  dealNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  effectiveEndDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  effectiveStartDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  monthlyVolume?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<FlatSwapDealFilterInput>>;
  salesAgreements?: InputMaybe<StringOperationFilterInput>;
  sglCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  suppliers?: InputMaybe<StringOperationFilterInput>;
  swapDealKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type FlatSwapDealSortInput = {
  basisType?: InputMaybe<SortEnumType>;
  dealNumber?: InputMaybe<SortEnumType>;
  effectiveEndDate?: InputMaybe<SortEnumType>;
  effectiveStartDate?: InputMaybe<SortEnumType>;
  monthlyVolume?: InputMaybe<SortEnumType>;
  salesAgreements?: InputMaybe<SortEnumType>;
  sglCost?: InputMaybe<SortEnumType>;
  suppliers?: InputMaybe<SortEnumType>;
  swapDealKey?: InputMaybe<SortEnumType>;
};

export type FuelSurcharge = {
  __typename?: 'FuelSurcharge';
  carrier?: Maybe<Carrier>;
  carrierKey: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  fuelSurchargeKey: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type FuelSurchargeFilterInput = {
  and?: InputMaybe<Array<FuelSurchargeFilterInput>>;
  carrier?: InputMaybe<CarrierFilterInput>;
  carrierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  endDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  fuelSurchargeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<FuelSurchargeFilterInput>>;
  rate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

/** A connection to a list of items. */
export type FuelSurchargeGetAllConnection = {
  __typename?: 'FuelSurchargeGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FuelSurchargeGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FuelSurcharge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FuelSurchargeGetAllEdge = {
  __typename?: 'FuelSurchargeGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FuelSurcharge>;
};

export type FuelSurchargeInput = {
  carrier?: InputMaybe<CarrierInput>;
  carrierKey: Scalars['Int']['input'];
  endDate: Scalars['DateTime']['input'];
  rate: Scalars['Float']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type FuelSurchargeSortInput = {
  carrier?: InputMaybe<CarrierSortInput>;
  carrierKey?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  fuelSurchargeKey?: InputMaybe<SortEnumType>;
  rate?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

export type IndexContract = {
  __typename?: 'IndexContract';
  accountInfo?: Maybe<Scalars['String']['output']>;
  aprilIndex: Scalars['Float']['output'];
  augustIndex: Scalars['Float']['output'];
  basisType: BasisType;
  basisTypeKey: Scalars['Int']['output'];
  contractPeriod: ContractPeriod;
  contractType: ContractType;
  dayPrior: Scalars['Boolean']['output'];
  decemberIndex: Scalars['Float']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  effectiveEndDate: Scalars['DateTime']['output'];
  februaryIndex: Scalars['Float']['output'];
  fileNumber?: Maybe<Scalars['String']['output']>;
  indexContractKey: Scalars['Int']['output'];
  isIndication: Scalars['Boolean']['output'];
  januaryIndex: Scalars['Float']['output'];
  julyIndex: Scalars['Float']['output'];
  juneIndex: Scalars['Float']['output'];
  marchIndex: Scalars['Float']['output'];
  maximumGallons?: Maybe<Scalars['Float']['output']>;
  maximumLoads?: Maybe<Scalars['Int']['output']>;
  mayIndex: Scalars['Float']['output'];
  minimumGallons?: Maybe<Scalars['Float']['output']>;
  minimumLoads?: Maybe<Scalars['Int']['output']>;
  novemberIndex: Scalars['Float']['output'];
  octoberIndex: Scalars['Float']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  septemberIndex: Scalars['Float']['output'];
  supplier: Supplier;
  supplierKey: Scalars['Int']['output'];
  supplierType: SupplierType;
  terminal: Terminal;
  terminalKey: Scalars['Int']['output'];
};

export type IndexContractFilterInput = {
  accountInfo?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<IndexContractFilterInput>>;
  aprilIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  augustIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  basisType?: InputMaybe<BasisTypeFilterInput>;
  basisTypeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  contractPeriod?: InputMaybe<ContractPeriodOperationFilterInput>;
  contractType?: InputMaybe<ContractTypeOperationFilterInput>;
  dayPrior?: InputMaybe<BooleanOperationFilterInput>;
  decemberIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  effectiveDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  effectiveEndDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  februaryIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  fileNumber?: InputMaybe<StringOperationFilterInput>;
  indexContractKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  isIndication?: InputMaybe<BooleanOperationFilterInput>;
  januaryIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  julyIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  juneIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  marchIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  maximumGallons?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  maximumLoads?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mayIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  minimumGallons?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  minimumLoads?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  novemberIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  octoberIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<IndexContractFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  septemberIndex?: InputMaybe<ComparableDoubleOperationFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  supplierType?: InputMaybe<SupplierTypeOperationFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type IndexContractInput = {
  accountInfo?: InputMaybe<Scalars['String']['input']>;
  aprilIndex: Scalars['Float']['input'];
  augustIndex: Scalars['Float']['input'];
  basisType?: InputMaybe<BasisTypeInput>;
  basisTypeKey: Scalars['Int']['input'];
  contractPeriod: ContractPeriod;
  contractType: ContractType;
  dayPrior: Scalars['Boolean']['input'];
  decemberIndex: Scalars['Float']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  effectiveEndDate: Scalars['DateTime']['input'];
  februaryIndex: Scalars['Float']['input'];
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  isIndication: Scalars['Boolean']['input'];
  januaryIndex: Scalars['Float']['input'];
  julyIndex: Scalars['Float']['input'];
  juneIndex: Scalars['Float']['input'];
  marchIndex: Scalars['Float']['input'];
  maximumGallons?: InputMaybe<Scalars['Float']['input']>;
  maximumLoads?: InputMaybe<Scalars['Int']['input']>;
  mayIndex: Scalars['Float']['input'];
  minimumGallons?: InputMaybe<Scalars['Float']['input']>;
  minimumLoads?: InputMaybe<Scalars['Int']['input']>;
  novemberIndex: Scalars['Float']['input'];
  octoberIndex: Scalars['Float']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  septemberIndex: Scalars['Float']['input'];
  supplier?: InputMaybe<SupplierInput>;
  supplierKey: Scalars['Int']['input'];
  supplierType: SupplierType;
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
};

export type IndexContractSortInput = {
  accountInfo?: InputMaybe<SortEnumType>;
  aprilIndex?: InputMaybe<SortEnumType>;
  augustIndex?: InputMaybe<SortEnumType>;
  basisType?: InputMaybe<BasisTypeSortInput>;
  basisTypeKey?: InputMaybe<SortEnumType>;
  contractPeriod?: InputMaybe<SortEnumType>;
  contractType?: InputMaybe<SortEnumType>;
  dayPrior?: InputMaybe<SortEnumType>;
  decemberIndex?: InputMaybe<SortEnumType>;
  effectiveDate?: InputMaybe<SortEnumType>;
  effectiveEndDate?: InputMaybe<SortEnumType>;
  februaryIndex?: InputMaybe<SortEnumType>;
  fileNumber?: InputMaybe<SortEnumType>;
  indexContractKey?: InputMaybe<SortEnumType>;
  isIndication?: InputMaybe<SortEnumType>;
  januaryIndex?: InputMaybe<SortEnumType>;
  julyIndex?: InputMaybe<SortEnumType>;
  juneIndex?: InputMaybe<SortEnumType>;
  marchIndex?: InputMaybe<SortEnumType>;
  maximumGallons?: InputMaybe<SortEnumType>;
  maximumLoads?: InputMaybe<SortEnumType>;
  mayIndex?: InputMaybe<SortEnumType>;
  minimumGallons?: InputMaybe<SortEnumType>;
  minimumLoads?: InputMaybe<SortEnumType>;
  novemberIndex?: InputMaybe<SortEnumType>;
  octoberIndex?: InputMaybe<SortEnumType>;
  septemberIndex?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierKey?: InputMaybe<SortEnumType>;
  supplierType?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export type LinkedSalesAgreement = {
  __typename?: 'LinkedSalesAgreement';
  relatedFromSalesAgreement?: Maybe<SalesAgreement>;
  relatedFromSalesAgreementKey: Scalars['Int']['output'];
  relatedFromSalesAgreements?: Maybe<Array<SalesAgreement>>;
  relatedToSalesAgreement?: Maybe<SalesAgreement>;
  relatedToSalesAgreementKey: Scalars['Int']['output'];
};

export type LinkedSalesAgreementFilterInput = {
  and?: InputMaybe<Array<LinkedSalesAgreementFilterInput>>;
  or?: InputMaybe<Array<LinkedSalesAgreementFilterInput>>;
  relatedFromSalesAgreement?: InputMaybe<SalesAgreementFilterInput>;
  relatedFromSalesAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  relatedToSalesAgreement?: InputMaybe<SalesAgreementFilterInput>;
  relatedToSalesAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type LinkedSalesAgreementInput = {
  relatedFromSalesAgreement?: InputMaybe<SalesAgreementInput>;
  relatedFromSalesAgreementKey: Scalars['Int']['input'];
  relatedToSalesAgreement?: InputMaybe<SalesAgreementInput>;
  relatedToSalesAgreementKey: Scalars['Int']['input'];
};

export type LinkedSalesAgreementSortInput = {
  relatedFromSalesAgreement?: InputMaybe<SalesAgreementSortInput>;
  relatedFromSalesAgreementKey?: InputMaybe<SortEnumType>;
  relatedToSalesAgreement?: InputMaybe<SalesAgreementSortInput>;
  relatedToSalesAgreementKey?: InputMaybe<SortEnumType>;
};

export type ListComparableInt32OperationFilterInput = {
  all?: InputMaybe<ComparableInt32OperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ComparableInt32OperationFilterInput>;
  some?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ListFilterInputTypeOfBasisTypePriceFilterInput = {
  all?: InputMaybe<BasisTypePriceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BasisTypePriceFilterInput>;
  some?: InputMaybe<BasisTypePriceFilterInput>;
};

export type ListFilterInputTypeOfCarrierPointToPointRateDateSpanFilterInput = {
  all?: InputMaybe<CarrierPointToPointRateDateSpanFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CarrierPointToPointRateDateSpanFilterInput>;
  some?: InputMaybe<CarrierPointToPointRateDateSpanFilterInput>;
};

export type ListFilterInputTypeOfCarrierPointToPointRateFilterInput = {
  all?: InputMaybe<CarrierPointToPointRateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CarrierPointToPointRateFilterInput>;
  some?: InputMaybe<CarrierPointToPointRateFilterInput>;
};

export type ListFilterInputTypeOfCarrierRateBandFilterInput = {
  all?: InputMaybe<CarrierRateBandFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CarrierRateBandFilterInput>;
  some?: InputMaybe<CarrierRateBandFilterInput>;
};

export type ListFilterInputTypeOfCarrierRateFilterInput = {
  all?: InputMaybe<CarrierRateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CarrierRateFilterInput>;
  some?: InputMaybe<CarrierRateFilterInput>;
};

export type ListFilterInputTypeOfCityFilterInput = {
  all?: InputMaybe<CityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CityFilterInput>;
  some?: InputMaybe<CityFilterInput>;
};

export type ListFilterInputTypeOfContactFilterInput = {
  all?: InputMaybe<ContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactFilterInput>;
  some?: InputMaybe<ContactFilterInput>;
};

export type ListFilterInputTypeOfContractVolumeFilterInput = {
  all?: InputMaybe<ContractVolumeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContractVolumeFilterInput>;
  some?: InputMaybe<ContractVolumeFilterInput>;
};

export type ListFilterInputTypeOfContractVolumeTerminalFilterInput = {
  all?: InputMaybe<ContractVolumeTerminalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContractVolumeTerminalFilterInput>;
  some?: InputMaybe<ContractVolumeTerminalFilterInput>;
};

export type ListFilterInputTypeOfCustomerFilterInput = {
  all?: InputMaybe<CustomerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerFilterInput>;
  some?: InputMaybe<CustomerFilterInput>;
};

export type ListFilterInputTypeOfCustomerTagFilterInput = {
  all?: InputMaybe<CustomerTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerTagFilterInput>;
  some?: InputMaybe<CustomerTagFilterInput>;
};

export type ListFilterInputTypeOfDirectMarkupFilterInput = {
  all?: InputMaybe<DirectMarkupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DirectMarkupFilterInput>;
  some?: InputMaybe<DirectMarkupFilterInput>;
};

export type ListFilterInputTypeOfFileNumberFilterInput = {
  all?: InputMaybe<FileNumberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FileNumberFilterInput>;
  some?: InputMaybe<FileNumberFilterInput>;
};

export type ListFilterInputTypeOfFuelSurchargeFilterInput = {
  all?: InputMaybe<FuelSurchargeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FuelSurchargeFilterInput>;
  some?: InputMaybe<FuelSurchargeFilterInput>;
};

export type ListFilterInputTypeOfIndexContractFilterInput = {
  all?: InputMaybe<IndexContractFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IndexContractFilterInput>;
  some?: InputMaybe<IndexContractFilterInput>;
};

export type ListFilterInputTypeOfLinkedSalesAgreementFilterInput = {
  all?: InputMaybe<LinkedSalesAgreementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LinkedSalesAgreementFilterInput>;
  some?: InputMaybe<LinkedSalesAgreementFilterInput>;
};

export type ListFilterInputTypeOfLocationContactFilterInput = {
  all?: InputMaybe<LocationContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LocationContactFilterInput>;
  some?: InputMaybe<LocationContactFilterInput>;
};

export type ListFilterInputTypeOfLocationFilterInput = {
  all?: InputMaybe<LocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LocationFilterInput>;
  some?: InputMaybe<LocationFilterInput>;
};

export type ListFilterInputTypeOfLocationTagFilterInput = {
  all?: InputMaybe<LocationTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LocationTagFilterInput>;
  some?: InputMaybe<LocationTagFilterInput>;
};

export type ListFilterInputTypeOfLocationTerminalFilterInput = {
  all?: InputMaybe<LocationTerminalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LocationTerminalFilterInput>;
  some?: InputMaybe<LocationTerminalFilterInput>;
};

export type ListFilterInputTypeOfOrderFilterInput = {
  all?: InputMaybe<OrderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderFilterInput>;
  some?: InputMaybe<OrderFilterInput>;
};

export type ListFilterInputTypeOfOrderTripNumberFillerFilterInput = {
  all?: InputMaybe<OrderTripNumberFillerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderTripNumberFillerFilterInput>;
  some?: InputMaybe<OrderTripNumberFillerFilterInput>;
};

export type ListFilterInputTypeOfPostingFilterInput = {
  all?: InputMaybe<PostingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PostingFilterInput>;
  some?: InputMaybe<PostingFilterInput>;
};

export type ListFilterInputTypeOfPostingPriceFilterInput = {
  all?: InputMaybe<PostingPriceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PostingPriceFilterInput>;
  some?: InputMaybe<PostingPriceFilterInput>;
};

export type ListFilterInputTypeOfPrePurchaseAgreementFilterInput = {
  all?: InputMaybe<PrePurchaseAgreementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PrePurchaseAgreementFilterInput>;
  some?: InputMaybe<PrePurchaseAgreementFilterInput>;
};

export type ListFilterInputTypeOfPrePurchaseAgreementSalesAgreementFilterInput = {
  all?: InputMaybe<PrePurchaseAgreementSalesAgreementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PrePurchaseAgreementSalesAgreementFilterInput>;
  some?: InputMaybe<PrePurchaseAgreementSalesAgreementFilterInput>;
};

export type ListFilterInputTypeOfRefreshTokenFilterInput = {
  all?: InputMaybe<RefreshTokenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RefreshTokenFilterInput>;
  some?: InputMaybe<RefreshTokenFilterInput>;
};

export type ListFilterInputTypeOfSalesAgreementFilterInput = {
  all?: InputMaybe<SalesAgreementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesAgreementFilterInput>;
  some?: InputMaybe<SalesAgreementFilterInput>;
};

export type ListFilterInputTypeOfSalesAgreementLocationFilterInput = {
  all?: InputMaybe<SalesAgreementLocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesAgreementLocationFilterInput>;
  some?: InputMaybe<SalesAgreementLocationFilterInput>;
};

export type ListFilterInputTypeOfStateTaxFilterInput = {
  all?: InputMaybe<StateTaxFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StateTaxFilterInput>;
  some?: InputMaybe<StateTaxFilterInput>;
};

export type ListFilterInputTypeOfSwapDealFilterInput = {
  all?: InputMaybe<SwapDealFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SwapDealFilterInput>;
  some?: InputMaybe<SwapDealFilterInput>;
};

export type ListFilterInputTypeOfSwapDealSalesAgreementFilterInput = {
  all?: InputMaybe<SwapDealSalesAgreementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SwapDealSalesAgreementFilterInput>;
  some?: InputMaybe<SwapDealSalesAgreementFilterInput>;
};

export type ListFilterInputTypeOfTankFilterInput = {
  all?: InputMaybe<TankFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TankFilterInput>;
  some?: InputMaybe<TankFilterInput>;
};

export type ListFilterInputTypeOfTaskFilterInput = {
  all?: InputMaybe<TaskFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TaskFilterInput>;
  some?: InputMaybe<TaskFilterInput>;
};

export type ListFilterInputTypeOfTermContractFilterInput = {
  all?: InputMaybe<TermContractFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TermContractFilterInput>;
  some?: InputMaybe<TermContractFilterInput>;
};

export type ListFilterInputTypeOfTermContractLocationFilterInput = {
  all?: InputMaybe<TermContractLocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TermContractLocationFilterInput>;
  some?: InputMaybe<TermContractLocationFilterInput>;
};

export type ListFilterInputTypeOfTermContractPrePurchaseAgreementFilterInput = {
  all?: InputMaybe<TermContractPrePurchaseAgreementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TermContractPrePurchaseAgreementFilterInput>;
  some?: InputMaybe<TermContractPrePurchaseAgreementFilterInput>;
};

export type ListFilterInputTypeOfTermContractSalesAgreementFilterInput = {
  all?: InputMaybe<TermContractSalesAgreementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TermContractSalesAgreementFilterInput>;
  some?: InputMaybe<TermContractSalesAgreementFilterInput>;
};

export type ListFilterInputTypeOfTermContractSupplierFilterInput = {
  all?: InputMaybe<TermContractSupplierFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TermContractSupplierFilterInput>;
  some?: InputMaybe<TermContractSupplierFilterInput>;
};

export type ListFilterInputTypeOfTermContractTerminalFilterInput = {
  all?: InputMaybe<TermContractTerminalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TermContractTerminalFilterInput>;
  some?: InputMaybe<TermContractTerminalFilterInput>;
};

export type ListFilterInputTypeOfUserCarrierFilterInput = {
  all?: InputMaybe<UserCarrierFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserCarrierFilterInput>;
  some?: InputMaybe<UserCarrierFilterInput>;
};

export type ListFilterInputTypeOfUserCustomerExclusionFilterInput = {
  all?: InputMaybe<UserCustomerExclusionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserCustomerExclusionFilterInput>;
  some?: InputMaybe<UserCustomerExclusionFilterInput>;
};

export type ListFilterInputTypeOfUserCustomerPermissionFilterInput = {
  all?: InputMaybe<UserCustomerPermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserCustomerPermissionFilterInput>;
  some?: InputMaybe<UserCustomerPermissionFilterInput>;
};

export type ListFilterInputTypeOfUserLocationExclusionFilterInput = {
  all?: InputMaybe<UserLocationExclusionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserLocationExclusionFilterInput>;
  some?: InputMaybe<UserLocationExclusionFilterInput>;
};

export type ListFilterInputTypeOfUserLocationPermissionFilterInput = {
  all?: InputMaybe<UserLocationPermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserLocationPermissionFilterInput>;
  some?: InputMaybe<UserLocationPermissionFilterInput>;
};

export type ListFilterInputTypeOfUserStatePermissionFilterInput = {
  all?: InputMaybe<UserStatePermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserStatePermissionFilterInput>;
  some?: InputMaybe<UserStatePermissionFilterInput>;
};

export type Location = {
  __typename?: 'Location';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  agId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerKey: Scalars['Int']['output'];
  directMarkups?: Maybe<Array<Maybe<DirectMarkup>>>;
  directions?: Maybe<Scalars['String']['output']>;
  federalId?: Maybe<Scalars['String']['output']>;
  hasPercCharge: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isAgExempt: Scalars['Boolean']['output'];
  isFobCustomer: Scalars['Boolean']['output'];
  isInternetCustomer: Scalars['Boolean']['output'];
  isTaxExempt: Scalars['Boolean']['output'];
  locationContacts?: Maybe<Array<Maybe<LocationContact>>>;
  locationKey: Scalars['Int']['output'];
  locationNotes?: Maybe<Scalars['String']['output']>;
  locationStatus: LocationStatus;
  locationTags?: Maybe<Array<Maybe<LocationTag>>>;
  locationTerminals?: Maybe<Array<Maybe<LocationTerminal>>>;
  lockMarkup: Scalars['Boolean']['output'];
  mailToAddress1?: Maybe<Scalars['String']['output']>;
  mailToAddress2?: Maybe<Scalars['String']['output']>;
  mailToCity?: Maybe<Scalars['String']['output']>;
  mailToDirections?: Maybe<Scalars['String']['output']>;
  mailToSameAsCustomer: Scalars['Boolean']['output'];
  mailToState?: Maybe<Scalars['String']['output']>;
  mailToZipCode?: Maybe<Scalars['String']['output']>;
  markupCost: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  percentOfSales?: Maybe<Scalars['Int']['output']>;
  primaryCarrier?: Maybe<Carrier>;
  primaryCarrierKey?: Maybe<Scalars['Int']['output']>;
  quickBooksName?: Maybe<Scalars['String']['output']>;
  salesAgreementLocations?: Maybe<Array<Maybe<SalesAgreementLocation>>>;
  secondaryCarrier?: Maybe<Carrier>;
  secondaryCarrierKey?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateId?: Maybe<Scalars['String']['output']>;
  stateKey: Scalars['Int']['output'];
  stateObj: State;
  tanks?: Maybe<Array<Maybe<Tank>>>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  termContractLocations?: Maybe<Array<Maybe<TermContractLocation>>>;
  userLocationExclusions?: Maybe<Array<Maybe<UserLocationExclusion>>>;
  userLocationPermissions?: Maybe<Array<Maybe<UserLocationPermission>>>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type LocationContact = {
  __typename?: 'LocationContact';
  contact?: Maybe<Contact>;
  contactKey: Scalars['Int']['output'];
  default: Scalars['Boolean']['output'];
  location?: Maybe<Array<Maybe<Location>>>;
  locationKey: Scalars['Int']['output'];
};

export type LocationContactFilterInput = {
  and?: InputMaybe<Array<LocationContactFilterInput>>;
  contact?: InputMaybe<ContactFilterInput>;
  contactKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<LocationContactFilterInput>>;
};

export type LocationContactInput = {
  contact?: InputMaybe<ContactInput>;
  contactKey: Scalars['Int']['input'];
  default: Scalars['Boolean']['input'];
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
};

export type LocationFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  agId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<LocationFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  directMarkups?: InputMaybe<ListFilterInputTypeOfDirectMarkupFilterInput>;
  directions?: InputMaybe<StringOperationFilterInput>;
  federalId?: InputMaybe<StringOperationFilterInput>;
  hasPercCharge?: InputMaybe<BooleanOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isAgExempt?: InputMaybe<BooleanOperationFilterInput>;
  isFobCustomer?: InputMaybe<BooleanOperationFilterInput>;
  isInternetCustomer?: InputMaybe<BooleanOperationFilterInput>;
  isTaxExempt?: InputMaybe<BooleanOperationFilterInput>;
  locationContacts?: InputMaybe<ListFilterInputTypeOfLocationContactFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationNotes?: InputMaybe<StringOperationFilterInput>;
  locationStatus?: InputMaybe<LocationStatusOperationFilterInput>;
  locationTags?: InputMaybe<ListFilterInputTypeOfLocationTagFilterInput>;
  locationTerminals?: InputMaybe<ListFilterInputTypeOfLocationTerminalFilterInput>;
  lockMarkup?: InputMaybe<BooleanOperationFilterInput>;
  mailToAddress1?: InputMaybe<StringOperationFilterInput>;
  mailToAddress2?: InputMaybe<StringOperationFilterInput>;
  mailToCity?: InputMaybe<StringOperationFilterInput>;
  mailToDirections?: InputMaybe<StringOperationFilterInput>;
  mailToSameAsCustomer?: InputMaybe<BooleanOperationFilterInput>;
  mailToState?: InputMaybe<StringOperationFilterInput>;
  mailToZipCode?: InputMaybe<StringOperationFilterInput>;
  markupCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  percentOfSales?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  primaryCarrier?: InputMaybe<CarrierFilterInput>;
  primaryCarrierKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  quickBooksName?: InputMaybe<StringOperationFilterInput>;
  salesAgreementLocations?: InputMaybe<ListFilterInputTypeOfSalesAgreementLocationFilterInput>;
  secondaryCarrier?: InputMaybe<CarrierFilterInput>;
  secondaryCarrierKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  stateId?: InputMaybe<StringOperationFilterInput>;
  stateKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  stateObj?: InputMaybe<StateFilterInput>;
  tanks?: InputMaybe<ListFilterInputTypeOfTankFilterInput>;
  tasks?: InputMaybe<ListFilterInputTypeOfTaskFilterInput>;
  termContractLocations?: InputMaybe<ListFilterInputTypeOfTermContractLocationFilterInput>;
  userLocationExclusions?: InputMaybe<ListFilterInputTypeOfUserLocationExclusionFilterInput>;
  userLocationPermissions?: InputMaybe<ListFilterInputTypeOfUserLocationPermissionFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type LocationGetAllConnection = {
  __typename?: 'LocationGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Location>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationGetAllEdge = {
  __typename?: 'LocationGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

export type LocationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  agId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  customerKey: Scalars['Int']['input'];
  directMarkups?: InputMaybe<Array<InputMaybe<DirectMarkupInput>>>;
  directions?: InputMaybe<Scalars['String']['input']>;
  federalId?: InputMaybe<Scalars['String']['input']>;
  hasPercCharge: Scalars['Boolean']['input'];
  isAgExempt: Scalars['Boolean']['input'];
  isFobCustomer: Scalars['Boolean']['input'];
  isInternetCustomer: Scalars['Boolean']['input'];
  isTaxExempt: Scalars['Boolean']['input'];
  locationContacts?: InputMaybe<Array<InputMaybe<LocationContactInput>>>;
  locationNotes?: InputMaybe<Scalars['String']['input']>;
  locationStatus: LocationStatus;
  locationTags?: InputMaybe<Array<InputMaybe<LocationTagInput>>>;
  locationTerminals?: InputMaybe<Array<InputMaybe<LocationTerminalInput>>>;
  lockMarkup: Scalars['Boolean']['input'];
  mailToAddress1?: InputMaybe<Scalars['String']['input']>;
  mailToAddress2?: InputMaybe<Scalars['String']['input']>;
  mailToCity?: InputMaybe<Scalars['String']['input']>;
  mailToDirections?: InputMaybe<Scalars['String']['input']>;
  mailToSameAsCustomer: Scalars['Boolean']['input'];
  mailToState?: InputMaybe<Scalars['String']['input']>;
  mailToZipCode?: InputMaybe<Scalars['String']['input']>;
  markupCost: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  percentOfSales?: InputMaybe<Scalars['Int']['input']>;
  primaryCarrier?: InputMaybe<CarrierInput>;
  primaryCarrierKey?: InputMaybe<Scalars['Int']['input']>;
  quickBooksName?: InputMaybe<Scalars['String']['input']>;
  salesAgreementLocations?: InputMaybe<Array<InputMaybe<SalesAgreementLocationInput>>>;
  secondaryCarrier?: InputMaybe<CarrierInput>;
  secondaryCarrierKey?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  stateKey: Scalars['Int']['input'];
  stateObj?: InputMaybe<StateInput>;
  tanks?: InputMaybe<Array<InputMaybe<TankInput>>>;
  tasks?: InputMaybe<Array<InputMaybe<TaskInput>>>;
  termContractLocations?: InputMaybe<Array<InputMaybe<TermContractLocationInput>>>;
  userLocationExclusions?: InputMaybe<Array<InputMaybe<UserLocationExclusionInput>>>;
  userLocationPermissions?: InputMaybe<Array<InputMaybe<UserLocationPermissionInput>>>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  agId?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerKey?: InputMaybe<SortEnumType>;
  directions?: InputMaybe<SortEnumType>;
  federalId?: InputMaybe<SortEnumType>;
  hasPercCharge?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isAgExempt?: InputMaybe<SortEnumType>;
  isFobCustomer?: InputMaybe<SortEnumType>;
  isInternetCustomer?: InputMaybe<SortEnumType>;
  isTaxExempt?: InputMaybe<SortEnumType>;
  locationKey?: InputMaybe<SortEnumType>;
  locationNotes?: InputMaybe<SortEnumType>;
  locationStatus?: InputMaybe<SortEnumType>;
  lockMarkup?: InputMaybe<SortEnumType>;
  mailToAddress1?: InputMaybe<SortEnumType>;
  mailToAddress2?: InputMaybe<SortEnumType>;
  mailToCity?: InputMaybe<SortEnumType>;
  mailToDirections?: InputMaybe<SortEnumType>;
  mailToSameAsCustomer?: InputMaybe<SortEnumType>;
  mailToState?: InputMaybe<SortEnumType>;
  mailToZipCode?: InputMaybe<SortEnumType>;
  markupCost?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  percentOfSales?: InputMaybe<SortEnumType>;
  primaryCarrier?: InputMaybe<CarrierSortInput>;
  primaryCarrierKey?: InputMaybe<SortEnumType>;
  quickBooksName?: InputMaybe<SortEnumType>;
  secondaryCarrier?: InputMaybe<CarrierSortInput>;
  secondaryCarrierKey?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  stateId?: InputMaybe<SortEnumType>;
  stateKey?: InputMaybe<SortEnumType>;
  stateObj?: InputMaybe<StateSortInput>;
  zipCode?: InputMaybe<SortEnumType>;
};

export enum LocationStatus {
  Active = 'ACTIVE',
  ApprovedCredit = 'APPROVED_CREDIT',
  CreditRequired = 'CREDIT_REQUIRED',
  Inactive = 'INACTIVE',
  NoSale = 'NO_SALE'
}

export type LocationStatusOperationFilterInput = {
  eq?: InputMaybe<LocationStatus>;
  in?: InputMaybe<Array<LocationStatus>>;
  neq?: InputMaybe<LocationStatus>;
  nin?: InputMaybe<Array<LocationStatus>>;
};

export type LocationTag = {
  __typename?: 'LocationTag';
  location?: Maybe<Location>;
  locationKey: Scalars['Int']['output'];
  tag?: Maybe<Tag>;
  tagKey: Scalars['Int']['output'];
};

export type LocationTagFilterInput = {
  and?: InputMaybe<Array<LocationTagFilterInput>>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<LocationTagFilterInput>>;
  tag?: InputMaybe<TagFilterInput>;
  tagKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type LocationTagInput = {
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  tag?: InputMaybe<TagInput>;
  tagKey: Scalars['Int']['input'];
};

export type LocationTerminal = {
  __typename?: 'LocationTerminal';
  billingFreight?: Maybe<Scalars['Int']['output']>;
  freight?: Maybe<Scalars['Int']['output']>;
  location: Location;
  locationKey: Scalars['Int']['output'];
  mileage: Scalars['Int']['output'];
  terminal: Terminal;
  terminalKey: Scalars['Int']['output'];
};

export type LocationTerminalFilterInput = {
  and?: InputMaybe<Array<LocationTerminalFilterInput>>;
  billingFreight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  freight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  mileage?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<LocationTerminalFilterInput>>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type LocationTerminalInput = {
  billingFreight?: InputMaybe<Scalars['Int']['input']>;
  freight?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  mileage: Scalars['Int']['input'];
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
};

export type LocationTerminalSortInput = {
  billingFreight?: InputMaybe<SortEnumType>;
  freight?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationKey?: InputMaybe<SortEnumType>;
  mileage?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export type MonthlyCvReport = {
  __typename?: 'MonthlyCVReport';
  contractVolumeKey: Scalars['Int']['output'];
  contractVolumeType?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  gallonsLifted: Scalars['Int']['output'];
  loadsBusDay?: Maybe<Scalars['String']['output']>;
  loadsLifted: Scalars['Int']['output'];
  monthlyVolume: Scalars['Int']['output'];
  remainingLoads: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  terminalName?: Maybe<Scalars['String']['output']>;
  totalLoads: Scalars['Float']['output'];
};

export type MonthlyCvReportFilterInput = {
  and?: InputMaybe<Array<MonthlyCvReportFilterInput>>;
  contractVolumeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  contractVolumeType?: InputMaybe<StringOperationFilterInput>;
  fileNumber?: InputMaybe<StringOperationFilterInput>;
  gallonsLifted?: InputMaybe<ComparableInt32OperationFilterInput>;
  loadsBusDay?: InputMaybe<StringOperationFilterInput>;
  loadsLifted?: InputMaybe<ComparableInt32OperationFilterInput>;
  monthlyVolume?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MonthlyCvReportFilterInput>>;
  remainingLoads?: InputMaybe<ComparableDoubleOperationFilterInput>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  supplierName?: InputMaybe<StringOperationFilterInput>;
  terminalName?: InputMaybe<StringOperationFilterInput>;
  totalLoads?: InputMaybe<ComparableDoubleOperationFilterInput>;
};

export type MonthlyCvReportSortInput = {
  contractVolumeKey?: InputMaybe<SortEnumType>;
  contractVolumeType?: InputMaybe<SortEnumType>;
  fileNumber?: InputMaybe<SortEnumType>;
  gallonsLifted?: InputMaybe<SortEnumType>;
  loadsBusDay?: InputMaybe<SortEnumType>;
  loadsLifted?: InputMaybe<SortEnumType>;
  monthlyVolume?: InputMaybe<SortEnumType>;
  remainingLoads?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  supplierName?: InputMaybe<SortEnumType>;
  terminalName?: InputMaybe<SortEnumType>;
  totalLoads?: InputMaybe<SortEnumType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addContactToLocation: Scalars['Boolean']['output'];
  basisTypeCreate: BasisType;
  basisTypeDelete: Scalars['Boolean']['output'];
  basisTypePriceBulkUpdate: Scalars['Boolean']['output'];
  basisTypePriceCleanupDuplicates: Scalars['Int']['output'];
  basisTypePriceCreate?: Maybe<BasisTypePrice>;
  basisTypePriceDetectDuplicates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  basisTypeUpdate: BasisType;
  carrierCreate: Carrier;
  carrierDelete: Scalars['Boolean']['output'];
  carrierPointToPointRateCreate: CarrierPointToPointRate;
  carrierPointToPointRateDateSpanCreate: CarrierPointToPointRateDateSpan;
  carrierPointToPointRateDateSpanDelete: Scalars['Boolean']['output'];
  carrierPointToPointRateDateSpanUpdate: CarrierPointToPointRateDateSpan;
  carrierPointToPointRateDelete: Scalars['Boolean']['output'];
  carrierPointToPointRateUpdate: CarrierPointToPointRate;
  carrierRateBandCreate: CarrierRateBand;
  carrierRateBandDelete: Scalars['Boolean']['output'];
  carrierRateBandUpdate: CarrierRateBand;
  carrierRateCreate: CarrierRate;
  carrierRateDelete: Scalars['Boolean']['output'];
  carrierRateUpdate: CarrierRate;
  carrierUpdate: Carrier;
  contactArchive: Scalars['Boolean']['output'];
  contactCreate: Contact;
  contactDelete: Scalars['Boolean']['output'];
  contactUpdate: Contact;
  contractVolumeCreate: ContractVolume;
  contractVolumeDelete: Scalars['Boolean']['output'];
  contractVolumeTerminalCreate: ContractVolumeTerminal;
  contractVolumeTerminalDelete: Scalars['Boolean']['output'];
  contractVolumeUpdate: ContractVolume;
  customerCreate: Customer;
  customerDelete: Scalars['Boolean']['output'];
  customerTagCreate: CustomerTag;
  customerTagDelete: Scalars['Boolean']['output'];
  customerUpdate: Customer;
  defaultContactLocation: Scalars['Boolean']['output'];
  directMarkupCreate: DirectMarkup;
  directMarkupDelete: Scalars['Boolean']['output'];
  directMarkupUpdate: DirectMarkup;
  exportPdfToCarriers: Scalars['Boolean']['output'];
  fileNumberCreate: FileNumber;
  fileNumberDelete: Scalars['Boolean']['output'];
  fileNumberUpdate: FileNumber;
  fuelSurchargeCreate: FuelSurcharge;
  fuelSurchargeDelete: Scalars['Boolean']['output'];
  fuelSurchargeUpdate: FuelSurcharge;
  indexContractCreate: IndexContract;
  indexContractDelete: Scalars['Boolean']['output'];
  indexContractUpdate: IndexContract;
  linkedSalesAgreementCreate: LinkedSalesAgreement;
  linkedSalesAgreementDelete: Scalars['Boolean']['output'];
  locationContactCreate?: Maybe<LocationContact>;
  locationContactDelete: Scalars['Boolean']['output'];
  locationCreate: Location;
  locationDelete: Scalars['Boolean']['output'];
  locationRemoveTerminal: Scalars['Boolean']['output'];
  locationTagCreate: LocationTag;
  locationTagDelete: Scalars['Boolean']['output'];
  locationTerminalCreate: LocationTerminal;
  locationTerminalEdit: LocationTerminal;
  locationUpdate: Location;
  massMarkup: Scalars['Boolean']['output'];
  orderBulkClose: Scalars['Boolean']['output'];
  orderBulkDispatch: Scalars['Boolean']['output'];
  orderClose: Order;
  orderCreate: Order;
  orderDelete: Scalars['Boolean']['output'];
  orderDispatch: Order;
  orderMarkAllCarrierPaid: Scalars['Boolean']['output'];
  orderMarkAllSupplierPaid: Scalars['Boolean']['output'];
  orderMarkCarrierPaid: Scalars['Boolean']['output'];
  orderMarkSupplierPaid: Scalars['Boolean']['output'];
  orderReadyForInvoicing: Scalars['Boolean']['output'];
  orderRedoPricing: Scalars['Boolean']['output'];
  orderSendBackToDispatch: Scalars['Boolean']['output'];
  orderUpdate: Order;
  orderUpdateBolAndGallons: Scalars['Boolean']['output'];
  patCostCreate: PatCost;
  patCostDelete: Scalars['Boolean']['output'];
  postingCreate: Posting;
  postingCreateAndEndActive: Posting;
  postingDelete: Scalars['Boolean']['output'];
  postingPriceBulkCreateOrUpdate: Scalars['Boolean']['output'];
  postingPriceCreateOrUpdate?: Maybe<PostingPrice>;
  postingPriceDelete: Scalars['Boolean']['output'];
  postingReplaceExisting: Posting;
  postingSetArchived: Scalars['Boolean']['output'];
  postingToggleArchived: Scalars['Boolean']['output'];
  postingUpdate: Posting;
  postingValidateBulkUpdate: BulkPostingValidationResult;
  prePurchaseAgreementCreate: PrePurchaseAgreement;
  prePurchaseAgreementDelete: Scalars['Boolean']['output'];
  prePurchaseAgreementSalesAgreementCreate: PrePurchaseAgreementSalesAgreement;
  prePurchaseAgreementSalesAgreementDelete: Scalars['Boolean']['output'];
  prePurchaseAgreementSalesAgreementDeleteByPrePurchase: Scalars['Boolean']['output'];
  prePurchaseAgreementUpdate: PrePurchaseAgreement;
  quickBooksTokenExchange: Scalars['Boolean']['output'];
  salesAgreementCreate: SalesAgreement;
  salesAgreementDelete: Scalars['Boolean']['output'];
  salesAgreementLocationCreate: SalesAgreementLocation;
  salesAgreementLocationDeleteBySalesAgreementKey: Scalars['Boolean']['output'];
  salesAgreementUpdate: SalesAgreement;
  stateTaxCreate: StateTax;
  stateTaxDelete: Scalars['Boolean']['output'];
  stateTaxUpdate: StateTax;
  supplierCreate: Supplier;
  supplierDelete: Scalars['Boolean']['output'];
  supplierUpdate: Supplier;
  swapDealCreate: SwapDeal;
  swapDealDelete: Scalars['Boolean']['output'];
  swapDealSalesAgreementCreate?: Maybe<SwapDealSalesAgreement>;
  swapDealSalesAgreementDelete: Scalars['Boolean']['output'];
  swapDealSalesAgreementDeleteBySwapDeal: Scalars['Boolean']['output'];
  swapDealUpdate: SwapDeal;
  tagCreate: Tag;
  tagDelete: Scalars['Boolean']['output'];
  tankCreate: Tank;
  tankDelete: Scalars['Boolean']['output'];
  taskCreate?: Maybe<Task>;
  taskCreateFuture?: Maybe<Task>;
  taskDelete: Scalars['Boolean']['output'];
  taskUpdate: Task;
  termContractCreate: TermContract;
  termContractDelete: Scalars['Boolean']['output'];
  termContractLocationCreate: TermContractLocation;
  termContractLocationDelete: Scalars['Boolean']['output'];
  termContractPrePurchaseAgreementCreate: TermContractPrePurchaseAgreement;
  termContractPrePurchaseAgreementDelete: Scalars['Boolean']['output'];
  termContractSalesAgreementCreate: TermContractSalesAgreement;
  termContractSalesAgreementDelete: Scalars['Boolean']['output'];
  termContractSupplierCreate: TermContractSupplier;
  termContractSupplierDelete: Scalars['Boolean']['output'];
  termContractTerminalCreate: TermContractTerminal;
  termContractTerminalDelete: Scalars['Boolean']['output'];
  termContractUpdate: TermContract;
  terminalArchive: Terminal;
  terminalCreate: Terminal;
  terminalDelete: Scalars['Boolean']['output'];
  terminalUpdate: Terminal;
  unlinkContactFromLocation: Scalars['Boolean']['output'];
  userCreate: User;
  userDelete: Scalars['Boolean']['output'];
  userUpdate: User;
};


export type MutationAddContactToLocationArgs = {
  contactKey: Scalars['Int']['input'];
  defaultContact: Scalars['Boolean']['input'];
  locationKey: Scalars['Int']['input'];
};


export type MutationBasisTypeCreateArgs = {
  basisType: BasisTypeInput;
};


export type MutationBasisTypeDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBasisTypePriceBulkUpdateArgs = {
  prices?: InputMaybe<Array<InputMaybe<BasisTypePriceInput>>>;
};


export type MutationBasisTypePriceCreateArgs = {
  basisTypePrice: BasisTypePriceInput;
};


export type MutationBasisTypeUpdateArgs = {
  basisType: BasisTypeInput;
  id: Scalars['Int']['input'];
};


export type MutationCarrierCreateArgs = {
  carrier: CarrierInput;
};


export type MutationCarrierDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCarrierPointToPointRateCreateArgs = {
  carrierPointToPointRate: CarrierPointToPointRateInput;
};


export type MutationCarrierPointToPointRateDateSpanCreateArgs = {
  carrierPointToPointRateDateSpan: CarrierPointToPointRateDateSpanInput;
  copyActiveRates?: InputMaybe<Scalars['Boolean']['input']>;
  percentMultiplier: Scalars['Float']['input'];
};


export type MutationCarrierPointToPointRateDateSpanDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCarrierPointToPointRateDateSpanUpdateArgs = {
  carrierPointToPointRateDateSpan: CarrierPointToPointRateDateSpanInput;
  id: Scalars['Int']['input'];
};


export type MutationCarrierPointToPointRateDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCarrierPointToPointRateUpdateArgs = {
  carrierPointToPointRate: CarrierPointToPointRateInput;
  id: Scalars['Int']['input'];
};


export type MutationCarrierRateBandCreateArgs = {
  carrierRateBand: CarrierRateBandInput;
};


export type MutationCarrierRateBandDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCarrierRateBandUpdateArgs = {
  carrierRateBand: CarrierRateBandInput;
  id: Scalars['Int']['input'];
};


export type MutationCarrierRateCreateArgs = {
  carrierRate: CarrierRateInput;
};


export type MutationCarrierRateDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCarrierRateUpdateArgs = {
  carrierRate: CarrierRateInput;
  id: Scalars['Int']['input'];
};


export type MutationCarrierUpdateArgs = {
  carrier: CarrierInput;
  id: Scalars['Int']['input'];
};


export type MutationContactArchiveArgs = {
  contactKey: Scalars['Int']['input'];
};


export type MutationContactCreateArgs = {
  contact: ContactInput;
};


export type MutationContactDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationContactUpdateArgs = {
  contact: ContactInput;
  id: Scalars['Int']['input'];
};


export type MutationContractVolumeCreateArgs = {
  contractVolume: ContractVolumeInput;
};


export type MutationContractVolumeDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationContractVolumeTerminalCreateArgs = {
  contractVolumeTerminal: ContractVolumeTerminalInput;
};


export type MutationContractVolumeTerminalDeleteArgs = {
  contractVolumeKey: Scalars['Int']['input'];
};


export type MutationContractVolumeUpdateArgs = {
  contractVolume: ContractVolumeInput;
  id: Scalars['Int']['input'];
};


export type MutationCustomerCreateArgs = {
  customer: CustomerInput;
};


export type MutationCustomerDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCustomerTagCreateArgs = {
  customerTag: CustomerTagInput;
};


export type MutationCustomerTagDeleteArgs = {
  customerKey: Scalars['Int']['input'];
  tagKey: Scalars['Int']['input'];
};


export type MutationCustomerUpdateArgs = {
  customer: CustomerInput;
  id: Scalars['Int']['input'];
};


export type MutationDefaultContactLocationArgs = {
  contactKey: Scalars['Int']['input'];
  def: Scalars['Boolean']['input'];
  locationKey: Scalars['Int']['input'];
};


export type MutationDirectMarkupCreateArgs = {
  directMarkup: DirectMarkupInput;
};


export type MutationDirectMarkupDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDirectMarkupUpdateArgs = {
  directMarkup: DirectMarkupInput;
  directMarkupKey: Scalars['Int']['input'];
};


export type MutationExportPdfToCarriersArgs = {
  id: Scalars['Int']['input'];
};


export type MutationFileNumberCreateArgs = {
  fileNumber: FileNumberInput;
};


export type MutationFileNumberDeleteArgs = {
  fileNumberKey: Scalars['Int']['input'];
};


export type MutationFileNumberUpdateArgs = {
  fileNumber: FileNumberInput;
  fileNumberKey: Scalars['Int']['input'];
};


export type MutationFuelSurchargeCreateArgs = {
  fuelSurcharge: FuelSurchargeInput;
};


export type MutationFuelSurchargeDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationFuelSurchargeUpdateArgs = {
  fuelSurcharge: FuelSurchargeInput;
  id: Scalars['Int']['input'];
};


export type MutationIndexContractCreateArgs = {
  indexContract: IndexContractInput;
};


export type MutationIndexContractDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationIndexContractUpdateArgs = {
  id: Scalars['Int']['input'];
  indexContract: IndexContractInput;
};


export type MutationLinkedSalesAgreementCreateArgs = {
  linkedSalesAgreement: LinkedSalesAgreementInput;
};


export type MutationLinkedSalesAgreementDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLocationContactCreateArgs = {
  locationContact?: InputMaybe<LocationContactInput>;
};


export type MutationLocationContactDeleteArgs = {
  contactKey: Scalars['Int']['input'];
  locationKey: Scalars['Int']['input'];
};


export type MutationLocationCreateArgs = {
  location: LocationInput;
};


export type MutationLocationDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLocationRemoveTerminalArgs = {
  locationKey: Scalars['Int']['input'];
  terminalKey: Scalars['Int']['input'];
};


export type MutationLocationTagCreateArgs = {
  locationTag: LocationTagInput;
};


export type MutationLocationTagDeleteArgs = {
  locationKey: Scalars['Int']['input'];
  tagKey: Scalars['Int']['input'];
};


export type MutationLocationTerminalCreateArgs = {
  locationTerminal: LocationTerminalInput;
};


export type MutationLocationTerminalEditArgs = {
  locationTerminal: LocationTerminalInput;
};


export type MutationLocationUpdateArgs = {
  id: Scalars['Int']['input'];
  location: LocationInput;
};


export type MutationMassMarkupArgs = {
  currentMarkup: Scalars['Float']['input'];
  markupAmount: Scalars['Float']['input'];
};


export type MutationOrderBulkCloseArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  sendToQuickbooks: Scalars['Boolean']['input'];
};


export type MutationOrderBulkDispatchArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOrderCloseArgs = {
  id: Scalars['Int']['input'];
  sendToQuickbooks: Scalars['Boolean']['input'];
};


export type MutationOrderCreateArgs = {
  copy?: InputMaybe<Scalars['Boolean']['input']>;
  order: OrderInput;
};


export type MutationOrderDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOrderDispatchArgs = {
  id: Scalars['Int']['input'];
  sendEmail: Scalars['Boolean']['input'];
};


export type MutationOrderMarkAllCarrierPaidArgs = {
  carrierKey: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
};


export type MutationOrderMarkAllSupplierPaidArgs = {
  date: Scalars['DateTime']['input'];
  supplierKey: Scalars['Int']['input'];
};


export type MutationOrderMarkCarrierPaidArgs = {
  orderKey: Scalars['Int']['input'];
};


export type MutationOrderMarkSupplierPaidArgs = {
  orderKey: Scalars['Int']['input'];
};


export type MutationOrderReadyForInvoicingArgs = {
  orderKey: Scalars['Int']['input'];
};


export type MutationOrderRedoPricingArgs = {
  date: Scalars['DateTime']['input'];
  icKey?: InputMaybe<Scalars['Int']['input']>;
  orderKey: Scalars['Int']['input'];
  postingKey?: InputMaybe<Scalars['Int']['input']>;
  ppaKey?: InputMaybe<Scalars['Int']['input']>;
  saKey?: InputMaybe<Scalars['Int']['input']>;
  termContractKey?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderSendBackToDispatchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOrderUpdateArgs = {
  id: Scalars['Int']['input'];
  order: OrderInput;
};


export type MutationOrderUpdateBolAndGallonsArgs = {
  actualGallons: Scalars['Int']['input'];
  close: Scalars['Boolean']['input'];
  manifest?: InputMaybe<Scalars['String']['input']>;
  orderKey: Scalars['Int']['input'];
};


export type MutationPatCostCreateArgs = {
  patCost: PatCostInput;
};


export type MutationPatCostDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPostingCreateArgs = {
  posting: PostingInput;
};


export type MutationPostingCreateAndEndActiveArgs = {
  posting: PostingInput;
};


export type MutationPostingDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPostingPriceBulkCreateOrUpdateArgs = {
  postingPrices?: InputMaybe<Array<InputMaybe<PostingPriceCreateOrUpdateInput>>>;
};


export type MutationPostingPriceCreateOrUpdateArgs = {
  postingPrice?: InputMaybe<PostingPriceCreateOrUpdateInput>;
};


export type MutationPostingPriceDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPostingReplaceExistingArgs = {
  existingPostingKey: Scalars['Int']['input'];
  posting: PostingInput;
};


export type MutationPostingSetArchivedArgs = {
  isArchived: Scalars['Boolean']['input'];
  postingKey: Scalars['Int']['input'];
};


export type MutationPostingToggleArchivedArgs = {
  postingKey: Scalars['Int']['input'];
};


export type MutationPostingUpdateArgs = {
  id: Scalars['Int']['input'];
  posting: PostingInput;
};


export type MutationPostingValidateBulkUpdateArgs = {
  postings: Array<InputMaybe<PostingInput>>;
};


export type MutationPrePurchaseAgreementCreateArgs = {
  prePurchaseAgreement: PrePurchaseAgreementInput;
};


export type MutationPrePurchaseAgreementDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPrePurchaseAgreementSalesAgreementCreateArgs = {
  prePurchaseAgreementSalesAgreement: PrePurchaseAgreementSalesAgreementInput;
};


export type MutationPrePurchaseAgreementSalesAgreementDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPrePurchaseAgreementSalesAgreementDeleteByPrePurchaseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPrePurchaseAgreementUpdateArgs = {
  id: Scalars['Int']['input'];
  prePurchaseAgreement: PrePurchaseAgreementInput;
};


export type MutationQuickBooksTokenExchangeArgs = {
  authCode?: InputMaybe<Scalars['String']['input']>;
  realmId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSalesAgreementCreateArgs = {
  salesAgreement: SalesAgreementInput;
};


export type MutationSalesAgreementDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSalesAgreementLocationCreateArgs = {
  salesAgreementLocation: SalesAgreementLocationInput;
};


export type MutationSalesAgreementLocationDeleteBySalesAgreementKeyArgs = {
  salesAgreementKey: Scalars['Int']['input'];
};


export type MutationSalesAgreementUpdateArgs = {
  id: Scalars['Int']['input'];
  salesAgreement: SalesAgreementInput;
};


export type MutationStateTaxCreateArgs = {
  stateTax: StateTaxInput;
};


export type MutationStateTaxDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationStateTaxUpdateArgs = {
  stateTax: StateTaxInput;
  stateTaxKey: Scalars['Int']['input'];
};


export type MutationSupplierCreateArgs = {
  supplier: SupplierInput;
};


export type MutationSupplierDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSupplierUpdateArgs = {
  id: Scalars['Int']['input'];
  supplier: SupplierInput;
};


export type MutationSwapDealCreateArgs = {
  swapDeal: SwapDealInput;
};


export type MutationSwapDealDeleteArgs = {
  swapDealKey: Scalars['Int']['input'];
};


export type MutationSwapDealSalesAgreementCreateArgs = {
  swapDealSalesAgreement?: InputMaybe<SwapDealSalesAgreementInput>;
};


export type MutationSwapDealSalesAgreementDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSwapDealSalesAgreementDeleteBySwapDealArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSwapDealUpdateArgs = {
  swapDeal: SwapDealInput;
  swapDealKey: Scalars['Int']['input'];
};


export type MutationTagCreateArgs = {
  tag: TagInput;
};


export type MutationTagDeleteArgs = {
  tagKey: Scalars['Int']['input'];
};


export type MutationTankCreateArgs = {
  tank: TankInput;
};


export type MutationTankDeleteArgs = {
  tankKey: Scalars['Int']['input'];
};


export type MutationTaskCreateArgs = {
  task: TaskInput;
};


export type MutationTaskCreateFutureArgs = {
  task: TaskInput;
};


export type MutationTaskDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationTaskUpdateArgs = {
  task: TaskInput;
  taskKey: Scalars['Int']['input'];
};


export type MutationTermContractCreateArgs = {
  termContract: TermContractInput;
};


export type MutationTermContractDeleteArgs = {
  termContractKey: Scalars['Int']['input'];
};


export type MutationTermContractLocationCreateArgs = {
  termContractLocation: TermContractLocationInput;
};


export type MutationTermContractLocationDeleteArgs = {
  termContractKey: Scalars['Int']['input'];
};


export type MutationTermContractPrePurchaseAgreementCreateArgs = {
  termContractPrePurchaseAgreement: TermContractPrePurchaseAgreementInput;
};


export type MutationTermContractPrePurchaseAgreementDeleteArgs = {
  prePurchaseAgreementKey: Scalars['Int']['input'];
};


export type MutationTermContractSalesAgreementCreateArgs = {
  termContractSalesAgreement: TermContractSalesAgreementInput;
};


export type MutationTermContractSalesAgreementDeleteArgs = {
  salesAgreementKey: Scalars['Int']['input'];
};


export type MutationTermContractSupplierCreateArgs = {
  termContractSupplier: TermContractSupplierInput;
};


export type MutationTermContractSupplierDeleteArgs = {
  termContractKey: Scalars['Int']['input'];
};


export type MutationTermContractTerminalCreateArgs = {
  termContractTerminal: TermContractTerminalInput;
};


export type MutationTermContractTerminalDeleteArgs = {
  termContractKey: Scalars['Int']['input'];
};


export type MutationTermContractUpdateArgs = {
  termContract: TermContractInput;
  termContractKey: Scalars['Int']['input'];
};


export type MutationTerminalArchiveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationTerminalCreateArgs = {
  terminal: TerminalInput;
};


export type MutationTerminalDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationTerminalUpdateArgs = {
  id: Scalars['Int']['input'];
  terminal: TerminalInput;
};


export type MutationUnlinkContactFromLocationArgs = {
  contactKey: Scalars['Int']['input'];
  locationKey: Scalars['Int']['input'];
};


export type MutationUserCreateArgs = {
  carriers?: InputMaybe<Array<Scalars['Int']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  user: UserInput;
};


export type MutationUserDeleteArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserUpdateArgs = {
  carriers?: InputMaybe<Array<Scalars['Int']['input']>>;
  customerExclusions?: InputMaybe<Array<Scalars['Int']['input']>>;
  customers?: InputMaybe<Array<Scalars['Int']['input']>>;
  locationExclusions?: InputMaybe<Array<Scalars['Int']['input']>>;
  locations?: InputMaybe<Array<Scalars['Int']['input']>>;
  newEmail?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['Int']['input']>>;
  user: UserInput;
};

export type Order = {
  __typename?: 'Order';
  actualGallons?: Maybe<Scalars['Int']['output']>;
  assessment: Scalars['Float']['output'];
  carrier?: Maybe<Carrier>;
  carrierKey: Scalars['Int']['output'];
  carrierPaid?: Maybe<Scalars['DateTime']['output']>;
  costDescription?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  customerKey: Scalars['Int']['output'];
  delivered: Scalars['Float']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  deliveryTime?: Maybe<DeliveryTime>;
  deliveryTimeKey?: Maybe<Scalars['Int']['output']>;
  fOB: Scalars['Float']['output'];
  fileNumber?: Maybe<FileNumber>;
  fileNumberKey?: Maybe<Scalars['Int']['output']>;
  freight: Scalars['Float']['output'];
  gallons: Scalars['Int']['output'];
  indexContract?: Maybe<IndexContract>;
  indexContractKey?: Maybe<Scalars['Int']['output']>;
  legacyCostType?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationKey: Scalars['Int']['output'];
  manifest?: Maybe<Scalars['String']['output']>;
  markup: Scalars['Float']['output'];
  miles: Scalars['Int']['output'];
  misc?: Maybe<Scalars['Float']['output']>;
  modifiedByUser?: Maybe<User>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  modifiedDate?: Maybe<Scalars['DateTime']['output']>;
  orderKey: Scalars['Int']['output'];
  orderType: OrderType;
  otherCharge?: Maybe<Scalars['Float']['output']>;
  otherCost?: Maybe<Scalars['Float']['output']>;
  patCost?: Maybe<Scalars['Float']['output']>;
  patCostTotal?: Maybe<Scalars['Float']['output']>;
  perc?: Maybe<Scalars['Float']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  posting?: Maybe<Posting>;
  postingKey?: Maybe<Scalars['Int']['output']>;
  prePurchaseAgreement?: Maybe<PrePurchaseAgreement>;
  prePurchaseAgreementKey?: Maybe<Scalars['Int']['output']>;
  product: Scalars['Float']['output'];
  quotedPrice: Scalars['Boolean']['output'];
  readyForInvoicing: Scalars['Boolean']['output'];
  salesAgreement?: Maybe<SalesAgreement>;
  salesAgreementKey?: Maybe<Scalars['Int']['output']>;
  sglInvoiceNumber?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  spotContract: Scalars['Boolean']['output'];
  stateAssessment?: Maybe<Scalars['Float']['output']>;
  stateTax?: Maybe<Scalars['Float']['output']>;
  status: OrderStatus;
  supplier?: Maybe<Supplier>;
  supplierKey: Scalars['Int']['output'];
  supplierPaid?: Maybe<Scalars['DateTime']['output']>;
  termContract?: Maybe<TermContract>;
  termContractKey?: Maybe<Scalars['Int']['output']>;
  terminal?: Maybe<Terminal>;
  terminalKey: Scalars['Int']['output'];
  tolls: Scalars['Float']['output'];
  tripManifest?: Maybe<Scalars['String']['output']>;
  tripNotes?: Maybe<Scalars['String']['output']>;
  tripNumber?: Maybe<Scalars['String']['output']>;
  tripsActualGallons?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type OrderDashboardConnection = {
  __typename?: 'OrderDashboardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderDashboardEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderDashboardEdge = {
  __typename?: 'OrderDashboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderFilterInput = {
  actualGallons?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<OrderFilterInput>>;
  assessment?: InputMaybe<ComparableDoubleOperationFilterInput>;
  carrier?: InputMaybe<CarrierFilterInput>;
  carrierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  carrierPaid?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  costDescription?: InputMaybe<StringOperationFilterInput>;
  createdByUser?: InputMaybe<UserFilterInput>;
  createdByUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  delivered?: InputMaybe<ComparableDoubleOperationFilterInput>;
  deliveryDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  deliveryTime?: InputMaybe<DeliveryTimeFilterInput>;
  deliveryTimeKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fOB?: InputMaybe<ComparableDoubleOperationFilterInput>;
  fileNumber?: InputMaybe<FileNumberFilterInput>;
  fileNumberKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  freight?: InputMaybe<ComparableDoubleOperationFilterInput>;
  gallons?: InputMaybe<ComparableInt32OperationFilterInput>;
  indexContract?: InputMaybe<IndexContractFilterInput>;
  indexContractKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  legacyCostType?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  manifest?: InputMaybe<StringOperationFilterInput>;
  markup?: InputMaybe<ComparableDoubleOperationFilterInput>;
  miles?: InputMaybe<ComparableInt32OperationFilterInput>;
  misc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  modifiedByUser?: InputMaybe<UserFilterInput>;
  modifiedByUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OrderFilterInput>>;
  orderKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderType?: InputMaybe<OrderTypeOperationFilterInput>;
  otherCharge?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  otherCost?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  patCost?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  patCostTotal?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  perc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  posting?: InputMaybe<PostingFilterInput>;
  postingKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  prePurchaseAgreement?: InputMaybe<PrePurchaseAgreementFilterInput>;
  prePurchaseAgreementKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: InputMaybe<ComparableDoubleOperationFilterInput>;
  quotedPrice?: InputMaybe<BooleanOperationFilterInput>;
  readyForInvoicing?: InputMaybe<BooleanOperationFilterInput>;
  salesAgreement?: InputMaybe<SalesAgreementFilterInput>;
  salesAgreementKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sglInvoiceNumber?: InputMaybe<StringOperationFilterInput>;
  specialInstructions?: InputMaybe<StringOperationFilterInput>;
  spotContract?: InputMaybe<BooleanOperationFilterInput>;
  stateAssessment?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  stateTax?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  status?: InputMaybe<OrderStatusOperationFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  supplierPaid?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  termContract?: InputMaybe<TermContractFilterInput>;
  termContractKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  tolls?: InputMaybe<ComparableDoubleOperationFilterInput>;
  tripManifest?: InputMaybe<StringOperationFilterInput>;
  tripNotes?: InputMaybe<StringOperationFilterInput>;
  tripNumber?: InputMaybe<StringOperationFilterInput>;
  tripsActualGallons?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type OrderGetAllConnection = {
  __typename?: 'OrderGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderGetAllEdge = {
  __typename?: 'OrderGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderInput = {
  actualGallons?: InputMaybe<Scalars['Int']['input']>;
  assessment: Scalars['Float']['input'];
  carrier?: InputMaybe<CarrierInput>;
  carrierKey: Scalars['Int']['input'];
  carrierPaid?: InputMaybe<Scalars['DateTime']['input']>;
  costDescription?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserInput>;
  createdByUserId?: InputMaybe<Scalars['Int']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<CustomerInput>;
  customerKey: Scalars['Int']['input'];
  delivered: Scalars['Float']['input'];
  deliveryDate: Scalars['DateTime']['input'];
  deliveryTime?: InputMaybe<DeliveryTimeInput>;
  deliveryTimeKey?: InputMaybe<Scalars['Int']['input']>;
  fOB: Scalars['Float']['input'];
  fileNumber?: InputMaybe<FileNumberInput>;
  fileNumberKey?: InputMaybe<Scalars['Int']['input']>;
  freight: Scalars['Float']['input'];
  gallons: Scalars['Int']['input'];
  indexContract?: InputMaybe<IndexContractInput>;
  indexContractKey?: InputMaybe<Scalars['Int']['input']>;
  legacyCostType?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  manifest?: InputMaybe<Scalars['String']['input']>;
  markup: Scalars['Float']['input'];
  miles: Scalars['Int']['input'];
  misc?: InputMaybe<Scalars['Float']['input']>;
  modifiedByUser?: InputMaybe<UserInput>;
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  modifiedDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderType: OrderType;
  otherCharge?: InputMaybe<Scalars['Float']['input']>;
  otherCost?: InputMaybe<Scalars['Float']['input']>;
  patCost?: InputMaybe<Scalars['Float']['input']>;
  patCostTotal?: InputMaybe<Scalars['Float']['input']>;
  perc?: InputMaybe<Scalars['Float']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  posting?: InputMaybe<PostingInput>;
  postingKey?: InputMaybe<Scalars['Int']['input']>;
  prePurchaseAgreement?: InputMaybe<PrePurchaseAgreementInput>;
  prePurchaseAgreementKey?: InputMaybe<Scalars['Int']['input']>;
  product: Scalars['Float']['input'];
  quotedPrice: Scalars['Boolean']['input'];
  readyForInvoicing: Scalars['Boolean']['input'];
  salesAgreement?: InputMaybe<SalesAgreementInput>;
  salesAgreementKey?: InputMaybe<Scalars['Int']['input']>;
  sglInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  spotContract: Scalars['Boolean']['input'];
  stateAssessment?: InputMaybe<Scalars['Float']['input']>;
  stateTax?: InputMaybe<Scalars['Float']['input']>;
  status: OrderStatus;
  supplier?: InputMaybe<SupplierInput>;
  supplierKey: Scalars['Int']['input'];
  supplierPaid?: InputMaybe<Scalars['DateTime']['input']>;
  termContract?: InputMaybe<TermContractInput>;
  termContractKey?: InputMaybe<Scalars['Int']['input']>;
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
  tolls: Scalars['Float']['input'];
  tripManifest?: InputMaybe<Scalars['String']['input']>;
  tripNotes?: InputMaybe<Scalars['String']['input']>;
  tripNumber?: InputMaybe<Scalars['String']['input']>;
  tripsActualGallons?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderSortInput = {
  actualGallons?: InputMaybe<SortEnumType>;
  assessment?: InputMaybe<SortEnumType>;
  carrier?: InputMaybe<CarrierSortInput>;
  carrierKey?: InputMaybe<SortEnumType>;
  carrierPaid?: InputMaybe<SortEnumType>;
  costDescription?: InputMaybe<SortEnumType>;
  createdByUser?: InputMaybe<UserSortInput>;
  createdByUserId?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerKey?: InputMaybe<SortEnumType>;
  delivered?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  deliveryTime?: InputMaybe<DeliveryTimeSortInput>;
  deliveryTimeKey?: InputMaybe<SortEnumType>;
  fOB?: InputMaybe<SortEnumType>;
  fileNumber?: InputMaybe<FileNumberSortInput>;
  fileNumberKey?: InputMaybe<SortEnumType>;
  freight?: InputMaybe<SortEnumType>;
  gallons?: InputMaybe<SortEnumType>;
  indexContract?: InputMaybe<IndexContractSortInput>;
  indexContractKey?: InputMaybe<SortEnumType>;
  legacyCostType?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationKey?: InputMaybe<SortEnumType>;
  manifest?: InputMaybe<SortEnumType>;
  markup?: InputMaybe<SortEnumType>;
  miles?: InputMaybe<SortEnumType>;
  misc?: InputMaybe<SortEnumType>;
  modifiedByUser?: InputMaybe<UserSortInput>;
  modifiedByUserId?: InputMaybe<SortEnumType>;
  modifiedDate?: InputMaybe<SortEnumType>;
  orderKey?: InputMaybe<SortEnumType>;
  orderType?: InputMaybe<SortEnumType>;
  otherCharge?: InputMaybe<SortEnumType>;
  otherCost?: InputMaybe<SortEnumType>;
  patCost?: InputMaybe<SortEnumType>;
  patCostTotal?: InputMaybe<SortEnumType>;
  perc?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  posting?: InputMaybe<PostingSortInput>;
  postingKey?: InputMaybe<SortEnumType>;
  prePurchaseAgreement?: InputMaybe<PrePurchaseAgreementSortInput>;
  prePurchaseAgreementKey?: InputMaybe<SortEnumType>;
  product?: InputMaybe<SortEnumType>;
  quotedPrice?: InputMaybe<SortEnumType>;
  readyForInvoicing?: InputMaybe<SortEnumType>;
  salesAgreement?: InputMaybe<SalesAgreementSortInput>;
  salesAgreementKey?: InputMaybe<SortEnumType>;
  sglInvoiceNumber?: InputMaybe<SortEnumType>;
  specialInstructions?: InputMaybe<SortEnumType>;
  spotContract?: InputMaybe<SortEnumType>;
  stateAssessment?: InputMaybe<SortEnumType>;
  stateTax?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierKey?: InputMaybe<SortEnumType>;
  supplierPaid?: InputMaybe<SortEnumType>;
  termContract?: InputMaybe<TermContractSortInput>;
  termContractKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
  tolls?: InputMaybe<SortEnumType>;
  tripManifest?: InputMaybe<SortEnumType>;
  tripNotes?: InputMaybe<SortEnumType>;
  tripNumber?: InputMaybe<SortEnumType>;
  tripsActualGallons?: InputMaybe<SortEnumType>;
};

export enum OrderStatus {
  All = 'ALL',
  Closed = 'CLOSED',
  Dispatched = 'DISPATCHED',
  Open = 'OPEN'
}

export type OrderStatusOperationFilterInput = {
  eq?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  neq?: InputMaybe<OrderStatus>;
  nin?: InputMaybe<Array<OrderStatus>>;
};

export type OrderTripNumberFiller = {
  __typename?: 'OrderTripNumberFiller';
  carrier?: Maybe<Carrier>;
  carrierKey: Scalars['Int']['output'];
  orderTripNumberFillerKey: Scalars['Int']['output'];
  tripNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderTripNumberFillerFilterInput = {
  and?: InputMaybe<Array<OrderTripNumberFillerFilterInput>>;
  carrier?: InputMaybe<CarrierFilterInput>;
  carrierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<OrderTripNumberFillerFilterInput>>;
  orderTripNumberFillerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  tripNumber?: InputMaybe<StringOperationFilterInput>;
};

export type OrderTripNumberFillerInput = {
  carrier?: InputMaybe<CarrierInput>;
  carrierKey: Scalars['Int']['input'];
  orderTripNumberFillerKey: Scalars['Int']['input'];
  tripNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderType {
  IndexContract = 'INDEX_CONTRACT',
  Posting = 'POSTING',
  PrePurchaseAgreement = 'PRE_PURCHASE_AGREEMENT',
  SalesAgreement = 'SALES_AGREEMENT'
}

export type OrderTypeOperationFilterInput = {
  eq?: InputMaybe<OrderType>;
  in?: InputMaybe<Array<OrderType>>;
  neq?: InputMaybe<OrderType>;
  nin?: InputMaybe<Array<OrderType>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PatCost = {
  __typename?: 'PatCost';
  cost: Scalars['Float']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  patCostKey: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PatCostFilterInput = {
  and?: InputMaybe<Array<PatCostFilterInput>>;
  cost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  effectiveDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PatCostFilterInput>>;
  patCostKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
};

export type PatCostInput = {
  cost: Scalars['Float']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PatCostSortInput = {
  cost?: InputMaybe<SortEnumType>;
  effectiveDate?: InputMaybe<SortEnumType>;
  patCostKey?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
};

export type Posting = {
  __typename?: 'Posting';
  archivedDate?: Maybe<Scalars['DateTime']['output']>;
  cost: Scalars['Float']['output'];
  createdDate: Scalars['DateTime']['output'];
  currentPrice?: Maybe<PostingPrice>;
  effectiveDate: Scalars['DateTime']['output'];
  effectiveEndDate: Scalars['DateTime']['output'];
  futurePrice?: Maybe<PostingPrice>;
  /** @deprecated Use IsArchived instead. This will be removed after migration. */
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  postingKey: Scalars['Int']['output'];
  postingPrices?: Maybe<Array<Maybe<PostingPrice>>>;
  supplier: Supplier;
  supplierKey: Scalars['Int']['output'];
  terminal: Terminal;
  terminalKey: Scalars['Int']['output'];
};

export enum PostingConflictResolution {
  CreateWithEndDateAdjustment = 'CREATE_WITH_END_DATE_ADJUSTMENT',
  EditExisting = 'EDIT_EXISTING',
  None = 'NONE',
  ReplaceExisting = 'REPLACE_EXISTING'
}

export type PostingFilterInput = {
  and?: InputMaybe<Array<PostingFilterInput>>;
  archivedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  cost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  createdDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  effectiveDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  effectiveEndDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PostingFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  postingKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  postingPrices?: InputMaybe<ListFilterInputTypeOfPostingPriceFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type PostingGetAllConnection = {
  __typename?: 'PostingGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PostingGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Posting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PostingGetAllEdge = {
  __typename?: 'PostingGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Posting>;
};

export type PostingInput = {
  cost: Scalars['Float']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  effectiveEndDate: Scalars['DateTime']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  postingPrices?: InputMaybe<Array<InputMaybe<PostingPriceInput>>>;
  supplier?: InputMaybe<SupplierInput>;
  supplierKey: Scalars['Int']['input'];
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
};

export type PostingPrice = {
  __typename?: 'PostingPrice';
  cost: Scalars['Float']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  effectiveEndDate: Scalars['DateTime']['output'];
  posting?: Maybe<Posting>;
  postingKey: Scalars['Int']['output'];
  postingPriceKey: Scalars['Int']['output'];
};

export type PostingPriceCreateOrUpdateInput = {
  cost: Scalars['Float']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  effectiveEndDate: Scalars['DateTime']['input'];
  postingKey: Scalars['Int']['input'];
  postingPriceKey?: InputMaybe<Scalars['Int']['input']>;
};

export type PostingPriceFilterInput = {
  and?: InputMaybe<Array<PostingPriceFilterInput>>;
  cost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  effectiveDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  effectiveEndDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PostingPriceFilterInput>>;
  posting?: InputMaybe<PostingFilterInput>;
  postingKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  postingPriceKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type PostingPriceInput = {
  cost: Scalars['Float']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  effectiveEndDate: Scalars['DateTime']['input'];
  posting?: InputMaybe<PostingInput>;
  postingKey: Scalars['Int']['input'];
  postingPriceKey: Scalars['Int']['input'];
};

export type PostingSortInput = {
  archivedDate?: InputMaybe<SortEnumType>;
  cost?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  effectiveDate?: InputMaybe<SortEnumType>;
  effectiveEndDate?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  postingKey?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export type PostingValidationResult = {
  __typename?: 'PostingValidationResult';
  canAutoResolve: Scalars['Boolean']['output'];
  conflictingPostings?: Maybe<Array<Maybe<Posting>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  suggestedResolution: PostingConflictResolution;
  validationType: PostingValidationType;
};

export enum PostingValidationType {
  DateRangeOverlap = 'DATE_RANGE_OVERLAP',
  ExactDuplicate = 'EXACT_DUPLICATE',
  InvalidDateRange = 'INVALID_DATE_RANGE',
  None = 'NONE'
}

export type PrePurchaseAgreement = {
  __typename?: 'PrePurchaseAgreement';
  aprilEstimate: Scalars['Float']['output'];
  aprilPriceIncrement: Scalars['Float']['output'];
  aprilSellBack: Scalars['Float']['output'];
  assessmentCost: Scalars['Float']['output'];
  augustEstimate: Scalars['Float']['output'];
  augustPriceIncrement: Scalars['Float']['output'];
  augustSellBack: Scalars['Float']['output'];
  chargeTariff: Scalars['Boolean']['output'];
  costDescription?: Maybe<Scalars['String']['output']>;
  decemberEstimate: Scalars['Float']['output'];
  decemberPriceIncrement: Scalars['Float']['output'];
  decemberSellBack: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endShipDate: Scalars['DateTime']['output'];
  februaryEstimate: Scalars['Float']['output'];
  februaryPriceIncrement: Scalars['Float']['output'];
  februarySellBack: Scalars['Float']['output'];
  freightCost: Scalars['Float']['output'];
  gallons: Scalars['Float']['output'];
  includeFreight: Scalars['Boolean']['output'];
  includeInTermContractVolume: Scalars['Boolean']['output'];
  januaryEstimate: Scalars['Float']['output'];
  januaryPriceIncrement: Scalars['Float']['output'];
  januarySellBack: Scalars['Float']['output'];
  julyEstimate: Scalars['Float']['output'];
  julyPriceIncrement: Scalars['Float']['output'];
  julySellBack: Scalars['Float']['output'];
  juneEstimate: Scalars['Float']['output'];
  junePriceIncrement: Scalars['Float']['output'];
  juneSellBack: Scalars['Float']['output'];
  marchEstimate: Scalars['Float']['output'];
  marchPriceIncrement: Scalars['Float']['output'];
  marchSellBack: Scalars['Float']['output'];
  mayEstimate: Scalars['Float']['output'];
  mayPriceIncrement: Scalars['Float']['output'];
  maySellBack: Scalars['Float']['output'];
  miscCost: Scalars['Float']['output'];
  novemberEstimate: Scalars['Float']['output'];
  novemberPriceIncrement: Scalars['Float']['output'];
  novemberSellBack: Scalars['Float']['output'];
  octoberEstimate: Scalars['Float']['output'];
  octoberPriceIncrement: Scalars['Float']['output'];
  octoberSellBack: Scalars['Float']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  otherCosts: Scalars['Float']['output'];
  prePaidDollars: Scalars['Float']['output'];
  prePurchaseAgreementKey: Scalars['Int']['output'];
  prePurchaseAgreementSalesAgreements?: Maybe<Array<PrePurchaseAgreementSalesAgreement>>;
  productCost: Scalars['Float']['output'];
  septemberEstimate: Scalars['Float']['output'];
  septemberPriceIncrement: Scalars['Float']['output'];
  septemberSellBack: Scalars['Float']['output'];
  showOnPricing: Scalars['Boolean']['output'];
  startShipDate: Scalars['DateTime']['output'];
  supplier: Supplier;
  supplierAgreement?: Maybe<Scalars['String']['output']>;
  supplierKey: Scalars['Int']['output'];
  termContractPrePurchaseAgreements?: Maybe<Array<TermContractPrePurchaseAgreement>>;
  terminal: Terminal;
  terminalKey: Scalars['Int']['output'];
  toDateGallons: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
};

export type PrePurchaseAgreementFilterInput = {
  and?: InputMaybe<Array<PrePurchaseAgreementFilterInput>>;
  aprilEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  aprilPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  aprilSellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  assessmentCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  augustEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  augustPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  augustSellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  chargeTariff?: InputMaybe<BooleanOperationFilterInput>;
  costDescription?: InputMaybe<StringOperationFilterInput>;
  decemberEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  decemberPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  decemberSellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endShipDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  februaryEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  februaryPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  februarySellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  freightCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  gallons?: InputMaybe<ComparableDoubleOperationFilterInput>;
  includeFreight?: InputMaybe<BooleanOperationFilterInput>;
  includeInTermContractVolume?: InputMaybe<BooleanOperationFilterInput>;
  januaryEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  januaryPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  januarySellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  julyEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  julyPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  julySellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  juneEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  junePriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  juneSellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  marchEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  marchPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  marchSellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  mayEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  mayPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  maySellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  miscCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  novemberEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  novemberPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  novemberSellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  octoberEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  octoberPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  octoberSellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<PrePurchaseAgreementFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  otherCosts?: InputMaybe<ComparableDoubleOperationFilterInput>;
  prePaidDollars?: InputMaybe<ComparableDoubleOperationFilterInput>;
  prePurchaseAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  prePurchaseAgreementSalesAgreements?: InputMaybe<ListFilterInputTypeOfPrePurchaseAgreementSalesAgreementFilterInput>;
  productCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  septemberEstimate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  septemberPriceIncrement?: InputMaybe<ComparableDoubleOperationFilterInput>;
  septemberSellBack?: InputMaybe<ComparableDoubleOperationFilterInput>;
  showOnPricing?: InputMaybe<BooleanOperationFilterInput>;
  startShipDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierAgreement?: InputMaybe<StringOperationFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  termContractPrePurchaseAgreements?: InputMaybe<ListFilterInputTypeOfTermContractPrePurchaseAgreementFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  toDateGallons?: InputMaybe<ComparableDoubleOperationFilterInput>;
  units?: InputMaybe<ComparableDoubleOperationFilterInput>;
};

/** A connection to a list of items. */
export type PrePurchaseAgreementGetAllConnection = {
  __typename?: 'PrePurchaseAgreementGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PrePurchaseAgreementGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PrePurchaseAgreement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PrePurchaseAgreementGetAllEdge = {
  __typename?: 'PrePurchaseAgreementGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PrePurchaseAgreement>;
};

export type PrePurchaseAgreementInput = {
  aprilEstimate: Scalars['Float']['input'];
  aprilPriceIncrement: Scalars['Float']['input'];
  aprilSellBack: Scalars['Float']['input'];
  assessmentCost: Scalars['Float']['input'];
  augustEstimate: Scalars['Float']['input'];
  augustPriceIncrement: Scalars['Float']['input'];
  augustSellBack: Scalars['Float']['input'];
  chargeTariff: Scalars['Boolean']['input'];
  costDescription?: InputMaybe<Scalars['String']['input']>;
  decemberEstimate: Scalars['Float']['input'];
  decemberPriceIncrement: Scalars['Float']['input'];
  decemberSellBack: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endShipDate: Scalars['DateTime']['input'];
  februaryEstimate: Scalars['Float']['input'];
  februaryPriceIncrement: Scalars['Float']['input'];
  februarySellBack: Scalars['Float']['input'];
  freightCost: Scalars['Float']['input'];
  gallons: Scalars['Float']['input'];
  includeFreight: Scalars['Boolean']['input'];
  includeInTermContractVolume: Scalars['Boolean']['input'];
  januaryEstimate: Scalars['Float']['input'];
  januaryPriceIncrement: Scalars['Float']['input'];
  januarySellBack: Scalars['Float']['input'];
  julyEstimate: Scalars['Float']['input'];
  julyPriceIncrement: Scalars['Float']['input'];
  julySellBack: Scalars['Float']['input'];
  juneEstimate: Scalars['Float']['input'];
  junePriceIncrement: Scalars['Float']['input'];
  juneSellBack: Scalars['Float']['input'];
  marchEstimate: Scalars['Float']['input'];
  marchPriceIncrement: Scalars['Float']['input'];
  marchSellBack: Scalars['Float']['input'];
  mayEstimate: Scalars['Float']['input'];
  mayPriceIncrement: Scalars['Float']['input'];
  maySellBack: Scalars['Float']['input'];
  miscCost: Scalars['Float']['input'];
  novemberEstimate: Scalars['Float']['input'];
  novemberPriceIncrement: Scalars['Float']['input'];
  novemberSellBack: Scalars['Float']['input'];
  octoberEstimate: Scalars['Float']['input'];
  octoberPriceIncrement: Scalars['Float']['input'];
  octoberSellBack: Scalars['Float']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  otherCosts: Scalars['Float']['input'];
  prePaidDollars: Scalars['Float']['input'];
  prePurchaseAgreementSalesAgreements?: InputMaybe<Array<InputMaybe<PrePurchaseAgreementSalesAgreementInput>>>;
  productCost: Scalars['Float']['input'];
  septemberEstimate: Scalars['Float']['input'];
  septemberPriceIncrement: Scalars['Float']['input'];
  septemberSellBack: Scalars['Float']['input'];
  showOnPricing: Scalars['Boolean']['input'];
  startShipDate: Scalars['DateTime']['input'];
  supplier?: InputMaybe<SupplierInput>;
  supplierAgreement?: InputMaybe<Scalars['String']['input']>;
  supplierKey: Scalars['Int']['input'];
  termContractPrePurchaseAgreements?: InputMaybe<Array<InputMaybe<TermContractPrePurchaseAgreementInput>>>;
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
  toDateGallons: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
};

export type PrePurchaseAgreementSalesAgreement = {
  __typename?: 'PrePurchaseAgreementSalesAgreement';
  prePurchaseAgreement: PrePurchaseAgreement;
  prePurchaseAgreementKey: Scalars['Int']['output'];
  salesAgreement: SalesAgreement;
  salesAgreementKey: Scalars['Int']['output'];
};

export type PrePurchaseAgreementSalesAgreementFilterInput = {
  and?: InputMaybe<Array<PrePurchaseAgreementSalesAgreementFilterInput>>;
  or?: InputMaybe<Array<PrePurchaseAgreementSalesAgreementFilterInput>>;
  prePurchaseAgreement?: InputMaybe<PrePurchaseAgreementFilterInput>;
  prePurchaseAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  salesAgreement?: InputMaybe<SalesAgreementFilterInput>;
  salesAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type PrePurchaseAgreementSalesAgreementInput = {
  prePurchaseAgreement?: InputMaybe<PrePurchaseAgreementInput>;
  prePurchaseAgreementKey: Scalars['Int']['input'];
  salesAgreement?: InputMaybe<SalesAgreementInput>;
  salesAgreementKey: Scalars['Int']['input'];
};

export type PrePurchaseAgreementSortInput = {
  aprilEstimate?: InputMaybe<SortEnumType>;
  aprilPriceIncrement?: InputMaybe<SortEnumType>;
  aprilSellBack?: InputMaybe<SortEnumType>;
  assessmentCost?: InputMaybe<SortEnumType>;
  augustEstimate?: InputMaybe<SortEnumType>;
  augustPriceIncrement?: InputMaybe<SortEnumType>;
  augustSellBack?: InputMaybe<SortEnumType>;
  chargeTariff?: InputMaybe<SortEnumType>;
  costDescription?: InputMaybe<SortEnumType>;
  decemberEstimate?: InputMaybe<SortEnumType>;
  decemberPriceIncrement?: InputMaybe<SortEnumType>;
  decemberSellBack?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endShipDate?: InputMaybe<SortEnumType>;
  februaryEstimate?: InputMaybe<SortEnumType>;
  februaryPriceIncrement?: InputMaybe<SortEnumType>;
  februarySellBack?: InputMaybe<SortEnumType>;
  freightCost?: InputMaybe<SortEnumType>;
  gallons?: InputMaybe<SortEnumType>;
  includeFreight?: InputMaybe<SortEnumType>;
  includeInTermContractVolume?: InputMaybe<SortEnumType>;
  januaryEstimate?: InputMaybe<SortEnumType>;
  januaryPriceIncrement?: InputMaybe<SortEnumType>;
  januarySellBack?: InputMaybe<SortEnumType>;
  julyEstimate?: InputMaybe<SortEnumType>;
  julyPriceIncrement?: InputMaybe<SortEnumType>;
  julySellBack?: InputMaybe<SortEnumType>;
  juneEstimate?: InputMaybe<SortEnumType>;
  junePriceIncrement?: InputMaybe<SortEnumType>;
  juneSellBack?: InputMaybe<SortEnumType>;
  marchEstimate?: InputMaybe<SortEnumType>;
  marchPriceIncrement?: InputMaybe<SortEnumType>;
  marchSellBack?: InputMaybe<SortEnumType>;
  mayEstimate?: InputMaybe<SortEnumType>;
  mayPriceIncrement?: InputMaybe<SortEnumType>;
  maySellBack?: InputMaybe<SortEnumType>;
  miscCost?: InputMaybe<SortEnumType>;
  novemberEstimate?: InputMaybe<SortEnumType>;
  novemberPriceIncrement?: InputMaybe<SortEnumType>;
  novemberSellBack?: InputMaybe<SortEnumType>;
  octoberEstimate?: InputMaybe<SortEnumType>;
  octoberPriceIncrement?: InputMaybe<SortEnumType>;
  octoberSellBack?: InputMaybe<SortEnumType>;
  otherCosts?: InputMaybe<SortEnumType>;
  prePaidDollars?: InputMaybe<SortEnumType>;
  prePurchaseAgreementKey?: InputMaybe<SortEnumType>;
  productCost?: InputMaybe<SortEnumType>;
  septemberEstimate?: InputMaybe<SortEnumType>;
  septemberPriceIncrement?: InputMaybe<SortEnumType>;
  septemberSellBack?: InputMaybe<SortEnumType>;
  showOnPricing?: InputMaybe<SortEnumType>;
  startShipDate?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierAgreement?: InputMaybe<SortEnumType>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
  toDateGallons?: InputMaybe<SortEnumType>;
  units?: InputMaybe<SortEnumType>;
};

export type Pricing = {
  __typename?: 'Pricing';
  contractVolumeExhausted: Scalars['Boolean']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  fob: Scalars['Float']['output'];
  hasErrors: Scalars['Boolean']['output'];
  locationKey: Scalars['Int']['output'];
  markup: Scalars['Float']['output'];
  mileage: Scalars['Int']['output'];
  patCost: Scalars['Float']['output'];
  perc: Scalars['Float']['output'];
  pricingKey: Scalars['Int']['output'];
  pricingName?: Maybe<Scalars['String']['output']>;
  pricingType: PricingType;
  primaryCarrier?: Maybe<Scalars['String']['output']>;
  primaryCarrierDelivered: Scalars['Float']['output'];
  primaryCarrierKey: Scalars['Int']['output'];
  primaryCarrierRate: Scalars['Float']['output'];
  product: Scalars['Float']['output'];
  queryString?: Maybe<Scalars['String']['output']>;
  secondaryCarrier?: Maybe<Scalars['String']['output']>;
  secondaryCarrierDelivered: Scalars['Float']['output'];
  secondaryCarrierKey?: Maybe<Scalars['Int']['output']>;
  secondaryCarrierRate: Scalars['Float']['output'];
  stateAssessment: Scalars['Float']['output'];
  stateTax: Scalars['Float']['output'];
  supplierKey: Scalars['Int']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  termContractKey?: Maybe<Scalars['Int']['output']>;
  terminalKey: Scalars['Int']['output'];
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type PricingSortInput = {
  contractVolumeExhausted?: InputMaybe<SortEnumType>;
  effectiveDate?: InputMaybe<SortEnumType>;
  fob?: InputMaybe<SortEnumType>;
  hasErrors?: InputMaybe<SortEnumType>;
  locationKey?: InputMaybe<SortEnumType>;
  markup?: InputMaybe<SortEnumType>;
  mileage?: InputMaybe<SortEnumType>;
  patCost?: InputMaybe<SortEnumType>;
  perc?: InputMaybe<SortEnumType>;
  pricingKey?: InputMaybe<SortEnumType>;
  pricingName?: InputMaybe<SortEnumType>;
  pricingType?: InputMaybe<SortEnumType>;
  primaryCarrier?: InputMaybe<SortEnumType>;
  primaryCarrierDelivered?: InputMaybe<SortEnumType>;
  primaryCarrierKey?: InputMaybe<SortEnumType>;
  primaryCarrierRate?: InputMaybe<SortEnumType>;
  product?: InputMaybe<SortEnumType>;
  queryString?: InputMaybe<SortEnumType>;
  secondaryCarrier?: InputMaybe<SortEnumType>;
  secondaryCarrierDelivered?: InputMaybe<SortEnumType>;
  secondaryCarrierKey?: InputMaybe<SortEnumType>;
  secondaryCarrierRate?: InputMaybe<SortEnumType>;
  stateAssessment?: InputMaybe<SortEnumType>;
  stateTax?: InputMaybe<SortEnumType>;
  supplierKey?: InputMaybe<SortEnumType>;
  supplierName?: InputMaybe<SortEnumType>;
  termContractKey?: InputMaybe<SortEnumType>;
  terminalKey?: InputMaybe<SortEnumType>;
  terminalName?: InputMaybe<SortEnumType>;
};

export enum PricingType {
  Ic = 'IC',
  P = 'P',
  Ppa = 'PPA',
  Sa = 'SA'
}

export type Query = {
  __typename?: 'Query';
  basisTypeGetAll: Array<BasisType>;
  basisTypeGetSingle: BasisType;
  basisTypePriceGetAll: Array<BasisTypePrice>;
  carrierGetAll: Array<Carrier>;
  carrierGetSingle: Carrier;
  carrierPointToPointRateDateSpanGetAll: Array<CarrierPointToPointRateDateSpan>;
  carrierPointToPointRateDateSpanGetSingle: CarrierPointToPointRateDateSpan;
  carrierPointToPointRateGetAll: Array<CarrierPointToPointRate>;
  carrierPointToPointRateGetSingle: CarrierPointToPointRate;
  carrierRateBandGetAll: Array<CarrierRateBand>;
  carrierRateBandGetSingle: CarrierRateBand;
  carrierRateGetAll?: Maybe<CarrierRateGetAllConnection>;
  carrierRateGetSingle: CarrierRate;
  carrierSearch?: Maybe<Array<CarrierSearch>>;
  contactGetAll?: Maybe<Array<Maybe<Contact>>>;
  contactGetByLocationKey?: Maybe<Array<Contact>>;
  contactGetSingle: Contact;
  contractVolumeGetAll?: Maybe<ContractVolumeGetAllConnection>;
  contractVolumeGetByIndexContract?: Maybe<ContractVolume>;
  contractVolumeGetSingle: ContractVolume;
  currentUser: User;
  customerGetAll?: Maybe<CustomerGetAllConnection>;
  customerGetSingle: Customer;
  customersWithFilter?: Maybe<CustomersWithFilterConnection>;
  deliveryTimeGetAll?: Maybe<Array<DeliveryTime>>;
  deliveryTimeGetSingle: DeliveryTime;
  directMarkupGetAll: Array<DirectMarkup>;
  directMarkupGetSingle: DirectMarkup;
  dispatchedShippedOrdersReport?: Maybe<Array<DispatchedShippedOrder>>;
  fileNumberGetAll?: Maybe<Array<FileNumber>>;
  fileNumberGetSingle: FileNumber;
  flatContractVolumeGetAll?: Maybe<FlatContractVolumeGetAllConnection>;
  flatDirectMarkupGetAll: Array<FlatDirectMarkup>;
  flatFileNumberGetAll: Array<FlatFileNumber>;
  flatIndexContractGetAll: Array<FlatIndexContract>;
  flatPostingGetAll?: Maybe<FlatPostingGetAllConnection>;
  flatPrePurchaseAgreementGetAll?: Maybe<FlatPrePurchaseAgreementGetAllConnection>;
  flatSalesAgreementGetAll?: Maybe<FlatSalesAgreementGetAllConnection>;
  flatSwapDealGetAll: Array<FlatSwapDeal>;
  freightForOrderGet?: Maybe<FlatCarrierRate>;
  fuelSurchargeGetAll?: Maybe<FuelSurchargeGetAllConnection>;
  fuelSurchargeGetSingle: FuelSurcharge;
  indexContractGetSingle: IndexContract;
  indexContractsGetAll: Array<IndexContract>;
  lifetimeGallons?: Maybe<Array<SumPerMonth>>;
  lifetimeTermContractGallons?: Maybe<Array<SumPerMonth>>;
  linkedSalesAgreementGetAll?: Maybe<Array<LinkedSalesAgreement>>;
  linkedSalesAgreementGetSingle: LinkedSalesAgreement;
  locationGetAll?: Maybe<LocationGetAllConnection>;
  locationGetByCustomer: Array<Location>;
  locationGetSingle: Location;
  locationTerminalGetAll: Array<LocationTerminal>;
  monthlyCVReport?: Maybe<Array<MonthlyCvReport>>;
  orderDashboard?: Maybe<OrderDashboardConnection>;
  orderGetAll?: Maybe<OrderGetAllConnection>;
  orderGetSingle: Order;
  patCostGetAll?: Maybe<Array<PatCost>>;
  patCostGetSingle: PatCost;
  postingGetAll?: Maybe<PostingGetAllConnection>;
  postingGetSingle: Posting;
  postingPriceGetCurrent?: Maybe<PostingPrice>;
  postingPriceGetHistory?: Maybe<Array<Maybe<PostingPrice>>>;
  postingValidateCreate: PostingValidationResult;
  postingsByLocationKey?: Maybe<Array<Maybe<Posting>>>;
  postingsByTerminalKeys?: Maybe<Array<Posting>>;
  postingsGetAllForSupplierMostRecent?: Maybe<Array<Posting>>;
  prePurchaseAgreementBySupplierTerminal?: Maybe<Array<PrePurchaseAgreement>>;
  prePurchaseAgreementGetAll?: Maybe<PrePurchaseAgreementGetAllConnection>;
  prePurchaseAgreementGetSingle?: Maybe<PrePurchaseAgreement>;
  prePurchaseAgreementSalesAgreementGetAll?: Maybe<Array<Maybe<PrePurchaseAgreementSalesAgreement>>>;
  pricingIndexContractGet?: Maybe<Pricing>;
  pricingPostingGet?: Maybe<Pricing>;
  pricingPrePurchaseAgreementGet?: Maybe<Pricing>;
  pricingSalesAgreementGet?: Maybe<Pricing>;
  pricingsGet?: Maybe<Array<Pricing>>;
  quickBooksAuthorizationUrl?: Maybe<Scalars['String']['output']>;
  salesAgreementByLocation?: Maybe<Array<SalesAgreement>>;
  salesAgreementGetAll?: Maybe<SalesAgreementGetAllConnection>;
  salesAgreementGetSingle: SalesAgreement;
  salesAgreementLocationGetAll?: Maybe<Array<SalesAgreementLocation>>;
  stateGetAll?: Maybe<Array<State>>;
  stateGetSingle: State;
  stateTaxGetAll?: Maybe<Array<StateTax>>;
  stateTaxGetForLocationOnDate?: Maybe<Array<StateTax>>;
  stateTaxGetForStateOnDate?: Maybe<Array<StateTax>>;
  stateTaxGetSingle: StateTax;
  supplierGetAll: Array<Supplier>;
  supplierGetSingle: Supplier;
  swapDealGetAll?: Maybe<Array<SwapDeal>>;
  swapDealGetSingle: SwapDeal;
  tagGetAll?: Maybe<Array<Tag>>;
  tagGetSingle: Tag;
  taskGetAll: Array<Task>;
  taskGetCompletedAfterDate?: Maybe<TaskGetCompletedAfterDateConnection>;
  taskGetSingle: Task;
  tasksByDate?: Maybe<Array<TaskReport>>;
  termContractGetAll?: Maybe<TermContractGetAllConnection>;
  termContractGetSingle?: Maybe<TermContract>;
  termContractSearch?: Maybe<Array<TermContract>>;
  terminalGetAll?: Maybe<TerminalGetAllConnection>;
  terminalGetSingle: Terminal;
  terminalSearch?: Maybe<Array<Terminal>>;
  userGetSingle: User;
  usersGetAll?: Maybe<UsersGetAllConnection>;
};


export type QueryBasisTypeGetAllArgs = {
  order?: InputMaybe<Array<BasisTypeSortInput>>;
  where?: InputMaybe<BasisTypeFilterInput>;
};


export type QueryBasisTypeGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBasisTypePriceGetAllArgs = {
  order?: InputMaybe<Array<BasisTypePriceSortInput>>;
  where?: InputMaybe<BasisTypePriceFilterInput>;
};


export type QueryCarrierGetAllArgs = {
  order?: InputMaybe<Array<CarrierSortInput>>;
  where?: InputMaybe<CarrierFilterInput>;
};


export type QueryCarrierGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCarrierPointToPointRateDateSpanGetAllArgs = {
  order?: InputMaybe<Array<CarrierPointToPointRateDateSpanSortInput>>;
  where?: InputMaybe<CarrierPointToPointRateDateSpanFilterInput>;
};


export type QueryCarrierPointToPointRateDateSpanGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCarrierPointToPointRateGetAllArgs = {
  order?: InputMaybe<Array<CarrierPointToPointRateSortInput>>;
  where?: InputMaybe<CarrierPointToPointRateFilterInput>;
};


export type QueryCarrierPointToPointRateGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCarrierRateBandGetAllArgs = {
  order?: InputMaybe<Array<CarrierRateBandSortInput>>;
  where?: InputMaybe<CarrierRateBandFilterInput>;
};


export type QueryCarrierRateBandGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCarrierRateGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CarrierRateSortInput>>;
  where?: InputMaybe<CarrierRateFilterInput>;
};


export type QueryCarrierRateGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCarrierSearchArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Array<CarrierSearchSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactGetAllArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type QueryContactGetByLocationKeyArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  customerKey?: InputMaybe<Scalars['Int']['input']>;
  locationKey?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContactSortInput>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContactFilterInput>;
};


export type QueryContactGetSingleArgs = {
  contactKey: Scalars['Int']['input'];
};


export type QueryContractVolumeGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContractVolumeSortInput>>;
  where?: InputMaybe<ContractVolumeFilterInput>;
};


export type QueryContractVolumeGetByIndexContractArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContractVolumeGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerSortInput>>;
  where?: InputMaybe<CustomerFilterInput>;
};


export type QueryCustomerGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomersWithFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationKey?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerSortInput>>;
  tagKey?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerFilterInput>;
};


export type QueryDeliveryTimeGetAllArgs = {
  order?: InputMaybe<Array<DeliveryTimeSortInput>>;
  where?: InputMaybe<DeliveryTimeFilterInput>;
};


export type QueryDeliveryTimeGetSingleArgs = {
  deliveryTimeKey: Scalars['Int']['input'];
};


export type QueryDirectMarkupGetAllArgs = {
  order?: InputMaybe<Array<DirectMarkupSortInput>>;
  where?: InputMaybe<DirectMarkupFilterInput>;
};


export type QueryDirectMarkupGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDispatchedShippedOrdersReportArgs = {
  endDate: Scalars['DateTime']['input'];
  order?: InputMaybe<Array<DispatchedShippedOrderSortInput>>;
  startDate: Scalars['DateTime']['input'];
  where?: InputMaybe<DispatchedShippedOrderFilterInput>;
};


export type QueryFileNumberGetAllArgs = {
  order?: InputMaybe<Array<FileNumberSortInput>>;
  where?: InputMaybe<FileNumberFilterInput>;
};


export type QueryFileNumberGetSingleArgs = {
  fileNumberKey: Scalars['Int']['input'];
};


export type QueryFlatContractVolumeGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FlatContractVolumeSortInput>>;
  where?: InputMaybe<FlatContractVolumeFilterInput>;
};


export type QueryFlatDirectMarkupGetAllArgs = {
  order?: InputMaybe<Array<FlatDirectMarkupSortInput>>;
  where?: InputMaybe<FlatDirectMarkupFilterInput>;
};


export type QueryFlatFileNumberGetAllArgs = {
  order?: InputMaybe<Array<FlatFileNumberSortInput>>;
  where?: InputMaybe<FlatFileNumberFilterInput>;
};


export type QueryFlatIndexContractGetAllArgs = {
  order?: InputMaybe<Array<FlatIndexContractSortInput>>;
  where?: InputMaybe<FlatIndexContractFilterInput>;
};


export type QueryFlatPostingGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FlatPostingSortInput>>;
  showExpired?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlatPostingFilterInput>;
};


export type QueryFlatPrePurchaseAgreementGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FlatPrePurchaseAgreementSortInput>>;
  where?: InputMaybe<FlatPrePurchaseAgreementFilterInput>;
};


export type QueryFlatSalesAgreementGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FlatSalesAgreementSortInput>>;
  where?: InputMaybe<FlatSalesAgreementFilterInput>;
};


export type QueryFlatSwapDealGetAllArgs = {
  order?: InputMaybe<Array<FlatSwapDealSortInput>>;
  where?: InputMaybe<FlatSwapDealFilterInput>;
};


export type QueryFreightForOrderGetArgs = {
  carrierKey: Scalars['Int']['input'];
  locationKey: Scalars['Int']['input'];
  mileage: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  terminalKey: Scalars['Int']['input'];
};


export type QueryFuelSurchargeGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FuelSurchargeSortInput>>;
  where?: InputMaybe<FuelSurchargeFilterInput>;
};


export type QueryFuelSurchargeGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIndexContractGetSingleArgs = {
  indexContractKey: Scalars['Int']['input'];
};


export type QueryIndexContractsGetAllArgs = {
  order?: InputMaybe<Array<IndexContractSortInput>>;
  where?: InputMaybe<IndexContractFilterInput>;
};


export type QueryLifetimeGallonsArgs = {
  locationKey: Scalars['Int']['input'];
};


export type QueryLifetimeTermContractGallonsArgs = {
  termContractKey: Scalars['Int']['input'];
};


export type QueryLinkedSalesAgreementGetAllArgs = {
  order?: InputMaybe<Array<LinkedSalesAgreementSortInput>>;
  where?: InputMaybe<LinkedSalesAgreementFilterInput>;
};


export type QueryLinkedSalesAgreementGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationSortInput>>;
  where?: InputMaybe<LocationFilterInput>;
};


export type QueryLocationGetByCustomerArgs = {
  customerKey?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<LocationFilterInput>;
};


export type QueryLocationGetSingleArgs = {
  locationKey: Scalars['Int']['input'];
};


export type QueryLocationTerminalGetAllArgs = {
  order?: InputMaybe<Array<LocationTerminalSortInput>>;
  where?: InputMaybe<LocationTerminalFilterInput>;
};


export type QueryMonthlyCvReportArgs = {
  order?: InputMaybe<Array<MonthlyCvReportSortInput>>;
  startDate: Scalars['DateTime']['input'];
  where?: InputMaybe<MonthlyCvReportFilterInput>;
};


export type QueryOrderDashboardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notPaidOrders?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<OrderSortInput>>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  status: OrderStatus;
  supplier?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrderFilterInput>;
};


export type QueryOrderGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderSortInput>>;
  where?: InputMaybe<OrderFilterInput>;
};


export type QueryOrderGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPatCostGetAllArgs = {
  order?: InputMaybe<Array<PatCostSortInput>>;
  where?: InputMaybe<PatCostFilterInput>;
};


export type QueryPatCostGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPostingGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PostingSortInput>>;
  where?: InputMaybe<PostingFilterInput>;
};


export type QueryPostingGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPostingPriceGetCurrentArgs = {
  postingKey: Scalars['Int']['input'];
};


export type QueryPostingPriceGetHistoryArgs = {
  postingKey: Scalars['Int']['input'];
};


export type QueryPostingValidateCreateArgs = {
  effectiveDate: Scalars['DateTime']['input'];
  supplierKey: Scalars['Int']['input'];
  terminalKey: Scalars['Int']['input'];
};


export type QueryPostingsByLocationKeyArgs = {
  locationKey: Scalars['Int']['input'];
};


export type QueryPostingsByTerminalKeysArgs = {
  terminalKeys?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryPostingsGetAllForSupplierMostRecentArgs = {
  supplierKey: Scalars['Int']['input'];
};


export type QueryPrePurchaseAgreementBySupplierTerminalArgs = {
  activeDate?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Array<PrePurchaseAgreementSortInput>>;
  supplierKey?: InputMaybe<Scalars['Int']['input']>;
  terminalKey?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PrePurchaseAgreementFilterInput>;
};


export type QueryPrePurchaseAgreementGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PrePurchaseAgreementSortInput>>;
  where?: InputMaybe<PrePurchaseAgreementFilterInput>;
};


export type QueryPrePurchaseAgreementGetSingleArgs = {
  prePurchaseAgreementKey: Scalars['Int']['input'];
};


export type QueryPricingIndexContractGetArgs = {
  indexContractKey: Scalars['Int']['input'];
  locationKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  salesAgreementKey?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPricingPostingGetArgs = {
  locationKey: Scalars['Int']['input'];
  postingKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  salesAgreementKey?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPricingPrePurchaseAgreementGetArgs = {
  locationKey: Scalars['Int']['input'];
  prePurchaseAgreementKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  salesAgreementKey?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPricingSalesAgreementGetArgs = {
  locationKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  salesAgreementKey: Scalars['Int']['input'];
};


export type QueryPricingsGetArgs = {
  locationKey: Scalars['Int']['input'];
  order?: InputMaybe<Array<PricingSortInput>>;
  pricingDate: Scalars['DateTime']['input'];
};


export type QuerySalesAgreementByLocationArgs = {
  locationKey?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesAgreementSortInput>>;
  where?: InputMaybe<SalesAgreementFilterInput>;
};


export type QuerySalesAgreementGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SalesAgreementSortInput>>;
  where?: InputMaybe<SalesAgreementFilterInput>;
};


export type QuerySalesAgreementGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySalesAgreementLocationGetAllArgs = {
  order?: InputMaybe<Array<SalesAgreementLocationSortInput>>;
  where?: InputMaybe<SalesAgreementLocationFilterInput>;
};


export type QueryStateGetAllArgs = {
  order?: InputMaybe<Array<StateSortInput>>;
  where?: InputMaybe<StateFilterInput>;
};


export type QueryStateGetSingleArgs = {
  stateKey: Scalars['Int']['input'];
};


export type QueryStateTaxGetAllArgs = {
  order?: InputMaybe<Array<StateTaxSortInput>>;
  where?: InputMaybe<StateTaxFilterInput>;
};


export type QueryStateTaxGetForLocationOnDateArgs = {
  date: Scalars['DateTime']['input'];
  locationKey: Scalars['Int']['input'];
};


export type QueryStateTaxGetForStateOnDateArgs = {
  date: Scalars['DateTime']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStateTaxGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySupplierGetAllArgs = {
  order?: InputMaybe<Array<SupplierSortInput>>;
  where?: InputMaybe<SupplierFilterInput>;
};


export type QuerySupplierGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySwapDealGetAllArgs = {
  order?: InputMaybe<Array<SwapDealSortInput>>;
  where?: InputMaybe<SwapDealFilterInput>;
};


export type QuerySwapDealGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTagGetAllArgs = {
  order?: InputMaybe<Array<TagSortInput>>;
  where?: InputMaybe<TagFilterInput>;
};


export type QueryTagGetSingleArgs = {
  tagKey: Scalars['Int']['input'];
};


export type QueryTaskGetAllArgs = {
  order?: InputMaybe<Array<TaskSortInput>>;
  where?: InputMaybe<TaskFilterInput>;
};


export type QueryTaskGetCompletedAfterDateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskSortInput>>;
  where?: InputMaybe<TaskFilterInput>;
};


export type QueryTaskGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTasksByDateArgs = {
  endDate: Scalars['DateTime']['input'];
  order?: InputMaybe<Array<TaskReportSortInput>>;
  startDate: Scalars['DateTime']['input'];
  where?: InputMaybe<TaskReportFilterInput>;
};


export type QueryTermContractGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TermContractSortInput>>;
  where?: InputMaybe<TermContractFilterInput>;
};


export type QueryTermContractGetSingleArgs = {
  termContractKey: Scalars['Int']['input'];
};


export type QueryTermContractSearchArgs = {
  locationKey?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TermContractSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TermContractFilterInput>;
};


export type QueryTerminalGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TerminalSortInput>>;
  where?: InputMaybe<TerminalFilterInput>;
};


export type QueryTerminalGetSingleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTerminalSearchArgs = {
  locationKey?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TerminalSortInput>>;
  where?: InputMaybe<TerminalFilterInput>;
};


export type QueryUserGetSingleArgs = {
  userKey: Scalars['Int']['input'];
};


export type QueryUsersGetAllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  where?: InputMaybe<UserFilterInput>;
};

export type RefreshTokenFilterInput = {
  and?: InputMaybe<Array<RefreshTokenFilterInput>>;
  expirationDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RefreshTokenFilterInput>>;
  refreshTokenKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  token?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SalesAgreement = {
  __typename?: 'SalesAgreement';
  agreementName?: Maybe<Scalars['String']['output']>;
  aprEst: Scalars['Float']['output'];
  aprPI: Scalars['Float']['output'];
  assessment: Scalars['Float']['output'];
  augEst: Scalars['Float']['output'];
  augPI: Scalars['Float']['output'];
  decEst: Scalars['Float']['output'];
  decPI: Scalars['Float']['output'];
  deposit: Scalars['Float']['output'];
  endShipDate: Scalars['DateTime']['output'];
  febEst: Scalars['Float']['output'];
  febPI: Scalars['Float']['output'];
  gallons: Scalars['Int']['output'];
  gallonsToDate: Scalars['Int']['output'];
  janEst: Scalars['Float']['output'];
  janPI: Scalars['Float']['output'];
  julEst: Scalars['Float']['output'];
  julPI: Scalars['Float']['output'];
  junEst: Scalars['Float']['output'];
  junPI: Scalars['Float']['output'];
  loadsToDate: Scalars['Int']['output'];
  marEst: Scalars['Float']['output'];
  marPI: Scalars['Float']['output'];
  mayEst: Scalars['Float']['output'];
  mayPI: Scalars['Float']['output'];
  misc?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  novEst: Scalars['Float']['output'];
  novPI: Scalars['Float']['output'];
  octEst: Scalars['Float']['output'];
  octPI: Scalars['Float']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  prePaid: Scalars['Float']['output'];
  prePurchaseAgreementSalesAgreements?: Maybe<Array<PrePurchaseAgreementSalesAgreement>>;
  quoted?: Maybe<Scalars['Float']['output']>;
  quotedFOB?: Maybe<Scalars['Float']['output']>;
  relatedFromSalesAgreements?: Maybe<Array<LinkedSalesAgreement>>;
  relatedToSalesAgreements?: Maybe<Array<Maybe<LinkedSalesAgreement>>>;
  salesAgreementKey: Scalars['Int']['output'];
  salesAgreementLocations?: Maybe<Array<SalesAgreementLocation>>;
  sepEst: Scalars['Float']['output'];
  sepPI: Scalars['Float']['output'];
  startShipDate: Scalars['DateTime']['output'];
  supplier?: Maybe<Supplier>;
  supplierKey?: Maybe<Scalars['Int']['output']>;
  swapDealSalesAgreements?: Maybe<Array<Maybe<SwapDealSalesAgreement>>>;
  termContractSalesAgreements?: Maybe<Array<TermContractSalesAgreement>>;
  terminal?: Maybe<Terminal>;
  terminalKey?: Maybe<Scalars['Int']['output']>;
};

export type SalesAgreementFilterInput = {
  agreementName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SalesAgreementFilterInput>>;
  aprEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  aprPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  assessment?: InputMaybe<ComparableDoubleOperationFilterInput>;
  augEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  augPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  decEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  decPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  deposit?: InputMaybe<ComparableDoubleOperationFilterInput>;
  endShipDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  febEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  febPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  gallons?: InputMaybe<ComparableInt32OperationFilterInput>;
  gallonsToDate?: InputMaybe<ComparableInt32OperationFilterInput>;
  janEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  janPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  julEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  julPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  junEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  junPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  loadsToDate?: InputMaybe<ComparableInt32OperationFilterInput>;
  marEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  marPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  mayEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  mayPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  misc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  novEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  novPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  octEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  octPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<SalesAgreementFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  prePaid?: InputMaybe<ComparableDoubleOperationFilterInput>;
  prePurchaseAgreementSalesAgreements?: InputMaybe<ListFilterInputTypeOfPrePurchaseAgreementSalesAgreementFilterInput>;
  quoted?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  quotedFOB?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  relatedFromSalesAgreements?: InputMaybe<ListFilterInputTypeOfLinkedSalesAgreementFilterInput>;
  relatedToSalesAgreements?: InputMaybe<ListFilterInputTypeOfLinkedSalesAgreementFilterInput>;
  salesAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  salesAgreementLocations?: InputMaybe<ListFilterInputTypeOfSalesAgreementLocationFilterInput>;
  sepEst?: InputMaybe<ComparableDoubleOperationFilterInput>;
  sepPI?: InputMaybe<ComparableDoubleOperationFilterInput>;
  startShipDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  swapDealSalesAgreements?: InputMaybe<ListFilterInputTypeOfSwapDealSalesAgreementFilterInput>;
  termContractSalesAgreements?: InputMaybe<ListFilterInputTypeOfTermContractSalesAgreementFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type SalesAgreementGetAllConnection = {
  __typename?: 'SalesAgreementGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SalesAgreementGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<SalesAgreement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SalesAgreementGetAllEdge = {
  __typename?: 'SalesAgreementGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SalesAgreement>;
};

export type SalesAgreementInput = {
  agreementName?: InputMaybe<Scalars['String']['input']>;
  aprEst: Scalars['Float']['input'];
  aprPI: Scalars['Float']['input'];
  assessment: Scalars['Float']['input'];
  augEst: Scalars['Float']['input'];
  augPI: Scalars['Float']['input'];
  decEst: Scalars['Float']['input'];
  decPI: Scalars['Float']['input'];
  deposit: Scalars['Float']['input'];
  endShipDate: Scalars['DateTime']['input'];
  febEst: Scalars['Float']['input'];
  febPI: Scalars['Float']['input'];
  gallons: Scalars['Int']['input'];
  gallonsToDate: Scalars['Int']['input'];
  janEst: Scalars['Float']['input'];
  janPI: Scalars['Float']['input'];
  julEst: Scalars['Float']['input'];
  julPI: Scalars['Float']['input'];
  junEst: Scalars['Float']['input'];
  junPI: Scalars['Float']['input'];
  loadsToDate: Scalars['Int']['input'];
  marEst: Scalars['Float']['input'];
  marPI: Scalars['Float']['input'];
  mayEst: Scalars['Float']['input'];
  mayPI: Scalars['Float']['input'];
  misc?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  novEst: Scalars['Float']['input'];
  novPI: Scalars['Float']['input'];
  octEst: Scalars['Float']['input'];
  octPI: Scalars['Float']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  prePaid: Scalars['Float']['input'];
  prePurchaseAgreementSalesAgreements?: InputMaybe<Array<InputMaybe<PrePurchaseAgreementSalesAgreementInput>>>;
  quoted?: InputMaybe<Scalars['Float']['input']>;
  quotedFOB?: InputMaybe<Scalars['Float']['input']>;
  relatedFromSalesAgreements?: InputMaybe<Array<InputMaybe<LinkedSalesAgreementInput>>>;
  relatedToSalesAgreements?: InputMaybe<Array<InputMaybe<LinkedSalesAgreementInput>>>;
  salesAgreementLocations?: InputMaybe<Array<InputMaybe<SalesAgreementLocationInput>>>;
  sepEst: Scalars['Float']['input'];
  sepPI: Scalars['Float']['input'];
  startShipDate: Scalars['DateTime']['input'];
  supplier?: InputMaybe<SupplierInput>;
  supplierKey?: InputMaybe<Scalars['Int']['input']>;
  swapDealSalesAgreements?: InputMaybe<Array<InputMaybe<SwapDealSalesAgreementInput>>>;
  termContractSalesAgreements?: InputMaybe<Array<InputMaybe<TermContractSalesAgreementInput>>>;
  terminal?: InputMaybe<TerminalInput>;
  terminalKey?: InputMaybe<Scalars['Int']['input']>;
};

export type SalesAgreementLocation = {
  __typename?: 'SalesAgreementLocation';
  location: Location;
  locationKey: Scalars['Int']['output'];
  salesAgreement: SalesAgreement;
  salesAgreementKey: Scalars['Int']['output'];
};

export type SalesAgreementLocationFilterInput = {
  and?: InputMaybe<Array<SalesAgreementLocationFilterInput>>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<SalesAgreementLocationFilterInput>>;
  salesAgreement?: InputMaybe<SalesAgreementFilterInput>;
  salesAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SalesAgreementLocationInput = {
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  salesAgreement?: InputMaybe<SalesAgreementInput>;
  salesAgreementKey: Scalars['Int']['input'];
};

export type SalesAgreementLocationSortInput = {
  location?: InputMaybe<LocationSortInput>;
  locationKey?: InputMaybe<SortEnumType>;
  salesAgreement?: InputMaybe<SalesAgreementSortInput>;
  salesAgreementKey?: InputMaybe<SortEnumType>;
};

export type SalesAgreementSortInput = {
  agreementName?: InputMaybe<SortEnumType>;
  aprEst?: InputMaybe<SortEnumType>;
  aprPI?: InputMaybe<SortEnumType>;
  assessment?: InputMaybe<SortEnumType>;
  augEst?: InputMaybe<SortEnumType>;
  augPI?: InputMaybe<SortEnumType>;
  decEst?: InputMaybe<SortEnumType>;
  decPI?: InputMaybe<SortEnumType>;
  deposit?: InputMaybe<SortEnumType>;
  endShipDate?: InputMaybe<SortEnumType>;
  febEst?: InputMaybe<SortEnumType>;
  febPI?: InputMaybe<SortEnumType>;
  gallons?: InputMaybe<SortEnumType>;
  gallonsToDate?: InputMaybe<SortEnumType>;
  janEst?: InputMaybe<SortEnumType>;
  janPI?: InputMaybe<SortEnumType>;
  julEst?: InputMaybe<SortEnumType>;
  julPI?: InputMaybe<SortEnumType>;
  junEst?: InputMaybe<SortEnumType>;
  junPI?: InputMaybe<SortEnumType>;
  loadsToDate?: InputMaybe<SortEnumType>;
  marEst?: InputMaybe<SortEnumType>;
  marPI?: InputMaybe<SortEnumType>;
  mayEst?: InputMaybe<SortEnumType>;
  mayPI?: InputMaybe<SortEnumType>;
  misc?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  novEst?: InputMaybe<SortEnumType>;
  novPI?: InputMaybe<SortEnumType>;
  octEst?: InputMaybe<SortEnumType>;
  octPI?: InputMaybe<SortEnumType>;
  prePaid?: InputMaybe<SortEnumType>;
  quoted?: InputMaybe<SortEnumType>;
  quotedFOB?: InputMaybe<SortEnumType>;
  salesAgreementKey?: InputMaybe<SortEnumType>;
  sepEst?: InputMaybe<SortEnumType>;
  sepPI?: InputMaybe<SortEnumType>;
  startShipDate?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SupplierSortInput>;
  supplierKey?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalSortInput>;
  terminalKey?: InputMaybe<SortEnumType>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type State = {
  __typename?: 'State';
  cities?: Maybe<Array<Maybe<City>>>;
  locations?: Maybe<Array<Maybe<Location>>>;
  name?: Maybe<Scalars['String']['output']>;
  stateKey: Scalars['Int']['output'];
  stateTaxes?: Maybe<Array<Maybe<StateTax>>>;
  userStatePermissions?: Maybe<Array<Maybe<UserStatePermission>>>;
};

export type StateFilterInput = {
  and?: InputMaybe<Array<StateFilterInput>>;
  cities?: InputMaybe<ListFilterInputTypeOfCityFilterInput>;
  locations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StateFilterInput>>;
  stateKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  stateTaxes?: InputMaybe<ListFilterInputTypeOfStateTaxFilterInput>;
  userStatePermissions?: InputMaybe<ListFilterInputTypeOfUserStatePermissionFilterInput>;
};

export type StateInput = {
  cities?: InputMaybe<Array<InputMaybe<CityInput>>>;
  locations?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  stateKey: Scalars['Int']['input'];
  stateTaxes?: InputMaybe<Array<InputMaybe<StateTaxInput>>>;
  userStatePermissions?: InputMaybe<Array<InputMaybe<UserStatePermissionInput>>>;
};

export type StateSortInput = {
  name?: InputMaybe<SortEnumType>;
  stateKey?: InputMaybe<SortEnumType>;
};

export type StateTax = {
  __typename?: 'StateTax';
  amount: Scalars['Float']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
  state?: Maybe<State>;
  stateKey: Scalars['Int']['output'];
  stateTaxKey: Scalars['Int']['output'];
  stateTaxType: StateTaxType;
};

export type StateTaxFilterInput = {
  amount?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<StateTaxFilterInput>>;
  endDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<StateTaxFilterInput>>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  state?: InputMaybe<StateFilterInput>;
  stateKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  stateTaxKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  stateTaxType?: InputMaybe<StateTaxTypeOperationFilterInput>;
};

export type StateTaxInput = {
  amount: Scalars['Float']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  state?: InputMaybe<StateInput>;
  stateKey: Scalars['Int']['input'];
  stateTaxType: StateTaxType;
};

export type StateTaxSortInput = {
  amount?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  state?: InputMaybe<StateSortInput>;
  stateKey?: InputMaybe<SortEnumType>;
  stateTaxKey?: InputMaybe<SortEnumType>;
  stateTaxType?: InputMaybe<SortEnumType>;
};

export enum StateTaxType {
  Assessment = 'ASSESSMENT',
  Tax = 'TAX'
}

export type StateTaxTypeOperationFilterInput = {
  eq?: InputMaybe<StateTaxType>;
  in?: InputMaybe<Array<StateTaxType>>;
  neq?: InputMaybe<StateTaxType>;
  nin?: InputMaybe<Array<StateTaxType>>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SumPerMonth = {
  __typename?: 'SumPerMonth';
  apr: Scalars['Float']['output'];
  aug: Scalars['Float']['output'];
  dec: Scalars['Float']['output'];
  feb: Scalars['Float']['output'];
  jan: Scalars['Float']['output'];
  jul: Scalars['Float']['output'];
  jun: Scalars['Float']['output'];
  mar: Scalars['Float']['output'];
  may: Scalars['Float']['output'];
  nov: Scalars['Float']['output'];
  oct: Scalars['Float']['output'];
  sep: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type Supplier = {
  __typename?: 'Supplier';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  contractVolumes?: Maybe<Array<Maybe<ContractVolume>>>;
  directMarkups?: Maybe<Array<Maybe<DirectMarkup>>>;
  directions?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fileNumbers?: Maybe<Array<Maybe<FileNumber>>>;
  indexContracts?: Maybe<Array<Maybe<IndexContract>>>;
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  phone?: Maybe<Scalars['String']['output']>;
  postings?: Maybe<Array<Maybe<Posting>>>;
  prePurchaseAgreements?: Maybe<Array<Maybe<PrePurchaseAgreement>>>;
  salesAgreements?: Maybe<Array<Maybe<SalesAgreement>>>;
  state?: Maybe<Scalars['String']['output']>;
  supplierKey: Scalars['Int']['output'];
  termContractSuppliers?: Maybe<Array<Maybe<TermContractSupplier>>>;
  termContracts?: Maybe<Array<Maybe<TermContract>>>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type SupplierFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SupplierFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  contacts?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  contractVolumes?: InputMaybe<ListFilterInputTypeOfContractVolumeFilterInput>;
  directMarkups?: InputMaybe<ListFilterInputTypeOfDirectMarkupFilterInput>;
  directions?: InputMaybe<StringOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  fileNumbers?: InputMaybe<ListFilterInputTypeOfFileNumberFilterInput>;
  indexContracts?: InputMaybe<ListFilterInputTypeOfIndexContractFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupplierFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  postings?: InputMaybe<ListFilterInputTypeOfPostingFilterInput>;
  prePurchaseAgreements?: InputMaybe<ListFilterInputTypeOfPrePurchaseAgreementFilterInput>;
  salesAgreements?: InputMaybe<ListFilterInputTypeOfSalesAgreementFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  termContractSuppliers?: InputMaybe<ListFilterInputTypeOfTermContractSupplierFilterInput>;
  termContracts?: InputMaybe<ListFilterInputTypeOfTermContractFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type SupplierInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<ContactInput>>>;
  contractVolumes?: InputMaybe<Array<InputMaybe<ContractVolumeInput>>>;
  directMarkups?: InputMaybe<Array<InputMaybe<DirectMarkupInput>>>;
  directions?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fileNumbers?: InputMaybe<Array<InputMaybe<FileNumberInput>>>;
  indexContracts?: InputMaybe<Array<InputMaybe<IndexContractInput>>>;
  isArchived: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postings?: InputMaybe<Array<InputMaybe<PostingInput>>>;
  prePurchaseAgreements?: InputMaybe<Array<InputMaybe<PrePurchaseAgreementInput>>>;
  salesAgreements?: InputMaybe<Array<InputMaybe<SalesAgreementInput>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  termContractSuppliers?: InputMaybe<Array<InputMaybe<TermContractSupplierInput>>>;
  termContracts?: InputMaybe<Array<InputMaybe<TermContractInput>>>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  directions?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  supplierKey?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export enum SupplierType {
  Cavern = 'CAVERN',
  GasProcessingPlant = 'GAS_PROCESSING_PLANT',
  Pipeline = 'PIPELINE',
  RailStorage = 'RAIL_STORAGE',
  Refinery = 'REFINERY',
  StorageFacility = 'STORAGE_FACILITY'
}

export type SupplierTypeOperationFilterInput = {
  eq?: InputMaybe<SupplierType>;
  in?: InputMaybe<Array<SupplierType>>;
  neq?: InputMaybe<SupplierType>;
  nin?: InputMaybe<Array<SupplierType>>;
};

export type SwapDeal = {
  __typename?: 'SwapDeal';
  basisType: BasisType;
  basisTypeKey: Scalars['Int']['output'];
  dealNumber: Scalars['Int']['output'];
  effectiveEndDate: Scalars['DateTime']['output'];
  effectiveStartDate: Scalars['DateTime']['output'];
  monthlyVolume: Scalars['Int']['output'];
  sglCost: Scalars['Float']['output'];
  swapDealKey: Scalars['Int']['output'];
  swapDealSalesAgreements?: Maybe<Array<SwapDealSalesAgreement>>;
};

export type SwapDealFilterInput = {
  and?: InputMaybe<Array<SwapDealFilterInput>>;
  basisType?: InputMaybe<BasisTypeFilterInput>;
  basisTypeKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  dealNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  effectiveEndDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  effectiveStartDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  monthlyVolume?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<SwapDealFilterInput>>;
  sglCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  swapDealKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  swapDealSalesAgreements?: InputMaybe<ListFilterInputTypeOfSwapDealSalesAgreementFilterInput>;
};

export type SwapDealInput = {
  basisType?: InputMaybe<BasisTypeInput>;
  basisTypeKey: Scalars['Int']['input'];
  dealNumber: Scalars['Int']['input'];
  effectiveEndDate: Scalars['DateTime']['input'];
  effectiveStartDate: Scalars['DateTime']['input'];
  monthlyVolume: Scalars['Int']['input'];
  sglCost: Scalars['Float']['input'];
  swapDealSalesAgreements?: InputMaybe<Array<InputMaybe<SwapDealSalesAgreementInput>>>;
};

export type SwapDealSalesAgreement = {
  __typename?: 'SwapDealSalesAgreement';
  salesAgreement: SalesAgreement;
  salesAgreementKey: Scalars['Int']['output'];
  swapDeal: SwapDeal;
  swapDealKey: Scalars['Int']['output'];
};

export type SwapDealSalesAgreementFilterInput = {
  and?: InputMaybe<Array<SwapDealSalesAgreementFilterInput>>;
  or?: InputMaybe<Array<SwapDealSalesAgreementFilterInput>>;
  salesAgreement?: InputMaybe<SalesAgreementFilterInput>;
  salesAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  swapDeal?: InputMaybe<SwapDealFilterInput>;
  swapDealKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SwapDealSalesAgreementInput = {
  salesAgreement?: InputMaybe<SalesAgreementInput>;
  salesAgreementKey: Scalars['Int']['input'];
  swapDeal?: InputMaybe<SwapDealInput>;
  swapDealKey: Scalars['Int']['input'];
};

export type SwapDealSortInput = {
  basisType?: InputMaybe<BasisTypeSortInput>;
  basisTypeKey?: InputMaybe<SortEnumType>;
  dealNumber?: InputMaybe<SortEnumType>;
  effectiveEndDate?: InputMaybe<SortEnumType>;
  effectiveStartDate?: InputMaybe<SortEnumType>;
  monthlyVolume?: InputMaybe<SortEnumType>;
  sglCost?: InputMaybe<SortEnumType>;
  swapDealKey?: InputMaybe<SortEnumType>;
};

export type Tag = {
  __typename?: 'Tag';
  customerTag?: Maybe<CustomerTag>;
  customerTags?: Maybe<Array<Maybe<CustomerTag>>>;
  locationTag?: Maybe<LocationTag>;
  locationTags?: Maybe<Array<Maybe<LocationTag>>>;
  name?: Maybe<Scalars['String']['output']>;
  tagKey: Scalars['Int']['output'];
};

export type TagFilterInput = {
  and?: InputMaybe<Array<TagFilterInput>>;
  customerTags?: InputMaybe<ListFilterInputTypeOfCustomerTagFilterInput>;
  locationTags?: InputMaybe<ListFilterInputTypeOfLocationTagFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TagFilterInput>>;
  tagKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TagInput = {
  customerTags?: InputMaybe<Array<InputMaybe<CustomerTagInput>>>;
  locationTags?: InputMaybe<Array<InputMaybe<LocationTagInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TagSortInput = {
  name?: InputMaybe<SortEnumType>;
  tagKey?: InputMaybe<SortEnumType>;
};

export type Tank = {
  __typename?: 'Tank';
  location?: Maybe<Location>;
  locationKey: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  tankKey: Scalars['Int']['output'];
};

export type TankFilterInput = {
  and?: InputMaybe<Array<TankFilterInput>>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TankFilterInput>>;
  size?: InputMaybe<ComparableInt32OperationFilterInput>;
  tankKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TankInput = {
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type Task = {
  __typename?: 'Task';
  callDetails?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  contact: Contact;
  contactKey: Scalars['Int']['output'];
  contactMethod: ContactMethod;
  isComplete: Scalars['Boolean']['output'];
  location: Location;
  locationKey: Scalars['Int']['output'];
  taskDate: Scalars['DateTime']['output'];
  taskKey: Scalars['Int']['output'];
  user: User;
  userKey: Scalars['Int']['output'];
};

export type TaskFilterInput = {
  and?: InputMaybe<Array<TaskFilterInput>>;
  callDetails?: InputMaybe<StringOperationFilterInput>;
  completedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  contactKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  contactMethod?: InputMaybe<ContactMethodOperationFilterInput>;
  isComplete?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TaskFilterInput>>;
  taskDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  taskKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type TaskGetCompletedAfterDateConnection = {
  __typename?: 'TaskGetCompletedAfterDateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TaskGetCompletedAfterDateEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Task>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaskGetCompletedAfterDateEdge = {
  __typename?: 'TaskGetCompletedAfterDateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Task>;
};

export type TaskInput = {
  callDetails?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactKey: Scalars['Int']['input'];
  contactMethod: ContactMethod;
  isComplete: Scalars['Boolean']['input'];
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  taskDate: Scalars['DateTime']['input'];
  userKey: Scalars['Int']['input'];
};

export type TaskReport = {
  __typename?: 'TaskReport';
  completedDate: Scalars['DateTime']['output'];
  contactKey: Scalars['Int']['output'];
  contactMethod?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  customerKey: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationKey: Scalars['Int']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  taskKey: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type TaskReportFilterInput = {
  and?: InputMaybe<Array<TaskReportFilterInput>>;
  completedDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  contactKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  contactMethod?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  customerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  info?: InputMaybe<StringOperationFilterInput>;
  locationCity?: InputMaybe<StringOperationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TaskReportFilterInput>>;
  taskKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type TaskReportSortInput = {
  completedDate?: InputMaybe<SortEnumType>;
  contactKey?: InputMaybe<SortEnumType>;
  contactMethod?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  customerKey?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  info?: InputMaybe<SortEnumType>;
  locationCity?: InputMaybe<SortEnumType>;
  locationKey?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  taskKey?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

export type TaskSortInput = {
  callDetails?: InputMaybe<SortEnumType>;
  completedDate?: InputMaybe<SortEnumType>;
  contact?: InputMaybe<ContactSortInput>;
  contactKey?: InputMaybe<SortEnumType>;
  contactMethod?: InputMaybe<SortEnumType>;
  isComplete?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationKey?: InputMaybe<SortEnumType>;
  taskDate?: InputMaybe<SortEnumType>;
  taskKey?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userKey?: InputMaybe<SortEnumType>;
};

export type TermContract = {
  __typename?: 'TermContract';
  april: Scalars['Float']['output'];
  august: Scalars['Float']['output'];
  december: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  february: Scalars['Float']['output'];
  indexContracts: Scalars['Boolean']['output'];
  january: Scalars['Float']['output'];
  july: Scalars['Float']['output'];
  june: Scalars['Float']['output'];
  march: Scalars['Float']['output'];
  may: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  november: Scalars['Float']['output'];
  october: Scalars['Float']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  posts: Scalars['Boolean']['output'];
  prePurchaseAgreements: Scalars['Boolean']['output'];
  september: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  termContractKey: Scalars['Int']['output'];
  termContractLocations?: Maybe<Array<Maybe<TermContractLocation>>>;
  termContractPrePurchaseAgreements?: Maybe<Array<Maybe<TermContractPrePurchaseAgreement>>>;
  termContractSalesAgreements?: Maybe<Array<Maybe<TermContractSalesAgreement>>>;
  termContractSuppliers?: Maybe<Array<Maybe<TermContractSupplier>>>;
  termContractTerminals?: Maybe<Array<Maybe<TermContractTerminal>>>;
};

export type TermContractFilterInput = {
  and?: InputMaybe<Array<TermContractFilterInput>>;
  april?: InputMaybe<ComparableDoubleOperationFilterInput>;
  august?: InputMaybe<ComparableDoubleOperationFilterInput>;
  december?: InputMaybe<ComparableDoubleOperationFilterInput>;
  endDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  february?: InputMaybe<ComparableDoubleOperationFilterInput>;
  indexContracts?: InputMaybe<BooleanOperationFilterInput>;
  january?: InputMaybe<ComparableDoubleOperationFilterInput>;
  july?: InputMaybe<ComparableDoubleOperationFilterInput>;
  june?: InputMaybe<ComparableDoubleOperationFilterInput>;
  march?: InputMaybe<ComparableDoubleOperationFilterInput>;
  may?: InputMaybe<ComparableDoubleOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  november?: InputMaybe<ComparableDoubleOperationFilterInput>;
  october?: InputMaybe<ComparableDoubleOperationFilterInput>;
  or?: InputMaybe<Array<TermContractFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  posts?: InputMaybe<BooleanOperationFilterInput>;
  prePurchaseAgreements?: InputMaybe<BooleanOperationFilterInput>;
  september?: InputMaybe<ComparableDoubleOperationFilterInput>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  termContractKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  termContractLocations?: InputMaybe<ListFilterInputTypeOfTermContractLocationFilterInput>;
  termContractPrePurchaseAgreements?: InputMaybe<ListFilterInputTypeOfTermContractPrePurchaseAgreementFilterInput>;
  termContractSalesAgreements?: InputMaybe<ListFilterInputTypeOfTermContractSalesAgreementFilterInput>;
  termContractSuppliers?: InputMaybe<ListFilterInputTypeOfTermContractSupplierFilterInput>;
  termContractTerminals?: InputMaybe<ListFilterInputTypeOfTermContractTerminalFilterInput>;
};

/** A connection to a list of items. */
export type TermContractGetAllConnection = {
  __typename?: 'TermContractGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TermContractGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TermContract>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TermContractGetAllEdge = {
  __typename?: 'TermContractGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TermContract>;
};

export type TermContractInput = {
  april: Scalars['Float']['input'];
  august: Scalars['Float']['input'];
  december: Scalars['Float']['input'];
  endDate: Scalars['DateTime']['input'];
  february: Scalars['Float']['input'];
  indexContracts: Scalars['Boolean']['input'];
  january: Scalars['Float']['input'];
  july: Scalars['Float']['input'];
  june: Scalars['Float']['input'];
  march: Scalars['Float']['input'];
  may: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  november: Scalars['Float']['input'];
  october: Scalars['Float']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  posts: Scalars['Boolean']['input'];
  prePurchaseAgreements: Scalars['Boolean']['input'];
  september: Scalars['Float']['input'];
  startDate: Scalars['DateTime']['input'];
  termContractLocations?: InputMaybe<Array<InputMaybe<TermContractLocationInput>>>;
  termContractPrePurchaseAgreements?: InputMaybe<Array<InputMaybe<TermContractPrePurchaseAgreementInput>>>;
  termContractSalesAgreements?: InputMaybe<Array<InputMaybe<TermContractSalesAgreementInput>>>;
  termContractSuppliers?: InputMaybe<Array<InputMaybe<TermContractSupplierInput>>>;
  termContractTerminals?: InputMaybe<Array<InputMaybe<TermContractTerminalInput>>>;
};

export type TermContractLocation = {
  __typename?: 'TermContractLocation';
  location?: Maybe<Location>;
  locationKey: Scalars['Int']['output'];
  termContract?: Maybe<TermContract>;
  termContractKey: Scalars['Int']['output'];
};

export type TermContractLocationFilterInput = {
  and?: InputMaybe<Array<TermContractLocationFilterInput>>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TermContractLocationFilterInput>>;
  termContract?: InputMaybe<TermContractFilterInput>;
  termContractKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TermContractLocationInput = {
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  termContract?: InputMaybe<TermContractInput>;
  termContractKey: Scalars['Int']['input'];
};

export type TermContractPrePurchaseAgreement = {
  __typename?: 'TermContractPrePurchaseAgreement';
  prePurchaseAgreement?: Maybe<PrePurchaseAgreement>;
  prePurchaseAgreementKey: Scalars['Int']['output'];
  termContract?: Maybe<TermContract>;
  termContractKey: Scalars['Int']['output'];
};

export type TermContractPrePurchaseAgreementFilterInput = {
  and?: InputMaybe<Array<TermContractPrePurchaseAgreementFilterInput>>;
  or?: InputMaybe<Array<TermContractPrePurchaseAgreementFilterInput>>;
  prePurchaseAgreement?: InputMaybe<PrePurchaseAgreementFilterInput>;
  prePurchaseAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  termContract?: InputMaybe<TermContractFilterInput>;
  termContractKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TermContractPrePurchaseAgreementInput = {
  prePurchaseAgreement?: InputMaybe<PrePurchaseAgreementInput>;
  prePurchaseAgreementKey: Scalars['Int']['input'];
  termContract?: InputMaybe<TermContractInput>;
  termContractKey: Scalars['Int']['input'];
};

export type TermContractSalesAgreement = {
  __typename?: 'TermContractSalesAgreement';
  salesAgreement?: Maybe<SalesAgreement>;
  salesAgreementKey: Scalars['Int']['output'];
  termContract?: Maybe<TermContract>;
  termContractKey: Scalars['Int']['output'];
};

export type TermContractSalesAgreementFilterInput = {
  and?: InputMaybe<Array<TermContractSalesAgreementFilterInput>>;
  or?: InputMaybe<Array<TermContractSalesAgreementFilterInput>>;
  salesAgreement?: InputMaybe<SalesAgreementFilterInput>;
  salesAgreementKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  termContract?: InputMaybe<TermContractFilterInput>;
  termContractKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TermContractSalesAgreementInput = {
  salesAgreement?: InputMaybe<SalesAgreementInput>;
  salesAgreementKey: Scalars['Int']['input'];
  termContract?: InputMaybe<TermContractInput>;
  termContractKey: Scalars['Int']['input'];
};

export type TermContractSortInput = {
  april?: InputMaybe<SortEnumType>;
  august?: InputMaybe<SortEnumType>;
  december?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  february?: InputMaybe<SortEnumType>;
  indexContracts?: InputMaybe<SortEnumType>;
  january?: InputMaybe<SortEnumType>;
  july?: InputMaybe<SortEnumType>;
  june?: InputMaybe<SortEnumType>;
  march?: InputMaybe<SortEnumType>;
  may?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  november?: InputMaybe<SortEnumType>;
  october?: InputMaybe<SortEnumType>;
  posts?: InputMaybe<SortEnumType>;
  prePurchaseAgreements?: InputMaybe<SortEnumType>;
  september?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  termContractKey?: InputMaybe<SortEnumType>;
};

export type TermContractSupplier = {
  __typename?: 'TermContractSupplier';
  supplier?: Maybe<Supplier>;
  supplierKey: Scalars['Int']['output'];
  termContract?: Maybe<TermContract>;
  termContractKey: Scalars['Int']['output'];
};

export type TermContractSupplierFilterInput = {
  and?: InputMaybe<Array<TermContractSupplierFilterInput>>;
  or?: InputMaybe<Array<TermContractSupplierFilterInput>>;
  supplier?: InputMaybe<SupplierFilterInput>;
  supplierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  termContract?: InputMaybe<TermContractFilterInput>;
  termContractKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TermContractSupplierInput = {
  supplier?: InputMaybe<SupplierInput>;
  supplierKey: Scalars['Int']['input'];
  termContract?: InputMaybe<TermContractInput>;
  termContractKey: Scalars['Int']['input'];
};

export type TermContractTerminal = {
  __typename?: 'TermContractTerminal';
  termContract?: Maybe<TermContract>;
  termContractKey: Scalars['Int']['output'];
  terminal?: Maybe<Terminal>;
  terminalKey: Scalars['Int']['output'];
};

export type TermContractTerminalFilterInput = {
  and?: InputMaybe<Array<TermContractTerminalFilterInput>>;
  or?: InputMaybe<Array<TermContractTerminalFilterInput>>;
  termContract?: InputMaybe<TermContractFilterInput>;
  termContractKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  terminal?: InputMaybe<TerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TermContractTerminalInput = {
  termContract?: InputMaybe<TermContractInput>;
  termContractKey: Scalars['Int']['input'];
  terminal?: InputMaybe<TerminalInput>;
  terminalKey: Scalars['Int']['input'];
};

export type Terminal = {
  __typename?: 'Terminal';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  contractVolumeTerminals?: Maybe<Array<Maybe<ContractVolumeTerminal>>>;
  directMarkups?: Maybe<Array<Maybe<DirectMarkup>>>;
  directions?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fileNumbers?: Maybe<Array<Maybe<FileNumber>>>;
  indexContracts?: Maybe<Array<Maybe<IndexContract>>>;
  isArchived: Scalars['Boolean']['output'];
  locationTerminals?: Maybe<Array<Maybe<LocationTerminal>>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  phone?: Maybe<Scalars['String']['output']>;
  postings?: Maybe<Array<Maybe<Posting>>>;
  prePurchaseAgreements?: Maybe<Array<Maybe<PrePurchaseAgreement>>>;
  salesAgreements?: Maybe<Array<Maybe<SalesAgreement>>>;
  state?: Maybe<Scalars['String']['output']>;
  termContractTerminals?: Maybe<Array<Maybe<TermContractTerminal>>>;
  terminalKey: Scalars['Int']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type TerminalFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TerminalFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  contacts?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  contractVolumeTerminals?: InputMaybe<ListFilterInputTypeOfContractVolumeTerminalFilterInput>;
  directMarkups?: InputMaybe<ListFilterInputTypeOfDirectMarkupFilterInput>;
  directions?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  fileNumbers?: InputMaybe<ListFilterInputTypeOfFileNumberFilterInput>;
  indexContracts?: InputMaybe<ListFilterInputTypeOfIndexContractFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  locationTerminals?: InputMaybe<ListFilterInputTypeOfLocationTerminalFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TerminalFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  postings?: InputMaybe<ListFilterInputTypeOfPostingFilterInput>;
  prePurchaseAgreements?: InputMaybe<ListFilterInputTypeOfPrePurchaseAgreementFilterInput>;
  salesAgreements?: InputMaybe<ListFilterInputTypeOfSalesAgreementFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  termContractTerminals?: InputMaybe<ListFilterInputTypeOfTermContractTerminalFilterInput>;
  terminalKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type TerminalGetAllConnection = {
  __typename?: 'TerminalGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TerminalGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Terminal>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TerminalGetAllEdge = {
  __typename?: 'TerminalGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Terminal>;
};

export type TerminalInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<ContactInput>>>;
  contractVolumeTerminals?: InputMaybe<Array<InputMaybe<ContractVolumeTerminalInput>>>;
  directMarkups?: InputMaybe<Array<InputMaybe<DirectMarkupInput>>>;
  directions?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fileNumbers?: InputMaybe<Array<InputMaybe<FileNumberInput>>>;
  indexContracts?: InputMaybe<Array<InputMaybe<IndexContractInput>>>;
  isArchived: Scalars['Boolean']['input'];
  locationTerminals?: InputMaybe<Array<InputMaybe<LocationTerminalInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postings?: InputMaybe<Array<InputMaybe<PostingInput>>>;
  prePurchaseAgreements?: InputMaybe<Array<InputMaybe<PrePurchaseAgreementInput>>>;
  salesAgreements?: InputMaybe<Array<InputMaybe<SalesAgreementInput>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  termContractTerminals?: InputMaybe<Array<InputMaybe<TermContractTerminalInput>>>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TerminalSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  directions?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  terminalKey?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  hasCustomerPermission: Scalars['Boolean']['output'];
  hasFullAccess: Scalars['Boolean']['output'];
  hasLocationPermission: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAdminUser: Scalars['Boolean']['output'];
  isGasPointUser: Scalars['Boolean']['output'];
  locations?: Maybe<Array<Maybe<Location>>>;
  lockoutEnabled: Scalars['Boolean']['output'];
  lockoutEnd?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferPrefixSearch: Scalars['Boolean']['output'];
  tasks?: Maybe<Array<Maybe<Task>>>;
  userCarriers?: Maybe<Array<Maybe<UserCarrier>>>;
  userCustomerExclusions?: Maybe<Array<Maybe<UserCustomerExclusion>>>;
  userCustomerPermissions?: Maybe<Array<Maybe<UserCustomerPermission>>>;
  userLocationExclusions?: Maybe<Array<Maybe<UserLocationExclusion>>>;
  userLocationPermissions?: Maybe<Array<Maybe<UserLocationPermission>>>;
  userName?: Maybe<Scalars['String']['output']>;
  userStatePermissions?: Maybe<Array<Maybe<UserStatePermission>>>;
};


export type UserHasCustomerPermissionArgs = {
  customerKey: Scalars['Int']['input'];
};


export type UserHasLocationPermissionArgs = {
  locationKey: Scalars['Int']['input'];
};

export type UserCarrier = {
  __typename?: 'UserCarrier';
  carrier: Carrier;
  carrierKey: Scalars['Int']['output'];
  user: User;
  userKey: Scalars['Int']['output'];
};

export type UserCarrierFilterInput = {
  and?: InputMaybe<Array<UserCarrierFilterInput>>;
  carrier?: InputMaybe<CarrierFilterInput>;
  carrierKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserCarrierFilterInput>>;
  user?: InputMaybe<UserFilterInput>;
  userKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserCarrierInput = {
  carrier?: InputMaybe<CarrierInput>;
  carrierKey: Scalars['Int']['input'];
  user?: InputMaybe<UserInput>;
  userKey: Scalars['Int']['input'];
};

export type UserCustomerExclusion = {
  __typename?: 'UserCustomerExclusion';
  customer: Customer;
  customerKey: Scalars['Int']['output'];
  user: User;
  userKey: Scalars['Int']['output'];
};

export type UserCustomerExclusionFilterInput = {
  and?: InputMaybe<Array<UserCustomerExclusionFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserCustomerExclusionFilterInput>>;
  user?: InputMaybe<UserFilterInput>;
  userKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserCustomerExclusionInput = {
  customer?: InputMaybe<CustomerInput>;
  customerKey: Scalars['Int']['input'];
  user?: InputMaybe<UserInput>;
  userKey: Scalars['Int']['input'];
};

export type UserCustomerPermission = {
  __typename?: 'UserCustomerPermission';
  customer: Customer;
  customerKey: Scalars['Int']['output'];
  user: User;
  userKey: Scalars['Int']['output'];
};

export type UserCustomerPermissionFilterInput = {
  and?: InputMaybe<Array<UserCustomerPermissionFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserCustomerPermissionFilterInput>>;
  user?: InputMaybe<UserFilterInput>;
  userKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserCustomerPermissionInput = {
  customer?: InputMaybe<CustomerInput>;
  customerKey: Scalars['Int']['input'];
  user?: InputMaybe<UserInput>;
  userKey: Scalars['Int']['input'];
};

export type UserFilterInput = {
  accessFailedCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<UserFilterInput>>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  hasFullAccess?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isAdminUser?: InputMaybe<BooleanOperationFilterInput>;
  isGasPointUser?: InputMaybe<BooleanOperationFilterInput>;
  locations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  lockoutEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lockoutEnd?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  normalizedUserName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  passwordHash?: InputMaybe<StringOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  phoneNumberConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  preferPrefixSearch?: InputMaybe<BooleanOperationFilterInput>;
  refreshTokens?: InputMaybe<ListFilterInputTypeOfRefreshTokenFilterInput>;
  securityStamp?: InputMaybe<StringOperationFilterInput>;
  tasks?: InputMaybe<ListFilterInputTypeOfTaskFilterInput>;
  twoFactorEnabled?: InputMaybe<BooleanOperationFilterInput>;
  userCarriers?: InputMaybe<ListFilterInputTypeOfUserCarrierFilterInput>;
  userCustomerExclusions?: InputMaybe<ListFilterInputTypeOfUserCustomerExclusionFilterInput>;
  userCustomerPermissions?: InputMaybe<ListFilterInputTypeOfUserCustomerPermissionFilterInput>;
  userLocationExclusions?: InputMaybe<ListFilterInputTypeOfUserLocationExclusionFilterInput>;
  userLocationPermissions?: InputMaybe<ListFilterInputTypeOfUserLocationPermissionFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
  userStatePermissions?: InputMaybe<ListFilterInputTypeOfUserStatePermissionFilterInput>;
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  hasFullAccess: Scalars['Boolean']['input'];
  isAdminUser: Scalars['Boolean']['input'];
  isGasPointUser: Scalars['Boolean']['input'];
  locations?: InputMaybe<Array<InputMaybe<LocationInput>>>;
  lockoutEnabled: Scalars['Boolean']['input'];
  lockoutEnd?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferPrefixSearch: Scalars['Boolean']['input'];
  tasks?: InputMaybe<Array<InputMaybe<TaskInput>>>;
  userCarriers?: InputMaybe<Array<InputMaybe<UserCarrierInput>>>;
  userCustomerExclusions?: InputMaybe<Array<InputMaybe<UserCustomerExclusionInput>>>;
  userCustomerPermissions?: InputMaybe<Array<InputMaybe<UserCustomerPermissionInput>>>;
  userLocationExclusions?: InputMaybe<Array<InputMaybe<UserLocationExclusionInput>>>;
  userLocationPermissions?: InputMaybe<Array<InputMaybe<UserLocationPermissionInput>>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userStatePermissions?: InputMaybe<Array<InputMaybe<UserStatePermissionInput>>>;
};

export type UserLocationExclusion = {
  __typename?: 'UserLocationExclusion';
  location: Location;
  locationKey: Scalars['Int']['output'];
  user: User;
  userKey: Scalars['Int']['output'];
};

export type UserLocationExclusionFilterInput = {
  and?: InputMaybe<Array<UserLocationExclusionFilterInput>>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserLocationExclusionFilterInput>>;
  user?: InputMaybe<UserFilterInput>;
  userKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserLocationExclusionInput = {
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  user?: InputMaybe<UserInput>;
  userKey: Scalars['Int']['input'];
};

export type UserLocationPermission = {
  __typename?: 'UserLocationPermission';
  location: Location;
  locationKey: Scalars['Int']['output'];
  user: User;
  userKey: Scalars['Int']['output'];
};

export type UserLocationPermissionFilterInput = {
  and?: InputMaybe<Array<UserLocationPermissionFilterInput>>;
  location?: InputMaybe<LocationFilterInput>;
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserLocationPermissionFilterInput>>;
  user?: InputMaybe<UserFilterInput>;
  userKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserLocationPermissionInput = {
  location?: InputMaybe<LocationInput>;
  locationKey: Scalars['Int']['input'];
  user?: InputMaybe<UserInput>;
  userKey: Scalars['Int']['input'];
};

export type UserSortInput = {
  accessFailedCount?: InputMaybe<SortEnumType>;
  concurrencyStamp?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmed?: InputMaybe<SortEnumType>;
  hasFullAccess?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isAdminUser?: InputMaybe<SortEnumType>;
  isGasPointUser?: InputMaybe<SortEnumType>;
  lockoutEnabled?: InputMaybe<SortEnumType>;
  lockoutEnd?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  normalizedUserName?: InputMaybe<SortEnumType>;
  passwordHash?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  phoneNumberConfirmed?: InputMaybe<SortEnumType>;
  preferPrefixSearch?: InputMaybe<SortEnumType>;
  securityStamp?: InputMaybe<SortEnumType>;
  twoFactorEnabled?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

export type UserStatePermission = {
  __typename?: 'UserStatePermission';
  state: State;
  stateKey: Scalars['Int']['output'];
  user: User;
  userKey: Scalars['Int']['output'];
};

export type UserStatePermissionFilterInput = {
  and?: InputMaybe<Array<UserStatePermissionFilterInput>>;
  or?: InputMaybe<Array<UserStatePermissionFilterInput>>;
  state?: InputMaybe<StateFilterInput>;
  stateKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userKey?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserStatePermissionInput = {
  state?: InputMaybe<StateInput>;
  stateKey: Scalars['Int']['input'];
  user?: InputMaybe<UserInput>;
  userKey: Scalars['Int']['input'];
};

/** A connection to a list of items. */
export type UsersGetAllConnection = {
  __typename?: 'UsersGetAllConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersGetAllEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersGetAllEdge = {
  __typename?: 'UsersGetAllEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type CreateTankMutationVariables = Exact<{
  tank: TankInput;
}>;


export type CreateTankMutation = { __typename?: 'Mutation', tankCreate: { __typename?: 'Tank', tankKey: number } };

export type CreateLocationTerminalMutationVariables = Exact<{
  locationTerminal: LocationTerminalInput;
}>;


export type CreateLocationTerminalMutation = { __typename?: 'Mutation', locationTerminalCreate: { __typename?: 'LocationTerminal', locationKey: number, terminalKey: number } };

export type BulkUpdateBasisTypePricesMutationVariables = Exact<{
  prices: Array<InputMaybe<BasisTypePriceInput>> | InputMaybe<BasisTypePriceInput>;
}>;


export type BulkUpdateBasisTypePricesMutation = { __typename?: 'Mutation', basisTypePriceBulkUpdate: boolean };

export type CreateAndEndActivePostingMutationVariables = Exact<{
  posting: PostingInput;
}>;


export type CreateAndEndActivePostingMutation = { __typename?: 'Mutation', postingCreateAndEndActive: { __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } };

export type BulkUpdatePostingPricesMutationVariables = Exact<{
  postingPrices: Array<InputMaybe<PostingPriceCreateOrUpdateInput>> | InputMaybe<PostingPriceCreateOrUpdateInput>;
}>;


export type BulkUpdatePostingPricesMutation = { __typename?: 'Mutation', postingPriceBulkCreateOrUpdate: boolean };

export type CreatePointToPointCarrierRateDateSpanMutationVariables = Exact<{
  carrierPointToPointRateDateSpan: CarrierPointToPointRateDateSpanInput;
  percentMultiplier: Scalars['Float']['input'];
  copyActiveRates: Scalars['Boolean']['input'];
}>;


export type CreatePointToPointCarrierRateDateSpanMutation = { __typename?: 'Mutation', carrierPointToPointRateDateSpanCreate: { __typename?: 'CarrierPointToPointRateDateSpan', carrierPointToPointRateDateSpanKey: number } };

export type UpdatePointToPointCarrierRateDateSpanMutationVariables = Exact<{
  carrierPointToPointRateDateSpan: CarrierPointToPointRateDateSpanInput;
  dateSpanKey: Scalars['Int']['input'];
}>;


export type UpdatePointToPointCarrierRateDateSpanMutation = { __typename?: 'Mutation', carrierPointToPointRateDateSpanUpdate: { __typename?: 'CarrierPointToPointRateDateSpan', carrierPointToPointRateDateSpanKey: number } };

export type GetSinglePointToPointCarrierRateDateSpanQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type GetSinglePointToPointCarrierRateDateSpanQuery = { __typename?: 'Query', carrierPointToPointRateDateSpanGetSingle: { __typename?: 'CarrierPointToPointRateDateSpan', carrierKey: number, startDate: any, endDate?: any | null, carrierPointToPointRates?: Array<{ __typename?: 'CarrierPointToPointRate', carrierPointToPointRateKey: number, rate: number, originCityKey: number, destinationCityKey: number, miles: number, tolls: number, carrierPointToPointRateDateSpanKey: number, originCity?: { __typename?: 'City', name?: string | null, cityKey: number, stateKey: number, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } | null, destinationCity?: { __typename?: 'City', name?: string | null, cityKey: number, stateKey: number, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } | null } | null> | null, carrier?: { __typename?: 'Carrier', name?: string | null } | null } };

export type DeleteCarrierPointToPointRateDateSpanMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCarrierPointToPointRateDateSpanMutation = { __typename?: 'Mutation', carrierPointToPointRateDateSpanDelete: boolean };

export type CreateCarrierRateMutationVariables = Exact<{
  carrierRate: CarrierRateInput;
}>;


export type CreateCarrierRateMutation = { __typename?: 'Mutation', carrierRateCreate: { __typename?: 'CarrierRate', carrierRateKey: number } };

export type CreatePointToPointCarrierRateMutationVariables = Exact<{
  carrierPointToPointRate: CarrierPointToPointRateInput;
}>;


export type CreatePointToPointCarrierRateMutation = { __typename?: 'Mutation', carrierPointToPointRateCreate: { __typename?: 'CarrierPointToPointRate', carrierPointToPointRateKey: number } };

export type UpdateCarrierRateMutationVariables = Exact<{
  carrierRate: CarrierRateInput;
  carrierRateKey: Scalars['Int']['input'];
}>;


export type UpdateCarrierRateMutation = { __typename?: 'Mutation', carrierRateUpdate: { __typename?: 'CarrierRate', carrierRateKey: number } };

export type UpdatePointToPointCarrierRateMutationVariables = Exact<{
  carrierPointToPointRate: CarrierPointToPointRateInput;
  carrierPointToPointRateKey: Scalars['Int']['input'];
}>;


export type UpdatePointToPointCarrierRateMutation = { __typename?: 'Mutation', carrierPointToPointRateUpdate: { __typename?: 'CarrierPointToPointRate', carrierPointToPointRateKey: number } };

export type SinglePointToPointCarrierRateFragment = { __typename?: 'CarrierPointToPointRate', carrierPointToPointRateKey: number, rate: number, originCityKey: number, destinationCityKey: number, miles: number, tolls: number, carrierPointToPointRateDateSpanKey: number, originCity?: { __typename?: 'City', name?: string | null, cityKey: number, stateKey: number, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } | null, destinationCity?: { __typename?: 'City', name?: string | null, cityKey: number, stateKey: number, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } | null };

export type GetSingleCarrierPointToPointRateQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type GetSingleCarrierPointToPointRateQuery = { __typename?: 'Query', carrierPointToPointRateGetSingle: { __typename?: 'CarrierPointToPointRate', carrierPointToPointRateKey: number, rate: number, originCityKey: number, destinationCityKey: number, miles: number, tolls: number, carrierPointToPointRateDateSpanKey: number, originCity?: { __typename?: 'City', name?: string | null, cityKey: number, stateKey: number, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } | null, destinationCity?: { __typename?: 'City', name?: string | null, cityKey: number, stateKey: number, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } | null } };

export type CreateContactMutationVariables = Exact<{
  contact: ContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', contactCreate: { __typename?: 'Contact', contactKey: number, default: boolean } };

export type EditContactMutationVariables = Exact<{
  contact: ContactInput;
  id: Scalars['Int']['input'];
}>;


export type EditContactMutation = { __typename?: 'Mutation', contactUpdate: { __typename?: 'Contact', contactKey: number, default: boolean } };

export type CreateLocationContactMutationVariables = Exact<{
  lc: LocationContactInput;
}>;


export type CreateLocationContactMutation = { __typename?: 'Mutation', locationContactCreate?: { __typename?: 'LocationContact', locationKey: number, contactKey: number } | null };

export type DeleteLocationContactMutationVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  contactKey: Scalars['Int']['input'];
}>;


export type DeleteLocationContactMutation = { __typename?: 'Mutation', locationContactDelete: boolean };

export type CreateCarrierRateBandMutationVariables = Exact<{
  carrierRateBand: CarrierRateBandInput;
}>;


export type CreateCarrierRateBandMutation = { __typename?: 'Mutation', carrierRateBandCreate: { __typename?: 'CarrierRateBand', carrierRateBandKey: number } };

export type GetAllCarrierRateBandByCarrierRateKeyQueryVariables = Exact<{
  carrierRateKey: Scalars['Int']['input'];
}>;


export type GetAllCarrierRateBandByCarrierRateKeyQuery = { __typename?: 'Query', carrierRateBandGetAll: Array<{ __typename?: 'CarrierRateBand', carrierRateKey: number, carrierRateBandKey: number, mileageFrom: number, mileageTo: number, ratePerGallon: number }> };

export type UpdateLocationTerminalMutationVariables = Exact<{
  locationTerminal: LocationTerminalInput;
}>;


export type UpdateLocationTerminalMutation = { __typename?: 'Mutation', locationTerminalEdit: { __typename?: 'LocationTerminal', locationKey: number, terminalKey: number } };

export type CreateFuelSurchargeMutationVariables = Exact<{
  fuelSurcharge: FuelSurchargeInput;
}>;


export type CreateFuelSurchargeMutation = { __typename?: 'Mutation', fuelSurchargeCreate: { __typename?: 'FuelSurcharge', fuelSurchargeKey: number } };

export type SingleFuelSurchargeFragment = { __typename?: 'FuelSurcharge', fuelSurchargeKey: number, carrierKey: number, rate: number, startDate: any, endDate: any };

export type GetSingleFuelSurchargeQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type GetSingleFuelSurchargeQuery = { __typename?: 'Query', fuelSurchargeGetSingle: { __typename?: 'FuelSurcharge', fuelSurchargeKey: number, carrierKey: number, rate: number, startDate: any, endDate: any } };

export type UpdateFuelSurchargeMutationVariables = Exact<{
  fuelSurcharge: FuelSurchargeInput;
  fuelSurchargeKey: Scalars['Int']['input'];
}>;


export type UpdateFuelSurchargeMutation = { __typename?: 'Mutation', fuelSurchargeUpdate: { __typename?: 'FuelSurcharge', fuelSurchargeKey: number } };

export type SingleOrderExportFragment = { __typename?: 'Order', tripNumber?: string | null, deliveryDate: any, specialInstructions?: string | null, poNumber?: string | null, miles: number, carrier?: { __typename?: 'Carrier', name?: string | null, email?: string | null, fax?: string | null } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, location?: { __typename?: 'Location', directions?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null, directions?: string | null } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null };

export type GetSingleOrderForExportQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleOrderForExportQuery = { __typename?: 'Query', orderGetSingle: { __typename?: 'Order', tripNumber?: string | null, deliveryDate: any, specialInstructions?: string | null, poNumber?: string | null, miles: number, carrier?: { __typename?: 'Carrier', name?: string | null, email?: string | null, fax?: string | null } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, location?: { __typename?: 'Location', directions?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null, directions?: string | null } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null } };

export type OrderBulkDispatchMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  sendEmail: Scalars['Boolean']['input'];
}>;


export type OrderBulkDispatchMutation = { __typename?: 'Mutation', orderBulkDispatch: boolean };

export type CreateStateTaxMutationVariables = Exact<{
  stateTax: StateTaxInput;
}>;


export type CreateStateTaxMutation = { __typename?: 'Mutation', stateTaxCreate: { __typename?: 'StateTax', stateTaxKey: number } };

export type UpdateStateTaxMutationVariables = Exact<{
  stateTax: StateTaxInput;
  stateTaxKey: Scalars['Int']['input'];
}>;


export type UpdateStateTaxMutation = { __typename?: 'Mutation', stateTaxUpdate: { __typename?: 'StateTax', stateTaxKey: number } };

export type GetSingleStateTaxQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type GetSingleStateTaxQuery = { __typename?: 'Query', stateTaxGetSingle: { __typename?: 'StateTax', stateTaxKey: number, startDate: any, endDate?: any | null, stateKey: number, amount: number, stateTaxType: StateTaxType, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } };

export type UpdateCarrierRateBandMutationVariables = Exact<{
  carrierRateBand: CarrierRateBandInput;
  key: Scalars['Int']['input'];
}>;


export type UpdateCarrierRateBandMutation = { __typename?: 'Mutation', carrierRateBandUpdate: { __typename?: 'CarrierRateBand', carrierRateBandKey: number } };

export type DeleteCarrierRateBandMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCarrierRateBandMutation = { __typename?: 'Mutation', carrierRateBandDelete: boolean };

export type LifetimeLocationGallonsQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
}>;


export type LifetimeLocationGallonsQuery = { __typename?: 'Query', lifetimeGallons?: Array<{ __typename?: 'SumPerMonth', year: number, jan: number, feb: number, mar: number, apr: number, may: number, jun: number, jul: number, aug: number, sep: number, oct: number, nov: number, dec: number }> | null };

export type LifetimeTermContractGallonsQueryVariables = Exact<{
  termContractKey: Scalars['Int']['input'];
}>;


export type LifetimeTermContractGallonsQuery = { __typename?: 'Query', lifetimeTermContractGallons?: Array<{ __typename?: 'SumPerMonth', year: number, jan: number, feb: number, mar: number, apr: number, may: number, jun: number, jul: number, aug: number, sep: number, oct: number, nov: number, dec: number }> | null };

export type PricingListingFragment = { __typename?: 'Pricing', pricingType: PricingType, effectiveDate: any, supplierName?: string | null, supplierKey: number, terminalName?: string | null, terminalKey: number, product: number, markup: number, patCost: number, perc: number, stateTax: number, stateAssessment: number, fob: number, mileage: number, primaryCarrier?: string | null, secondaryCarrier?: string | null, primaryCarrierRate: number, secondaryCarrierRate: number, primaryCarrierDelivered: number, secondaryCarrierDelivered: number, primaryCarrierKey: number, secondaryCarrierKey?: number | null, locationKey: number, queryString?: string | null, contractVolumeExhausted: boolean, pricingName?: string | null, termContractKey?: number | null, hasErrors: boolean, pricingKey: number };

export type GetPricingQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  sort?: InputMaybe<Array<PricingSortInput> | PricingSortInput>;
  pricingDate: Scalars['DateTime']['input'];
}>;


export type GetPricingQuery = { __typename?: 'Query', pricingsGet?: Array<{ __typename?: 'Pricing', pricingType: PricingType, effectiveDate: any, supplierName?: string | null, supplierKey: number, terminalName?: string | null, terminalKey: number, product: number, markup: number, patCost: number, perc: number, stateTax: number, stateAssessment: number, fob: number, mileage: number, primaryCarrier?: string | null, secondaryCarrier?: string | null, primaryCarrierRate: number, secondaryCarrierRate: number, primaryCarrierDelivered: number, secondaryCarrierDelivered: number, primaryCarrierKey: number, secondaryCarrierKey?: number | null, locationKey: number, queryString?: string | null, contractVolumeExhausted: boolean, pricingName?: string | null, termContractKey?: number | null, hasErrors: boolean, pricingKey: number }> | null };

export type LocationCustomerSupplierFragment = { __typename?: 'Location', locationKey: number, primaryCarrierKey?: number | null, secondaryCarrierKey?: number | null, markupCost: number, city?: string | null, state?: string | null, isFobCustomer: boolean, locationTerminals?: Array<{ __typename?: 'LocationTerminal', terminalKey: number, mileage: number, terminal: { __typename?: 'Terminal', name?: string | null, indexContracts?: Array<{ __typename?: 'IndexContract', indexContractKey: number, effectiveDate: any, januaryIndex: number, februaryIndex: number, marchIndex: number, aprilIndex: number, mayIndex: number, juneIndex: number, julyIndex: number, augustIndex: number, septemberIndex: number, octoberIndex: number, novemberIndex: number, decemberIndex: number, supplier: { __typename?: 'Supplier', name?: string | null }, basisType: { __typename?: 'BasisType', basisTypeKey: number, name?: string | null } } | null> | null, prePurchaseAgreements?: Array<{ __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, toDateGallons: number, gallons: number, productCost: number, assessmentCost: number, freightCost: number, miscCost: number, endShipDate: any, startShipDate: any, supplier: { __typename?: 'Supplier', name?: string | null } } | null> | null } } | null> | null, primaryCarrier?: { __typename?: 'Carrier', name?: string | null, carrierRates?: Array<{ __typename?: 'CarrierRate', startDate: any, endDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null } | null, secondaryCarrier?: { __typename?: 'Carrier', name?: string | null, carrierRates?: Array<{ __typename?: 'CarrierRate', startDate: any, endDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null } | null, customer: { __typename?: 'Customer', customerKey: number, name?: string | null, deliveryTimeKey?: number | null } };

export type GetLocationSingleQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
}>;


export type GetLocationSingleQuery = { __typename?: 'Query', locationGetSingle: { __typename?: 'Location', locationKey: number, primaryCarrierKey?: number | null, secondaryCarrierKey?: number | null, markupCost: number, city?: string | null, state?: string | null, isFobCustomer: boolean, locationTerminals?: Array<{ __typename?: 'LocationTerminal', terminalKey: number, mileage: number, terminal: { __typename?: 'Terminal', name?: string | null, indexContracts?: Array<{ __typename?: 'IndexContract', indexContractKey: number, effectiveDate: any, januaryIndex: number, februaryIndex: number, marchIndex: number, aprilIndex: number, mayIndex: number, juneIndex: number, julyIndex: number, augustIndex: number, septemberIndex: number, octoberIndex: number, novemberIndex: number, decemberIndex: number, supplier: { __typename?: 'Supplier', name?: string | null }, basisType: { __typename?: 'BasisType', basisTypeKey: number, name?: string | null } } | null> | null, prePurchaseAgreements?: Array<{ __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, toDateGallons: number, gallons: number, productCost: number, assessmentCost: number, freightCost: number, miscCost: number, endShipDate: any, startShipDate: any, supplier: { __typename?: 'Supplier', name?: string | null } } | null> | null } } | null> | null, primaryCarrier?: { __typename?: 'Carrier', name?: string | null, carrierRates?: Array<{ __typename?: 'CarrierRate', startDate: any, endDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null } | null, secondaryCarrier?: { __typename?: 'Carrier', name?: string | null, carrierRates?: Array<{ __typename?: 'CarrierRate', startDate: any, endDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null } | null, customer: { __typename?: 'Customer', customerKey: number, name?: string | null, deliveryTimeKey?: number | null } } };

export type InnerTerminalPostingFragment = { __typename?: 'Posting', postingKey: number, terminalKey: number, supplierKey: number, cost: number, effectiveDate: any, terminal: { __typename?: 'Terminal', name?: string | null }, supplier: { __typename?: 'Supplier', name?: string | null } };

export type GetPostingsByLocationQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
}>;


export type GetPostingsByLocationQuery = { __typename?: 'Query', postingsByLocationKey?: Array<{ __typename?: 'Posting', postingKey: number, terminalKey: number, supplierKey: number, cost: number, effectiveDate: any, terminal: { __typename?: 'Terminal', name?: string | null }, supplier: { __typename?: 'Supplier', name?: string | null } } | null> | null };

export type BasicBasisTypeFragment = { __typename?: 'BasisType', basisTypeKey: number, name?: string | null };

export type SearchBasisTypesQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchBasisTypesQuery = { __typename?: 'Query', basisTypeGetAll: Array<{ __typename?: 'BasisType', basisTypeKey: number, name?: string | null }> };

export type CarrierSearchListingFragment = { __typename?: 'CarrierSearch', carrierKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, fax?: string | null, email?: string | null, carrierRates?: Array<{ __typename?: 'CarrierRate', endDate: any, startDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null };

export type GetSearchCarrierQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<CarrierSearchSortInput> | CarrierSearchSortInput>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetSearchCarrierQuery = { __typename?: 'Query', carrierSearch?: Array<{ __typename?: 'CarrierSearch', carrierKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, fax?: string | null, email?: string | null, carrierRates?: Array<{ __typename?: 'CarrierRate', endDate: any, startDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null }> | null };

export type BasicContactFragment = { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, cellPhone?: string | null, homePhone?: string | null, default: boolean };

export type GetSingleContactQueryVariables = Exact<{
  contactKey: Scalars['Int']['input'];
}>;


export type GetSingleContactQuery = { __typename?: 'Query', contactGetSingle: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, cellPhone?: string | null, homePhone?: string | null, default: boolean } };

export type GetContactsSearchQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  locationKey?: InputMaybe<Scalars['Int']['input']>;
  customerKey?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContactsSearchQuery = { __typename?: 'Query', contactGetByLocationKey?: Array<{ __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, cellPhone?: string | null, homePhone?: string | null, default: boolean }> | null };

export type BasicCustomerFragment = { __typename?: 'Customer', customerKey: number, name?: string | null, dbaName?: string | null };

export type GetSearchCustomersQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<CustomerSortInput> | CustomerSortInput>;
}>;


export type GetSearchCustomersQuery = { __typename?: 'Query', customerGetAll?: { __typename?: 'CustomerGetAllConnection', edges?: Array<{ __typename?: 'CustomerGetAllEdge', node?: { __typename?: 'Customer', customerKey: number, name?: string | null, dbaName?: string | null } | null }> | null } | null };

export type GetTasksForTaskPageQueryVariables = Exact<{
  locationKey?: InputMaybe<ComparableInt32OperationFilterInput>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetTasksForTaskPageQuery = { __typename?: 'Query', taskGetAll: Array<{ __typename?: 'Task', taskKey: number, isComplete: boolean, taskDate: any, callDetails?: string | null, contactMethod: ContactMethod, completedDate?: any | null, locationKey: number, contact: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null }, location: { __typename?: 'Location', customerKey: number, locationKey: number, name?: string | null }, user: { __typename?: 'User', id: number, email?: string | null, name?: string | null } }> };

export type InnerDeliveryTimeFragment = { __typename?: 'DeliveryTime', deliveryTimeKey: number, code?: string | null, description?: string | null };

export type DeliveryTimeSearchQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<DeliveryTimeSortInput> | DeliveryTimeSortInput>;
}>;


export type DeliveryTimeSearchQuery = { __typename?: 'Query', deliveryTimeGetAll?: Array<{ __typename?: 'DeliveryTime', deliveryTimeKey: number, code?: string | null, description?: string | null }> | null };

export type GetDeliveryTimeQueryVariables = Exact<{
  deliveryTimeKey: Scalars['Int']['input'];
}>;


export type GetDeliveryTimeQuery = { __typename?: 'Query', deliveryTimeGetSingle: { __typename?: 'DeliveryTime', deliveryTimeKey: number, code?: string | null, description?: string | null } };

export type FileNumbersSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FileNumbersSearchQuery = { __typename?: 'Query', fileNumberGetAll?: Array<{ __typename?: 'FileNumber', fileNumberKey: number, number?: string | null, supplierKey: number, terminalKey: number, isArchived: boolean, isDefault: boolean }> | null };

export type BasicLocationFragment = { __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, customer: { __typename?: 'Customer', customerKey: number, name?: string | null } };

export type GetSearchLocationsQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  customerKey?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LocationSortInput> | LocationSortInput>;
}>;


export type GetSearchLocationsQuery = { __typename?: 'Query', locationGetByCustomer: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, zipCode?: string | null, address1?: string | null, address2?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, customer: { __typename?: 'Customer', customerKey: number, name?: string | null } }> };

export type PrePurchaseAgreementSearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  terminalKey?: InputMaybe<Scalars['Int']['input']>;
  supplierKey?: InputMaybe<Scalars['Int']['input']>;
  activeDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type PrePurchaseAgreementSearchQuery = { __typename?: 'Query', prePurchaseAgreementBySupplierTerminal?: Array<{ __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } }> | null };

export type SalesAgreementSearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  locationKey?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<Array<SalesAgreementSortInput> | SalesAgreementSortInput>;
}>;


export type SalesAgreementSearchQuery = { __typename?: 'Query', salesAgreementByLocation?: Array<{ __typename?: 'SalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplierKey?: number | null, terminalKey?: number | null, endShipDate: any, supplier?: { __typename?: 'Supplier', name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null }> | null };

export type InnerStateFragment = { __typename?: 'State', stateKey: number, name?: string | null };

export type StatesSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type StatesSearchQuery = { __typename?: 'Query', stateGetAll?: Array<{ __typename?: 'State', stateKey: number, name?: string | null }> | null };

export type GetSingleStateQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type GetSingleStateQuery = { __typename?: 'Query', stateGetSingle: { __typename?: 'State', stateKey: number, name?: string | null } };

export type BasicSupplierFragment = { __typename?: 'Supplier', supplierKey: number, name?: string | null, city?: string | null, state?: string | null };

export type SearchSuppliersQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SupplierSortInput> | SupplierSortInput>;
}>;


export type SearchSuppliersQuery = { __typename?: 'Query', supplierGetAll: Array<{ __typename?: 'Supplier', supplierKey: number, name?: string | null, city?: string | null, state?: string | null }> };

export type TagSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagSearchQuery = { __typename?: 'Query', tagGetAll?: Array<{ __typename?: 'Tag', tagKey: number, name?: string | null }> | null };

export type AllTagQueryVariables = Exact<{
  filter?: InputMaybe<TagFilterInput>;
}>;


export type AllTagQuery = { __typename?: 'Query', tagGetAll?: Array<{ __typename?: 'Tag', tagKey: number, name?: string | null }> | null };

export type GetSingleTagQueryVariables = Exact<{
  tagKey: Scalars['Int']['input'];
}>;


export type GetSingleTagQuery = { __typename?: 'Query', tagGetSingle: { __typename?: 'Tag', tagKey: number, name?: string | null } };

export type FullTagFragment = { __typename?: 'Tag', tagKey: number, name?: string | null };

export type CreateTagMutationVariables = Exact<{
  tag: TagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', tagCreate: { __typename?: 'Tag', tagKey: number } };

export type TermContractSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  locationKey?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TermContractFilterInput>;
}>;


export type TermContractSearchQuery = { __typename?: 'Query', termContractSearch?: Array<{ __typename?: 'TermContract', termContractKey: number, name?: string | null, startDate: any, endDate: any, notes?: string | null, termContractSuppliers?: Array<{ __typename?: 'TermContractSupplier', supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null> | null, termContractTerminals?: Array<{ __typename?: 'TermContractTerminal', terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null }> | null };

export type BasicTerminalFragment = { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, locationTerminals?: Array<{ __typename?: 'LocationTerminal', mileage: number, locationKey: number } | null> | null };

export type SearchTerminalsQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  locationKey?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchTerminalsQuery = { __typename?: 'Query', terminalSearch?: Array<{ __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, locationTerminals?: Array<{ __typename?: 'LocationTerminal', mileage: number, locationKey: number } | null> | null }> | null };

export type AllUserSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllUserSearchQuery = { __typename?: 'Query', usersGetAll?: { __typename?: 'UsersGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'UsersGetAllEdge', cursor: string, node?: { __typename?: 'User', id: number, name?: string | null, email?: string | null, phoneNumber?: string | null, isGasPointUser: boolean, isAdminUser: boolean, hasFullAccess: boolean, preferPrefixSearch: boolean, userCarriers?: Array<{ __typename?: 'UserCarrier', carrierKey: number } | null> | null, userStatePermissions?: Array<{ __typename?: 'UserStatePermission', stateKey: number, state: { __typename?: 'State', name?: string | null } } | null> | null, userCustomerPermissions?: Array<{ __typename?: 'UserCustomerPermission', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationPermissions?: Array<{ __typename?: 'UserLocationPermission', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null, userCustomerExclusions?: Array<{ __typename?: 'UserCustomerExclusion', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationExclusions?: Array<{ __typename?: 'UserLocationExclusion', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null } | null }> | null } | null };

export type GetAllFuelSurchargesByCarrierKeyQueryVariables = Exact<{
  filterFuelSurcharge?: InputMaybe<FuelSurchargeFilterInput>;
  sort?: InputMaybe<Array<FuelSurchargeSortInput> | FuelSurchargeSortInput>;
  pageSize: Scalars['Int']['input'];
}>;


export type GetAllFuelSurchargesByCarrierKeyQuery = { __typename?: 'Query', fuelSurchargeGetAll?: { __typename?: 'FuelSurchargeGetAllConnection', nodes?: Array<{ __typename?: 'FuelSurcharge', carrierKey: number, fuelSurchargeKey: number, startDate: any, endDate: any, rate: number } | null> | null } | null };

export type DeleteFuelSurchargeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFuelSurchargeMutation = { __typename?: 'Mutation', fuelSurchargeDelete: boolean };

export type TaskShowCompletedAfterFragment = { __typename?: 'Task', taskKey: number, isComplete: boolean, taskDate: any, callDetails?: string | null, contactMethod: ContactMethod, completedDate?: any | null, locationKey: number, contact: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null }, location: { __typename?: 'Location', customerKey: number, locationKey: number, name?: string | null }, user: { __typename?: 'User', id: number, email?: string | null, name?: string | null } };

export type GetTasksCompletedAfterQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  locationKey: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type GetTasksCompletedAfterQuery = { __typename?: 'Query', taskGetCompletedAfterDate?: { __typename?: 'TaskGetCompletedAfterDateConnection', totalCount: number, edges?: Array<{ __typename?: 'TaskGetCompletedAfterDateEdge', cursor: string, node?: { __typename?: 'Task', taskKey: number, isComplete: boolean, taskDate: any, callDetails?: string | null, contactMethod: ContactMethod, completedDate?: any | null, locationKey: number, contact: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null }, location: { __typename?: 'Location', customerKey: number, locationKey: number, name?: string | null }, user: { __typename?: 'User', id: number, email?: string | null, name?: string | null } } | null }> | null } | null };

export type CreateBasisTypeMutationVariables = Exact<{
  basisType: BasisTypeInput;
}>;


export type CreateBasisTypeMutation = { __typename?: 'Mutation', basisTypeCreate: { __typename?: 'BasisType', basisTypeKey: number } };

export type EditBasisTypeMutationVariables = Exact<{
  basisType: BasisTypeInput;
  id: Scalars['Int']['input'];
}>;


export type EditBasisTypeMutation = { __typename?: 'Mutation', basisTypeUpdate: { __typename?: 'BasisType', basisTypeKey: number } };

export type AllBasisTypeListingFragment = { __typename?: 'BasisType', basisTypeKey: number, description?: string | null, name?: string | null, isArchived: boolean, currentPrice?: { __typename?: 'BasisTypePrice', price: number, effectiveDate: any } | null };

export type AllBasisTypesQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<BasisTypeSortInput> | BasisTypeSortInput>;
  filterObject?: InputMaybe<BasisTypeFilterInput>;
}>;


export type AllBasisTypesQuery = { __typename?: 'Query', basisTypeGetAll: Array<{ __typename?: 'BasisType', basisTypeKey: number, description?: string | null, name?: string | null, isArchived: boolean, currentPrice?: { __typename?: 'BasisTypePrice', price: number, effectiveDate: any } | null }> };

export type DeleteBasisTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBasisTypeMutation = { __typename?: 'Mutation', basisTypeDelete: boolean };

export type BasisTypePriceDetectDuplicatesMutationVariables = Exact<{ [key: string]: never; }>;


export type BasisTypePriceDetectDuplicatesMutation = { __typename?: 'Mutation', basisTypePriceDetectDuplicates?: Array<string | null> | null };

export type BasisTypePriceCleanupDuplicatesMutationVariables = Exact<{ [key: string]: never; }>;


export type BasisTypePriceCleanupDuplicatesMutation = { __typename?: 'Mutation', basisTypePriceCleanupDuplicates: number };

export type BasisTypePricingFragment = { __typename?: 'BasisTypePrice', basisTypePriceKey: number, basisTypeKey: number, price: number, effectiveDate: any };

export type GetBasisTypePricesQueryVariables = Exact<{
  sort?: InputMaybe<Array<BasisTypePriceSortInput> | BasisTypePriceSortInput>;
  filter: BasisTypePriceFilterInput;
}>;


export type GetBasisTypePricesQuery = { __typename?: 'Query', basisTypePriceGetAll: Array<{ __typename?: 'BasisTypePrice', basisTypePriceKey: number, basisTypeKey: number, price: number, effectiveDate: any }> };

export type SingleBasisTypeFragment = { __typename?: 'BasisType', basisTypeKey: number, description?: string | null, name?: string | null, isArchived: boolean, currentPrice?: { __typename?: 'BasisTypePrice', price: number, effectiveDate: any } | null };

export type GetSingleBasisTypeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleBasisTypeQuery = { __typename?: 'Query', basisTypeGetSingle: { __typename?: 'BasisType', basisTypeKey: number, description?: string | null, name?: string | null, isArchived: boolean, currentPrice?: { __typename?: 'BasisTypePrice', price: number, effectiveDate: any } | null } };

export type CreateBasisTypePriceMutationVariables = Exact<{
  basisTypePrice: BasisTypePriceInput;
}>;


export type CreateBasisTypePriceMutation = { __typename?: 'Mutation', basisTypePriceCreate?: { __typename?: 'BasisTypePrice', basisTypePriceKey: number, price: number, effectiveDate: any } | null };

export type CarrierListingFragment = { __typename?: 'Carrier', carrierKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, fax?: string | null, email?: string | null, carrierType: CarrierType, isArchived: boolean };

export type AllCarrierListingFragment = { __typename?: 'Carrier', carrierKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, fax?: string | null, email?: string | null, carrierType: CarrierType, isArchived: boolean, carrierRates?: Array<{ __typename?: 'CarrierRate', endDate: any, startDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null };

export type AllCarrierQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<CarrierSortInput> | CarrierSortInput>;
  filterObject?: InputMaybe<CarrierFilterInput>;
}>;


export type AllCarrierQuery = { __typename?: 'Query', carrierGetAll: Array<{ __typename?: 'Carrier', carrierKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, fax?: string | null, email?: string | null, carrierType: CarrierType, isArchived: boolean }> };

export type DeleteCarrierMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCarrierMutation = { __typename?: 'Mutation', carrierDelete: boolean };

export type SingleCarrierRateFragment = { __typename?: 'CarrierRate', carrierRateKey: number, carrierKey: number, basePercent: number, startDate: any, endDate: any, default: boolean, fuelPercent: number };

export type GetSingleCarrierRateQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type GetSingleCarrierRateQuery = { __typename?: 'Query', carrierRateGetSingle: { __typename?: 'CarrierRate', carrierRateKey: number, carrierKey: number, basePercent: number, startDate: any, endDate: any, default: boolean, fuelPercent: number } };

export type CreateCarrierMutationVariables = Exact<{
  carrier: CarrierInput;
}>;


export type CreateCarrierMutation = { __typename?: 'Mutation', carrierCreate: { __typename?: 'Carrier', carrierKey: number } };

export type EditCarrierMutationVariables = Exact<{
  carrier: CarrierInput;
  id: Scalars['Int']['input'];
}>;


export type EditCarrierMutation = { __typename?: 'Mutation', carrierUpdate: { __typename?: 'Carrier', carrierKey: number } };

export type SingleCarrierFragment = { __typename?: 'Carrier', carrierKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, fax?: string | null, email?: string | null, carrierType: CarrierType, isArchived: boolean, carrierRates?: Array<{ __typename?: 'CarrierRate', endDate: any, startDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null };

export type GetSingleCarrierQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleCarrierQuery = { __typename?: 'Query', carrierGetSingle: { __typename?: 'Carrier', carrierKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, fax?: string | null, email?: string | null, carrierType: CarrierType, isArchived: boolean, carrierRates?: Array<{ __typename?: 'CarrierRate', endDate: any, startDate: any, basePercent: number, carrierRateBands?: Array<{ __typename?: 'CarrierRateBand', mileageFrom: number, mileageTo: number, ratePerGallon: number } | null> | null } | null> | null } };

export type GetAllContactByCarrierKeyQueryVariables = Exact<{
  filterContact?: InputMaybe<ContactFilterInput>;
}>;


export type GetAllContactByCarrierKeyQuery = { __typename?: 'Query', contactGetAll?: Array<{ __typename?: 'Contact', carrierKey?: number | null, contactKey: number, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, notes?: string | null, default: boolean, cellPhone?: string | null, homePhone?: string | null, deleted: boolean } | null> | null };

export type GetAllCarrierRateByCarrierKeyQueryVariables = Exact<{
  filterCarrierRate?: InputMaybe<CarrierRateFilterInput>;
  sort?: InputMaybe<Array<CarrierRateSortInput> | CarrierRateSortInput>;
  pageSize: Scalars['Int']['input'];
}>;


export type GetAllCarrierRateByCarrierKeyQuery = { __typename?: 'Query', carrierRateGetAll?: { __typename?: 'CarrierRateGetAllConnection', edges?: Array<{ __typename?: 'CarrierRateGetAllEdge', cursor: string, node?: { __typename?: 'CarrierRate', carrierKey: number, carrierRateKey: number, startDate: any, endDate: any, basePercent: number, default: boolean, fuelPercent: number } | null }> | null } | null };

export type GetAllCarrierPointToPointRateByCarrierKeyQueryVariables = Exact<{
  filterCarrierRate?: InputMaybe<CarrierPointToPointRateFilterInput>;
  sort?: InputMaybe<Array<CarrierPointToPointRateSortInput> | CarrierPointToPointRateSortInput>;
}>;


export type GetAllCarrierPointToPointRateByCarrierKeyQuery = { __typename?: 'Query', carrierPointToPointRateGetAll: Array<{ __typename?: 'CarrierPointToPointRate', carrierPointToPointRateKey: number, rate: number, originCityKey: number, destinationCityKey: number, miles: number, tolls: number, originCity?: { __typename?: 'City', name?: string | null, cityKey: number, stateKey: number, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } | null, destinationCity?: { __typename?: 'City', name?: string | null, cityKey: number, stateKey: number, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null } | null }> };

export type GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryVariables = Exact<{
  filterDateSpans?: InputMaybe<CarrierPointToPointRateDateSpanFilterInput>;
  sort?: InputMaybe<Array<CarrierPointToPointRateDateSpanSortInput> | CarrierPointToPointRateDateSpanSortInput>;
}>;


export type GetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery = { __typename?: 'Query', carrierPointToPointRateDateSpanGetAll: Array<{ __typename?: 'CarrierPointToPointRateDateSpan', carrierPointToPointRateDateSpanKey: number, startDate: any, endDate?: any | null, carrierKey: number }> };

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', contactArchive: boolean };

export type DeleteCarrierRateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCarrierRateMutation = { __typename?: 'Mutation', carrierRateDelete: boolean };

export type DeleteCarrierPointToPointRateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCarrierPointToPointRateMutation = { __typename?: 'Mutation', carrierPointToPointRateDelete: boolean };

export type CreateContractVolumeMutationVariables = Exact<{
  contractVolume: ContractVolumeInput;
}>;


export type CreateContractVolumeMutation = { __typename?: 'Mutation', contractVolumeCreate: { __typename?: 'ContractVolume', contractVolumeKey: number } };

export type CreateContractVolumeTerminalMutationVariables = Exact<{
  contractVolumeTerminal: ContractVolumeTerminalInput;
}>;


export type CreateContractVolumeTerminalMutation = { __typename?: 'Mutation', contractVolumeTerminalCreate: { __typename?: 'ContractVolumeTerminal', contractVolumeKey: number } };

export type EditContractVolumeMutationVariables = Exact<{
  contractVolume: ContractVolumeInput;
  id: Scalars['Int']['input'];
}>;


export type EditContractVolumeMutation = { __typename?: 'Mutation', contractVolumeUpdate: { __typename?: 'ContractVolume', contractVolumeKey: number } };

export type SingleContractVolumeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SingleContractVolumeQuery = { __typename?: 'Query', contractVolumeGetSingle: { __typename?: 'ContractVolume', contractVolumeKey: number, startDate: any, contractVolumeType: ContractVolumeType, supplierKey: number, january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number, contractVolumeTerminals?: Array<{ __typename?: 'ContractVolumeTerminal', terminalKey: number, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null } };

export type DeleteContractVolumeTerminalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteContractVolumeTerminalMutation = { __typename?: 'Mutation', contractVolumeTerminalDelete: boolean };

export type InnerContractVolumeFragment = { __typename?: 'ContractVolume', contractVolumeKey: number, startDate: any, contractVolumeType: ContractVolumeType, supplierKey: number, january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number, contractVolumeTerminals?: Array<{ __typename?: 'ContractVolumeTerminal', terminalKey: number, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null };

export type InnerContractVolumeListingFragment = { __typename?: 'ContractVolumeGetAllEdge', node?: { __typename?: 'ContractVolume', contractVolumeKey: number, startDate: any, contractVolumeType: ContractVolumeType, supplierKey: number, january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number, contractVolumeTerminals?: Array<{ __typename?: 'ContractVolumeTerminal', terminalKey: number, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null };

export type AllContractVolumeListingFragment = { __typename?: 'ContractVolumeGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'ContractVolumeGetAllEdge', cursor: string, node?: { __typename?: 'ContractVolume', contractVolumeKey: number, startDate: any, contractVolumeType: ContractVolumeType, supplierKey: number, january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number, contractVolumeTerminals?: Array<{ __typename?: 'ContractVolumeTerminal', terminalKey: number, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null }> | null };

export type InnerFlatContractVolumeFragment = { __typename?: 'FlatContractVolume', contractVolumeKey: number, startDate: any, supplier?: string | null, terminals?: string | null };

export type InnerFlatContractVolumeListingFragment = { __typename?: 'FlatContractVolumeGetAllEdge', node?: { __typename?: 'FlatContractVolume', contractVolumeKey: number, startDate: any, supplier?: string | null, terminals?: string | null } | null };

export type AllFlatContractVolumeListingFragment = { __typename?: 'FlatContractVolumeGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'FlatContractVolumeGetAllEdge', cursor: string, node?: { __typename?: 'FlatContractVolume', contractVolumeKey: number, startDate: any, supplier?: string | null, terminals?: string | null } | null }> | null };

export type AllContractVolumesQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<ContractVolumeSortInput> | ContractVolumeSortInput>;
  filterObject?: InputMaybe<ContractVolumeFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllContractVolumesQuery = { __typename?: 'Query', contractVolumeGetAll?: { __typename?: 'ContractVolumeGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'ContractVolumeGetAllEdge', cursor: string, node?: { __typename?: 'ContractVolume', contractVolumeKey: number, startDate: any, contractVolumeType: ContractVolumeType, supplierKey: number, january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number, contractVolumeTerminals?: Array<{ __typename?: 'ContractVolumeTerminal', terminalKey: number, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null }> | null } | null };

export type AllFlatContractVolumesQueryVariables = Exact<{
  sort?: InputMaybe<Array<FlatContractVolumeSortInput> | FlatContractVolumeSortInput>;
  filter?: InputMaybe<FlatContractVolumeFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllFlatContractVolumesQuery = { __typename?: 'Query', flatContractVolumeGetAll?: { __typename?: 'FlatContractVolumeGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'FlatContractVolumeGetAllEdge', cursor: string, node?: { __typename?: 'FlatContractVolume', contractVolumeKey: number, startDate: any, supplier?: string | null, terminals?: string | null } | null }> | null } | null };

export type ContractVolumeForIndexContractQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ContractVolumeForIndexContractQuery = { __typename?: 'Query', contractVolumeGetByIndexContract?: { __typename?: 'ContractVolume', contractVolumeKey: number, startDate: any, contractVolumeType: ContractVolumeType, supplierKey: number, january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number, contractVolumeTerminals?: Array<{ __typename?: 'ContractVolumeTerminal', terminalKey: number, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null };

export type DeleteContractVolumeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteContractVolumeMutation = { __typename?: 'Mutation', contractVolumeDelete: boolean };

export type CreateCustomerMutationVariables = Exact<{
  customer: CustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', customerCreate: { __typename?: 'Customer', customerKey: number } };

export type EditCustomerMutationVariables = Exact<{
  customer: CustomerInput;
  id: Scalars['Int']['input'];
}>;


export type EditCustomerMutation = { __typename?: 'Mutation', customerUpdate: { __typename?: 'Customer', customerKey: number } };

export type CreateCustomerTagMutationVariables = Exact<{
  customerTag: CustomerTagInput;
}>;


export type CreateCustomerTagMutation = { __typename?: 'Mutation', customerTagCreate: { __typename?: 'CustomerTag', customerKey: number, tagKey: number } };

export type DeleteCustomerTagMutationVariables = Exact<{
  customerKey: Scalars['Int']['input'];
  tagKey: Scalars['Int']['input'];
}>;


export type DeleteCustomerTagMutation = { __typename?: 'Mutation', customerTagDelete: boolean };

export type GetCustomerQueryVariables = Exact<{
  customerKey: Scalars['Int']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', customerGetSingle: { __typename?: 'Customer', customerKey: number, name?: string | null, dbaName?: string | null, description?: string | null, creditLimit: number, creditNotes?: string | null, businessType: BusinessType, quickBooksName?: string | null, deliveryTimeKey?: number | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, directions?: string | null, isArchived: boolean, customerTags?: Array<{ __typename?: 'CustomerTag', tagKey: number }> | null } };

export type LocationListingFragment = { __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, zipCode?: string | null, isActive: boolean, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } };

export type SingleCustomerFragment = { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, businessType: BusinessType, deliveryTimeKey?: number | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, directions?: string | null, creditLimit: number, creditNotes?: string | null, isActive: boolean, deliveryTime?: { __typename?: 'DeliveryTime', code?: string | null, description?: string | null } | null, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, zipCode?: string | null, isActive: boolean, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } }> };

export type GetSingleCustomerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleCustomerQuery = { __typename?: 'Query', customerGetSingle: { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, businessType: BusinessType, deliveryTimeKey?: number | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, directions?: string | null, creditLimit: number, creditNotes?: string | null, isActive: boolean, deliveryTime?: { __typename?: 'DeliveryTime', code?: string | null, description?: string | null } | null, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, zipCode?: string | null, isActive: boolean, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } }> } };

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', locationDelete: boolean };

export type InnerCustomerFragment = { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, isActive: boolean, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, locationTags?: Array<{ __typename?: 'LocationTag', tag?: { __typename?: 'Tag', name?: string | null } | null } | null> | null }>, customerTags?: Array<{ __typename?: 'CustomerTag', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null };

export type InnerCustomerListingFragment = { __typename?: 'CustomerGetAllEdge', node?: { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, isActive: boolean, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, locationTags?: Array<{ __typename?: 'LocationTag', tag?: { __typename?: 'Tag', name?: string | null } | null } | null> | null }>, customerTags?: Array<{ __typename?: 'CustomerTag', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null } | null };

export type AllCustomerListingFragment = { __typename?: 'CustomerGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'CustomerGetAllEdge', cursor: string, node?: { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, isActive: boolean, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, locationTags?: Array<{ __typename?: 'LocationTag', tag?: { __typename?: 'Tag', name?: string | null } | null } | null> | null }>, customerTags?: Array<{ __typename?: 'CustomerTag', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null } | null }> | null };

export type InnerCustomersWithFilterListingFragment = { __typename?: 'CustomersWithFilterEdge', node?: { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, isActive: boolean, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, locationTags?: Array<{ __typename?: 'LocationTag', tag?: { __typename?: 'Tag', name?: string | null } | null } | null> | null }>, customerTags?: Array<{ __typename?: 'CustomerTag', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null } | null };

export type CustomersWithFilterListingFragment = { __typename?: 'CustomersWithFilterConnection', totalCount: number, edges?: Array<{ __typename?: 'CustomersWithFilterEdge', cursor: string, node?: { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, isActive: boolean, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, locationTags?: Array<{ __typename?: 'LocationTag', tag?: { __typename?: 'Tag', name?: string | null } | null } | null> | null }>, customerTags?: Array<{ __typename?: 'CustomerTag', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null } | null }> | null };

export type AllCustomersQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<CustomerSortInput> | CustomerSortInput>;
  filterObject?: InputMaybe<CustomerFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllCustomersQuery = { __typename?: 'Query', customerGetAll?: { __typename?: 'CustomerGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'CustomerGetAllEdge', cursor: string, node?: { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, isActive: boolean, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, locationTags?: Array<{ __typename?: 'LocationTag', tag?: { __typename?: 'Tag', name?: string | null } | null } | null> | null }>, customerTags?: Array<{ __typename?: 'CustomerTag', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null } | null }> | null } | null };

export type AllCustomersTagQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<CustomerSortInput> | CustomerSortInput>;
  filterObject?: InputMaybe<CustomerFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  tag?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllCustomersTagQuery = { __typename?: 'Query', customersWithFilter?: { __typename?: 'CustomersWithFilterConnection', totalCount: number, edges?: Array<{ __typename?: 'CustomersWithFilterEdge', cursor: string, node?: { __typename?: 'Customer', customerKey: number, description?: string | null, name?: string | null, dbaName?: string | null, isActive: boolean, locations: Array<{ __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, locationTags?: Array<{ __typename?: 'LocationTag', tag?: { __typename?: 'Tag', name?: string | null } | null } | null> | null }>, customerTags?: Array<{ __typename?: 'CustomerTag', tag?: { __typename?: 'Tag', name?: string | null } | null }> | null } | null }> | null } | null };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', customerDelete: boolean };

export type CreateDirectMarkupMutationVariables = Exact<{
  directMarkup: DirectMarkupInput;
}>;


export type CreateDirectMarkupMutation = { __typename?: 'Mutation', directMarkupCreate: { __typename?: 'DirectMarkup', directMarkupKey: number } };

export type EditDirectMarkupMutationVariables = Exact<{
  directMarkup: DirectMarkupInput;
  id: Scalars['Int']['input'];
}>;


export type EditDirectMarkupMutation = { __typename?: 'Mutation', directMarkupUpdate: { __typename?: 'DirectMarkup', directMarkupKey: number } };

export type InnerDirectMarkupFragment = { __typename?: 'DirectMarkup', directMarkupKey: number, markup: number, supplierKey: number, locationKey: number, terminalKey: number, directMarkupType: DirectMarkupType, isArchived: boolean };

export type GetSingleDirectMarkupQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleDirectMarkupQuery = { __typename?: 'Query', directMarkupGetSingle: { __typename?: 'DirectMarkup', directMarkupKey: number, markup: number, supplierKey: number, locationKey: number, terminalKey: number, directMarkupType: DirectMarkupType, isArchived: boolean } };

export type AllDirectMarkupListingFragment = { __typename?: 'DirectMarkup', directMarkupKey: number, markup: number, directMarkupType: DirectMarkupType, terminal?: { __typename?: 'Terminal', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, state?: string | null, customer: { __typename?: 'Customer', name?: string | null } } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null };

export type AllFlatDirectMarkupListingFragment = { __typename?: 'FlatDirectMarkup', directMarkupKey: number, markup: number, directMarkupType: DirectMarkupType, terminal?: string | null, location?: string | null, supplier?: string | null };

export type AllDirectMarkupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDirectMarkupsQuery = { __typename?: 'Query', directMarkupGetAll: Array<{ __typename?: 'DirectMarkup', directMarkupKey: number, markup: number, directMarkupType: DirectMarkupType, terminal?: { __typename?: 'Terminal', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, state?: string | null, customer: { __typename?: 'Customer', name?: string | null } } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null }> };

export type AllFlatDirectMarkupsQueryVariables = Exact<{
  sort?: InputMaybe<Array<FlatDirectMarkupSortInput> | FlatDirectMarkupSortInput>;
  filter: FlatDirectMarkupFilterInput;
}>;


export type AllFlatDirectMarkupsQuery = { __typename?: 'Query', flatDirectMarkupGetAll: Array<{ __typename?: 'FlatDirectMarkup', directMarkupKey: number, markup: number, directMarkupType: DirectMarkupType, terminal?: string | null, location?: string | null, supplier?: string | null }> };

export type DeleteDirectMarkupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteDirectMarkupMutation = { __typename?: 'Mutation', directMarkupDelete: boolean };

export type CreateFileNumberMutationVariables = Exact<{
  fileNumber: FileNumberInput;
}>;


export type CreateFileNumberMutation = { __typename?: 'Mutation', fileNumberCreate: { __typename?: 'FileNumber', fileNumberKey: number } };

export type EditFileNumberMutationVariables = Exact<{
  fileNumber: FileNumberInput;
  id: Scalars['Int']['input'];
}>;


export type EditFileNumberMutation = { __typename?: 'Mutation', fileNumberUpdate: { __typename?: 'FileNumber', fileNumberKey: number } };

export type DeleteFileNumberMutationVariables = Exact<{
  fileNumberKey: Scalars['Int']['input'];
}>;


export type DeleteFileNumberMutation = { __typename?: 'Mutation', fileNumberDelete: boolean };

export type InnerFileNumberFragment = { __typename?: 'FileNumber', fileNumberKey: number, number?: string | null, supplierKey: number, terminalKey: number, isArchived: boolean, isDefault: boolean };

export type GetSingleFileNumberQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type GetSingleFileNumberQuery = { __typename?: 'Query', fileNumberGetSingle: { __typename?: 'FileNumber', fileNumberKey: number, number?: string | null, supplierKey: number, terminalKey: number, isArchived: boolean, isDefault: boolean } };

export type AllFileNumberListingFragment = { __typename?: 'FileNumber', fileNumberKey: number, number?: string | null, isDefault: boolean, isArchived: boolean, terminal?: { __typename?: 'Terminal', name?: string | null } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null };

export type AllFileNumbersQueryVariables = Exact<{
  filter?: InputMaybe<FileNumberFilterInput>;
  sort?: InputMaybe<Array<FileNumberSortInput> | FileNumberSortInput>;
}>;


export type AllFileNumbersQuery = { __typename?: 'Query', fileNumberGetAll?: Array<{ __typename?: 'FileNumber', fileNumberKey: number, number?: string | null, isDefault: boolean, isArchived: boolean, terminal?: { __typename?: 'Terminal', name?: string | null } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null }> | null };

export type FlatFileNumberListingFragment = { __typename?: 'FlatFileNumber', fileNumberKey: number, number?: string | null, isDefault: boolean, terminal?: string | null, supplier?: string | null, isArchived: boolean };

export type GetAllFlatFileNumbersQueryVariables = Exact<{
  sort?: InputMaybe<Array<FlatFileNumberSortInput> | FlatFileNumberSortInput>;
  filter?: InputMaybe<FlatFileNumberFilterInput>;
}>;


export type GetAllFlatFileNumbersQuery = { __typename?: 'Query', flatFileNumberGetAll: Array<{ __typename?: 'FlatFileNumber', fileNumberKey: number, number?: string | null, isDefault: boolean, terminal?: string | null, supplier?: string | null, isArchived: boolean }> };

export type DisplayTaskFragment = { __typename?: 'Task', taskKey: number, taskDate: any, contactKey: number, contact: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, phone?: string | null }, location: { __typename?: 'Location', name?: string | null, city?: string | null, customer: { __typename?: 'Customer', name?: string | null }, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } }, user: { __typename?: 'User', email?: string | null, name?: string | null } };

export type GetHomeScreenTasksQueryVariables = Exact<{
  endOfDayDate: Scalars['DateTime']['input'];
}>;


export type GetHomeScreenTasksQuery = { __typename?: 'Query', taskGetAll: Array<{ __typename?: 'Task', taskKey: number, taskDate: any, contactKey: number, contact: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, phone?: string | null }, location: { __typename?: 'Location', name?: string | null, city?: string | null, customer: { __typename?: 'Customer', name?: string | null }, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } }, user: { __typename?: 'User', email?: string | null, name?: string | null } }> };

export type CreateIndexContractMutationVariables = Exact<{
  indexContract: IndexContractInput;
}>;


export type CreateIndexContractMutation = { __typename?: 'Mutation', indexContractCreate: { __typename?: 'IndexContract', indexContractKey: number } };

export type AllIndexContractFragment = { __typename?: 'IndexContract', terminalKey: number, supplierKey: number, basisTypeKey: number, effectiveDate: any, effectiveEndDate: any, accountInfo?: string | null, supplierType: SupplierType, contractPeriod: ContractPeriod, isIndication: boolean, minimumLoads?: number | null, maximumLoads?: number | null, minimumGallons?: number | null, maximumGallons?: number | null, januaryIndex: number, februaryIndex: number, marchIndex: number, aprilIndex: number, mayIndex: number, juneIndex: number, julyIndex: number, augustIndex: number, septemberIndex: number, octoberIndex: number, novemberIndex: number, decemberIndex: number, dayPrior: boolean, terminal: { __typename?: 'Terminal', name?: string | null }, supplier: { __typename?: 'Supplier', name?: string | null }, basisType: { __typename?: 'BasisType', name?: string | null, basisTypePrices?: Array<{ __typename?: 'BasisTypePrice', effectiveDate: any, price: number } | null> | null } };

export type EditIndexContractMutationVariables = Exact<{
  indexContract: IndexContractInput;
  id: Scalars['Int']['input'];
}>;


export type EditIndexContractMutation = { __typename?: 'Mutation', indexContractUpdate: { __typename?: 'IndexContract', indexContractKey: number } };

export type SingleIndexContractFragment = { __typename?: 'IndexContract', terminalKey: number, supplierKey: number, basisTypeKey: number, effectiveDate: any, effectiveEndDate: any, accountInfo?: string | null, supplierType: SupplierType, contractPeriod: ContractPeriod, isIndication: boolean, minimumLoads?: number | null, maximumLoads?: number | null, minimumGallons?: number | null, maximumGallons?: number | null, januaryIndex: number, februaryIndex: number, marchIndex: number, aprilIndex: number, mayIndex: number, juneIndex: number, julyIndex: number, augustIndex: number, septemberIndex: number, octoberIndex: number, novemberIndex: number, decemberIndex: number, dayPrior: boolean, terminal: { __typename?: 'Terminal', name?: string | null }, supplier: { __typename?: 'Supplier', name?: string | null }, basisType: { __typename?: 'BasisType', name?: string | null, basisTypePrices?: Array<{ __typename?: 'BasisTypePrice', effectiveDate: any, price: number } | null> | null } };

export type GetSingleIndexContractQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleIndexContractQuery = { __typename?: 'Query', indexContractGetSingle: { __typename?: 'IndexContract', terminalKey: number, supplierKey: number, basisTypeKey: number, effectiveDate: any, effectiveEndDate: any, accountInfo?: string | null, supplierType: SupplierType, contractPeriod: ContractPeriod, isIndication: boolean, minimumLoads?: number | null, maximumLoads?: number | null, minimumGallons?: number | null, maximumGallons?: number | null, januaryIndex: number, februaryIndex: number, marchIndex: number, aprilIndex: number, mayIndex: number, juneIndex: number, julyIndex: number, augustIndex: number, septemberIndex: number, octoberIndex: number, novemberIndex: number, decemberIndex: number, dayPrior: boolean, terminal: { __typename?: 'Terminal', name?: string | null }, supplier: { __typename?: 'Supplier', name?: string | null }, basisType: { __typename?: 'BasisType', name?: string | null, basisTypePrices?: Array<{ __typename?: 'BasisTypePrice', effectiveDate: any, price: number } | null> | null } } };

export type IndexContractListingFragment = { __typename?: 'IndexContract', indexContractKey: number, accountInfo?: string | null, effectiveDate: any, effectiveEndDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } };

export type FlatIndexContractListingFragment = { __typename?: 'FlatIndexContract', indexContractKey: number, supplier?: string | null, supplierKey: number, terminal?: string | null, accountInfo?: string | null, effectiveDate: any, effectiveEndDate: any };

export type GetAllIndexContractsQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<IndexContractSortInput> | IndexContractSortInput>;
  filterObject?: InputMaybe<IndexContractFilterInput>;
}>;


export type GetAllIndexContractsQuery = { __typename?: 'Query', indexContractsGetAll: Array<{ __typename?: 'IndexContract', indexContractKey: number, accountInfo?: string | null, effectiveDate: any, effectiveEndDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } }> };

export type GetAllFlatIndexContractsQueryVariables = Exact<{
  sort?: InputMaybe<Array<FlatIndexContractSortInput> | FlatIndexContractSortInput>;
  filter?: InputMaybe<FlatIndexContractFilterInput>;
}>;


export type GetAllFlatIndexContractsQuery = { __typename?: 'Query', flatIndexContractGetAll: Array<{ __typename?: 'FlatIndexContract', indexContractKey: number, supplier?: string | null, supplierKey: number, terminal?: string | null, accountInfo?: string | null, effectiveDate: any, effectiveEndDate: any }> };

export type DeleteIndexContractMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteIndexContractMutation = { __typename?: 'Mutation', indexContractDelete: boolean };

export type CreateLocationMutationVariables = Exact<{
  location: LocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', locationCreate: { __typename?: 'Location', locationKey: number } };

export type CreateLocationTagMutationVariables = Exact<{
  locationTag: LocationTagInput;
}>;


export type CreateLocationTagMutation = { __typename?: 'Mutation', locationTagCreate: { __typename?: 'LocationTag', locationKey: number, tagKey: number } };

export type DeleteLocationTagMutationVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  tagKey: Scalars['Int']['input'];
}>;


export type DeleteLocationTagMutation = { __typename?: 'Mutation', locationTagDelete: boolean };

export type EditLocationMutationVariables = Exact<{
  location: LocationInput;
  id: Scalars['Int']['input'];
}>;


export type EditLocationMutation = { __typename?: 'Mutation', locationUpdate: { __typename?: 'Location', locationKey: number } };

export type RemoveTerminalFromLocationMutationVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  terminalKey: Scalars['Int']['input'];
}>;


export type RemoveTerminalFromLocationMutation = { __typename?: 'Mutation', locationRemoveTerminal: boolean };

export type SingleLocationTerminalFragment = { __typename?: 'LocationTerminal', mileage: number, terminalKey: number, locationKey: number, terminal: { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, isArchived: boolean, contacts?: Array<{ __typename?: 'Contact', contactKey: number } | null> | null } };

export type SingleLocationFragmentFragment = { __typename?: 'Location', locationKey: number, address1?: string | null, address2?: string | null, agId?: string | null, city?: string | null, customerKey: number, directions?: string | null, federalId?: string | null, hasPercCharge: boolean, isAgExempt: boolean, isFobCustomer: boolean, isInternetCustomer: boolean, isTaxExempt: boolean, locationNotes?: string | null, markupCost: number, lockMarkup: boolean, name?: string | null, quickBooksName?: string | null, state?: string | null, stateId?: string | null, stateKey: number, zipCode?: string | null, locationStatus: LocationStatus, percentOfSales?: number | null, mailToAddress1?: string | null, mailToAddress2?: string | null, mailToCity?: string | null, mailToDirections?: string | null, mailToState?: string | null, mailToZipCode?: string | null, mailToSameAsCustomer: boolean, isActive: boolean, primaryCarrierKey?: number | null, secondaryCarrierKey?: number | null, stateObj: { __typename?: 'State', name?: string | null, stateKey: number }, tanks?: Array<{ __typename?: 'Tank', tankKey: number, size: number } | null> | null, primaryCarrier?: { __typename?: 'Carrier', name?: string | null } | null, secondaryCarrier?: { __typename?: 'Carrier', name?: string | null } | null, locationContacts?: Array<{ __typename?: 'LocationContact', default: boolean, contact?: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, notes?: string | null, default: boolean, cellPhone?: string | null, homePhone?: string | null, deleted: boolean } | null } | null> | null, customer: { __typename?: 'Customer', customerKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, directions?: string | null }, locationTerminals?: Array<{ __typename?: 'LocationTerminal', mileage: number, terminalKey: number, locationKey: number, terminal: { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, isArchived: boolean, contacts?: Array<{ __typename?: 'Contact', contactKey: number } | null> | null } } | null> | null, tasks?: Array<{ __typename?: 'Task', callDetails?: string | null, taskDate: any, contact: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null } } | null> | null, locationTags?: Array<{ __typename?: 'LocationTag', locationKey: number, tagKey: number } | null> | null };

export type GetSingleLocationQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
}>;


export type GetSingleLocationQuery = { __typename?: 'Query', locationGetSingle: { __typename?: 'Location', locationKey: number, address1?: string | null, address2?: string | null, agId?: string | null, city?: string | null, customerKey: number, directions?: string | null, federalId?: string | null, hasPercCharge: boolean, isAgExempt: boolean, isFobCustomer: boolean, isInternetCustomer: boolean, isTaxExempt: boolean, locationNotes?: string | null, markupCost: number, lockMarkup: boolean, name?: string | null, quickBooksName?: string | null, state?: string | null, stateId?: string | null, stateKey: number, zipCode?: string | null, locationStatus: LocationStatus, percentOfSales?: number | null, mailToAddress1?: string | null, mailToAddress2?: string | null, mailToCity?: string | null, mailToDirections?: string | null, mailToState?: string | null, mailToZipCode?: string | null, mailToSameAsCustomer: boolean, isActive: boolean, primaryCarrierKey?: number | null, secondaryCarrierKey?: number | null, stateObj: { __typename?: 'State', name?: string | null, stateKey: number }, tanks?: Array<{ __typename?: 'Tank', tankKey: number, size: number } | null> | null, primaryCarrier?: { __typename?: 'Carrier', name?: string | null } | null, secondaryCarrier?: { __typename?: 'Carrier', name?: string | null } | null, locationContacts?: Array<{ __typename?: 'LocationContact', default: boolean, contact?: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, notes?: string | null, default: boolean, cellPhone?: string | null, homePhone?: string | null, deleted: boolean } | null } | null> | null, customer: { __typename?: 'Customer', customerKey: number, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, directions?: string | null }, locationTerminals?: Array<{ __typename?: 'LocationTerminal', mileage: number, terminalKey: number, locationKey: number, terminal: { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, isArchived: boolean, contacts?: Array<{ __typename?: 'Contact', contactKey: number } | null> | null } } | null> | null, tasks?: Array<{ __typename?: 'Task', callDetails?: string | null, taskDate: any, contact: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null } } | null> | null, locationTags?: Array<{ __typename?: 'LocationTag', locationKey: number, tagKey: number } | null> | null } };

export type AddContactToLocationMutationVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  contactKey: Scalars['Int']['input'];
  default: Scalars['Boolean']['input'];
}>;


export type AddContactToLocationMutation = { __typename?: 'Mutation', addContactToLocation: boolean };

export type DefaultContactLocationMutationVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  contactKey: Scalars['Int']['input'];
  def: Scalars['Boolean']['input'];
}>;


export type DefaultContactLocationMutation = { __typename?: 'Mutation', defaultContactLocation: boolean };

export type UnlinkContactFromLocationMutationVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  contactKey: Scalars['Int']['input'];
}>;


export type UnlinkContactFromLocationMutation = { __typename?: 'Mutation', unlinkContactFromLocation: boolean };

export type LatestOrderQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
}>;


export type LatestOrderQuery = { __typename?: 'Query', orderGetAll?: { __typename?: 'OrderGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'OrderGetAllEdge', cursor: string, node?: { __typename?: 'Order', orderKey: number, deliveryDate: any, tripNumber?: string | null, status: OrderStatus, actualGallons?: number | null, gallons: number, freight: number, tolls: number, product: number, otherCharge?: number | null, otherCost?: number | null, supplierPaid?: any | null, carrierPaid?: any | null, manifest?: string | null, delivered: number, orderType: OrderType, tripsActualGallons?: number | null, tripManifest?: string | null, tripNotes?: string | null, readyForInvoicing: boolean, specialInstructions?: string | null, costDescription?: string | null, postingKey?: number | null, indexContractKey?: number | null, legacyCostType?: string | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, assessment: number, location?: { __typename?: 'Location', name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', supplierKey: number, name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, carrier?: { __typename?: 'Carrier', carrierKey: number, name?: string | null, email?: string | null, state?: string | null } | null, indexContract?: { __typename?: 'IndexContract', fileNumber?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null } | null }> | null } | null };

export type DeleteTankMutationVariables = Exact<{
  tankKey: Scalars['Int']['input'];
}>;


export type DeleteTankMutation = { __typename?: 'Mutation', tankDelete: boolean };

export type InnerLocationFragment = { __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, zipCode?: string | null, address1?: string | null, address2?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, customer: { __typename?: 'Customer', customerKey: number, name?: string | null } };

export type InnerLocationListingFragment = { __typename?: 'LocationGetAllEdge', node?: { __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, zipCode?: string | null, address1?: string | null, address2?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, customer: { __typename?: 'Customer', customerKey: number, name?: string | null } } | null };

export type AllLocationListingFragment = { __typename?: 'LocationGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'LocationGetAllEdge', cursor: string, node?: { __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, zipCode?: string | null, address1?: string | null, address2?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, customer: { __typename?: 'Customer', customerKey: number, name?: string | null } } | null }> | null };

export type AllLocationsQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<LocationSortInput> | LocationSortInput>;
  filterObject?: InputMaybe<LocationFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllLocationsQuery = { __typename?: 'Query', locationGetAll?: { __typename?: 'LocationGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'LocationGetAllEdge', cursor: string, node?: { __typename?: 'Location', locationKey: number, name?: string | null, city?: string | null, zipCode?: string | null, address1?: string | null, address2?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null }, customer: { __typename?: 'Customer', customerKey: number, name?: string | null } } | null }> | null } | null };

export type MassMarkupMutationVariables = Exact<{
  markupAmount: Scalars['Float']['input'];
  currentMarkup: Scalars['Float']['input'];
}>;


export type MassMarkupMutation = { __typename?: 'Mutation', massMarkup: boolean };

export type CreateOrderMutationVariables = Exact<{
  order: OrderInput;
  copy?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', orderCreate: { __typename?: 'Order', orderKey: number } };

export type GetPricingPostingQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  postingKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  salesAgreementKey?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPricingPostingQuery = { __typename?: 'Query', pricingPostingGet?: { __typename?: 'Pricing', pricingType: PricingType, effectiveDate: any, supplierName?: string | null, supplierKey: number, terminalName?: string | null, terminalKey: number, product: number, markup: number, patCost: number, perc: number, stateTax: number, stateAssessment: number, fob: number, mileage: number, primaryCarrier?: string | null, secondaryCarrier?: string | null, primaryCarrierRate: number, secondaryCarrierRate: number, primaryCarrierDelivered: number, secondaryCarrierDelivered: number, primaryCarrierKey: number, secondaryCarrierKey?: number | null, locationKey: number, queryString?: string | null, contractVolumeExhausted: boolean, pricingName?: string | null, termContractKey?: number | null, hasErrors: boolean, pricingKey: number } | null };

export type GetPricingIndexContractQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  indexContractKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  salesAgreementKey?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPricingIndexContractQuery = { __typename?: 'Query', pricingIndexContractGet?: { __typename?: 'Pricing', pricingType: PricingType, effectiveDate: any, supplierName?: string | null, supplierKey: number, terminalName?: string | null, terminalKey: number, product: number, markup: number, patCost: number, perc: number, stateTax: number, stateAssessment: number, fob: number, mileage: number, primaryCarrier?: string | null, secondaryCarrier?: string | null, primaryCarrierRate: number, secondaryCarrierRate: number, primaryCarrierDelivered: number, secondaryCarrierDelivered: number, primaryCarrierKey: number, secondaryCarrierKey?: number | null, locationKey: number, queryString?: string | null, contractVolumeExhausted: boolean, pricingName?: string | null, termContractKey?: number | null, hasErrors: boolean, pricingKey: number } | null };

export type GetPricingPrePurchaseAgreementQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  prePurchaseAgreementKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  salesAgreementKey?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPricingPrePurchaseAgreementQuery = { __typename?: 'Query', pricingPrePurchaseAgreementGet?: { __typename?: 'Pricing', pricingType: PricingType, effectiveDate: any, supplierName?: string | null, supplierKey: number, terminalName?: string | null, terminalKey: number, product: number, markup: number, patCost: number, perc: number, stateTax: number, stateAssessment: number, fob: number, mileage: number, primaryCarrier?: string | null, secondaryCarrier?: string | null, primaryCarrierRate: number, secondaryCarrierRate: number, primaryCarrierDelivered: number, secondaryCarrierDelivered: number, primaryCarrierKey: number, secondaryCarrierKey?: number | null, locationKey: number, queryString?: string | null, contractVolumeExhausted: boolean, pricingName?: string | null, termContractKey?: number | null, hasErrors: boolean, pricingKey: number } | null };

export type GetPricingSalesAgreementQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  salesAgreementKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
}>;


export type GetPricingSalesAgreementQuery = { __typename?: 'Query', pricingSalesAgreementGet?: { __typename?: 'Pricing', pricingType: PricingType, effectiveDate: any, supplierName?: string | null, supplierKey: number, terminalName?: string | null, terminalKey: number, product: number, markup: number, patCost: number, perc: number, stateTax: number, stateAssessment: number, fob: number, mileage: number, primaryCarrier?: string | null, secondaryCarrier?: string | null, primaryCarrierRate: number, secondaryCarrierRate: number, primaryCarrierDelivered: number, secondaryCarrierDelivered: number, primaryCarrierKey: number, secondaryCarrierKey?: number | null, locationKey: number, queryString?: string | null, contractVolumeExhausted: boolean, pricingName?: string | null, termContractKey?: number | null, hasErrors: boolean, pricingKey: number } | null };

export type GetFreightForOrderQueryVariables = Exact<{
  carrierKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
  mileage: Scalars['Int']['input'];
  terminalKey: Scalars['Int']['input'];
  locationKey: Scalars['Int']['input'];
}>;


export type GetFreightForOrderQuery = { __typename?: 'Query', freightForOrderGet?: { __typename?: 'FlatCarrierRate', carrierRateKey: number, rateType: CarrierType, ratePerGallon: number, toll: number } | null };

export type GetStateTaxesForOrderQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']['input']>;
  pricingDate: Scalars['DateTime']['input'];
}>;


export type GetStateTaxesForOrderQuery = { __typename?: 'Query', stateTaxGetForStateOnDate?: Array<{ __typename?: 'StateTax', stateTaxKey: number, amount: number, stateTaxType: StateTaxType }> | null };

export type GetStateTaxesForLocationQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  pricingDate: Scalars['DateTime']['input'];
}>;


export type GetStateTaxesForLocationQuery = { __typename?: 'Query', stateTaxGetForLocationOnDate?: Array<{ __typename?: 'StateTax', stateTaxKey: number, amount: number, stateTaxType: StateTaxType }> | null };

export type GetLocationSingleForOrderCreationQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
}>;


export type GetLocationSingleForOrderCreationQuery = { __typename?: 'Query', locationGetSingle: { __typename?: 'Location', isFobCustomer: boolean, customer: { __typename?: 'Customer', deliveryTimeKey?: number | null } } };

export type UpdateOrderMutationVariables = Exact<{
  order: OrderInput;
  id: Scalars['Int']['input'];
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', orderUpdate: { __typename?: 'Order', orderKey: number } };

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', orderDelete: boolean };

export type DispatchOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DispatchOrderMutation = { __typename?: 'Mutation', orderDispatch: { __typename?: 'Order', locationKey: number, customerKey: number, supplierKey: number, terminalKey: number, carrierKey: number, termContractKey?: number | null, deliveryTimeKey?: number | null, status: OrderStatus, fileNumberKey?: number | null, deliveryDate: any, gallons: number, miles: number, tripNumber?: string | null, specialInstructions?: string | null, product: number, markup: number, freight: number, tolls: number, assessment: number, misc?: number | null, fOB: number, delivered: number, actualGallons?: number | null, poNumber?: string | null, sglInvoiceNumber?: string | null, manifest?: string | null, otherCharge?: number | null, otherCost?: number | null, costDescription?: string | null, patCost?: number | null, patCostTotal?: number | null, prePurchaseAgreementKey?: number | null, postingKey?: number | null, indexContractKey?: number | null, salesAgreementKey?: number | null, createdByUserId?: number | null, createdDate?: any | null, orderType: OrderType, quotedPrice: boolean, readyForInvoicing: boolean, tripNotes?: string | null, tripsActualGallons?: number | null, tripManifest?: string | null, carrierPaid?: any | null, supplierPaid?: any | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, perc?: number | null, location?: { __typename?: 'Location', state?: string | null, locationTerminals?: Array<{ __typename?: 'LocationTerminal', mileage: number } | null> | null } | null, customer?: { __typename?: 'Customer', quickBooksName?: string | null } | null, prePurchaseAgreement?: { __typename?: 'PrePurchaseAgreement', supplierAgreement?: string | null } | null, carrier?: { __typename?: 'Carrier', email?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null, modifiedByUser?: { __typename?: 'User', name?: string | null } | null } };

export type ReadyForInvoicingOrderMutationVariables = Exact<{
  orderKey: Scalars['Int']['input'];
}>;


export type ReadyForInvoicingOrderMutation = { __typename?: 'Mutation', orderReadyForInvoicing: boolean };

export type CloseOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  quickbooks: Scalars['Boolean']['input'];
}>;


export type CloseOrderMutation = { __typename?: 'Mutation', orderClose: { __typename?: 'Order', locationKey: number, customerKey: number, supplierKey: number, terminalKey: number, carrierKey: number, termContractKey?: number | null, deliveryTimeKey?: number | null, status: OrderStatus, fileNumberKey?: number | null, deliveryDate: any, gallons: number, miles: number, tripNumber?: string | null, specialInstructions?: string | null, product: number, markup: number, freight: number, tolls: number, assessment: number, misc?: number | null, fOB: number, delivered: number, actualGallons?: number | null, poNumber?: string | null, sglInvoiceNumber?: string | null, manifest?: string | null, otherCharge?: number | null, otherCost?: number | null, costDescription?: string | null, patCost?: number | null, patCostTotal?: number | null, prePurchaseAgreementKey?: number | null, postingKey?: number | null, indexContractKey?: number | null, salesAgreementKey?: number | null, createdByUserId?: number | null, createdDate?: any | null, orderType: OrderType, quotedPrice: boolean, readyForInvoicing: boolean, tripNotes?: string | null, tripsActualGallons?: number | null, tripManifest?: string | null, carrierPaid?: any | null, supplierPaid?: any | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, perc?: number | null, location?: { __typename?: 'Location', state?: string | null, locationTerminals?: Array<{ __typename?: 'LocationTerminal', mileage: number } | null> | null } | null, customer?: { __typename?: 'Customer', quickBooksName?: string | null } | null, prePurchaseAgreement?: { __typename?: 'PrePurchaseAgreement', supplierAgreement?: string | null } | null, carrier?: { __typename?: 'Carrier', email?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null, modifiedByUser?: { __typename?: 'User', name?: string | null } | null } };

export type SendBackToDispatchedOrderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SendBackToDispatchedOrderMutation = { __typename?: 'Mutation', orderSendBackToDispatch: boolean };

export type SingleOrderFragment = { __typename?: 'Order', locationKey: number, customerKey: number, supplierKey: number, terminalKey: number, carrierKey: number, termContractKey?: number | null, deliveryTimeKey?: number | null, status: OrderStatus, fileNumberKey?: number | null, deliveryDate: any, gallons: number, miles: number, tripNumber?: string | null, specialInstructions?: string | null, product: number, markup: number, freight: number, tolls: number, assessment: number, misc?: number | null, fOB: number, delivered: number, actualGallons?: number | null, poNumber?: string | null, sglInvoiceNumber?: string | null, manifest?: string | null, otherCharge?: number | null, otherCost?: number | null, costDescription?: string | null, patCost?: number | null, patCostTotal?: number | null, prePurchaseAgreementKey?: number | null, postingKey?: number | null, indexContractKey?: number | null, salesAgreementKey?: number | null, createdByUserId?: number | null, createdDate?: any | null, orderType: OrderType, quotedPrice: boolean, readyForInvoicing: boolean, tripNotes?: string | null, tripsActualGallons?: number | null, tripManifest?: string | null, carrierPaid?: any | null, supplierPaid?: any | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, perc?: number | null, location?: { __typename?: 'Location', state?: string | null, locationTerminals?: Array<{ __typename?: 'LocationTerminal', mileage: number } | null> | null } | null, customer?: { __typename?: 'Customer', quickBooksName?: string | null } | null, prePurchaseAgreement?: { __typename?: 'PrePurchaseAgreement', supplierAgreement?: string | null } | null, carrier?: { __typename?: 'Carrier', email?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null, modifiedByUser?: { __typename?: 'User', name?: string | null } | null };

export type GetSingleOrderQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleOrderQuery = { __typename?: 'Query', orderGetSingle: { __typename?: 'Order', locationKey: number, customerKey: number, supplierKey: number, terminalKey: number, carrierKey: number, termContractKey?: number | null, deliveryTimeKey?: number | null, status: OrderStatus, fileNumberKey?: number | null, deliveryDate: any, gallons: number, miles: number, tripNumber?: string | null, specialInstructions?: string | null, product: number, markup: number, freight: number, tolls: number, assessment: number, misc?: number | null, fOB: number, delivered: number, actualGallons?: number | null, poNumber?: string | null, sglInvoiceNumber?: string | null, manifest?: string | null, otherCharge?: number | null, otherCost?: number | null, costDescription?: string | null, patCost?: number | null, patCostTotal?: number | null, prePurchaseAgreementKey?: number | null, postingKey?: number | null, indexContractKey?: number | null, salesAgreementKey?: number | null, createdByUserId?: number | null, createdDate?: any | null, orderType: OrderType, quotedPrice: boolean, readyForInvoicing: boolean, tripNotes?: string | null, tripsActualGallons?: number | null, tripManifest?: string | null, carrierPaid?: any | null, supplierPaid?: any | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, perc?: number | null, location?: { __typename?: 'Location', state?: string | null, locationTerminals?: Array<{ __typename?: 'LocationTerminal', mileage: number } | null> | null } | null, customer?: { __typename?: 'Customer', quickBooksName?: string | null } | null, prePurchaseAgreement?: { __typename?: 'PrePurchaseAgreement', supplierAgreement?: string | null } | null, carrier?: { __typename?: 'Carrier', email?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null, modifiedByUser?: { __typename?: 'User', name?: string | null } | null } };

export type RefreshOrderPricingMutationVariables = Exact<{
  orderKey: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
  pKey?: InputMaybe<Scalars['Int']['input']>;
  icKey?: InputMaybe<Scalars['Int']['input']>;
  ppaKey?: InputMaybe<Scalars['Int']['input']>;
  saKey?: InputMaybe<Scalars['Int']['input']>;
  termContractKey?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RefreshOrderPricingMutation = { __typename?: 'Mutation', orderRedoPricing: boolean };

export type InnerOrderFragment = { __typename?: 'Order', orderKey: number, deliveryDate: any, tripNumber?: string | null, status: OrderStatus, actualGallons?: number | null, gallons: number, freight: number, tolls: number, product: number, otherCharge?: number | null, otherCost?: number | null, supplierPaid?: any | null, carrierPaid?: any | null, manifest?: string | null, delivered: number, orderType: OrderType, tripsActualGallons?: number | null, tripManifest?: string | null, tripNotes?: string | null, readyForInvoicing: boolean, specialInstructions?: string | null, costDescription?: string | null, postingKey?: number | null, indexContractKey?: number | null, legacyCostType?: string | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, assessment: number, location?: { __typename?: 'Location', name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', supplierKey: number, name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, carrier?: { __typename?: 'Carrier', carrierKey: number, name?: string | null, email?: string | null, state?: string | null } | null, indexContract?: { __typename?: 'IndexContract', fileNumber?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null };

export type OrderDashboardListingFragment = { __typename?: 'OrderDashboardConnection', totalCount: number, edges?: Array<{ __typename?: 'OrderDashboardEdge', cursor: string, node?: { __typename?: 'Order', orderKey: number, deliveryDate: any, tripNumber?: string | null, status: OrderStatus, actualGallons?: number | null, gallons: number, freight: number, tolls: number, product: number, otherCharge?: number | null, otherCost?: number | null, supplierPaid?: any | null, carrierPaid?: any | null, manifest?: string | null, delivered: number, orderType: OrderType, tripsActualGallons?: number | null, tripManifest?: string | null, tripNotes?: string | null, readyForInvoicing: boolean, specialInstructions?: string | null, costDescription?: string | null, postingKey?: number | null, indexContractKey?: number | null, legacyCostType?: string | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, assessment: number, location?: { __typename?: 'Location', name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', supplierKey: number, name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, carrier?: { __typename?: 'Carrier', carrierKey: number, name?: string | null, email?: string | null, state?: string | null } | null, indexContract?: { __typename?: 'IndexContract', fileNumber?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null } | null }> | null };

export type InnerOrderListingFragment = { __typename?: 'OrderDashboardEdge', node?: { __typename?: 'Order', orderKey: number, deliveryDate: any, tripNumber?: string | null, status: OrderStatus, actualGallons?: number | null, gallons: number, freight: number, tolls: number, product: number, otherCharge?: number | null, otherCost?: number | null, supplierPaid?: any | null, carrierPaid?: any | null, manifest?: string | null, delivered: number, orderType: OrderType, tripsActualGallons?: number | null, tripManifest?: string | null, tripNotes?: string | null, readyForInvoicing: boolean, specialInstructions?: string | null, costDescription?: string | null, postingKey?: number | null, indexContractKey?: number | null, legacyCostType?: string | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, assessment: number, location?: { __typename?: 'Location', name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', supplierKey: number, name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, carrier?: { __typename?: 'Carrier', carrierKey: number, name?: string | null, email?: string | null, state?: string | null } | null, indexContract?: { __typename?: 'IndexContract', fileNumber?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null } | null };

export type OrderGetAllListingFragment = { __typename?: 'OrderGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'OrderGetAllEdge', cursor: string, node?: { __typename?: 'Order', orderKey: number, deliveryDate: any, tripNumber?: string | null, status: OrderStatus, actualGallons?: number | null, gallons: number, freight: number, tolls: number, product: number, otherCharge?: number | null, otherCost?: number | null, supplierPaid?: any | null, carrierPaid?: any | null, manifest?: string | null, delivered: number, orderType: OrderType, tripsActualGallons?: number | null, tripManifest?: string | null, tripNotes?: string | null, readyForInvoicing: boolean, specialInstructions?: string | null, costDescription?: string | null, postingKey?: number | null, indexContractKey?: number | null, legacyCostType?: string | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, assessment: number, location?: { __typename?: 'Location', name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', supplierKey: number, name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, carrier?: { __typename?: 'Carrier', carrierKey: number, name?: string | null, email?: string | null, state?: string | null } | null, indexContract?: { __typename?: 'IndexContract', fileNumber?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null } | null }> | null };

export type InnerOrderGetAllListingFragment = { __typename?: 'OrderGetAllEdge', node?: { __typename?: 'Order', orderKey: number, deliveryDate: any, tripNumber?: string | null, status: OrderStatus, actualGallons?: number | null, gallons: number, freight: number, tolls: number, product: number, otherCharge?: number | null, otherCost?: number | null, supplierPaid?: any | null, carrierPaid?: any | null, manifest?: string | null, delivered: number, orderType: OrderType, tripsActualGallons?: number | null, tripManifest?: string | null, tripNotes?: string | null, readyForInvoicing: boolean, specialInstructions?: string | null, costDescription?: string | null, postingKey?: number | null, indexContractKey?: number | null, legacyCostType?: string | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, assessment: number, location?: { __typename?: 'Location', name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', supplierKey: number, name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, carrier?: { __typename?: 'Carrier', carrierKey: number, name?: string | null, email?: string | null, state?: string | null } | null, indexContract?: { __typename?: 'IndexContract', fileNumber?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null } | null };

export type AllOrdersQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<OrderSortInput> | OrderSortInput>;
  filterObject?: InputMaybe<OrderFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllOrdersQuery = { __typename?: 'Query', orderGetAll?: { __typename?: 'OrderGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'OrderGetAllEdge', cursor: string, node?: { __typename?: 'Order', orderKey: number, deliveryDate: any, tripNumber?: string | null, status: OrderStatus, actualGallons?: number | null, gallons: number, freight: number, tolls: number, product: number, otherCharge?: number | null, otherCost?: number | null, supplierPaid?: any | null, carrierPaid?: any | null, manifest?: string | null, delivered: number, orderType: OrderType, tripsActualGallons?: number | null, tripManifest?: string | null, tripNotes?: string | null, readyForInvoicing: boolean, specialInstructions?: string | null, costDescription?: string | null, postingKey?: number | null, indexContractKey?: number | null, legacyCostType?: string | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, assessment: number, location?: { __typename?: 'Location', name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', supplierKey: number, name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, carrier?: { __typename?: 'Carrier', carrierKey: number, name?: string | null, email?: string | null, state?: string | null } | null, indexContract?: { __typename?: 'IndexContract', fileNumber?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null } | null }> | null } | null };

export type DashboardOrderQueryVariables = Exact<{
  notPaidOrders?: InputMaybe<Scalars['Boolean']['input']>;
  sortObject?: InputMaybe<Array<OrderSortInput> | OrderSortInput>;
  filterObject?: InputMaybe<OrderFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  status: OrderStatus;
  customer?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  customSort?: InputMaybe<Scalars['String']['input']>;
  customOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardOrderQuery = { __typename?: 'Query', orderDashboard?: { __typename?: 'OrderDashboardConnection', totalCount: number, edges?: Array<{ __typename?: 'OrderDashboardEdge', cursor: string, node?: { __typename?: 'Order', orderKey: number, deliveryDate: any, tripNumber?: string | null, status: OrderStatus, actualGallons?: number | null, gallons: number, freight: number, tolls: number, product: number, otherCharge?: number | null, otherCost?: number | null, supplierPaid?: any | null, carrierPaid?: any | null, manifest?: string | null, delivered: number, orderType: OrderType, tripsActualGallons?: number | null, tripManifest?: string | null, tripNotes?: string | null, readyForInvoicing: boolean, specialInstructions?: string | null, costDescription?: string | null, postingKey?: number | null, indexContractKey?: number | null, legacyCostType?: string | null, spotContract: boolean, stateAssessment?: number | null, stateTax?: number | null, assessment: number, location?: { __typename?: 'Location', name?: string | null, city?: string | null, stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', supplierKey: number, name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, carrier?: { __typename?: 'Carrier', carrierKey: number, name?: string | null, email?: string | null, state?: string | null } | null, indexContract?: { __typename?: 'IndexContract', fileNumber?: string | null } | null, createdByUser?: { __typename?: 'User', name?: string | null } | null } | null }> | null } | null };

export type OrderBulkCloseMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  sendToQB: Scalars['Boolean']['input'];
}>;


export type OrderBulkCloseMutation = { __typename?: 'Mutation', orderBulkClose: boolean };

export type OrderCarrierPaidMutationVariables = Exact<{
  orderKey: Scalars['Int']['input'];
}>;


export type OrderCarrierPaidMutation = { __typename?: 'Mutation', orderMarkCarrierPaid: boolean };

export type OrderCarrierAllPaidMutationVariables = Exact<{
  carrierKey: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type OrderCarrierAllPaidMutation = { __typename?: 'Mutation', orderMarkAllCarrierPaid: boolean };

export type OrderSupplierPaidMutationVariables = Exact<{
  orderKey: Scalars['Int']['input'];
}>;


export type OrderSupplierPaidMutation = { __typename?: 'Mutation', orderMarkSupplierPaid: boolean };

export type OrderSupplierAllPaidMutationVariables = Exact<{
  supplierKey: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type OrderSupplierAllPaidMutation = { __typename?: 'Mutation', orderMarkAllSupplierPaid: boolean };

export type OrderBolAndGallonsMutationVariables = Exact<{
  orderKey: Scalars['Int']['input'];
  manifest: Scalars['String']['input'];
  gallons: Scalars['Int']['input'];
  close: Scalars['Boolean']['input'];
}>;


export type OrderBolAndGallonsMutation = { __typename?: 'Mutation', orderUpdateBolAndGallons: boolean };

export type InnerPatCostFragment = { __typename?: 'PatCost', patCostKey: number, effectiveDate: any, cost: number, state?: string | null };

export type AllPatCostQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<PatCostSortInput> | PatCostSortInput>;
  filterObject?: InputMaybe<PatCostFilterInput>;
}>;


export type AllPatCostQuery = { __typename?: 'Query', patCostGetAll?: Array<{ __typename?: 'PatCost', patCostKey: number, effectiveDate: any, cost: number, state?: string | null }> | null };

export type DeletePatCostMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePatCostMutation = { __typename?: 'Mutation', patCostDelete: boolean };

export type CreatePatCostMutationVariables = Exact<{
  patCost: PatCostInput;
}>;


export type CreatePatCostMutation = { __typename?: 'Mutation', patCostCreate: { __typename?: 'PatCost', patCostKey: number } };

export type CreatePostingMutationVariables = Exact<{
  posting: PostingInput;
}>;


export type CreatePostingMutation = { __typename?: 'Mutation', postingCreate: { __typename?: 'Posting', postingKey: number } };

export type ValidatePostingCreateQueryVariables = Exact<{
  supplierKey: Scalars['Int']['input'];
  terminalKey: Scalars['Int']['input'];
  effectiveDate: Scalars['DateTime']['input'];
}>;


export type ValidatePostingCreateQuery = { __typename?: 'Query', postingValidateCreate: { __typename?: 'PostingValidationResult', isValid: boolean, errorMessage?: string | null, validationType: PostingValidationType, suggestedResolution: PostingConflictResolution, canAutoResolve: boolean, conflictingPostings?: Array<{ __typename?: 'Posting', postingKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null> | null } };

export type GetRelatedPostingsQueryVariables = Exact<{
  supplierKey: Scalars['Int']['input'];
  terminalKey: Scalars['Int']['input'];
}>;


export type GetRelatedPostingsQuery = { __typename?: 'Query', postingGetAll?: { __typename?: 'PostingGetAllConnection', nodes?: Array<{ __typename?: 'Posting', postingKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null> | null } | null };

export type PostingReplaceExistingMutationVariables = Exact<{
  posting: PostingInput;
  existingPostingKey: Scalars['Int']['input'];
}>;


export type PostingReplaceExistingMutation = { __typename?: 'Mutation', postingReplaceExisting: { __typename?: 'Posting', postingKey: number } };

export type PostingInfoFragment = { __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, isArchived: boolean, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null }, currentPrice?: { __typename?: 'PostingPrice', postingPriceKey: number, cost: number, effectiveDate: any } | null };

export type GetSinglePostingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSinglePostingQuery = { __typename?: 'Query', postingGetSingle: { __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, isArchived: boolean, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null }, currentPrice?: { __typename?: 'PostingPrice', postingPriceKey: number, cost: number, effectiveDate: any } | null } };

export type PostingPriceInfoFragment = { __typename?: 'PostingPrice', postingPriceKey: number, effectiveDate: any, cost: number, postingKey: number };

export type PostingPriceGetHistoryQueryVariables = Exact<{
  postingKey: Scalars['Int']['input'];
}>;


export type PostingPriceGetHistoryQuery = { __typename?: 'Query', postingPriceGetHistory?: Array<{ __typename?: 'PostingPrice', postingPriceKey: number, effectiveDate: any, cost: number, postingKey: number } | null> | null };

export type PostingPriceCreateOrUpdateMutationVariables = Exact<{
  postingPrice: PostingPriceCreateOrUpdateInput;
}>;


export type PostingPriceCreateOrUpdateMutation = { __typename?: 'Mutation', postingPriceCreateOrUpdate?: { __typename?: 'PostingPrice', postingPriceKey: number, effectiveDate: any, cost: number, postingKey: number } | null };

export type PostingPriceDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PostingPriceDeleteMutation = { __typename?: 'Mutation', postingPriceDelete: boolean };

export type PostingToggleArchivedMutationVariables = Exact<{
  postingKey: Scalars['Int']['input'];
}>;


export type PostingToggleArchivedMutation = { __typename?: 'Mutation', postingToggleArchived: boolean };

export type PostingSetArchivedMutationVariables = Exact<{
  postingKey: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
}>;


export type PostingSetArchivedMutation = { __typename?: 'Mutation', postingSetArchived: boolean };

export type InnerPostingFragment = { __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } };

export type InnerPostingListingFragment = { __typename?: 'PostingGetAllEdge', node?: { __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null };

export type AllPostingListingFragment = { __typename?: 'PostingGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'PostingGetAllEdge', cursor: string, node?: { __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null }> | null };

export type InnerFlatPostingFragment = { __typename?: 'FlatPosting', postingKey: number, cost: number, effectiveDate: any, supplier?: string | null, terminal?: string | null, currentPrice?: number | null, currentPriceEffectiveDate?: any | null, isArchived: boolean };

export type InnerFlatPostingListingFragment = { __typename?: 'FlatPostingGetAllEdge', node?: { __typename?: 'FlatPosting', postingKey: number, cost: number, effectiveDate: any, supplier?: string | null, terminal?: string | null, currentPrice?: number | null, currentPriceEffectiveDate?: any | null, isArchived: boolean } | null };

export type AllFlatPostingListingFragment = { __typename?: 'FlatPostingGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'FlatPostingGetAllEdge', cursor: string, node?: { __typename?: 'FlatPosting', postingKey: number, cost: number, effectiveDate: any, supplier?: string | null, terminal?: string | null, currentPrice?: number | null, currentPriceEffectiveDate?: any | null, isArchived: boolean } | null }> | null };

export type AllPostingsQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<PostingSortInput> | PostingSortInput>;
  filterObject?: InputMaybe<PostingFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllPostingsQuery = { __typename?: 'Query', postingGetAll?: { __typename?: 'PostingGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'PostingGetAllEdge', cursor: string, node?: { __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null }> | null } | null };

export type AllFlatPostingsQueryVariables = Exact<{
  sort?: InputMaybe<Array<FlatPostingSortInput> | FlatPostingSortInput>;
  filter?: InputMaybe<FlatPostingFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  showExpired: Scalars['Boolean']['input'];
}>;


export type AllFlatPostingsQuery = { __typename?: 'Query', flatPostingGetAll?: { __typename?: 'FlatPostingGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'FlatPostingGetAllEdge', cursor: string, node?: { __typename?: 'FlatPosting', postingKey: number, cost: number, effectiveDate: any, supplier?: string | null, terminal?: string | null, currentPrice?: number | null, currentPriceEffectiveDate?: any | null, isArchived: boolean } | null }> | null } | null };

export type DeletePostingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePostingMutation = { __typename?: 'Mutation', postingDelete: boolean };

export type TogglePostingArchivedMutationVariables = Exact<{
  postingKey: Scalars['Int']['input'];
}>;


export type TogglePostingArchivedMutation = { __typename?: 'Mutation', postingToggleArchived: boolean };

export type CreatePrePurchaseAgreementMutationVariables = Exact<{
  prePurchaseAgreement: PrePurchaseAgreementInput;
}>;


export type CreatePrePurchaseAgreementMutation = { __typename?: 'Mutation', prePurchaseAgreementCreate: { __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number } };

export type DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation = { __typename?: 'Mutation', prePurchaseAgreementSalesAgreementDeleteByPrePurchase: boolean };

export type EditPrePurchaseAgreementMutationVariables = Exact<{
  prePurchaseAgreement: PrePurchaseAgreementInput;
  id: Scalars['Int']['input'];
}>;


export type EditPrePurchaseAgreementMutation = { __typename?: 'Mutation', prePurchaseAgreementUpdate: { __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number } };

export type SinglePrePurchaseAgreementFragment = { __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, prePaidDollars: number, gallons: number, toDateGallons: number, productCost: number, assessmentCost: number, otherCosts: number, units: number, freightCost: number, miscCost: number, costDescription?: string | null, startShipDate: any, endShipDate: any, includeInTermContractVolume: boolean, includeFreight: boolean, chargeTariff: boolean, showOnPricing: boolean, description?: string | null, aprilEstimate: number, mayEstimate: number, juneEstimate: number, julyEstimate: number, augustEstimate: number, septemberEstimate: number, octoberEstimate: number, novemberEstimate: number, decemberEstimate: number, januaryEstimate: number, februaryEstimate: number, marchEstimate: number, aprilPriceIncrement: number, mayPriceIncrement: number, junePriceIncrement: number, julyPriceIncrement: number, augustPriceIncrement: number, septemberPriceIncrement: number, octoberPriceIncrement: number, novemberPriceIncrement: number, decemberPriceIncrement: number, januaryPriceIncrement: number, februaryPriceIncrement: number, marchPriceIncrement: number, aprilSellBack: number, maySellBack: number, juneSellBack: number, julySellBack: number, augustSellBack: number, septemberSellBack: number, octoberSellBack: number, novemberSellBack: number, decemberSellBack: number, januarySellBack: number, februarySellBack: number, marchSellBack: number, terminal: { __typename?: 'Terminal', terminalKey: number, name?: string | null }, supplier: { __typename?: 'Supplier', supplierKey: number, name?: string | null }, prePurchaseAgreementSalesAgreements?: Array<{ __typename?: 'PrePurchaseAgreementSalesAgreement', salesAgreementKey: number }> | null };

export type GetSinglePrePurchaseAgreementQueryVariables = Exact<{
  prePurchaseAgreementKey: Scalars['Int']['input'];
}>;


export type GetSinglePrePurchaseAgreementQuery = { __typename?: 'Query', prePurchaseAgreementGetSingle?: { __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, prePaidDollars: number, gallons: number, toDateGallons: number, productCost: number, assessmentCost: number, otherCosts: number, units: number, freightCost: number, miscCost: number, costDescription?: string | null, startShipDate: any, endShipDate: any, includeInTermContractVolume: boolean, includeFreight: boolean, chargeTariff: boolean, showOnPricing: boolean, description?: string | null, aprilEstimate: number, mayEstimate: number, juneEstimate: number, julyEstimate: number, augustEstimate: number, septemberEstimate: number, octoberEstimate: number, novemberEstimate: number, decemberEstimate: number, januaryEstimate: number, februaryEstimate: number, marchEstimate: number, aprilPriceIncrement: number, mayPriceIncrement: number, junePriceIncrement: number, julyPriceIncrement: number, augustPriceIncrement: number, septemberPriceIncrement: number, octoberPriceIncrement: number, novemberPriceIncrement: number, decemberPriceIncrement: number, januaryPriceIncrement: number, februaryPriceIncrement: number, marchPriceIncrement: number, aprilSellBack: number, maySellBack: number, juneSellBack: number, julySellBack: number, augustSellBack: number, septemberSellBack: number, octoberSellBack: number, novemberSellBack: number, decemberSellBack: number, januarySellBack: number, februarySellBack: number, marchSellBack: number, terminal: { __typename?: 'Terminal', terminalKey: number, name?: string | null }, supplier: { __typename?: 'Supplier', supplierKey: number, name?: string | null }, prePurchaseAgreementSalesAgreements?: Array<{ __typename?: 'PrePurchaseAgreementSalesAgreement', salesAgreementKey: number }> | null } | null };

export type InnerPrePurchaseAgreementFragment = { __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } };

export type AllPrePurchaseAgreementListingFragment = { __typename?: 'PrePurchaseAgreementGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'PrePurchaseAgreementGetAllEdge', cursor: string, node?: { __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null }> | null };

export type InnerPrePurchaseAgreementListingFragment = { __typename?: 'PrePurchaseAgreementGetAllEdge', node?: { __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null };

export type InnerFlatPrePurchaseAgreementFragment = { __typename?: 'FlatPrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, endShipDate: any, supplier?: string | null, terminal?: string | null };

export type AllFlatPrePurchaseAgreementListingFragment = { __typename?: 'FlatPrePurchaseAgreementGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'FlatPrePurchaseAgreementGetAllEdge', cursor: string, node?: { __typename?: 'FlatPrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, endShipDate: any, supplier?: string | null, terminal?: string | null } | null }> | null };

export type InnerFlatPrePurchaseAgreementListingFragment = { __typename?: 'FlatPrePurchaseAgreementGetAllEdge', node?: { __typename?: 'FlatPrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, endShipDate: any, supplier?: string | null, terminal?: string | null } | null };

export type AllPrePurchaseAgreementQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<PrePurchaseAgreementSortInput> | PrePurchaseAgreementSortInput>;
  filterObject?: InputMaybe<PrePurchaseAgreementFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllPrePurchaseAgreementQuery = { __typename?: 'Query', prePurchaseAgreementGetAll?: { __typename?: 'PrePurchaseAgreementGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'PrePurchaseAgreementGetAllEdge', cursor: string, node?: { __typename?: 'PrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null }> | null } | null };

export type AllFlatPrePurchaseAgreementQueryVariables = Exact<{
  sort?: InputMaybe<Array<FlatPrePurchaseAgreementSortInput> | FlatPrePurchaseAgreementSortInput>;
  filter?: InputMaybe<FlatPrePurchaseAgreementFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllFlatPrePurchaseAgreementQuery = { __typename?: 'Query', flatPrePurchaseAgreementGetAll?: { __typename?: 'FlatPrePurchaseAgreementGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'FlatPrePurchaseAgreementGetAllEdge', cursor: string, node?: { __typename?: 'FlatPrePurchaseAgreement', prePurchaseAgreementKey: number, supplierAgreement?: string | null, endShipDate: any, supplier?: string | null, terminal?: string | null } | null }> | null } | null };

export type DeletePrePurchaseAgreementMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePrePurchaseAgreementMutation = { __typename?: 'Mutation', prePurchaseAgreementDelete: boolean };

export type QuickbooksAuthorizationQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksAuthorizationQuery = { __typename?: 'Query', quickBooksAuthorizationUrl?: string | null };

export type QuickBooksTokenExchangeMutationVariables = Exact<{
  authCode: Scalars['String']['input'];
  realmId: Scalars['String']['input'];
}>;


export type QuickBooksTokenExchangeMutation = { __typename?: 'Mutation', quickBooksTokenExchange: boolean };

export type GallonsByStateFragment = { __typename?: 'DispatchedShippedOrder', orderKey: number, state?: string | null, businessType?: string | null, customerName?: string | null, locationName?: string | null, manifest?: string | null, deliveryDate: any, gallons: number, actualGallons?: number | null, product: number, misc?: number | null, freight: number, assessment: number, patCost?: number | null, otherCost?: number | null, otherCharge?: number | null, markup: number, invoiceNumber?: string | null };

export type AllGallonsByStateQueryVariables = Exact<{
  sort?: InputMaybe<Array<DispatchedShippedOrderSortInput> | DispatchedShippedOrderSortInput>;
  filter?: InputMaybe<DispatchedShippedOrderFilterInput>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type AllGallonsByStateQuery = { __typename?: 'Query', dispatchedShippedOrdersReport?: Array<{ __typename?: 'DispatchedShippedOrder', orderKey: number, state?: string | null, businessType?: string | null, customerName?: string | null, locationName?: string | null, manifest?: string | null, deliveryDate: any, gallons: number, actualGallons?: number | null, product: number, misc?: number | null, freight: number, assessment: number, patCost?: number | null, otherCost?: number | null, otherCharge?: number | null, markup: number, invoiceNumber?: string | null }> | null };

export type MonthlyCvReportListingFragment = { __typename?: 'MonthlyCVReport', contractVolumeKey: number, startDate: any, supplierName?: string | null, terminalName?: string | null, contractVolumeType?: string | null, fileNumber?: string | null, monthlyVolume: number, totalLoads: number, loadsLifted: number, gallonsLifted: number, remainingLoads: number, loadsBusDay?: string | null };

export type MonthlyContractReportQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  filter?: InputMaybe<MonthlyCvReportFilterInput>;
  sort?: InputMaybe<Array<MonthlyCvReportSortInput> | MonthlyCvReportSortInput>;
}>;


export type MonthlyContractReportQuery = { __typename?: 'Query', monthlyCVReport?: Array<{ __typename?: 'MonthlyCVReport', contractVolumeKey: number, startDate: any, supplierName?: string | null, terminalName?: string | null, contractVolumeType?: string | null, fileNumber?: string | null, monthlyVolume: number, totalLoads: number, loadsLifted: number, gallonsLifted: number, remainingLoads: number, loadsBusDay?: string | null }> | null };

export type DispatchedShippedOrdersFragment = { __typename?: 'DispatchedShippedOrder', actualGallons?: number | null, carrierKey: number, carrierName?: string | null, customerKey: number, customerName?: string | null, delivered: number, deliveryDate: any, gallons: number, locationKey: number, locationName?: string | null, manifest?: string | null, orderKey: number, product: number, supplierKey: number, supplierName?: string | null, terminalKey: number, terminalName?: string | null };

export type AllShippedDispatchedOrdersQueryVariables = Exact<{
  sort?: InputMaybe<Array<DispatchedShippedOrderSortInput> | DispatchedShippedOrderSortInput>;
  filter?: InputMaybe<DispatchedShippedOrderFilterInput>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type AllShippedDispatchedOrdersQuery = { __typename?: 'Query', dispatchedShippedOrdersReport?: Array<{ __typename?: 'DispatchedShippedOrder', actualGallons?: number | null, carrierKey: number, carrierName?: string | null, customerKey: number, customerName?: string | null, delivered: number, deliveryDate: any, gallons: number, locationKey: number, locationName?: string | null, manifest?: string | null, orderKey: number, product: number, supplierKey: number, supplierName?: string | null, terminalKey: number, terminalName?: string | null }> | null };

export type ShippedDispatchedOrderDetailsFragment = { __typename?: 'DispatchedShippedOrder', actualGallons?: number | null, carrierKey: number, carrierName?: string | null, customerKey: number, customerName?: string | null, deliveryDate: any, gallons: number, locationKey: number, locationName?: string | null, manifest?: string | null, orderKey: number, supplierKey: number, supplierName?: string | null, terminalKey: number, terminalName?: string | null, product: number, markup: number, assessment: number, misc?: number | null, fOB: number, freight: number, delivered: number, otherCost?: number | null, otherCharge?: number | null, patCost?: number | null };

export type AllShippedDispatchedOrderDetailsQueryVariables = Exact<{
  sort?: InputMaybe<Array<DispatchedShippedOrderSortInput> | DispatchedShippedOrderSortInput>;
  filter?: InputMaybe<DispatchedShippedOrderFilterInput>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type AllShippedDispatchedOrderDetailsQuery = { __typename?: 'Query', dispatchedShippedOrdersReport?: Array<{ __typename?: 'DispatchedShippedOrder', actualGallons?: number | null, carrierKey: number, carrierName?: string | null, customerKey: number, customerName?: string | null, deliveryDate: any, gallons: number, locationKey: number, locationName?: string | null, manifest?: string | null, orderKey: number, supplierKey: number, supplierName?: string | null, terminalKey: number, terminalName?: string | null, product: number, markup: number, assessment: number, misc?: number | null, fOB: number, freight: number, delivered: number, otherCost?: number | null, otherCharge?: number | null, patCost?: number | null }> | null };

export type TaskReportListingFragment = { __typename?: 'TaskReport', taskKey: number, completedDate: any, locationKey: number, locationName?: string | null, locationCity?: string | null, customerKey: number, customerName?: string | null, contactKey: number, contactName?: string | null, contactMethod?: string | null, info?: string | null, userName?: string | null };

export type AllTasksByDateQueryVariables = Exact<{
  sort?: InputMaybe<Array<TaskReportSortInput> | TaskReportSortInput>;
  filter?: InputMaybe<TaskReportFilterInput>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type AllTasksByDateQuery = { __typename?: 'Query', tasksByDate?: Array<{ __typename?: 'TaskReport', taskKey: number, completedDate: any, locationKey: number, locationName?: string | null, locationCity?: string | null, customerKey: number, customerName?: string | null, contactKey: number, contactName?: string | null, contactMethod?: string | null, info?: string | null, userName?: string | null }> | null };

export type CreateSalesAgreementMutationVariables = Exact<{
  salesAgreement: SalesAgreementInput;
}>;


export type CreateSalesAgreementMutation = { __typename?: 'Mutation', salesAgreementCreate: { __typename?: 'SalesAgreement', salesAgreementKey: number } };

export type CreateSalesAgreementLocationMutationVariables = Exact<{
  salesAgreementLocation: SalesAgreementLocationInput;
}>;


export type CreateSalesAgreementLocationMutation = { __typename?: 'Mutation', salesAgreementLocationCreate: { __typename?: 'SalesAgreementLocation', salesAgreementKey: number, locationKey: number } };

export type EditSalesAgreementMutationVariables = Exact<{
  salesAgreement: SalesAgreementInput;
  id: Scalars['Int']['input'];
}>;


export type EditSalesAgreementMutation = { __typename?: 'Mutation', salesAgreementUpdate: { __typename?: 'SalesAgreement', salesAgreementKey: number } };

export type DeleteSalesAgreementLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSalesAgreementLocationMutation = { __typename?: 'Mutation', salesAgreementLocationDeleteBySalesAgreementKey: boolean };

export type DeleteSalesAgreementMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSalesAgreementMutation = { __typename?: 'Mutation', salesAgreementDelete: boolean };

export type DeleteLinkedSalesAgreementsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteLinkedSalesAgreementsMutation = { __typename?: 'Mutation', linkedSalesAgreementDelete: boolean };

export type CreateLinkedSalesAgreementMutationVariables = Exact<{
  linkedSalesAgreement: LinkedSalesAgreementInput;
}>;


export type CreateLinkedSalesAgreementMutation = { __typename?: 'Mutation', linkedSalesAgreementCreate: { __typename?: 'LinkedSalesAgreement', relatedToSalesAgreementKey: number, relatedFromSalesAgreementKey: number } };

export type DeletePrePurchaseAgreementSalesAgreementMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePrePurchaseAgreementSalesAgreementMutation = { __typename?: 'Mutation', prePurchaseAgreementSalesAgreementDelete: boolean };

export type CreatePrePurchaseAgreementSalesAgreementMutationVariables = Exact<{
  ppasa: PrePurchaseAgreementSalesAgreementInput;
}>;


export type CreatePrePurchaseAgreementSalesAgreementMutation = { __typename?: 'Mutation', prePurchaseAgreementSalesAgreementCreate: { __typename?: 'PrePurchaseAgreementSalesAgreement', prePurchaseAgreementKey: number, salesAgreementKey: number } };

export type CreateTermContractSalesAgreementMutationVariables = Exact<{
  tcsa: TermContractSalesAgreementInput;
}>;


export type CreateTermContractSalesAgreementMutation = { __typename?: 'Mutation', termContractSalesAgreementCreate: { __typename?: 'TermContractSalesAgreement', termContractKey: number, salesAgreementKey: number } };

export type DeleteTermContractSalesAgreementsMutationVariables = Exact<{
  salesAgreementKey: Scalars['Int']['input'];
}>;


export type DeleteTermContractSalesAgreementsMutation = { __typename?: 'Mutation', termContractSalesAgreementDelete: boolean };

export type SalesAgreementListingFragment = { __typename?: 'SalesAgreement', salesAgreementKey: number, agreementName?: string | null, prePaid: number, gallons: number, deposit: number, assessment: number, startShipDate: any, endShipDate: any, notes?: string | null, gallonsToDate: number, loadsToDate: number, quoted?: number | null, quotedFOB?: number | null, misc?: number | null, supplierKey?: number | null, terminalKey?: number | null, aprEst: number, mayEst: number, junEst: number, julEst: number, augEst: number, sepEst: number, octEst: number, novEst: number, decEst: number, janEst: number, febEst: number, marEst: number, aprPI: number, mayPI: number, junPI: number, julPI: number, augPI: number, sepPI: number, octPI: number, novPI: number, decPI: number, janPI: number, febPI: number, marPI: number, supplier?: { __typename?: 'Supplier', name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, salesAgreementLocations?: Array<{ __typename?: 'SalesAgreementLocation', locationKey: number, location: { __typename?: 'Location', stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } }> | null, relatedFromSalesAgreements?: Array<{ __typename?: 'LinkedSalesAgreement', relatedFromSalesAgreementKey: number }> | null, prePurchaseAgreementSalesAgreements?: Array<{ __typename?: 'PrePurchaseAgreementSalesAgreement', prePurchaseAgreementKey: number }> | null, termContractSalesAgreements?: Array<{ __typename?: 'TermContractSalesAgreement', termContractKey: number }> | null };

export type GetSingleSalesAgreementQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleSalesAgreementQuery = { __typename?: 'Query', salesAgreementGetSingle: { __typename?: 'SalesAgreement', salesAgreementKey: number, agreementName?: string | null, prePaid: number, gallons: number, deposit: number, assessment: number, startShipDate: any, endShipDate: any, notes?: string | null, gallonsToDate: number, loadsToDate: number, quoted?: number | null, quotedFOB?: number | null, misc?: number | null, supplierKey?: number | null, terminalKey?: number | null, aprEst: number, mayEst: number, junEst: number, julEst: number, augEst: number, sepEst: number, octEst: number, novEst: number, decEst: number, janEst: number, febEst: number, marEst: number, aprPI: number, mayPI: number, junPI: number, julPI: number, augPI: number, sepPI: number, octPI: number, novPI: number, decPI: number, janPI: number, febPI: number, marPI: number, supplier?: { __typename?: 'Supplier', name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, salesAgreementLocations?: Array<{ __typename?: 'SalesAgreementLocation', locationKey: number, location: { __typename?: 'Location', stateObj: { __typename?: 'State', stateKey: number, name?: string | null } } }> | null, relatedFromSalesAgreements?: Array<{ __typename?: 'LinkedSalesAgreement', relatedFromSalesAgreementKey: number }> | null, prePurchaseAgreementSalesAgreements?: Array<{ __typename?: 'PrePurchaseAgreementSalesAgreement', prePurchaseAgreementKey: number }> | null, termContractSalesAgreements?: Array<{ __typename?: 'TermContractSalesAgreement', termContractKey: number }> | null } };

export type InnerSalesAgreementFragment = { __typename?: 'SalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplierKey?: number | null, terminalKey?: number | null, endShipDate: any, supplier?: { __typename?: 'Supplier', name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null };

export type InnerSalesAgreementListingFragment = { __typename?: 'SalesAgreementGetAllEdge', node?: { __typename?: 'SalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplierKey?: number | null, terminalKey?: number | null, endShipDate: any, supplier?: { __typename?: 'Supplier', name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null };

export type AllSalesAgreementListingFragment = { __typename?: 'SalesAgreementGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesAgreementGetAllEdge', cursor: string, node?: { __typename?: 'SalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplierKey?: number | null, terminalKey?: number | null, endShipDate: any, supplier?: { __typename?: 'Supplier', name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null }> | null };

export type InnerFlatSalesAgreementFragment = { __typename?: 'FlatSalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplier?: string | null, terminal?: string | null, endShipDate: any, locationKeys?: Array<number> | null, customerKeys?: Array<number> | null, stateKeys?: Array<number> | null };

export type InnerFlatSalesAgreementListingFragment = { __typename?: 'FlatSalesAgreementGetAllEdge', node?: { __typename?: 'FlatSalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplier?: string | null, terminal?: string | null, endShipDate: any, locationKeys?: Array<number> | null, customerKeys?: Array<number> | null, stateKeys?: Array<number> | null } | null };

export type AllFlatSalesAgreementListingFragment = { __typename?: 'FlatSalesAgreementGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'FlatSalesAgreementGetAllEdge', cursor: string, node?: { __typename?: 'FlatSalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplier?: string | null, terminal?: string | null, endShipDate: any, locationKeys?: Array<number> | null, customerKeys?: Array<number> | null, stateKeys?: Array<number> | null } | null }> | null };

export type AllSalesAgreementQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<SalesAgreementSortInput> | SalesAgreementSortInput>;
  filterObject?: InputMaybe<SalesAgreementFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllSalesAgreementQuery = { __typename?: 'Query', salesAgreementGetAll?: { __typename?: 'SalesAgreementGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'SalesAgreementGetAllEdge', cursor: string, node?: { __typename?: 'SalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplierKey?: number | null, terminalKey?: number | null, endShipDate: any, supplier?: { __typename?: 'Supplier', name?: string | null } | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null }> | null } | null };

export type AllFlatSalesAgreementQueryVariables = Exact<{
  sort?: InputMaybe<Array<FlatSalesAgreementSortInput> | FlatSalesAgreementSortInput>;
  filter?: InputMaybe<FlatSalesAgreementFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllFlatSalesAgreementQuery = { __typename?: 'Query', flatSalesAgreementGetAll?: { __typename?: 'FlatSalesAgreementGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'FlatSalesAgreementGetAllEdge', cursor: string, node?: { __typename?: 'FlatSalesAgreement', salesAgreementKey: number, agreementName?: string | null, supplier?: string | null, terminal?: string | null, endShipDate: any, locationKeys?: Array<number> | null, customerKeys?: Array<number> | null, stateKeys?: Array<number> | null } | null }> | null } | null };

export type InnerStateTaxFragment = { __typename?: 'StateTax', stateTaxKey: number, startDate: any, endDate?: any | null, stateKey: number, amount: number, stateTaxType: StateTaxType, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null };

export type AllStateTaxQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<StateTaxSortInput> | StateTaxSortInput>;
  filterObject?: InputMaybe<StateTaxFilterInput>;
}>;


export type AllStateTaxQuery = { __typename?: 'Query', stateTaxGetAll?: Array<{ __typename?: 'StateTax', stateTaxKey: number, startDate: any, endDate?: any | null, stateKey: number, amount: number, stateTaxType: StateTaxType, state?: { __typename?: 'State', stateKey: number, name?: string | null } | null }> | null };

export type DeleteStateTaxMutationVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type DeleteStateTaxMutation = { __typename?: 'Mutation', stateTaxDelete: boolean };

export type CreateSupplierMutationVariables = Exact<{
  supplier: SupplierInput;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', supplierCreate: { __typename?: 'Supplier', supplierKey: number } };

export type EditSupplierMutationVariables = Exact<{
  supplier: SupplierInput;
  id: Scalars['Int']['input'];
}>;


export type EditSupplierMutation = { __typename?: 'Mutation', supplierUpdate: { __typename?: 'Supplier', supplierKey: number } };

export type SingleSupplierFragment = { __typename?: 'Supplier', name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, directions?: string | null, fax?: string | null, phone?: string | null, state?: string | null, supplierKey: number, zipCode?: string | null, notes?: string | null, isArchived: boolean, indexContracts?: Array<{ __typename?: 'IndexContract', indexContractKey: number, accountInfo?: string | null, effectiveDate: any, terminal: { __typename?: 'Terminal', name?: string | null } } | null> | null };

export type GetSingleSupplierQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleSupplierQuery = { __typename?: 'Query', supplierGetSingle: { __typename?: 'Supplier', name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, directions?: string | null, fax?: string | null, phone?: string | null, state?: string | null, supplierKey: number, zipCode?: string | null, notes?: string | null, isArchived: boolean, indexContracts?: Array<{ __typename?: 'IndexContract', indexContractKey: number, accountInfo?: string | null, effectiveDate: any, terminal: { __typename?: 'Terminal', name?: string | null } } | null> | null } };

export type GetAllContactBySupplierKeyQueryVariables = Exact<{
  filterContact?: InputMaybe<ContactFilterInput>;
}>;


export type GetAllContactBySupplierKeyQuery = { __typename?: 'Query', contactGetAll?: Array<{ __typename?: 'Contact', supplierKey?: number | null, contactKey: number, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, notes?: string | null, default: boolean, cellPhone?: string | null, homePhone?: string | null, deleted: boolean } | null> | null };

export type PostingsForSupplierQueryVariables = Exact<{
  supplierKey: Scalars['Int']['input'];
  sort?: InputMaybe<Array<PostingSortInput> | PostingSortInput>;
}>;


export type PostingsForSupplierQuery = { __typename?: 'Query', postingGetAll?: { __typename?: 'PostingGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'PostingGetAllEdge', cursor: string, node?: { __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null } } | null }> | null } | null };

export type MostRecentPostingsForSupplierQueryVariables = Exact<{
  supplierKey: Scalars['Int']['input'];
}>;


export type MostRecentPostingsForSupplierQuery = { __typename?: 'Query', postingsGetAllForSupplierMostRecent?: Array<{ __typename?: 'Posting', postingKey: number, supplierKey: number, terminalKey: number, cost: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null }, terminal: { __typename?: 'Terminal', name?: string | null }, postingPrices?: Array<{ __typename?: 'PostingPrice', postingPriceKey: number, cost: number, effectiveDate: any, effectiveEndDate: any } | null> | null, currentPrice?: { __typename?: 'PostingPrice', postingPriceKey: number, cost: number, effectiveDate: any, effectiveEndDate: any } | null, futurePrice?: { __typename?: 'PostingPrice', postingPriceKey: number, cost: number, effectiveDate: any, effectiveEndDate: any } | null }> | null };

export type AllSupplierListingFragment = { __typename?: 'Supplier', name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, directions?: string | null, fax?: string | null, phone?: string | null, state?: string | null, supplierKey: number, zipCode?: string | null, notes?: string | null, isArchived: boolean };

export type AllSupplierQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<SupplierSortInput> | SupplierSortInput>;
  filterObject?: InputMaybe<SupplierFilterInput>;
}>;


export type AllSupplierQuery = { __typename?: 'Query', supplierGetAll: Array<{ __typename?: 'Supplier', name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, directions?: string | null, fax?: string | null, phone?: string | null, state?: string | null, supplierKey: number, zipCode?: string | null, notes?: string | null, isArchived: boolean }> };

export type DeleteSupplierMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSupplierMutation = { __typename?: 'Mutation', supplierDelete: boolean };

export type CreateSwapDealMutationVariables = Exact<{
  swapDeal: SwapDealInput;
}>;


export type CreateSwapDealMutation = { __typename?: 'Mutation', swapDealCreate: { __typename?: 'SwapDeal', swapDealKey: number } };

export type CreateSwapDealSalesAgreementMutationVariables = Exact<{
  sdsa: SwapDealSalesAgreementInput;
}>;


export type CreateSwapDealSalesAgreementMutation = { __typename?: 'Mutation', swapDealSalesAgreementCreate?: { __typename?: 'SwapDealSalesAgreement', swapDealKey: number, salesAgreementKey: number } | null };

export type SingleSwapDealFragment = { __typename?: 'SwapDeal', swapDealKey: number, dealNumber: number, sglCost: number, effectiveStartDate: any, effectiveEndDate: any, monthlyVolume: number, basisType: { __typename?: 'BasisType', basisTypeKey: number }, swapDealSalesAgreements?: Array<{ __typename?: 'SwapDealSalesAgreement', salesAgreementKey: number, salesAgreement: { __typename?: 'SalesAgreement', agreementName?: string | null } }> | null };

export type GetSingleSwapDealQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleSwapDealQuery = { __typename?: 'Query', swapDealGetSingle: { __typename?: 'SwapDeal', swapDealKey: number, dealNumber: number, sglCost: number, effectiveStartDate: any, effectiveEndDate: any, monthlyVolume: number, basisType: { __typename?: 'BasisType', basisTypeKey: number }, swapDealSalesAgreements?: Array<{ __typename?: 'SwapDealSalesAgreement', salesAgreementKey: number, salesAgreement: { __typename?: 'SalesAgreement', agreementName?: string | null } }> | null } };

export type EditSwapDealMutationVariables = Exact<{
  swapDeal: SwapDealInput;
  id: Scalars['Int']['input'];
}>;


export type EditSwapDealMutation = { __typename?: 'Mutation', swapDealUpdate: { __typename?: 'SwapDeal', swapDealKey: number } };

export type DeleteSwapDealSalesAgreementBySwapDealMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSwapDealSalesAgreementBySwapDealMutation = { __typename?: 'Mutation', swapDealSalesAgreementDeleteBySwapDeal: boolean };

export type InnerFlatSwapDealFragment = { __typename?: 'FlatSwapDeal', swapDealKey: number, basisType?: string | null, salesAgreements?: string | null, suppliers?: string | null, dealNumber: number, sglCost: number, effectiveStartDate: any, effectiveEndDate: any, monthlyVolume: number };

export type AllSwapDealQueryVariables = Exact<{
  sort?: InputMaybe<Array<FlatSwapDealSortInput> | FlatSwapDealSortInput>;
  filter?: InputMaybe<FlatSwapDealFilterInput>;
}>;


export type AllSwapDealQuery = { __typename?: 'Query', flatSwapDealGetAll: Array<{ __typename?: 'FlatSwapDeal', swapDealKey: number, basisType?: string | null, salesAgreements?: string | null, suppliers?: string | null, dealNumber: number, sglCost: number, effectiveStartDate: any, effectiveEndDate: any, monthlyVolume: number }> };

export type DeleteSwapDealMutationVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type DeleteSwapDealMutation = { __typename?: 'Mutation', swapDealDelete: boolean };

export type CreateTaskMutationVariables = Exact<{
  task: TaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', taskCreate?: { __typename?: 'Task', taskKey: number } | null };

export type CreateFutureTaskMutationVariables = Exact<{
  task: TaskInput;
}>;


export type CreateFutureTaskMutation = { __typename?: 'Mutation', taskCreateFuture?: { __typename?: 'Task', taskKey: number } | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: number, userName?: string | null, name?: string | null, isAdminUser: boolean } };

export type TaskShowFragment = { __typename?: 'Task', taskKey: number, isComplete: boolean, taskDate: any, callDetails?: string | null, contactMethod: ContactMethod, completedDate?: any | null, locationKey: number, contact: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null }, location: { __typename?: 'Location', customerKey: number, locationKey: number, name?: string | null }, user: { __typename?: 'User', id: number, email?: string | null, name?: string | null } };

export type GetSingleTaskQueryVariables = Exact<{
  taskKey: Scalars['Int']['input'];
}>;


export type GetSingleTaskQuery = { __typename?: 'Query', taskGetSingle: { __typename?: 'Task', taskKey: number, isComplete: boolean, taskDate: any, callDetails?: string | null, contactMethod: ContactMethod, completedDate?: any | null, locationKey: number, contact: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null }, location: { __typename?: 'Location', customerKey: number, locationKey: number, name?: string | null }, user: { __typename?: 'User', id: number, email?: string | null, name?: string | null } } };

export type GetCompletedTasksForLocationQueryVariables = Exact<{
  locationKey: Scalars['Int']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetCompletedTasksForLocationQuery = { __typename?: 'Query', taskGetAll: Array<{ __typename?: 'Task', taskKey: number, isComplete: boolean, taskDate: any, callDetails?: string | null, contactMethod: ContactMethod, completedDate?: any | null, locationKey: number, contact: { __typename?: 'Contact', contactKey: number, firstName?: string | null, lastName?: string | null }, location: { __typename?: 'Location', customerKey: number, locationKey: number, name?: string | null }, user: { __typename?: 'User', id: number, email?: string | null, name?: string | null } }> };

export type UpdateTaskMutationVariables = Exact<{
  task: TaskInput;
  taskKey: Scalars['Int']['input'];
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', taskUpdate: { __typename?: 'Task', taskKey: number } };

export type CreateTaskAndUpdateTaskMutationVariables = Exact<{
  newTask: TaskInput;
  task: TaskInput;
  currentTaskKey: Scalars['Int']['input'];
}>;


export type CreateTaskAndUpdateTaskMutation = { __typename?: 'Mutation', taskUpdate: { __typename?: 'Task', taskKey: number }, taskCreate?: { __typename?: 'Task', taskKey: number } | null };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', taskDelete: boolean };

export type CreateTermContractMutationVariables = Exact<{
  termContract: TermContractInput;
}>;


export type CreateTermContractMutation = { __typename?: 'Mutation', termContractCreate: { __typename?: 'TermContract', termContractKey: number } };

export type CreateTermContractLocationMutationVariables = Exact<{
  termContractLocation: TermContractLocationInput;
}>;


export type CreateTermContractLocationMutation = { __typename?: 'Mutation', termContractLocationCreate: { __typename?: 'TermContractLocation', termContractKey: number, locationKey: number } };

export type CreateTermContractTerminalMutationVariables = Exact<{
  termContractTerminal: TermContractTerminalInput;
}>;


export type CreateTermContractTerminalMutation = { __typename?: 'Mutation', termContractTerminalCreate: { __typename?: 'TermContractTerminal', termContractKey: number, terminalKey: number } };

export type CreateTermContractSupplierMutationVariables = Exact<{
  termContractSupplier: TermContractSupplierInput;
}>;


export type CreateTermContractSupplierMutation = { __typename?: 'Mutation', termContractSupplierCreate: { __typename?: 'TermContractSupplier', termContractKey: number, supplierKey: number } };

export type EditTermContractMutationVariables = Exact<{
  termContract: TermContractInput;
  key: Scalars['Int']['input'];
}>;


export type EditTermContractMutation = { __typename?: 'Mutation', termContractUpdate: { __typename?: 'TermContract', termContractKey: number } };

export type AllTermContractFragment = { __typename?: 'TermContract', termContractKey: number, name?: string | null, startDate: any, endDate: any, notes?: string | null, january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number, posts: boolean, indexContracts: boolean, prePurchaseAgreements: boolean, termContractSuppliers?: Array<{ __typename?: 'TermContractSupplier', supplierKey: number } | null> | null, termContractLocations?: Array<{ __typename?: 'TermContractLocation', locationKey: number } | null> | null, termContractTerminals?: Array<{ __typename?: 'TermContractTerminal', terminalKey: number } | null> | null };

export type SingleTermContractQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type SingleTermContractQuery = { __typename?: 'Query', termContractGetSingle?: { __typename?: 'TermContract', termContractKey: number, name?: string | null, startDate: any, endDate: any, notes?: string | null, january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number, posts: boolean, indexContracts: boolean, prePurchaseAgreements: boolean, termContractSuppliers?: Array<{ __typename?: 'TermContractSupplier', supplierKey: number } | null> | null, termContractLocations?: Array<{ __typename?: 'TermContractLocation', locationKey: number } | null> | null, termContractTerminals?: Array<{ __typename?: 'TermContractTerminal', terminalKey: number } | null> | null } | null };

export type SingleSearchTermContractQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type SingleSearchTermContractQuery = { __typename?: 'Query', termContractGetSingle?: { __typename?: 'TermContract', termContractKey: number, name?: string | null, startDate: any, endDate: any, notes?: string | null, termContractSuppliers?: Array<{ __typename?: 'TermContractSupplier', supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null> | null, termContractTerminals?: Array<{ __typename?: 'TermContractTerminal', terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null } | null };

export type DeleteTermContractLocationMutationVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type DeleteTermContractLocationMutation = { __typename?: 'Mutation', termContractLocationDelete: boolean };

export type DeleteTermContractTerminalMutationVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type DeleteTermContractTerminalMutation = { __typename?: 'Mutation', termContractTerminalDelete: boolean };

export type DeleteTermContractSupplierMutationVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type DeleteTermContractSupplierMutation = { __typename?: 'Mutation', termContractSupplierDelete: boolean };

export type InnerTermContractFragment = { __typename?: 'TermContract', termContractKey: number, name?: string | null, startDate: any, endDate: any, notes?: string | null, termContractSuppliers?: Array<{ __typename?: 'TermContractSupplier', supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null> | null, termContractTerminals?: Array<{ __typename?: 'TermContractTerminal', terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null };

export type InnerTermContractListingFragment = { __typename?: 'TermContractGetAllEdge', node?: { __typename?: 'TermContract', termContractKey: number, name?: string | null, startDate: any, endDate: any, notes?: string | null, termContractSuppliers?: Array<{ __typename?: 'TermContractSupplier', supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null> | null, termContractTerminals?: Array<{ __typename?: 'TermContractTerminal', terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null } | null };

export type AllTermContractListingFragment = { __typename?: 'TermContractGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'TermContractGetAllEdge', cursor: string, node?: { __typename?: 'TermContract', termContractKey: number, name?: string | null, startDate: any, endDate: any, notes?: string | null, termContractSuppliers?: Array<{ __typename?: 'TermContractSupplier', supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null> | null, termContractTerminals?: Array<{ __typename?: 'TermContractTerminal', terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null } | null }> | null };

export type AllTermContractQueryVariables = Exact<{
  sort?: InputMaybe<Array<TermContractSortInput> | TermContractSortInput>;
  filter?: InputMaybe<TermContractFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllTermContractQuery = { __typename?: 'Query', termContractGetAll?: { __typename?: 'TermContractGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'TermContractGetAllEdge', cursor: string, node?: { __typename?: 'TermContract', termContractKey: number, name?: string | null, startDate: any, endDate: any, notes?: string | null, termContractSuppliers?: Array<{ __typename?: 'TermContractSupplier', supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null> | null, termContractTerminals?: Array<{ __typename?: 'TermContractTerminal', terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null> | null } | null }> | null } | null };

export type DeleteTermContractMutationVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type DeleteTermContractMutation = { __typename?: 'Mutation', termContractDelete: boolean };

export type CreateTerminalMutationVariables = Exact<{
  terminal: TerminalInput;
}>;


export type CreateTerminalMutation = { __typename?: 'Mutation', terminalCreate: { __typename?: 'Terminal', terminalKey: number } };

export type EditTerminalMutationVariables = Exact<{
  terminal: TerminalInput;
  id: Scalars['Int']['input'];
}>;


export type EditTerminalMutation = { __typename?: 'Mutation', terminalUpdate: { __typename?: 'Terminal', terminalKey: number } };

export type InnerTerminalFragment = { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, notes?: string | null };

export type AllTerminalListingFragment = { __typename?: 'TerminalGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'TerminalGetAllEdge', cursor: string, node?: { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, notes?: string | null } | null }> | null };

export type InnerTerminalListingFragment = { __typename?: 'TerminalGetAllEdge', node?: { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, notes?: string | null } | null };

export type AllTerminalQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<TerminalSortInput> | TerminalSortInput>;
  filterObject?: InputMaybe<TerminalFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllTerminalQuery = { __typename?: 'Query', terminalGetAll?: { __typename?: 'TerminalGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'TerminalGetAllEdge', cursor: string, node?: { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, notes?: string | null } | null }> | null } | null };

export type DeleteTerminalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTerminalMutation = { __typename?: 'Mutation', terminalDelete: boolean };

export type ArchiveTerminalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ArchiveTerminalMutation = { __typename?: 'Mutation', terminalArchive: { __typename?: 'Terminal', terminalKey: number } };

export type SingleTerminalFragment = { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, address1?: string | null, address2?: string | null, directions?: string | null, email?: string | null, fax?: string | null, phone?: string | null, isArchived: boolean, notes?: string | null, locationTerminals?: Array<{ __typename?: 'LocationTerminal', locationKey: number, mileage: number } | null> | null };

export type GetSingleTerminalQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleTerminalQuery = { __typename?: 'Query', terminalGetSingle: { __typename?: 'Terminal', terminalKey: number, name?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, address1?: string | null, address2?: string | null, directions?: string | null, email?: string | null, fax?: string | null, phone?: string | null, isArchived: boolean, notes?: string | null, locationTerminals?: Array<{ __typename?: 'LocationTerminal', locationKey: number, mileage: number } | null> | null } };

export type GetAllContactByTerminalKeyQueryVariables = Exact<{
  filterContact?: InputMaybe<ContactFilterInput>;
}>;


export type GetAllContactByTerminalKeyQuery = { __typename?: 'Query', contactGetAll?: Array<{ __typename?: 'Contact', terminalKey?: number | null, contactKey: number, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, notes?: string | null, default: boolean, cellPhone?: string | null, homePhone?: string | null, deleted: boolean } | null> | null };

export type GetAllIndexContractsByTerminalKeyQueryVariables = Exact<{
  terminalKey: Scalars['Int']['input'];
}>;


export type GetAllIndexContractsByTerminalKeyQuery = { __typename?: 'Query', indexContractsGetAll: Array<{ __typename?: 'IndexContract', indexContractKey: number, effectiveDate: any, supplier: { __typename?: 'Supplier', name?: string | null } }> };

export type SingleUserFragmentFragment = { __typename?: 'User', email?: string | null, name?: string | null };

export type CreateUserMutationVariables = Exact<{
  user: UserInput;
  password: Scalars['String']['input'];
  carriers?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', userCreate: { __typename?: 'User', email?: string | null, name?: string | null } };

export type GetUserQueryVariables = Exact<{
  userKey: Scalars['Int']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', userGetSingle: { __typename?: 'User', id: number, name?: string | null, email?: string | null, phoneNumber?: string | null, isGasPointUser: boolean, isAdminUser: boolean, hasFullAccess: boolean, preferPrefixSearch: boolean, userCarriers?: Array<{ __typename?: 'UserCarrier', carrierKey: number } | null> | null, userStatePermissions?: Array<{ __typename?: 'UserStatePermission', stateKey: number, state: { __typename?: 'State', name?: string | null } } | null> | null, userCustomerPermissions?: Array<{ __typename?: 'UserCustomerPermission', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationPermissions?: Array<{ __typename?: 'UserLocationPermission', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null, userCustomerExclusions?: Array<{ __typename?: 'UserCustomerExclusion', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationExclusions?: Array<{ __typename?: 'UserLocationExclusion', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null } };

export type EditUserMutationVariables = Exact<{
  user: UserInput;
  email?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  carriers?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  customers?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  locations?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  states?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  disabledCustomers?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  disabledLocations?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type EditUserMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', id: number, name?: string | null, email?: string | null, phoneNumber?: string | null, isGasPointUser: boolean, isAdminUser: boolean, hasFullAccess: boolean, preferPrefixSearch: boolean, userCarriers?: Array<{ __typename?: 'UserCarrier', carrierKey: number } | null> | null, userStatePermissions?: Array<{ __typename?: 'UserStatePermission', stateKey: number, state: { __typename?: 'State', name?: string | null } } | null> | null, userCustomerPermissions?: Array<{ __typename?: 'UserCustomerPermission', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationPermissions?: Array<{ __typename?: 'UserLocationPermission', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null, userCustomerExclusions?: Array<{ __typename?: 'UserCustomerExclusion', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationExclusions?: Array<{ __typename?: 'UserLocationExclusion', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null } };

export type InnerUserFragment = { __typename?: 'User', id: number, name?: string | null, email?: string | null, phoneNumber?: string | null, isGasPointUser: boolean, isAdminUser: boolean, hasFullAccess: boolean, preferPrefixSearch: boolean, userCarriers?: Array<{ __typename?: 'UserCarrier', carrierKey: number } | null> | null, userStatePermissions?: Array<{ __typename?: 'UserStatePermission', stateKey: number, state: { __typename?: 'State', name?: string | null } } | null> | null, userCustomerPermissions?: Array<{ __typename?: 'UserCustomerPermission', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationPermissions?: Array<{ __typename?: 'UserLocationPermission', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null, userCustomerExclusions?: Array<{ __typename?: 'UserCustomerExclusion', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationExclusions?: Array<{ __typename?: 'UserLocationExclusion', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null };

export type InnerUserListingFragment = { __typename?: 'UsersGetAllEdge', node?: { __typename?: 'User', id: number, name?: string | null, email?: string | null, phoneNumber?: string | null, isGasPointUser: boolean, isAdminUser: boolean, hasFullAccess: boolean, preferPrefixSearch: boolean, userCarriers?: Array<{ __typename?: 'UserCarrier', carrierKey: number } | null> | null, userStatePermissions?: Array<{ __typename?: 'UserStatePermission', stateKey: number, state: { __typename?: 'State', name?: string | null } } | null> | null, userCustomerPermissions?: Array<{ __typename?: 'UserCustomerPermission', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationPermissions?: Array<{ __typename?: 'UserLocationPermission', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null, userCustomerExclusions?: Array<{ __typename?: 'UserCustomerExclusion', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationExclusions?: Array<{ __typename?: 'UserLocationExclusion', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null } | null };

export type AllUserListingFragment = { __typename?: 'UsersGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'UsersGetAllEdge', cursor: string, node?: { __typename?: 'User', id: number, name?: string | null, email?: string | null, phoneNumber?: string | null, isGasPointUser: boolean, isAdminUser: boolean, hasFullAccess: boolean, preferPrefixSearch: boolean, userCarriers?: Array<{ __typename?: 'UserCarrier', carrierKey: number } | null> | null, userStatePermissions?: Array<{ __typename?: 'UserStatePermission', stateKey: number, state: { __typename?: 'State', name?: string | null } } | null> | null, userCustomerPermissions?: Array<{ __typename?: 'UserCustomerPermission', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationPermissions?: Array<{ __typename?: 'UserLocationPermission', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null, userCustomerExclusions?: Array<{ __typename?: 'UserCustomerExclusion', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationExclusions?: Array<{ __typename?: 'UserLocationExclusion', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null } | null }> | null };

export type AllUsersQueryVariables = Exact<{
  sortObject?: InputMaybe<Array<UserSortInput> | UserSortInput>;
  filterObject?: InputMaybe<UserFilterInput>;
  cursor: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AllUsersQuery = { __typename?: 'Query', usersGetAll?: { __typename?: 'UsersGetAllConnection', totalCount: number, edges?: Array<{ __typename?: 'UsersGetAllEdge', cursor: string, node?: { __typename?: 'User', id: number, name?: string | null, email?: string | null, phoneNumber?: string | null, isGasPointUser: boolean, isAdminUser: boolean, hasFullAccess: boolean, preferPrefixSearch: boolean, userCarriers?: Array<{ __typename?: 'UserCarrier', carrierKey: number } | null> | null, userStatePermissions?: Array<{ __typename?: 'UserStatePermission', stateKey: number, state: { __typename?: 'State', name?: string | null } } | null> | null, userCustomerPermissions?: Array<{ __typename?: 'UserCustomerPermission', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationPermissions?: Array<{ __typename?: 'UserLocationPermission', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null, userCustomerExclusions?: Array<{ __typename?: 'UserCustomerExclusion', customerKey: number, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } | null> | null, userLocationExclusions?: Array<{ __typename?: 'UserLocationExclusion', locationKey: number, location: { __typename?: 'Location', customerKey: number, name?: string | null, city?: string | null, state?: string | null, stateObj: { __typename?: 'State', name?: string | null }, customer: { __typename?: 'Customer', name?: string | null, dbaName?: string | null } } } | null> | null } | null }> | null } | null };

export type DeleteUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', userDelete: boolean };

export const SinglePointToPointCarrierRateFragmentDoc = gql`
    fragment singlePointToPointCarrierRate on CarrierPointToPointRate {
  carrierPointToPointRateKey
  rate
  originCityKey
  originCity {
    name
    cityKey
    stateKey
    state {
      stateKey
      name
    }
  }
  destinationCityKey
  destinationCity {
    name
    cityKey
    stateKey
    state {
      stateKey
      name
    }
  }
  miles
  tolls
  carrierPointToPointRateDateSpanKey
}
    `;
export const SingleFuelSurchargeFragmentDoc = gql`
    fragment singleFuelSurcharge on FuelSurcharge {
  fuelSurchargeKey
  carrierKey
  rate
  startDate
  endDate
}
    `;
export const SingleOrderExportFragmentDoc = gql`
    fragment singleOrderExport on Order {
  carrier {
    name
    email
    fax
  }
  customer {
    name
  }
  tripNumber
  deliveryDate
  location {
    directions
  }
  terminal {
    name
    directions
  }
  specialInstructions
  supplier {
    name
  }
  poNumber
  miles
}
    `;
export const PricingListingFragmentDoc = gql`
    fragment pricingListing on Pricing {
  pricingType
  effectiveDate
  supplierName
  supplierKey
  terminalName
  terminalKey
  product
  markup
  patCost
  perc
  stateTax
  stateAssessment
  fob
  mileage
  primaryCarrier
  secondaryCarrier
  primaryCarrierRate
  secondaryCarrierRate
  primaryCarrierDelivered
  secondaryCarrierDelivered
  primaryCarrierKey
  secondaryCarrierKey
  locationKey
  queryString
  contractVolumeExhausted
  pricingName
  termContractKey
  hasErrors
  pricingKey
}
    `;
export const LocationCustomerSupplierFragmentDoc = gql`
    fragment LocationCustomerSupplier on Location {
  locationTerminals {
    terminalKey
    mileage
    terminal {
      name
      indexContracts {
        indexContractKey
        supplier {
          name
        }
        basisType {
          basisTypeKey
          name
        }
        effectiveDate
        januaryIndex
        februaryIndex
        marchIndex
        aprilIndex
        mayIndex
        juneIndex
        julyIndex
        augustIndex
        septemberIndex
        octoberIndex
        novemberIndex
        decemberIndex
      }
      prePurchaseAgreements {
        prePurchaseAgreementKey
        supplierAgreement
        supplier {
          name
        }
        toDateGallons
        gallons
        productCost
        assessmentCost
        freightCost
        miscCost
        endShipDate
        startShipDate
      }
    }
  }
  locationKey
  primaryCarrierKey
  primaryCarrier {
    name
    carrierRates {
      startDate
      endDate
      basePercent
      carrierRateBands {
        mileageFrom
        mileageTo
        ratePerGallon
      }
    }
  }
  secondaryCarrierKey
  secondaryCarrier {
    name
    carrierRates {
      startDate
      endDate
      basePercent
      carrierRateBands {
        mileageFrom
        mileageTo
        ratePerGallon
      }
    }
  }
  markupCost
  city
  state
  customer {
    customerKey
    name
    deliveryTimeKey
  }
  isFobCustomer
}
    `;
export const InnerTerminalPostingFragmentDoc = gql`
    fragment InnerTerminalPosting on Posting {
  postingKey
  terminalKey
  supplierKey
  terminal {
    name
  }
  supplier {
    name
  }
  cost
  effectiveDate
}
    `;
export const BasicBasisTypeFragmentDoc = gql`
    fragment BasicBasisType on BasisType {
  basisTypeKey
  name
}
    `;
export const CarrierSearchListingFragmentDoc = gql`
    fragment carrierSearchListing on CarrierSearch {
  carrierKey
  name
  address1
  address2
  city
  state
  zipCode
  phone
  fax
  email
  carrierRates {
    endDate
    startDate
    basePercent
    carrierRateBands {
      mileageFrom
      mileageTo
      ratePerGallon
    }
  }
}
    `;
export const BasicContactFragmentDoc = gql`
    fragment BasicContact on Contact {
  contactKey
  firstName
  lastName
  email
  phone
  cellPhone
  homePhone
  default
}
    `;
export const BasicCustomerFragmentDoc = gql`
    fragment basicCustomer on Customer {
  customerKey
  name
  dbaName
}
    `;
export const InnerDeliveryTimeFragmentDoc = gql`
    fragment innerDeliveryTime on DeliveryTime {
  deliveryTimeKey
  code
  description
}
    `;
export const BasicLocationFragmentDoc = gql`
    fragment BasicLocation on Location {
  locationKey
  name
  city
  stateObj {
    stateKey
    name
  }
  customer {
    customerKey
    name
  }
}
    `;
export const BasicSupplierFragmentDoc = gql`
    fragment BasicSupplier on Supplier {
  supplierKey
  name
  city
  state
}
    `;
export const FullTagFragmentDoc = gql`
    fragment fullTag on Tag {
  tagKey
  name
}
    `;
export const BasicTerminalFragmentDoc = gql`
    fragment BasicTerminal on Terminal {
  terminalKey
  name
  city
  state
  locationTerminals {
    mileage
    locationKey
  }
}
    `;
export const TaskShowCompletedAfterFragmentDoc = gql`
    fragment TaskShowCompletedAfter on Task {
  contact {
    contactKey
    firstName
    lastName
  }
  location {
    customerKey
    locationKey
    name
  }
  user {
    id
    email
    name
  }
  taskKey
  isComplete
  taskDate
  callDetails
  contactMethod
  completedDate
  locationKey
}
    `;
export const BasisTypePricingFragmentDoc = gql`
    fragment basisTypePricing on BasisTypePrice {
  basisTypePriceKey
  basisTypeKey
  price
  effectiveDate
}
    `;
export const AllBasisTypeListingFragmentDoc = gql`
    fragment allBasisTypeListing on BasisType {
  basisTypeKey
  description
  name
  isArchived
  currentPrice {
    price
    effectiveDate
  }
}
    `;
export const SingleBasisTypeFragmentDoc = gql`
    fragment singleBasisType on BasisType {
  ...allBasisTypeListing
}
    ${AllBasisTypeListingFragmentDoc}`;
export const CarrierListingFragmentDoc = gql`
    fragment carrierListing on Carrier {
  carrierKey
  name
  address1
  address2
  city
  state
  zipCode
  phone
  fax
  email
  carrierType
  isArchived
}
    `;
export const SingleCarrierRateFragmentDoc = gql`
    fragment singleCarrierRate on CarrierRate {
  carrierRateKey
  carrierKey
  basePercent
  startDate
  endDate
  default
  fuelPercent
}
    `;
export const AllCarrierListingFragmentDoc = gql`
    fragment allCarrierListing on Carrier {
  carrierKey
  name
  address1
  address2
  city
  state
  zipCode
  phone
  fax
  email
  carrierType
  isArchived
  carrierRates {
    endDate
    startDate
    basePercent
    carrierRateBands {
      mileageFrom
      mileageTo
      ratePerGallon
    }
  }
}
    `;
export const SingleCarrierFragmentDoc = gql`
    fragment singleCarrier on Carrier {
  ...allCarrierListing
}
    ${AllCarrierListingFragmentDoc}`;
export const InnerContractVolumeFragmentDoc = gql`
    fragment innerContractVolume on ContractVolume {
  contractVolumeKey
  startDate
  contractVolumeType
  contractVolumeTerminals {
    terminalKey
    terminal {
      name
    }
  }
  supplierKey
  supplier {
    name
  }
  january
  february
  march
  april
  may
  june
  july
  august
  september
  october
  november
  december
}
    `;
export const InnerContractVolumeListingFragmentDoc = gql`
    fragment innerContractVolumeListing on ContractVolumeGetAllEdge {
  node {
    ...innerContractVolume
  }
}
    ${InnerContractVolumeFragmentDoc}`;
export const AllContractVolumeListingFragmentDoc = gql`
    fragment allContractVolumeListing on ContractVolumeGetAllConnection {
  edges {
    cursor
    ...innerContractVolumeListing
  }
  totalCount
}
    ${InnerContractVolumeListingFragmentDoc}`;
export const InnerFlatContractVolumeFragmentDoc = gql`
    fragment innerFlatContractVolume on FlatContractVolume {
  contractVolumeKey
  startDate
  supplier
  terminals
}
    `;
export const InnerFlatContractVolumeListingFragmentDoc = gql`
    fragment innerFlatContractVolumeListing on FlatContractVolumeGetAllEdge {
  node {
    ...innerFlatContractVolume
  }
}
    ${InnerFlatContractVolumeFragmentDoc}`;
export const AllFlatContractVolumeListingFragmentDoc = gql`
    fragment allFlatContractVolumeListing on FlatContractVolumeGetAllConnection {
  edges {
    cursor
    ...innerFlatContractVolumeListing
  }
  totalCount
}
    ${InnerFlatContractVolumeListingFragmentDoc}`;
export const LocationListingFragmentDoc = gql`
    fragment locationListing on Location {
  locationKey
  name
  city
  stateObj {
    stateKey
    name
  }
  zipCode
  isActive
}
    `;
export const SingleCustomerFragmentDoc = gql`
    fragment singleCustomer on Customer {
  customerKey
  description
  name
  dbaName
  businessType
  deliveryTimeKey
  deliveryTime {
    code
    description
  }
  address1
  address2
  city
  state
  zipCode
  directions
  creditLimit
  creditNotes
  isActive
  locations {
    ...locationListing
  }
}
    ${LocationListingFragmentDoc}`;
export const InnerCustomerFragmentDoc = gql`
    fragment innerCustomer on Customer {
  customerKey
  description
  name
  dbaName
  isActive
  locations {
    locationKey
    name
    city
    stateObj {
      stateKey
      name
    }
    locationTags {
      tag {
        name
      }
    }
  }
  customerTags {
    tag {
      name
    }
  }
}
    `;
export const InnerCustomerListingFragmentDoc = gql`
    fragment innerCustomerListing on CustomerGetAllEdge {
  node {
    ...innerCustomer
  }
}
    ${InnerCustomerFragmentDoc}`;
export const AllCustomerListingFragmentDoc = gql`
    fragment allCustomerListing on CustomerGetAllConnection {
  edges {
    cursor
    ...innerCustomerListing
  }
  totalCount
}
    ${InnerCustomerListingFragmentDoc}`;
export const InnerCustomersWithFilterListingFragmentDoc = gql`
    fragment innerCustomersWithFilterListing on CustomersWithFilterEdge {
  node {
    ...innerCustomer
  }
}
    ${InnerCustomerFragmentDoc}`;
export const CustomersWithFilterListingFragmentDoc = gql`
    fragment customersWithFilterListing on CustomersWithFilterConnection {
  edges {
    cursor
    ...innerCustomersWithFilterListing
  }
  totalCount
}
    ${InnerCustomersWithFilterListingFragmentDoc}`;
export const InnerDirectMarkupFragmentDoc = gql`
    fragment innerDirectMarkup on DirectMarkup {
  directMarkupKey
  markup
  supplierKey
  locationKey
  terminalKey
  directMarkupType
  isArchived
}
    `;
export const AllDirectMarkupListingFragmentDoc = gql`
    fragment allDirectMarkupListing on DirectMarkup {
  directMarkupKey
  markup
  terminal {
    name
  }
  location {
    name
    city
    state
    customer {
      name
    }
  }
  supplier {
    name
  }
  directMarkupType
}
    `;
export const AllFlatDirectMarkupListingFragmentDoc = gql`
    fragment allFlatDirectMarkupListing on FlatDirectMarkup {
  directMarkupKey
  markup
  directMarkupType
  terminal
  location
  supplier
}
    `;
export const InnerFileNumberFragmentDoc = gql`
    fragment innerFileNumber on FileNumber {
  fileNumberKey
  number
  supplierKey
  terminalKey
  isArchived
  isDefault
}
    `;
export const AllFileNumberListingFragmentDoc = gql`
    fragment allFileNumberListing on FileNumber {
  fileNumberKey
  number
  isDefault
  terminal {
    name
  }
  supplier {
    name
  }
  isArchived
}
    `;
export const FlatFileNumberListingFragmentDoc = gql`
    fragment FlatFileNumberListing on FlatFileNumber {
  fileNumberKey
  number
  isDefault
  terminal
  supplier
  isArchived
}
    `;
export const DisplayTaskFragmentDoc = gql`
    fragment DisplayTask on Task {
  taskKey
  taskDate
  contactKey
  contact {
    firstName
    lastName
    phone
  }
  location {
    name
    customer {
      name
    }
    city
    stateObj {
      stateKey
      name
    }
  }
  user {
    email
    name
  }
}
    `;
export const AllIndexContractFragmentDoc = gql`
    fragment allIndexContract on IndexContract {
  terminalKey
  terminal {
    name
  }
  supplierKey
  supplier {
    name
  }
  basisTypeKey
  basisType {
    basisTypePrices {
      effectiveDate
      price
    }
    name
  }
  effectiveDate
  effectiveEndDate
  accountInfo
  supplierType
  contractPeriod
  isIndication
  minimumLoads
  maximumLoads
  minimumGallons
  maximumGallons
  januaryIndex
  februaryIndex
  marchIndex
  aprilIndex
  mayIndex
  juneIndex
  julyIndex
  augustIndex
  septemberIndex
  octoberIndex
  novemberIndex
  decemberIndex
  dayPrior
}
    `;
export const SingleIndexContractFragmentDoc = gql`
    fragment singleIndexContract on IndexContract {
  ...allIndexContract
}
    ${AllIndexContractFragmentDoc}`;
export const IndexContractListingFragmentDoc = gql`
    fragment IndexContractListing on IndexContract {
  indexContractKey
  supplier {
    name
  }
  terminal {
    name
  }
  accountInfo
  effectiveDate
  effectiveEndDate
}
    `;
export const FlatIndexContractListingFragmentDoc = gql`
    fragment FlatIndexContractListing on FlatIndexContract {
  indexContractKey
  supplier
  supplierKey
  terminal
  accountInfo
  effectiveDate
  effectiveEndDate
}
    `;
export const SingleLocationTerminalFragmentDoc = gql`
    fragment SingleLocationTerminal on LocationTerminal {
  mileage
  terminalKey
  locationKey
  terminal {
    terminalKey
    name
    city
    state
    contacts {
      contactKey
    }
    isArchived
  }
}
    `;
export const SingleLocationFragmentFragmentDoc = gql`
    fragment SingleLocationFragment on Location {
  locationKey
  address1
  address2
  agId
  city
  customerKey
  directions
  federalId
  hasPercCharge
  isAgExempt
  isFobCustomer
  isInternetCustomer
  isTaxExempt
  locationNotes
  markupCost
  lockMarkup
  name
  quickBooksName
  state
  stateId
  stateKey
  stateObj {
    name
    stateKey
  }
  zipCode
  locationStatus
  percentOfSales
  mailToAddress1
  mailToAddress2
  mailToCity
  mailToDirections
  mailToState
  mailToZipCode
  mailToSameAsCustomer
  isActive
  tanks {
    tankKey
    size
  }
  primaryCarrierKey
  primaryCarrier {
    name
  }
  secondaryCarrierKey
  secondaryCarrier {
    name
  }
  locationContacts {
    contact {
      contactKey
      firstName
      lastName
      email
      phone
      notes
      default
      cellPhone
      homePhone
      deleted
    }
    default
  }
  customer {
    customerKey
    name
    address1
    address2
    city
    state
    zipCode
    directions
  }
  locationTerminals {
    ...SingleLocationTerminal
  }
  tasks {
    contact {
      firstName
      lastName
    }
    callDetails
    taskDate
  }
  locationTags {
    locationKey
    tagKey
  }
}
    ${SingleLocationTerminalFragmentDoc}`;
export const InnerLocationFragmentDoc = gql`
    fragment innerLocation on Location {
  locationKey
  name
  city
  stateObj {
    stateKey
    name
  }
  zipCode
  address1
  address2
  customer {
    customerKey
    name
  }
}
    `;
export const InnerLocationListingFragmentDoc = gql`
    fragment innerLocationListing on LocationGetAllEdge {
  node {
    ...innerLocation
  }
}
    ${InnerLocationFragmentDoc}`;
export const AllLocationListingFragmentDoc = gql`
    fragment allLocationListing on LocationGetAllConnection {
  edges {
    cursor
    ...innerLocationListing
  }
  totalCount
}
    ${InnerLocationListingFragmentDoc}`;
export const SingleOrderFragmentDoc = gql`
    fragment singleOrder on Order {
  locationKey
  location {
    state
    locationTerminals {
      mileage
    }
  }
  customerKey
  customer {
    quickBooksName
  }
  supplierKey
  terminalKey
  carrierKey
  termContractKey
  deliveryTimeKey
  status
  fileNumberKey
  deliveryDate
  gallons
  miles
  tripNumber
  specialInstructions
  product
  markup
  freight
  tolls
  assessment
  misc
  fOB
  delivered
  actualGallons
  poNumber
  sglInvoiceNumber
  manifest
  otherCharge
  otherCost
  costDescription
  patCost
  patCostTotal
  prePurchaseAgreementKey
  prePurchaseAgreement {
    supplierAgreement
  }
  postingKey
  indexContractKey
  salesAgreementKey
  createdByUserId
  createdDate
  carrier {
    email
  }
  createdByUser {
    name
  }
  modifiedByUser {
    name
  }
  orderType
  quotedPrice
  readyForInvoicing
  tripNotes
  tripsActualGallons
  tripManifest
  carrierPaid
  supplierPaid
  spotContract
  stateAssessment
  stateTax
  perc
}
    `;
export const InnerOrderFragmentDoc = gql`
    fragment innerOrder on Order {
  orderKey
  location {
    name
    city
    stateObj {
      stateKey
      name
    }
  }
  customer {
    name
  }
  supplier {
    supplierKey
    name
  }
  terminal {
    name
  }
  carrier {
    carrierKey
    name
    email
    state
  }
  indexContract {
    fileNumber
  }
  createdByUser {
    name
  }
  deliveryDate
  tripNumber
  status
  actualGallons
  gallons
  freight
  tolls
  product
  otherCharge
  otherCost
  supplierPaid
  carrierPaid
  manifest
  delivered
  orderType
  tripsActualGallons
  tripManifest
  tripNotes
  readyForInvoicing
  specialInstructions
  costDescription
  postingKey
  indexContractKey
  legacyCostType
  spotContract
  stateAssessment
  stateTax
  assessment
}
    `;
export const InnerOrderListingFragmentDoc = gql`
    fragment innerOrderListing on OrderDashboardEdge {
  node {
    ...innerOrder
  }
}
    ${InnerOrderFragmentDoc}`;
export const OrderDashboardListingFragmentDoc = gql`
    fragment orderDashboardListing on OrderDashboardConnection {
  edges {
    cursor
    ...innerOrderListing
  }
  totalCount
}
    ${InnerOrderListingFragmentDoc}`;
export const InnerOrderGetAllListingFragmentDoc = gql`
    fragment innerOrderGetAllListing on OrderGetAllEdge {
  node {
    ...innerOrder
  }
}
    ${InnerOrderFragmentDoc}`;
export const OrderGetAllListingFragmentDoc = gql`
    fragment orderGetAllListing on OrderGetAllConnection {
  edges {
    cursor
    ...innerOrderGetAllListing
  }
  totalCount
}
    ${InnerOrderGetAllListingFragmentDoc}`;
export const InnerPatCostFragmentDoc = gql`
    fragment innerPatCost on PatCost {
  patCostKey
  effectiveDate
  cost
  state
}
    `;
export const PostingInfoFragmentDoc = gql`
    fragment postingInfo on Posting {
  postingKey
  supplierKey
  supplier {
    name
  }
  terminalKey
  terminal {
    name
  }
  isArchived
  currentPrice {
    postingPriceKey
    cost
    effectiveDate
  }
}
    `;
export const PostingPriceInfoFragmentDoc = gql`
    fragment postingPriceInfo on PostingPrice {
  postingPriceKey
  effectiveDate
  cost
  postingKey
}
    `;
export const InnerPostingFragmentDoc = gql`
    fragment InnerPosting on Posting {
  postingKey
  supplierKey
  supplier {
    name
  }
  terminalKey
  terminal {
    name
  }
  cost
  effectiveDate
}
    `;
export const InnerPostingListingFragmentDoc = gql`
    fragment InnerPostingListing on PostingGetAllEdge {
  node {
    ...InnerPosting
  }
}
    ${InnerPostingFragmentDoc}`;
export const AllPostingListingFragmentDoc = gql`
    fragment AllPostingListing on PostingGetAllConnection {
  edges {
    cursor
    ...InnerPostingListing
  }
  totalCount
}
    ${InnerPostingListingFragmentDoc}`;
export const InnerFlatPostingFragmentDoc = gql`
    fragment InnerFlatPosting on FlatPosting {
  postingKey
  cost
  effectiveDate
  supplier
  terminal
  currentPrice
  currentPriceEffectiveDate
  isArchived
}
    `;
export const InnerFlatPostingListingFragmentDoc = gql`
    fragment InnerFlatPostingListing on FlatPostingGetAllEdge {
  node {
    ...InnerFlatPosting
  }
}
    ${InnerFlatPostingFragmentDoc}`;
export const AllFlatPostingListingFragmentDoc = gql`
    fragment AllFlatPostingListing on FlatPostingGetAllConnection {
  edges {
    cursor
    ...InnerFlatPostingListing
  }
  totalCount
}
    ${InnerFlatPostingListingFragmentDoc}`;
export const SinglePrePurchaseAgreementFragmentDoc = gql`
    fragment singlePrePurchaseAgreement on PrePurchaseAgreement {
  prePurchaseAgreementKey
  supplierAgreement
  prePaidDollars
  gallons
  toDateGallons
  productCost
  assessmentCost
  otherCosts
  units
  freightCost
  miscCost
  costDescription
  startShipDate
  endShipDate
  includeInTermContractVolume
  includeFreight
  chargeTariff
  showOnPricing
  terminal {
    terminalKey
    name
  }
  supplier {
    supplierKey
    name
  }
  prePurchaseAgreementSalesAgreements {
    salesAgreementKey
  }
  description
  aprilEstimate
  mayEstimate
  juneEstimate
  julyEstimate
  augustEstimate
  septemberEstimate
  octoberEstimate
  novemberEstimate
  decemberEstimate
  januaryEstimate
  februaryEstimate
  marchEstimate
  aprilPriceIncrement
  mayPriceIncrement
  junePriceIncrement
  julyPriceIncrement
  augustPriceIncrement
  septemberPriceIncrement
  octoberPriceIncrement
  novemberPriceIncrement
  decemberPriceIncrement
  januaryPriceIncrement
  februaryPriceIncrement
  marchPriceIncrement
  aprilSellBack
  maySellBack
  juneSellBack
  julySellBack
  augustSellBack
  septemberSellBack
  octoberSellBack
  novemberSellBack
  decemberSellBack
  januarySellBack
  februarySellBack
  marchSellBack
}
    `;
export const InnerPrePurchaseAgreementFragmentDoc = gql`
    fragment innerPrePurchaseAgreement on PrePurchaseAgreement {
  prePurchaseAgreementKey
  supplierAgreement
  supplier {
    name
  }
  terminal {
    name
  }
}
    `;
export const InnerPrePurchaseAgreementListingFragmentDoc = gql`
    fragment innerPrePurchaseAgreementListing on PrePurchaseAgreementGetAllEdge {
  node {
    ...innerPrePurchaseAgreement
  }
}
    ${InnerPrePurchaseAgreementFragmentDoc}`;
export const AllPrePurchaseAgreementListingFragmentDoc = gql`
    fragment allPrePurchaseAgreementListing on PrePurchaseAgreementGetAllConnection {
  edges {
    cursor
    ...innerPrePurchaseAgreementListing
  }
  totalCount
}
    ${InnerPrePurchaseAgreementListingFragmentDoc}`;
export const InnerFlatPrePurchaseAgreementFragmentDoc = gql`
    fragment innerFlatPrePurchaseAgreement on FlatPrePurchaseAgreement {
  prePurchaseAgreementKey
  supplierAgreement
  endShipDate
  supplier
  terminal
}
    `;
export const InnerFlatPrePurchaseAgreementListingFragmentDoc = gql`
    fragment innerFlatPrePurchaseAgreementListing on FlatPrePurchaseAgreementGetAllEdge {
  node {
    ...innerFlatPrePurchaseAgreement
  }
}
    ${InnerFlatPrePurchaseAgreementFragmentDoc}`;
export const AllFlatPrePurchaseAgreementListingFragmentDoc = gql`
    fragment allFlatPrePurchaseAgreementListing on FlatPrePurchaseAgreementGetAllConnection {
  edges {
    cursor
    ...innerFlatPrePurchaseAgreementListing
  }
  totalCount
}
    ${InnerFlatPrePurchaseAgreementListingFragmentDoc}`;
export const GallonsByStateFragmentDoc = gql`
    fragment gallonsByState on DispatchedShippedOrder {
  orderKey
  state
  businessType
  customerName
  locationName
  manifest
  deliveryDate
  gallons
  actualGallons
  product
  misc
  freight
  assessment
  patCost
  otherCost
  otherCharge
  markup
  invoiceNumber
}
    `;
export const MonthlyCvReportListingFragmentDoc = gql`
    fragment monthlyCvReportListing on MonthlyCVReport {
  contractVolumeKey
  startDate
  supplierName
  terminalName
  contractVolumeType
  fileNumber
  monthlyVolume
  totalLoads
  loadsLifted
  gallonsLifted
  remainingLoads
  loadsBusDay
}
    `;
export const DispatchedShippedOrdersFragmentDoc = gql`
    fragment dispatchedShippedOrders on DispatchedShippedOrder {
  actualGallons
  carrierKey
  carrierName
  customerKey
  customerName
  delivered
  deliveryDate
  gallons
  locationKey
  locationName
  manifest
  orderKey
  product
  supplierKey
  supplierName
  terminalKey
  terminalName
}
    `;
export const ShippedDispatchedOrderDetailsFragmentDoc = gql`
    fragment shippedDispatchedOrderDetails on DispatchedShippedOrder {
  actualGallons
  carrierKey
  carrierName
  customerKey
  customerName
  deliveryDate
  gallons
  locationKey
  locationName
  manifest
  orderKey
  supplierKey
  supplierName
  terminalKey
  terminalName
  product
  markup
  assessment
  misc
  fOB
  freight
  delivered
  otherCost
  otherCharge
  patCost
}
    `;
export const TaskReportListingFragmentDoc = gql`
    fragment taskReportListing on TaskReport {
  taskKey
  completedDate
  locationKey
  locationName
  locationCity
  customerKey
  customerName
  contactKey
  contactName
  contactMethod
  info
  userName
}
    `;
export const SalesAgreementListingFragmentDoc = gql`
    fragment salesAgreementListing on SalesAgreement {
  salesAgreementKey
  agreementName
  prePaid
  gallons
  deposit
  assessment
  startShipDate
  endShipDate
  notes
  gallonsToDate
  loadsToDate
  quoted
  quotedFOB
  misc
  supplierKey
  terminalKey
  aprEst
  mayEst
  junEst
  julEst
  augEst
  sepEst
  octEst
  novEst
  decEst
  janEst
  febEst
  marEst
  aprPI
  mayPI
  junPI
  julPI
  augPI
  sepPI
  octPI
  novPI
  decPI
  janPI
  febPI
  marPI
  supplier {
    name
  }
  terminal {
    name
  }
  salesAgreementLocations {
    locationKey
    location {
      stateObj {
        stateKey
        name
      }
    }
  }
  relatedFromSalesAgreements {
    relatedFromSalesAgreementKey
  }
  prePurchaseAgreementSalesAgreements {
    prePurchaseAgreementKey
  }
  termContractSalesAgreements {
    termContractKey
  }
}
    `;
export const InnerSalesAgreementFragmentDoc = gql`
    fragment innerSalesAgreement on SalesAgreement {
  salesAgreementKey
  agreementName
  supplierKey
  terminalKey
  endShipDate
  supplier {
    name
  }
  terminal {
    name
  }
}
    `;
export const InnerSalesAgreementListingFragmentDoc = gql`
    fragment innerSalesAgreementListing on SalesAgreementGetAllEdge {
  node {
    ...innerSalesAgreement
  }
}
    ${InnerSalesAgreementFragmentDoc}`;
export const AllSalesAgreementListingFragmentDoc = gql`
    fragment allSalesAgreementListing on SalesAgreementGetAllConnection {
  edges {
    cursor
    ...innerSalesAgreementListing
  }
  totalCount
}
    ${InnerSalesAgreementListingFragmentDoc}`;
export const InnerFlatSalesAgreementFragmentDoc = gql`
    fragment innerFlatSalesAgreement on FlatSalesAgreement {
  salesAgreementKey
  agreementName
  supplier
  terminal
  endShipDate
  locationKeys
  customerKeys
  stateKeys
}
    `;
export const InnerFlatSalesAgreementListingFragmentDoc = gql`
    fragment innerFlatSalesAgreementListing on FlatSalesAgreementGetAllEdge {
  node {
    ...innerFlatSalesAgreement
  }
}
    ${InnerFlatSalesAgreementFragmentDoc}`;
export const AllFlatSalesAgreementListingFragmentDoc = gql`
    fragment allFlatSalesAgreementListing on FlatSalesAgreementGetAllConnection {
  edges {
    cursor
    ...innerFlatSalesAgreementListing
  }
  totalCount
}
    ${InnerFlatSalesAgreementListingFragmentDoc}`;
export const InnerStateFragmentDoc = gql`
    fragment innerState on State {
  stateKey
  name
}
    `;
export const InnerStateTaxFragmentDoc = gql`
    fragment innerStateTax on StateTax {
  stateTaxKey
  startDate
  endDate
  stateKey
  state {
    ...innerState
  }
  amount
  stateTaxType
}
    ${InnerStateFragmentDoc}`;
export const AllSupplierListingFragmentDoc = gql`
    fragment allSupplierListing on Supplier {
  name
  address1
  address2
  city
  directions
  fax
  phone
  state
  supplierKey
  zipCode
  notes
  isArchived
}
    `;
export const SingleSupplierFragmentDoc = gql`
    fragment singleSupplier on Supplier {
  ...allSupplierListing
  indexContracts {
    indexContractKey
    terminal {
      name
    }
    accountInfo
    effectiveDate
  }
}
    ${AllSupplierListingFragmentDoc}`;
export const SingleSwapDealFragmentDoc = gql`
    fragment singleSwapDeal on SwapDeal {
  swapDealKey
  basisType {
    basisTypeKey
  }
  swapDealSalesAgreements {
    salesAgreementKey
    salesAgreement {
      agreementName
    }
  }
  dealNumber
  sglCost
  effectiveStartDate
  effectiveEndDate
  monthlyVolume
}
    `;
export const InnerFlatSwapDealFragmentDoc = gql`
    fragment innerFlatSwapDeal on FlatSwapDeal {
  swapDealKey
  basisType
  salesAgreements
  suppliers
  dealNumber
  sglCost
  effectiveStartDate
  effectiveEndDate
  monthlyVolume
}
    `;
export const TaskShowFragmentDoc = gql`
    fragment TaskShow on Task {
  contact {
    contactKey
    firstName
    lastName
  }
  location {
    customerKey
    locationKey
    name
  }
  user {
    id
    email
    name
  }
  taskKey
  isComplete
  taskDate
  callDetails
  contactMethod
  completedDate
  locationKey
}
    `;
export const AllTermContractFragmentDoc = gql`
    fragment AllTermContract on TermContract {
  termContractKey
  name
  startDate
  endDate
  notes
  january
  february
  march
  april
  may
  june
  july
  august
  september
  october
  november
  december
  posts
  indexContracts
  prePurchaseAgreements
  termContractSuppliers {
    supplierKey
  }
  termContractLocations {
    locationKey
  }
  termContractTerminals {
    terminalKey
  }
}
    `;
export const InnerTermContractFragmentDoc = gql`
    fragment innerTermContract on TermContract {
  termContractKey
  name
  termContractSuppliers {
    supplier {
      name
    }
  }
  termContractTerminals {
    terminal {
      name
    }
  }
  startDate
  endDate
  notes
}
    `;
export const InnerTermContractListingFragmentDoc = gql`
    fragment innerTermContractListing on TermContractGetAllEdge {
  node {
    ...innerTermContract
  }
}
    ${InnerTermContractFragmentDoc}`;
export const AllTermContractListingFragmentDoc = gql`
    fragment allTermContractListing on TermContractGetAllConnection {
  edges {
    cursor
    ...innerTermContractListing
  }
  totalCount
}
    ${InnerTermContractListingFragmentDoc}`;
export const InnerTerminalFragmentDoc = gql`
    fragment innerTerminal on Terminal {
  terminalKey
  name
  city
  state
  zipCode
  notes
}
    `;
export const InnerTerminalListingFragmentDoc = gql`
    fragment innerTerminalListing on TerminalGetAllEdge {
  node {
    ...innerTerminal
  }
}
    ${InnerTerminalFragmentDoc}`;
export const AllTerminalListingFragmentDoc = gql`
    fragment allTerminalListing on TerminalGetAllConnection {
  edges {
    cursor
    ...innerTerminalListing
  }
  totalCount
}
    ${InnerTerminalListingFragmentDoc}`;
export const SingleTerminalFragmentDoc = gql`
    fragment singleTerminal on Terminal {
  terminalKey
  name
  city
  state
  zipCode
  address1
  address2
  directions
  email
  fax
  phone
  isArchived
  locationTerminals {
    locationKey
    mileage
  }
  notes
}
    `;
export const SingleUserFragmentFragmentDoc = gql`
    fragment SingleUserFragment on User {
  email
  name
}
    `;
export const InnerUserFragmentDoc = gql`
    fragment innerUser on User {
  id
  name
  email
  phoneNumber
  isGasPointUser
  isAdminUser
  hasFullAccess
  preferPrefixSearch
  userCarriers {
    carrierKey
  }
  userStatePermissions {
    stateKey
    state {
      name
    }
  }
  userCustomerPermissions {
    customerKey
    customer {
      name
      dbaName
    }
  }
  userLocationPermissions {
    locationKey
    location {
      customerKey
      name
      city
      state
      stateObj {
        name
      }
      customer {
        name
        dbaName
      }
    }
  }
  userCustomerExclusions {
    customerKey
    customer {
      name
      dbaName
    }
  }
  userLocationExclusions {
    locationKey
    location {
      customerKey
      name
      city
      state
      stateObj {
        name
      }
      customer {
        name
        dbaName
      }
    }
  }
}
    `;
export const InnerUserListingFragmentDoc = gql`
    fragment innerUserListing on UsersGetAllEdge {
  node {
    ...innerUser
  }
}
    ${InnerUserFragmentDoc}`;
export const AllUserListingFragmentDoc = gql`
    fragment allUserListing on UsersGetAllConnection {
  edges {
    cursor
    ...innerUserListing
  }
  totalCount
}
    ${InnerUserListingFragmentDoc}`;
export const CreateTankDocument = gql`
    mutation CreateTank($tank: TankInput!) {
  tankCreate(tank: $tank) {
    tankKey
  }
}
    `;
export type CreateTankMutationFn = Apollo.MutationFunction<CreateTankMutation, CreateTankMutationVariables>;

/**
 * __useCreateTankMutation__
 *
 * To run a mutation, you first call `useCreateTankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTankMutation, { data, loading, error }] = useCreateTankMutation({
 *   variables: {
 *      tank: // value for 'tank'
 *   },
 * });
 */
export function useCreateTankMutation(baseOptions?: Apollo.MutationHookOptions<CreateTankMutation, CreateTankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTankMutation, CreateTankMutationVariables>(CreateTankDocument, options);
      }
export type CreateTankMutationHookResult = ReturnType<typeof useCreateTankMutation>;
export type CreateTankMutationResult = Apollo.MutationResult<CreateTankMutation>;
export type CreateTankMutationOptions = Apollo.BaseMutationOptions<CreateTankMutation, CreateTankMutationVariables>;
export const CreateLocationTerminalDocument = gql`
    mutation CreateLocationTerminal($locationTerminal: LocationTerminalInput!) {
  locationTerminalCreate(locationTerminal: $locationTerminal) {
    locationKey
    terminalKey
  }
}
    `;
export type CreateLocationTerminalMutationFn = Apollo.MutationFunction<CreateLocationTerminalMutation, CreateLocationTerminalMutationVariables>;

/**
 * __useCreateLocationTerminalMutation__
 *
 * To run a mutation, you first call `useCreateLocationTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationTerminalMutation, { data, loading, error }] = useCreateLocationTerminalMutation({
 *   variables: {
 *      locationTerminal: // value for 'locationTerminal'
 *   },
 * });
 */
export function useCreateLocationTerminalMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationTerminalMutation, CreateLocationTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationTerminalMutation, CreateLocationTerminalMutationVariables>(CreateLocationTerminalDocument, options);
      }
export type CreateLocationTerminalMutationHookResult = ReturnType<typeof useCreateLocationTerminalMutation>;
export type CreateLocationTerminalMutationResult = Apollo.MutationResult<CreateLocationTerminalMutation>;
export type CreateLocationTerminalMutationOptions = Apollo.BaseMutationOptions<CreateLocationTerminalMutation, CreateLocationTerminalMutationVariables>;
export const BulkUpdateBasisTypePricesDocument = gql`
    mutation BulkUpdateBasisTypePrices($prices: [BasisTypePriceInput]!) {
  basisTypePriceBulkUpdate(prices: $prices)
}
    `;
export type BulkUpdateBasisTypePricesMutationFn = Apollo.MutationFunction<BulkUpdateBasisTypePricesMutation, BulkUpdateBasisTypePricesMutationVariables>;

/**
 * __useBulkUpdateBasisTypePricesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBasisTypePricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBasisTypePricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBasisTypePricesMutation, { data, loading, error }] = useBulkUpdateBasisTypePricesMutation({
 *   variables: {
 *      prices: // value for 'prices'
 *   },
 * });
 */
export function useBulkUpdateBasisTypePricesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateBasisTypePricesMutation, BulkUpdateBasisTypePricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateBasisTypePricesMutation, BulkUpdateBasisTypePricesMutationVariables>(BulkUpdateBasisTypePricesDocument, options);
      }
export type BulkUpdateBasisTypePricesMutationHookResult = ReturnType<typeof useBulkUpdateBasisTypePricesMutation>;
export type BulkUpdateBasisTypePricesMutationResult = Apollo.MutationResult<BulkUpdateBasisTypePricesMutation>;
export type BulkUpdateBasisTypePricesMutationOptions = Apollo.BaseMutationOptions<BulkUpdateBasisTypePricesMutation, BulkUpdateBasisTypePricesMutationVariables>;
export const CreateAndEndActivePostingDocument = gql`
    mutation CreateAndEndActivePosting($posting: PostingInput!) {
  postingCreateAndEndActive(posting: $posting) {
    ...InnerPosting
  }
}
    ${InnerPostingFragmentDoc}`;
export type CreateAndEndActivePostingMutationFn = Apollo.MutationFunction<CreateAndEndActivePostingMutation, CreateAndEndActivePostingMutationVariables>;

/**
 * __useCreateAndEndActivePostingMutation__
 *
 * To run a mutation, you first call `useCreateAndEndActivePostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndEndActivePostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndEndActivePostingMutation, { data, loading, error }] = useCreateAndEndActivePostingMutation({
 *   variables: {
 *      posting: // value for 'posting'
 *   },
 * });
 */
export function useCreateAndEndActivePostingMutation(baseOptions?: Apollo.MutationHookOptions<CreateAndEndActivePostingMutation, CreateAndEndActivePostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAndEndActivePostingMutation, CreateAndEndActivePostingMutationVariables>(CreateAndEndActivePostingDocument, options);
      }
export type CreateAndEndActivePostingMutationHookResult = ReturnType<typeof useCreateAndEndActivePostingMutation>;
export type CreateAndEndActivePostingMutationResult = Apollo.MutationResult<CreateAndEndActivePostingMutation>;
export type CreateAndEndActivePostingMutationOptions = Apollo.BaseMutationOptions<CreateAndEndActivePostingMutation, CreateAndEndActivePostingMutationVariables>;
export const BulkUpdatePostingPricesDocument = gql`
    mutation BulkUpdatePostingPrices($postingPrices: [PostingPriceCreateOrUpdateInput]!) {
  postingPriceBulkCreateOrUpdate(postingPrices: $postingPrices)
}
    `;
export type BulkUpdatePostingPricesMutationFn = Apollo.MutationFunction<BulkUpdatePostingPricesMutation, BulkUpdatePostingPricesMutationVariables>;

/**
 * __useBulkUpdatePostingPricesMutation__
 *
 * To run a mutation, you first call `useBulkUpdatePostingPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdatePostingPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdatePostingPricesMutation, { data, loading, error }] = useBulkUpdatePostingPricesMutation({
 *   variables: {
 *      postingPrices: // value for 'postingPrices'
 *   },
 * });
 */
export function useBulkUpdatePostingPricesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdatePostingPricesMutation, BulkUpdatePostingPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdatePostingPricesMutation, BulkUpdatePostingPricesMutationVariables>(BulkUpdatePostingPricesDocument, options);
      }
export type BulkUpdatePostingPricesMutationHookResult = ReturnType<typeof useBulkUpdatePostingPricesMutation>;
export type BulkUpdatePostingPricesMutationResult = Apollo.MutationResult<BulkUpdatePostingPricesMutation>;
export type BulkUpdatePostingPricesMutationOptions = Apollo.BaseMutationOptions<BulkUpdatePostingPricesMutation, BulkUpdatePostingPricesMutationVariables>;
export const CreatePointToPointCarrierRateDateSpanDocument = gql`
    mutation CreatePointToPointCarrierRateDateSpan($carrierPointToPointRateDateSpan: CarrierPointToPointRateDateSpanInput!, $percentMultiplier: Float!, $copyActiveRates: Boolean!) {
  carrierPointToPointRateDateSpanCreate(
    carrierPointToPointRateDateSpan: $carrierPointToPointRateDateSpan
    percentMultiplier: $percentMultiplier
    copyActiveRates: $copyActiveRates
  ) {
    carrierPointToPointRateDateSpanKey
  }
}
    `;
export type CreatePointToPointCarrierRateDateSpanMutationFn = Apollo.MutationFunction<CreatePointToPointCarrierRateDateSpanMutation, CreatePointToPointCarrierRateDateSpanMutationVariables>;

/**
 * __useCreatePointToPointCarrierRateDateSpanMutation__
 *
 * To run a mutation, you first call `useCreatePointToPointCarrierRateDateSpanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointToPointCarrierRateDateSpanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointToPointCarrierRateDateSpanMutation, { data, loading, error }] = useCreatePointToPointCarrierRateDateSpanMutation({
 *   variables: {
 *      carrierPointToPointRateDateSpan: // value for 'carrierPointToPointRateDateSpan'
 *      percentMultiplier: // value for 'percentMultiplier'
 *      copyActiveRates: // value for 'copyActiveRates'
 *   },
 * });
 */
export function useCreatePointToPointCarrierRateDateSpanMutation(baseOptions?: Apollo.MutationHookOptions<CreatePointToPointCarrierRateDateSpanMutation, CreatePointToPointCarrierRateDateSpanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePointToPointCarrierRateDateSpanMutation, CreatePointToPointCarrierRateDateSpanMutationVariables>(CreatePointToPointCarrierRateDateSpanDocument, options);
      }
export type CreatePointToPointCarrierRateDateSpanMutationHookResult = ReturnType<typeof useCreatePointToPointCarrierRateDateSpanMutation>;
export type CreatePointToPointCarrierRateDateSpanMutationResult = Apollo.MutationResult<CreatePointToPointCarrierRateDateSpanMutation>;
export type CreatePointToPointCarrierRateDateSpanMutationOptions = Apollo.BaseMutationOptions<CreatePointToPointCarrierRateDateSpanMutation, CreatePointToPointCarrierRateDateSpanMutationVariables>;
export const UpdatePointToPointCarrierRateDateSpanDocument = gql`
    mutation UpdatePointToPointCarrierRateDateSpan($carrierPointToPointRateDateSpan: CarrierPointToPointRateDateSpanInput!, $dateSpanKey: Int!) {
  carrierPointToPointRateDateSpanUpdate(
    carrierPointToPointRateDateSpan: $carrierPointToPointRateDateSpan
    id: $dateSpanKey
  ) {
    carrierPointToPointRateDateSpanKey
  }
}
    `;
export type UpdatePointToPointCarrierRateDateSpanMutationFn = Apollo.MutationFunction<UpdatePointToPointCarrierRateDateSpanMutation, UpdatePointToPointCarrierRateDateSpanMutationVariables>;

/**
 * __useUpdatePointToPointCarrierRateDateSpanMutation__
 *
 * To run a mutation, you first call `useUpdatePointToPointCarrierRateDateSpanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointToPointCarrierRateDateSpanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointToPointCarrierRateDateSpanMutation, { data, loading, error }] = useUpdatePointToPointCarrierRateDateSpanMutation({
 *   variables: {
 *      carrierPointToPointRateDateSpan: // value for 'carrierPointToPointRateDateSpan'
 *      dateSpanKey: // value for 'dateSpanKey'
 *   },
 * });
 */
export function useUpdatePointToPointCarrierRateDateSpanMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointToPointCarrierRateDateSpanMutation, UpdatePointToPointCarrierRateDateSpanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointToPointCarrierRateDateSpanMutation, UpdatePointToPointCarrierRateDateSpanMutationVariables>(UpdatePointToPointCarrierRateDateSpanDocument, options);
      }
export type UpdatePointToPointCarrierRateDateSpanMutationHookResult = ReturnType<typeof useUpdatePointToPointCarrierRateDateSpanMutation>;
export type UpdatePointToPointCarrierRateDateSpanMutationResult = Apollo.MutationResult<UpdatePointToPointCarrierRateDateSpanMutation>;
export type UpdatePointToPointCarrierRateDateSpanMutationOptions = Apollo.BaseMutationOptions<UpdatePointToPointCarrierRateDateSpanMutation, UpdatePointToPointCarrierRateDateSpanMutationVariables>;
export const GetSinglePointToPointCarrierRateDateSpanDocument = gql`
    query GetSinglePointToPointCarrierRateDateSpan($key: Int!) {
  carrierPointToPointRateDateSpanGetSingle(id: $key) {
    carrierKey
    startDate
    endDate
    carrierPointToPointRates {
      ...singlePointToPointCarrierRate
    }
    carrier {
      name
    }
  }
}
    ${SinglePointToPointCarrierRateFragmentDoc}`;

/**
 * __useGetSinglePointToPointCarrierRateDateSpanQuery__
 *
 * To run a query within a React component, call `useGetSinglePointToPointCarrierRateDateSpanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSinglePointToPointCarrierRateDateSpanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSinglePointToPointCarrierRateDateSpanQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSinglePointToPointCarrierRateDateSpanQuery(baseOptions: Apollo.QueryHookOptions<GetSinglePointToPointCarrierRateDateSpanQuery, GetSinglePointToPointCarrierRateDateSpanQueryVariables> & ({ variables: GetSinglePointToPointCarrierRateDateSpanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSinglePointToPointCarrierRateDateSpanQuery, GetSinglePointToPointCarrierRateDateSpanQueryVariables>(GetSinglePointToPointCarrierRateDateSpanDocument, options);
      }
export function useGetSinglePointToPointCarrierRateDateSpanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSinglePointToPointCarrierRateDateSpanQuery, GetSinglePointToPointCarrierRateDateSpanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSinglePointToPointCarrierRateDateSpanQuery, GetSinglePointToPointCarrierRateDateSpanQueryVariables>(GetSinglePointToPointCarrierRateDateSpanDocument, options);
        }
export function useGetSinglePointToPointCarrierRateDateSpanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSinglePointToPointCarrierRateDateSpanQuery, GetSinglePointToPointCarrierRateDateSpanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSinglePointToPointCarrierRateDateSpanQuery, GetSinglePointToPointCarrierRateDateSpanQueryVariables>(GetSinglePointToPointCarrierRateDateSpanDocument, options);
        }
export type GetSinglePointToPointCarrierRateDateSpanQueryHookResult = ReturnType<typeof useGetSinglePointToPointCarrierRateDateSpanQuery>;
export type GetSinglePointToPointCarrierRateDateSpanLazyQueryHookResult = ReturnType<typeof useGetSinglePointToPointCarrierRateDateSpanLazyQuery>;
export type GetSinglePointToPointCarrierRateDateSpanSuspenseQueryHookResult = ReturnType<typeof useGetSinglePointToPointCarrierRateDateSpanSuspenseQuery>;
export type GetSinglePointToPointCarrierRateDateSpanQueryResult = Apollo.QueryResult<GetSinglePointToPointCarrierRateDateSpanQuery, GetSinglePointToPointCarrierRateDateSpanQueryVariables>;
export const DeleteCarrierPointToPointRateDateSpanDocument = gql`
    mutation DeleteCarrierPointToPointRateDateSpan($id: Int!) {
  carrierPointToPointRateDateSpanDelete(id: $id)
}
    `;
export type DeleteCarrierPointToPointRateDateSpanMutationFn = Apollo.MutationFunction<DeleteCarrierPointToPointRateDateSpanMutation, DeleteCarrierPointToPointRateDateSpanMutationVariables>;

/**
 * __useDeleteCarrierPointToPointRateDateSpanMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierPointToPointRateDateSpanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierPointToPointRateDateSpanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierPointToPointRateDateSpanMutation, { data, loading, error }] = useDeleteCarrierPointToPointRateDateSpanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCarrierPointToPointRateDateSpanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierPointToPointRateDateSpanMutation, DeleteCarrierPointToPointRateDateSpanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarrierPointToPointRateDateSpanMutation, DeleteCarrierPointToPointRateDateSpanMutationVariables>(DeleteCarrierPointToPointRateDateSpanDocument, options);
      }
export type DeleteCarrierPointToPointRateDateSpanMutationHookResult = ReturnType<typeof useDeleteCarrierPointToPointRateDateSpanMutation>;
export type DeleteCarrierPointToPointRateDateSpanMutationResult = Apollo.MutationResult<DeleteCarrierPointToPointRateDateSpanMutation>;
export type DeleteCarrierPointToPointRateDateSpanMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierPointToPointRateDateSpanMutation, DeleteCarrierPointToPointRateDateSpanMutationVariables>;
export const CreateCarrierRateDocument = gql`
    mutation CreateCarrierRate($carrierRate: CarrierRateInput!) {
  carrierRateCreate(carrierRate: $carrierRate) {
    carrierRateKey
  }
}
    `;
export type CreateCarrierRateMutationFn = Apollo.MutationFunction<CreateCarrierRateMutation, CreateCarrierRateMutationVariables>;

/**
 * __useCreateCarrierRateMutation__
 *
 * To run a mutation, you first call `useCreateCarrierRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierRateMutation, { data, loading, error }] = useCreateCarrierRateMutation({
 *   variables: {
 *      carrierRate: // value for 'carrierRate'
 *   },
 * });
 */
export function useCreateCarrierRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierRateMutation, CreateCarrierRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarrierRateMutation, CreateCarrierRateMutationVariables>(CreateCarrierRateDocument, options);
      }
export type CreateCarrierRateMutationHookResult = ReturnType<typeof useCreateCarrierRateMutation>;
export type CreateCarrierRateMutationResult = Apollo.MutationResult<CreateCarrierRateMutation>;
export type CreateCarrierRateMutationOptions = Apollo.BaseMutationOptions<CreateCarrierRateMutation, CreateCarrierRateMutationVariables>;
export const CreatePointToPointCarrierRateDocument = gql`
    mutation CreatePointToPointCarrierRate($carrierPointToPointRate: CarrierPointToPointRateInput!) {
  carrierPointToPointRateCreate(carrierPointToPointRate: $carrierPointToPointRate) {
    carrierPointToPointRateKey
  }
}
    `;
export type CreatePointToPointCarrierRateMutationFn = Apollo.MutationFunction<CreatePointToPointCarrierRateMutation, CreatePointToPointCarrierRateMutationVariables>;

/**
 * __useCreatePointToPointCarrierRateMutation__
 *
 * To run a mutation, you first call `useCreatePointToPointCarrierRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointToPointCarrierRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointToPointCarrierRateMutation, { data, loading, error }] = useCreatePointToPointCarrierRateMutation({
 *   variables: {
 *      carrierPointToPointRate: // value for 'carrierPointToPointRate'
 *   },
 * });
 */
export function useCreatePointToPointCarrierRateMutation(baseOptions?: Apollo.MutationHookOptions<CreatePointToPointCarrierRateMutation, CreatePointToPointCarrierRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePointToPointCarrierRateMutation, CreatePointToPointCarrierRateMutationVariables>(CreatePointToPointCarrierRateDocument, options);
      }
export type CreatePointToPointCarrierRateMutationHookResult = ReturnType<typeof useCreatePointToPointCarrierRateMutation>;
export type CreatePointToPointCarrierRateMutationResult = Apollo.MutationResult<CreatePointToPointCarrierRateMutation>;
export type CreatePointToPointCarrierRateMutationOptions = Apollo.BaseMutationOptions<CreatePointToPointCarrierRateMutation, CreatePointToPointCarrierRateMutationVariables>;
export const UpdateCarrierRateDocument = gql`
    mutation UpdateCarrierRate($carrierRate: CarrierRateInput!, $carrierRateKey: Int!) {
  carrierRateUpdate(carrierRate: $carrierRate, id: $carrierRateKey) {
    carrierRateKey
  }
}
    `;
export type UpdateCarrierRateMutationFn = Apollo.MutationFunction<UpdateCarrierRateMutation, UpdateCarrierRateMutationVariables>;

/**
 * __useUpdateCarrierRateMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierRateMutation, { data, loading, error }] = useUpdateCarrierRateMutation({
 *   variables: {
 *      carrierRate: // value for 'carrierRate'
 *      carrierRateKey: // value for 'carrierRateKey'
 *   },
 * });
 */
export function useUpdateCarrierRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierRateMutation, UpdateCarrierRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarrierRateMutation, UpdateCarrierRateMutationVariables>(UpdateCarrierRateDocument, options);
      }
export type UpdateCarrierRateMutationHookResult = ReturnType<typeof useUpdateCarrierRateMutation>;
export type UpdateCarrierRateMutationResult = Apollo.MutationResult<UpdateCarrierRateMutation>;
export type UpdateCarrierRateMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierRateMutation, UpdateCarrierRateMutationVariables>;
export const UpdatePointToPointCarrierRateDocument = gql`
    mutation UpdatePointToPointCarrierRate($carrierPointToPointRate: CarrierPointToPointRateInput!, $carrierPointToPointRateKey: Int!) {
  carrierPointToPointRateUpdate(
    carrierPointToPointRate: $carrierPointToPointRate
    id: $carrierPointToPointRateKey
  ) {
    carrierPointToPointRateKey
  }
}
    `;
export type UpdatePointToPointCarrierRateMutationFn = Apollo.MutationFunction<UpdatePointToPointCarrierRateMutation, UpdatePointToPointCarrierRateMutationVariables>;

/**
 * __useUpdatePointToPointCarrierRateMutation__
 *
 * To run a mutation, you first call `useUpdatePointToPointCarrierRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointToPointCarrierRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointToPointCarrierRateMutation, { data, loading, error }] = useUpdatePointToPointCarrierRateMutation({
 *   variables: {
 *      carrierPointToPointRate: // value for 'carrierPointToPointRate'
 *      carrierPointToPointRateKey: // value for 'carrierPointToPointRateKey'
 *   },
 * });
 */
export function useUpdatePointToPointCarrierRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointToPointCarrierRateMutation, UpdatePointToPointCarrierRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointToPointCarrierRateMutation, UpdatePointToPointCarrierRateMutationVariables>(UpdatePointToPointCarrierRateDocument, options);
      }
export type UpdatePointToPointCarrierRateMutationHookResult = ReturnType<typeof useUpdatePointToPointCarrierRateMutation>;
export type UpdatePointToPointCarrierRateMutationResult = Apollo.MutationResult<UpdatePointToPointCarrierRateMutation>;
export type UpdatePointToPointCarrierRateMutationOptions = Apollo.BaseMutationOptions<UpdatePointToPointCarrierRateMutation, UpdatePointToPointCarrierRateMutationVariables>;
export const GetSingleCarrierPointToPointRateDocument = gql`
    query GetSingleCarrierPointToPointRate($key: Int!) {
  carrierPointToPointRateGetSingle(id: $key) {
    ...singlePointToPointCarrierRate
  }
}
    ${SinglePointToPointCarrierRateFragmentDoc}`;

/**
 * __useGetSingleCarrierPointToPointRateQuery__
 *
 * To run a query within a React component, call `useGetSingleCarrierPointToPointRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleCarrierPointToPointRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleCarrierPointToPointRateQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSingleCarrierPointToPointRateQuery(baseOptions: Apollo.QueryHookOptions<GetSingleCarrierPointToPointRateQuery, GetSingleCarrierPointToPointRateQueryVariables> & ({ variables: GetSingleCarrierPointToPointRateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleCarrierPointToPointRateQuery, GetSingleCarrierPointToPointRateQueryVariables>(GetSingleCarrierPointToPointRateDocument, options);
      }
export function useGetSingleCarrierPointToPointRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleCarrierPointToPointRateQuery, GetSingleCarrierPointToPointRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleCarrierPointToPointRateQuery, GetSingleCarrierPointToPointRateQueryVariables>(GetSingleCarrierPointToPointRateDocument, options);
        }
export function useGetSingleCarrierPointToPointRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleCarrierPointToPointRateQuery, GetSingleCarrierPointToPointRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleCarrierPointToPointRateQuery, GetSingleCarrierPointToPointRateQueryVariables>(GetSingleCarrierPointToPointRateDocument, options);
        }
export type GetSingleCarrierPointToPointRateQueryHookResult = ReturnType<typeof useGetSingleCarrierPointToPointRateQuery>;
export type GetSingleCarrierPointToPointRateLazyQueryHookResult = ReturnType<typeof useGetSingleCarrierPointToPointRateLazyQuery>;
export type GetSingleCarrierPointToPointRateSuspenseQueryHookResult = ReturnType<typeof useGetSingleCarrierPointToPointRateSuspenseQuery>;
export type GetSingleCarrierPointToPointRateQueryResult = Apollo.QueryResult<GetSingleCarrierPointToPointRateQuery, GetSingleCarrierPointToPointRateQueryVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($contact: ContactInput!) {
  contactCreate(contact: $contact) {
    contactKey
    default
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const EditContactDocument = gql`
    mutation EditContact($contact: ContactInput!, $id: Int!) {
  contactUpdate(contact: $contact, id: $id) {
    contactKey
    default
  }
}
    `;
export type EditContactMutationFn = Apollo.MutationFunction<EditContactMutation, EditContactMutationVariables>;

/**
 * __useEditContactMutation__
 *
 * To run a mutation, you first call `useEditContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContactMutation, { data, loading, error }] = useEditContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditContactMutation(baseOptions?: Apollo.MutationHookOptions<EditContactMutation, EditContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContactMutation, EditContactMutationVariables>(EditContactDocument, options);
      }
export type EditContactMutationHookResult = ReturnType<typeof useEditContactMutation>;
export type EditContactMutationResult = Apollo.MutationResult<EditContactMutation>;
export type EditContactMutationOptions = Apollo.BaseMutationOptions<EditContactMutation, EditContactMutationVariables>;
export const CreateLocationContactDocument = gql`
    mutation CreateLocationContact($lc: LocationContactInput!) {
  locationContactCreate(locationContact: $lc) {
    locationKey
    contactKey
  }
}
    `;
export type CreateLocationContactMutationFn = Apollo.MutationFunction<CreateLocationContactMutation, CreateLocationContactMutationVariables>;

/**
 * __useCreateLocationContactMutation__
 *
 * To run a mutation, you first call `useCreateLocationContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationContactMutation, { data, loading, error }] = useCreateLocationContactMutation({
 *   variables: {
 *      lc: // value for 'lc'
 *   },
 * });
 */
export function useCreateLocationContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationContactMutation, CreateLocationContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationContactMutation, CreateLocationContactMutationVariables>(CreateLocationContactDocument, options);
      }
export type CreateLocationContactMutationHookResult = ReturnType<typeof useCreateLocationContactMutation>;
export type CreateLocationContactMutationResult = Apollo.MutationResult<CreateLocationContactMutation>;
export type CreateLocationContactMutationOptions = Apollo.BaseMutationOptions<CreateLocationContactMutation, CreateLocationContactMutationVariables>;
export const DeleteLocationContactDocument = gql`
    mutation DeleteLocationContact($locationKey: Int!, $contactKey: Int!) {
  locationContactDelete(locationKey: $locationKey, contactKey: $contactKey)
}
    `;
export type DeleteLocationContactMutationFn = Apollo.MutationFunction<DeleteLocationContactMutation, DeleteLocationContactMutationVariables>;

/**
 * __useDeleteLocationContactMutation__
 *
 * To run a mutation, you first call `useDeleteLocationContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationContactMutation, { data, loading, error }] = useDeleteLocationContactMutation({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      contactKey: // value for 'contactKey'
 *   },
 * });
 */
export function useDeleteLocationContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationContactMutation, DeleteLocationContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationContactMutation, DeleteLocationContactMutationVariables>(DeleteLocationContactDocument, options);
      }
export type DeleteLocationContactMutationHookResult = ReturnType<typeof useDeleteLocationContactMutation>;
export type DeleteLocationContactMutationResult = Apollo.MutationResult<DeleteLocationContactMutation>;
export type DeleteLocationContactMutationOptions = Apollo.BaseMutationOptions<DeleteLocationContactMutation, DeleteLocationContactMutationVariables>;
export const CreateCarrierRateBandDocument = gql`
    mutation CreateCarrierRateBand($carrierRateBand: CarrierRateBandInput!) {
  carrierRateBandCreate(carrierRateBand: $carrierRateBand) {
    carrierRateBandKey
  }
}
    `;
export type CreateCarrierRateBandMutationFn = Apollo.MutationFunction<CreateCarrierRateBandMutation, CreateCarrierRateBandMutationVariables>;

/**
 * __useCreateCarrierRateBandMutation__
 *
 * To run a mutation, you first call `useCreateCarrierRateBandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierRateBandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierRateBandMutation, { data, loading, error }] = useCreateCarrierRateBandMutation({
 *   variables: {
 *      carrierRateBand: // value for 'carrierRateBand'
 *   },
 * });
 */
export function useCreateCarrierRateBandMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierRateBandMutation, CreateCarrierRateBandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarrierRateBandMutation, CreateCarrierRateBandMutationVariables>(CreateCarrierRateBandDocument, options);
      }
export type CreateCarrierRateBandMutationHookResult = ReturnType<typeof useCreateCarrierRateBandMutation>;
export type CreateCarrierRateBandMutationResult = Apollo.MutationResult<CreateCarrierRateBandMutation>;
export type CreateCarrierRateBandMutationOptions = Apollo.BaseMutationOptions<CreateCarrierRateBandMutation, CreateCarrierRateBandMutationVariables>;
export const GetAllCarrierRateBandByCarrierRateKeyDocument = gql`
    query GetAllCarrierRateBandByCarrierRateKey($carrierRateKey: Int!) {
  carrierRateBandGetAll(
    where: {carrierRateKey: {eq: $carrierRateKey}}
    order: [{mileageFrom: ASC}]
  ) {
    carrierRateKey
    carrierRateBandKey
    mileageFrom
    mileageTo
    ratePerGallon
  }
}
    `;

/**
 * __useGetAllCarrierRateBandByCarrierRateKeyQuery__
 *
 * To run a query within a React component, call `useGetAllCarrierRateBandByCarrierRateKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCarrierRateBandByCarrierRateKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCarrierRateBandByCarrierRateKeyQuery({
 *   variables: {
 *      carrierRateKey: // value for 'carrierRateKey'
 *   },
 * });
 */
export function useGetAllCarrierRateBandByCarrierRateKeyQuery(baseOptions: Apollo.QueryHookOptions<GetAllCarrierRateBandByCarrierRateKeyQuery, GetAllCarrierRateBandByCarrierRateKeyQueryVariables> & ({ variables: GetAllCarrierRateBandByCarrierRateKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCarrierRateBandByCarrierRateKeyQuery, GetAllCarrierRateBandByCarrierRateKeyQueryVariables>(GetAllCarrierRateBandByCarrierRateKeyDocument, options);
      }
export function useGetAllCarrierRateBandByCarrierRateKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCarrierRateBandByCarrierRateKeyQuery, GetAllCarrierRateBandByCarrierRateKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCarrierRateBandByCarrierRateKeyQuery, GetAllCarrierRateBandByCarrierRateKeyQueryVariables>(GetAllCarrierRateBandByCarrierRateKeyDocument, options);
        }
export function useGetAllCarrierRateBandByCarrierRateKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCarrierRateBandByCarrierRateKeyQuery, GetAllCarrierRateBandByCarrierRateKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCarrierRateBandByCarrierRateKeyQuery, GetAllCarrierRateBandByCarrierRateKeyQueryVariables>(GetAllCarrierRateBandByCarrierRateKeyDocument, options);
        }
export type GetAllCarrierRateBandByCarrierRateKeyQueryHookResult = ReturnType<typeof useGetAllCarrierRateBandByCarrierRateKeyQuery>;
export type GetAllCarrierRateBandByCarrierRateKeyLazyQueryHookResult = ReturnType<typeof useGetAllCarrierRateBandByCarrierRateKeyLazyQuery>;
export type GetAllCarrierRateBandByCarrierRateKeySuspenseQueryHookResult = ReturnType<typeof useGetAllCarrierRateBandByCarrierRateKeySuspenseQuery>;
export type GetAllCarrierRateBandByCarrierRateKeyQueryResult = Apollo.QueryResult<GetAllCarrierRateBandByCarrierRateKeyQuery, GetAllCarrierRateBandByCarrierRateKeyQueryVariables>;
export const UpdateLocationTerminalDocument = gql`
    mutation UpdateLocationTerminal($locationTerminal: LocationTerminalInput!) {
  locationTerminalEdit(locationTerminal: $locationTerminal) {
    locationKey
    terminalKey
  }
}
    `;
export type UpdateLocationTerminalMutationFn = Apollo.MutationFunction<UpdateLocationTerminalMutation, UpdateLocationTerminalMutationVariables>;

/**
 * __useUpdateLocationTerminalMutation__
 *
 * To run a mutation, you first call `useUpdateLocationTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationTerminalMutation, { data, loading, error }] = useUpdateLocationTerminalMutation({
 *   variables: {
 *      locationTerminal: // value for 'locationTerminal'
 *   },
 * });
 */
export function useUpdateLocationTerminalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationTerminalMutation, UpdateLocationTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationTerminalMutation, UpdateLocationTerminalMutationVariables>(UpdateLocationTerminalDocument, options);
      }
export type UpdateLocationTerminalMutationHookResult = ReturnType<typeof useUpdateLocationTerminalMutation>;
export type UpdateLocationTerminalMutationResult = Apollo.MutationResult<UpdateLocationTerminalMutation>;
export type UpdateLocationTerminalMutationOptions = Apollo.BaseMutationOptions<UpdateLocationTerminalMutation, UpdateLocationTerminalMutationVariables>;
export const CreateFuelSurchargeDocument = gql`
    mutation CreateFuelSurcharge($fuelSurcharge: FuelSurchargeInput!) {
  fuelSurchargeCreate(fuelSurcharge: $fuelSurcharge) {
    fuelSurchargeKey
  }
}
    `;
export type CreateFuelSurchargeMutationFn = Apollo.MutationFunction<CreateFuelSurchargeMutation, CreateFuelSurchargeMutationVariables>;

/**
 * __useCreateFuelSurchargeMutation__
 *
 * To run a mutation, you first call `useCreateFuelSurchargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFuelSurchargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFuelSurchargeMutation, { data, loading, error }] = useCreateFuelSurchargeMutation({
 *   variables: {
 *      fuelSurcharge: // value for 'fuelSurcharge'
 *   },
 * });
 */
export function useCreateFuelSurchargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateFuelSurchargeMutation, CreateFuelSurchargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFuelSurchargeMutation, CreateFuelSurchargeMutationVariables>(CreateFuelSurchargeDocument, options);
      }
export type CreateFuelSurchargeMutationHookResult = ReturnType<typeof useCreateFuelSurchargeMutation>;
export type CreateFuelSurchargeMutationResult = Apollo.MutationResult<CreateFuelSurchargeMutation>;
export type CreateFuelSurchargeMutationOptions = Apollo.BaseMutationOptions<CreateFuelSurchargeMutation, CreateFuelSurchargeMutationVariables>;
export const GetSingleFuelSurchargeDocument = gql`
    query GetSingleFuelSurcharge($key: Int!) {
  fuelSurchargeGetSingle(id: $key) {
    ...singleFuelSurcharge
  }
}
    ${SingleFuelSurchargeFragmentDoc}`;

/**
 * __useGetSingleFuelSurchargeQuery__
 *
 * To run a query within a React component, call `useGetSingleFuelSurchargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleFuelSurchargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleFuelSurchargeQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSingleFuelSurchargeQuery(baseOptions: Apollo.QueryHookOptions<GetSingleFuelSurchargeQuery, GetSingleFuelSurchargeQueryVariables> & ({ variables: GetSingleFuelSurchargeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleFuelSurchargeQuery, GetSingleFuelSurchargeQueryVariables>(GetSingleFuelSurchargeDocument, options);
      }
export function useGetSingleFuelSurchargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleFuelSurchargeQuery, GetSingleFuelSurchargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleFuelSurchargeQuery, GetSingleFuelSurchargeQueryVariables>(GetSingleFuelSurchargeDocument, options);
        }
export function useGetSingleFuelSurchargeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleFuelSurchargeQuery, GetSingleFuelSurchargeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleFuelSurchargeQuery, GetSingleFuelSurchargeQueryVariables>(GetSingleFuelSurchargeDocument, options);
        }
export type GetSingleFuelSurchargeQueryHookResult = ReturnType<typeof useGetSingleFuelSurchargeQuery>;
export type GetSingleFuelSurchargeLazyQueryHookResult = ReturnType<typeof useGetSingleFuelSurchargeLazyQuery>;
export type GetSingleFuelSurchargeSuspenseQueryHookResult = ReturnType<typeof useGetSingleFuelSurchargeSuspenseQuery>;
export type GetSingleFuelSurchargeQueryResult = Apollo.QueryResult<GetSingleFuelSurchargeQuery, GetSingleFuelSurchargeQueryVariables>;
export const UpdateFuelSurchargeDocument = gql`
    mutation UpdateFuelSurcharge($fuelSurcharge: FuelSurchargeInput!, $fuelSurchargeKey: Int!) {
  fuelSurchargeUpdate(fuelSurcharge: $fuelSurcharge, id: $fuelSurchargeKey) {
    fuelSurchargeKey
  }
}
    `;
export type UpdateFuelSurchargeMutationFn = Apollo.MutationFunction<UpdateFuelSurchargeMutation, UpdateFuelSurchargeMutationVariables>;

/**
 * __useUpdateFuelSurchargeMutation__
 *
 * To run a mutation, you first call `useUpdateFuelSurchargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFuelSurchargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFuelSurchargeMutation, { data, loading, error }] = useUpdateFuelSurchargeMutation({
 *   variables: {
 *      fuelSurcharge: // value for 'fuelSurcharge'
 *      fuelSurchargeKey: // value for 'fuelSurchargeKey'
 *   },
 * });
 */
export function useUpdateFuelSurchargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFuelSurchargeMutation, UpdateFuelSurchargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFuelSurchargeMutation, UpdateFuelSurchargeMutationVariables>(UpdateFuelSurchargeDocument, options);
      }
export type UpdateFuelSurchargeMutationHookResult = ReturnType<typeof useUpdateFuelSurchargeMutation>;
export type UpdateFuelSurchargeMutationResult = Apollo.MutationResult<UpdateFuelSurchargeMutation>;
export type UpdateFuelSurchargeMutationOptions = Apollo.BaseMutationOptions<UpdateFuelSurchargeMutation, UpdateFuelSurchargeMutationVariables>;
export const GetSingleOrderForExportDocument = gql`
    query GetSingleOrderForExport($id: Int!) {
  orderGetSingle(id: $id) {
    ...singleOrderExport
  }
}
    ${SingleOrderExportFragmentDoc}`;

/**
 * __useGetSingleOrderForExportQuery__
 *
 * To run a query within a React component, call `useGetSingleOrderForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleOrderForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleOrderForExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleOrderForExportQuery(baseOptions: Apollo.QueryHookOptions<GetSingleOrderForExportQuery, GetSingleOrderForExportQueryVariables> & ({ variables: GetSingleOrderForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleOrderForExportQuery, GetSingleOrderForExportQueryVariables>(GetSingleOrderForExportDocument, options);
      }
export function useGetSingleOrderForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleOrderForExportQuery, GetSingleOrderForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleOrderForExportQuery, GetSingleOrderForExportQueryVariables>(GetSingleOrderForExportDocument, options);
        }
export function useGetSingleOrderForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleOrderForExportQuery, GetSingleOrderForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleOrderForExportQuery, GetSingleOrderForExportQueryVariables>(GetSingleOrderForExportDocument, options);
        }
export type GetSingleOrderForExportQueryHookResult = ReturnType<typeof useGetSingleOrderForExportQuery>;
export type GetSingleOrderForExportLazyQueryHookResult = ReturnType<typeof useGetSingleOrderForExportLazyQuery>;
export type GetSingleOrderForExportSuspenseQueryHookResult = ReturnType<typeof useGetSingleOrderForExportSuspenseQuery>;
export type GetSingleOrderForExportQueryResult = Apollo.QueryResult<GetSingleOrderForExportQuery, GetSingleOrderForExportQueryVariables>;
export const OrderBulkDispatchDocument = gql`
    mutation orderBulkDispatch($ids: [Int!], $sendEmail: Boolean!) {
  orderBulkDispatch(ids: $ids, sendEmail: $sendEmail)
}
    `;
export type OrderBulkDispatchMutationFn = Apollo.MutationFunction<OrderBulkDispatchMutation, OrderBulkDispatchMutationVariables>;

/**
 * __useOrderBulkDispatchMutation__
 *
 * To run a mutation, you first call `useOrderBulkDispatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderBulkDispatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderBulkDispatchMutation, { data, loading, error }] = useOrderBulkDispatchMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useOrderBulkDispatchMutation(baseOptions?: Apollo.MutationHookOptions<OrderBulkDispatchMutation, OrderBulkDispatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderBulkDispatchMutation, OrderBulkDispatchMutationVariables>(OrderBulkDispatchDocument, options);
      }
export type OrderBulkDispatchMutationHookResult = ReturnType<typeof useOrderBulkDispatchMutation>;
export type OrderBulkDispatchMutationResult = Apollo.MutationResult<OrderBulkDispatchMutation>;
export type OrderBulkDispatchMutationOptions = Apollo.BaseMutationOptions<OrderBulkDispatchMutation, OrderBulkDispatchMutationVariables>;
export const CreateStateTaxDocument = gql`
    mutation CreateStateTax($stateTax: StateTaxInput!) {
  stateTaxCreate(stateTax: $stateTax) {
    stateTaxKey
  }
}
    `;
export type CreateStateTaxMutationFn = Apollo.MutationFunction<CreateStateTaxMutation, CreateStateTaxMutationVariables>;

/**
 * __useCreateStateTaxMutation__
 *
 * To run a mutation, you first call `useCreateStateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStateTaxMutation, { data, loading, error }] = useCreateStateTaxMutation({
 *   variables: {
 *      stateTax: // value for 'stateTax'
 *   },
 * });
 */
export function useCreateStateTaxMutation(baseOptions?: Apollo.MutationHookOptions<CreateStateTaxMutation, CreateStateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStateTaxMutation, CreateStateTaxMutationVariables>(CreateStateTaxDocument, options);
      }
export type CreateStateTaxMutationHookResult = ReturnType<typeof useCreateStateTaxMutation>;
export type CreateStateTaxMutationResult = Apollo.MutationResult<CreateStateTaxMutation>;
export type CreateStateTaxMutationOptions = Apollo.BaseMutationOptions<CreateStateTaxMutation, CreateStateTaxMutationVariables>;
export const UpdateStateTaxDocument = gql`
    mutation UpdateStateTax($stateTax: StateTaxInput!, $stateTaxKey: Int!) {
  stateTaxUpdate(stateTax: $stateTax, stateTaxKey: $stateTaxKey) {
    stateTaxKey
  }
}
    `;
export type UpdateStateTaxMutationFn = Apollo.MutationFunction<UpdateStateTaxMutation, UpdateStateTaxMutationVariables>;

/**
 * __useUpdateStateTaxMutation__
 *
 * To run a mutation, you first call `useUpdateStateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStateTaxMutation, { data, loading, error }] = useUpdateStateTaxMutation({
 *   variables: {
 *      stateTax: // value for 'stateTax'
 *      stateTaxKey: // value for 'stateTaxKey'
 *   },
 * });
 */
export function useUpdateStateTaxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStateTaxMutation, UpdateStateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStateTaxMutation, UpdateStateTaxMutationVariables>(UpdateStateTaxDocument, options);
      }
export type UpdateStateTaxMutationHookResult = ReturnType<typeof useUpdateStateTaxMutation>;
export type UpdateStateTaxMutationResult = Apollo.MutationResult<UpdateStateTaxMutation>;
export type UpdateStateTaxMutationOptions = Apollo.BaseMutationOptions<UpdateStateTaxMutation, UpdateStateTaxMutationVariables>;
export const GetSingleStateTaxDocument = gql`
    query GetSingleStateTax($key: Int!) {
  stateTaxGetSingle(id: $key) {
    ...innerStateTax
  }
}
    ${InnerStateTaxFragmentDoc}`;

/**
 * __useGetSingleStateTaxQuery__
 *
 * To run a query within a React component, call `useGetSingleStateTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleStateTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleStateTaxQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSingleStateTaxQuery(baseOptions: Apollo.QueryHookOptions<GetSingleStateTaxQuery, GetSingleStateTaxQueryVariables> & ({ variables: GetSingleStateTaxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleStateTaxQuery, GetSingleStateTaxQueryVariables>(GetSingleStateTaxDocument, options);
      }
export function useGetSingleStateTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleStateTaxQuery, GetSingleStateTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleStateTaxQuery, GetSingleStateTaxQueryVariables>(GetSingleStateTaxDocument, options);
        }
export function useGetSingleStateTaxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleStateTaxQuery, GetSingleStateTaxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleStateTaxQuery, GetSingleStateTaxQueryVariables>(GetSingleStateTaxDocument, options);
        }
export type GetSingleStateTaxQueryHookResult = ReturnType<typeof useGetSingleStateTaxQuery>;
export type GetSingleStateTaxLazyQueryHookResult = ReturnType<typeof useGetSingleStateTaxLazyQuery>;
export type GetSingleStateTaxSuspenseQueryHookResult = ReturnType<typeof useGetSingleStateTaxSuspenseQuery>;
export type GetSingleStateTaxQueryResult = Apollo.QueryResult<GetSingleStateTaxQuery, GetSingleStateTaxQueryVariables>;
export const UpdateCarrierRateBandDocument = gql`
    mutation UpdateCarrierRateBand($carrierRateBand: CarrierRateBandInput!, $key: Int!) {
  carrierRateBandUpdate(carrierRateBand: $carrierRateBand, id: $key) {
    carrierRateBandKey
  }
}
    `;
export type UpdateCarrierRateBandMutationFn = Apollo.MutationFunction<UpdateCarrierRateBandMutation, UpdateCarrierRateBandMutationVariables>;

/**
 * __useUpdateCarrierRateBandMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierRateBandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierRateBandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierRateBandMutation, { data, loading, error }] = useUpdateCarrierRateBandMutation({
 *   variables: {
 *      carrierRateBand: // value for 'carrierRateBand'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useUpdateCarrierRateBandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierRateBandMutation, UpdateCarrierRateBandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarrierRateBandMutation, UpdateCarrierRateBandMutationVariables>(UpdateCarrierRateBandDocument, options);
      }
export type UpdateCarrierRateBandMutationHookResult = ReturnType<typeof useUpdateCarrierRateBandMutation>;
export type UpdateCarrierRateBandMutationResult = Apollo.MutationResult<UpdateCarrierRateBandMutation>;
export type UpdateCarrierRateBandMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierRateBandMutation, UpdateCarrierRateBandMutationVariables>;
export const DeleteCarrierRateBandDocument = gql`
    mutation DeleteCarrierRateBand($id: Int!) {
  carrierRateBandDelete(id: $id)
}
    `;
export type DeleteCarrierRateBandMutationFn = Apollo.MutationFunction<DeleteCarrierRateBandMutation, DeleteCarrierRateBandMutationVariables>;

/**
 * __useDeleteCarrierRateBandMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierRateBandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierRateBandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierRateBandMutation, { data, loading, error }] = useDeleteCarrierRateBandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCarrierRateBandMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierRateBandMutation, DeleteCarrierRateBandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarrierRateBandMutation, DeleteCarrierRateBandMutationVariables>(DeleteCarrierRateBandDocument, options);
      }
export type DeleteCarrierRateBandMutationHookResult = ReturnType<typeof useDeleteCarrierRateBandMutation>;
export type DeleteCarrierRateBandMutationResult = Apollo.MutationResult<DeleteCarrierRateBandMutation>;
export type DeleteCarrierRateBandMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierRateBandMutation, DeleteCarrierRateBandMutationVariables>;
export const LifetimeLocationGallonsDocument = gql`
    query LifetimeLocationGallons($locationKey: Int!) {
  lifetimeGallons(locationKey: $locationKey) {
    year
    jan
    feb
    mar
    apr
    may
    jun
    jul
    aug
    sep
    oct
    nov
    dec
  }
}
    `;

/**
 * __useLifetimeLocationGallonsQuery__
 *
 * To run a query within a React component, call `useLifetimeLocationGallonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifetimeLocationGallonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifetimeLocationGallonsQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *   },
 * });
 */
export function useLifetimeLocationGallonsQuery(baseOptions: Apollo.QueryHookOptions<LifetimeLocationGallonsQuery, LifetimeLocationGallonsQueryVariables> & ({ variables: LifetimeLocationGallonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifetimeLocationGallonsQuery, LifetimeLocationGallonsQueryVariables>(LifetimeLocationGallonsDocument, options);
      }
export function useLifetimeLocationGallonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifetimeLocationGallonsQuery, LifetimeLocationGallonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifetimeLocationGallonsQuery, LifetimeLocationGallonsQueryVariables>(LifetimeLocationGallonsDocument, options);
        }
export function useLifetimeLocationGallonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LifetimeLocationGallonsQuery, LifetimeLocationGallonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LifetimeLocationGallonsQuery, LifetimeLocationGallonsQueryVariables>(LifetimeLocationGallonsDocument, options);
        }
export type LifetimeLocationGallonsQueryHookResult = ReturnType<typeof useLifetimeLocationGallonsQuery>;
export type LifetimeLocationGallonsLazyQueryHookResult = ReturnType<typeof useLifetimeLocationGallonsLazyQuery>;
export type LifetimeLocationGallonsSuspenseQueryHookResult = ReturnType<typeof useLifetimeLocationGallonsSuspenseQuery>;
export type LifetimeLocationGallonsQueryResult = Apollo.QueryResult<LifetimeLocationGallonsQuery, LifetimeLocationGallonsQueryVariables>;
export const LifetimeTermContractGallonsDocument = gql`
    query LifetimeTermContractGallons($termContractKey: Int!) {
  lifetimeTermContractGallons(termContractKey: $termContractKey) {
    year
    jan
    feb
    mar
    apr
    may
    jun
    jul
    aug
    sep
    oct
    nov
    dec
  }
}
    `;

/**
 * __useLifetimeTermContractGallonsQuery__
 *
 * To run a query within a React component, call `useLifetimeTermContractGallonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifetimeTermContractGallonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifetimeTermContractGallonsQuery({
 *   variables: {
 *      termContractKey: // value for 'termContractKey'
 *   },
 * });
 */
export function useLifetimeTermContractGallonsQuery(baseOptions: Apollo.QueryHookOptions<LifetimeTermContractGallonsQuery, LifetimeTermContractGallonsQueryVariables> & ({ variables: LifetimeTermContractGallonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifetimeTermContractGallonsQuery, LifetimeTermContractGallonsQueryVariables>(LifetimeTermContractGallonsDocument, options);
      }
export function useLifetimeTermContractGallonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifetimeTermContractGallonsQuery, LifetimeTermContractGallonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifetimeTermContractGallonsQuery, LifetimeTermContractGallonsQueryVariables>(LifetimeTermContractGallonsDocument, options);
        }
export function useLifetimeTermContractGallonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LifetimeTermContractGallonsQuery, LifetimeTermContractGallonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LifetimeTermContractGallonsQuery, LifetimeTermContractGallonsQueryVariables>(LifetimeTermContractGallonsDocument, options);
        }
export type LifetimeTermContractGallonsQueryHookResult = ReturnType<typeof useLifetimeTermContractGallonsQuery>;
export type LifetimeTermContractGallonsLazyQueryHookResult = ReturnType<typeof useLifetimeTermContractGallonsLazyQuery>;
export type LifetimeTermContractGallonsSuspenseQueryHookResult = ReturnType<typeof useLifetimeTermContractGallonsSuspenseQuery>;
export type LifetimeTermContractGallonsQueryResult = Apollo.QueryResult<LifetimeTermContractGallonsQuery, LifetimeTermContractGallonsQueryVariables>;
export const GetPricingDocument = gql`
    query GetPricing($locationKey: Int!, $sort: [PricingSortInput!], $pricingDate: DateTime!) {
  pricingsGet(locationKey: $locationKey, order: $sort, pricingDate: $pricingDate) {
    ...pricingListing
  }
}
    ${PricingListingFragmentDoc}`;

/**
 * __useGetPricingQuery__
 *
 * To run a query within a React component, call `useGetPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      sort: // value for 'sort'
 *      pricingDate: // value for 'pricingDate'
 *   },
 * });
 */
export function useGetPricingQuery(baseOptions: Apollo.QueryHookOptions<GetPricingQuery, GetPricingQueryVariables> & ({ variables: GetPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingQuery, GetPricingQueryVariables>(GetPricingDocument, options);
      }
export function useGetPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingQuery, GetPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingQuery, GetPricingQueryVariables>(GetPricingDocument, options);
        }
export function useGetPricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricingQuery, GetPricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPricingQuery, GetPricingQueryVariables>(GetPricingDocument, options);
        }
export type GetPricingQueryHookResult = ReturnType<typeof useGetPricingQuery>;
export type GetPricingLazyQueryHookResult = ReturnType<typeof useGetPricingLazyQuery>;
export type GetPricingSuspenseQueryHookResult = ReturnType<typeof useGetPricingSuspenseQuery>;
export type GetPricingQueryResult = Apollo.QueryResult<GetPricingQuery, GetPricingQueryVariables>;
export const GetLocationSingleDocument = gql`
    query GetLocationSingle($locationKey: Int!) {
  locationGetSingle(locationKey: $locationKey) {
    ...LocationCustomerSupplier
  }
}
    ${LocationCustomerSupplierFragmentDoc}`;

/**
 * __useGetLocationSingleQuery__
 *
 * To run a query within a React component, call `useGetLocationSingleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSingleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSingleQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *   },
 * });
 */
export function useGetLocationSingleQuery(baseOptions: Apollo.QueryHookOptions<GetLocationSingleQuery, GetLocationSingleQueryVariables> & ({ variables: GetLocationSingleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationSingleQuery, GetLocationSingleQueryVariables>(GetLocationSingleDocument, options);
      }
export function useGetLocationSingleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSingleQuery, GetLocationSingleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationSingleQuery, GetLocationSingleQueryVariables>(GetLocationSingleDocument, options);
        }
export function useGetLocationSingleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationSingleQuery, GetLocationSingleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationSingleQuery, GetLocationSingleQueryVariables>(GetLocationSingleDocument, options);
        }
export type GetLocationSingleQueryHookResult = ReturnType<typeof useGetLocationSingleQuery>;
export type GetLocationSingleLazyQueryHookResult = ReturnType<typeof useGetLocationSingleLazyQuery>;
export type GetLocationSingleSuspenseQueryHookResult = ReturnType<typeof useGetLocationSingleSuspenseQuery>;
export type GetLocationSingleQueryResult = Apollo.QueryResult<GetLocationSingleQuery, GetLocationSingleQueryVariables>;
export const GetPostingsByLocationDocument = gql`
    query GetPostingsByLocation($locationKey: Int!) {
  postingsByLocationKey(locationKey: $locationKey) {
    ...InnerTerminalPosting
  }
}
    ${InnerTerminalPostingFragmentDoc}`;

/**
 * __useGetPostingsByLocationQuery__
 *
 * To run a query within a React component, call `useGetPostingsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostingsByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostingsByLocationQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *   },
 * });
 */
export function useGetPostingsByLocationQuery(baseOptions: Apollo.QueryHookOptions<GetPostingsByLocationQuery, GetPostingsByLocationQueryVariables> & ({ variables: GetPostingsByLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostingsByLocationQuery, GetPostingsByLocationQueryVariables>(GetPostingsByLocationDocument, options);
      }
export function useGetPostingsByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostingsByLocationQuery, GetPostingsByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostingsByLocationQuery, GetPostingsByLocationQueryVariables>(GetPostingsByLocationDocument, options);
        }
export function useGetPostingsByLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostingsByLocationQuery, GetPostingsByLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostingsByLocationQuery, GetPostingsByLocationQueryVariables>(GetPostingsByLocationDocument, options);
        }
export type GetPostingsByLocationQueryHookResult = ReturnType<typeof useGetPostingsByLocationQuery>;
export type GetPostingsByLocationLazyQueryHookResult = ReturnType<typeof useGetPostingsByLocationLazyQuery>;
export type GetPostingsByLocationSuspenseQueryHookResult = ReturnType<typeof useGetPostingsByLocationSuspenseQuery>;
export type GetPostingsByLocationQueryResult = Apollo.QueryResult<GetPostingsByLocationQuery, GetPostingsByLocationQueryVariables>;
export const SearchBasisTypesDocument = gql`
    query SearchBasisTypes($searchTerm: String) {
  basisTypeGetAll(where: {name: {contains: $searchTerm}, isArchived: {eq: false}}) {
    ...BasicBasisType
  }
}
    ${BasicBasisTypeFragmentDoc}`;

/**
 * __useSearchBasisTypesQuery__
 *
 * To run a query within a React component, call `useSearchBasisTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBasisTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBasisTypesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchBasisTypesQuery(baseOptions?: Apollo.QueryHookOptions<SearchBasisTypesQuery, SearchBasisTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBasisTypesQuery, SearchBasisTypesQueryVariables>(SearchBasisTypesDocument, options);
      }
export function useSearchBasisTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBasisTypesQuery, SearchBasisTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBasisTypesQuery, SearchBasisTypesQueryVariables>(SearchBasisTypesDocument, options);
        }
export function useSearchBasisTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBasisTypesQuery, SearchBasisTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBasisTypesQuery, SearchBasisTypesQueryVariables>(SearchBasisTypesDocument, options);
        }
export type SearchBasisTypesQueryHookResult = ReturnType<typeof useSearchBasisTypesQuery>;
export type SearchBasisTypesLazyQueryHookResult = ReturnType<typeof useSearchBasisTypesLazyQuery>;
export type SearchBasisTypesSuspenseQueryHookResult = ReturnType<typeof useSearchBasisTypesSuspenseQuery>;
export type SearchBasisTypesQueryResult = Apollo.QueryResult<SearchBasisTypesQuery, SearchBasisTypesQueryVariables>;
export const GetSearchCarrierDocument = gql`
    query GetSearchCarrier($searchTerm: String, $sort: [CarrierSearchSortInput!], $date: DateTime) {
  carrierSearch(search: $searchTerm, order: $sort, date: $date) {
    ...carrierSearchListing
  }
}
    ${CarrierSearchListingFragmentDoc}`;

/**
 * __useGetSearchCarrierQuery__
 *
 * To run a query within a React component, call `useGetSearchCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchCarrierQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      sort: // value for 'sort'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetSearchCarrierQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchCarrierQuery, GetSearchCarrierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchCarrierQuery, GetSearchCarrierQueryVariables>(GetSearchCarrierDocument, options);
      }
export function useGetSearchCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchCarrierQuery, GetSearchCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchCarrierQuery, GetSearchCarrierQueryVariables>(GetSearchCarrierDocument, options);
        }
export function useGetSearchCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchCarrierQuery, GetSearchCarrierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchCarrierQuery, GetSearchCarrierQueryVariables>(GetSearchCarrierDocument, options);
        }
export type GetSearchCarrierQueryHookResult = ReturnType<typeof useGetSearchCarrierQuery>;
export type GetSearchCarrierLazyQueryHookResult = ReturnType<typeof useGetSearchCarrierLazyQuery>;
export type GetSearchCarrierSuspenseQueryHookResult = ReturnType<typeof useGetSearchCarrierSuspenseQuery>;
export type GetSearchCarrierQueryResult = Apollo.QueryResult<GetSearchCarrierQuery, GetSearchCarrierQueryVariables>;
export const GetSingleContactDocument = gql`
    query GetSingleContact($contactKey: Int!) {
  contactGetSingle(contactKey: $contactKey) {
    ...BasicContact
  }
}
    ${BasicContactFragmentDoc}`;

/**
 * __useGetSingleContactQuery__
 *
 * To run a query within a React component, call `useGetSingleContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleContactQuery({
 *   variables: {
 *      contactKey: // value for 'contactKey'
 *   },
 * });
 */
export function useGetSingleContactQuery(baseOptions: Apollo.QueryHookOptions<GetSingleContactQuery, GetSingleContactQueryVariables> & ({ variables: GetSingleContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleContactQuery, GetSingleContactQueryVariables>(GetSingleContactDocument, options);
      }
export function useGetSingleContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleContactQuery, GetSingleContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleContactQuery, GetSingleContactQueryVariables>(GetSingleContactDocument, options);
        }
export function useGetSingleContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleContactQuery, GetSingleContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleContactQuery, GetSingleContactQueryVariables>(GetSingleContactDocument, options);
        }
export type GetSingleContactQueryHookResult = ReturnType<typeof useGetSingleContactQuery>;
export type GetSingleContactLazyQueryHookResult = ReturnType<typeof useGetSingleContactLazyQuery>;
export type GetSingleContactSuspenseQueryHookResult = ReturnType<typeof useGetSingleContactSuspenseQuery>;
export type GetSingleContactQueryResult = Apollo.QueryResult<GetSingleContactQuery, GetSingleContactQueryVariables>;
export const GetContactsSearchDocument = gql`
    query GetContactsSearch($searchTerm: String, $locationKey: Int, $customerKey: Int, $archived: Boolean) {
  contactGetByLocationKey(
    searchTerm: $searchTerm
    locationKey: $locationKey
    customerKey: $customerKey
    archived: $archived
    order: [{firstName: ASC}]
  ) {
    ...BasicContact
  }
}
    ${BasicContactFragmentDoc}`;

/**
 * __useGetContactsSearchQuery__
 *
 * To run a query within a React component, call `useGetContactsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      locationKey: // value for 'locationKey'
 *      customerKey: // value for 'customerKey'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useGetContactsSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetContactsSearchQuery, GetContactsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsSearchQuery, GetContactsSearchQueryVariables>(GetContactsSearchDocument, options);
      }
export function useGetContactsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsSearchQuery, GetContactsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsSearchQuery, GetContactsSearchQueryVariables>(GetContactsSearchDocument, options);
        }
export function useGetContactsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactsSearchQuery, GetContactsSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactsSearchQuery, GetContactsSearchQueryVariables>(GetContactsSearchDocument, options);
        }
export type GetContactsSearchQueryHookResult = ReturnType<typeof useGetContactsSearchQuery>;
export type GetContactsSearchLazyQueryHookResult = ReturnType<typeof useGetContactsSearchLazyQuery>;
export type GetContactsSearchSuspenseQueryHookResult = ReturnType<typeof useGetContactsSearchSuspenseQuery>;
export type GetContactsSearchQueryResult = Apollo.QueryResult<GetContactsSearchQuery, GetContactsSearchQueryVariables>;
export const GetSearchCustomersDocument = gql`
    query GetSearchCustomers($searchTerm: String, $sort: [CustomerSortInput!]) {
  customerGetAll(
    where: {or: [{name: {contains: $searchTerm}}, {dbaName: {contains: $searchTerm}}], and: {isArchived: {eq: false}}}
    order: $sort
  ) {
    edges {
      node {
        ...basicCustomer
      }
    }
  }
}
    ${BasicCustomerFragmentDoc}`;

/**
 * __useGetSearchCustomersQuery__
 *
 * To run a query within a React component, call `useGetSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchCustomersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSearchCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchCustomersQuery, GetSearchCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchCustomersQuery, GetSearchCustomersQueryVariables>(GetSearchCustomersDocument, options);
      }
export function useGetSearchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchCustomersQuery, GetSearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchCustomersQuery, GetSearchCustomersQueryVariables>(GetSearchCustomersDocument, options);
        }
export function useGetSearchCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchCustomersQuery, GetSearchCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchCustomersQuery, GetSearchCustomersQueryVariables>(GetSearchCustomersDocument, options);
        }
export type GetSearchCustomersQueryHookResult = ReturnType<typeof useGetSearchCustomersQuery>;
export type GetSearchCustomersLazyQueryHookResult = ReturnType<typeof useGetSearchCustomersLazyQuery>;
export type GetSearchCustomersSuspenseQueryHookResult = ReturnType<typeof useGetSearchCustomersSuspenseQuery>;
export type GetSearchCustomersQueryResult = Apollo.QueryResult<GetSearchCustomersQuery, GetSearchCustomersQueryVariables>;
export const GetTasksForTaskPageDocument = gql`
    query GetTasksForTaskPage($locationKey: ComparableInt32OperationFilterInput, $date: DateTime) {
  taskGetAll(where: {and: [{locationKey: $locationKey, taskDate: {gt: $date}}]}) {
    ...TaskShow
  }
}
    ${TaskShowFragmentDoc}`;

/**
 * __useGetTasksForTaskPageQuery__
 *
 * To run a query within a React component, call `useGetTasksForTaskPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForTaskPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksForTaskPageQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetTasksForTaskPageQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksForTaskPageQuery, GetTasksForTaskPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksForTaskPageQuery, GetTasksForTaskPageQueryVariables>(GetTasksForTaskPageDocument, options);
      }
export function useGetTasksForTaskPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksForTaskPageQuery, GetTasksForTaskPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksForTaskPageQuery, GetTasksForTaskPageQueryVariables>(GetTasksForTaskPageDocument, options);
        }
export function useGetTasksForTaskPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksForTaskPageQuery, GetTasksForTaskPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksForTaskPageQuery, GetTasksForTaskPageQueryVariables>(GetTasksForTaskPageDocument, options);
        }
export type GetTasksForTaskPageQueryHookResult = ReturnType<typeof useGetTasksForTaskPageQuery>;
export type GetTasksForTaskPageLazyQueryHookResult = ReturnType<typeof useGetTasksForTaskPageLazyQuery>;
export type GetTasksForTaskPageSuspenseQueryHookResult = ReturnType<typeof useGetTasksForTaskPageSuspenseQuery>;
export type GetTasksForTaskPageQueryResult = Apollo.QueryResult<GetTasksForTaskPageQuery, GetTasksForTaskPageQueryVariables>;
export const DeliveryTimeSearchDocument = gql`
    query DeliveryTimeSearch($searchTerm: String, $sort: [DeliveryTimeSortInput!]) {
  deliveryTimeGetAll(
    where: {or: [{code: {contains: $searchTerm}}, {description: {contains: $searchTerm}}]}
    order: $sort
  ) {
    ...innerDeliveryTime
  }
}
    ${InnerDeliveryTimeFragmentDoc}`;

/**
 * __useDeliveryTimeSearchQuery__
 *
 * To run a query within a React component, call `useDeliveryTimeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryTimeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryTimeSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useDeliveryTimeSearchQuery(baseOptions?: Apollo.QueryHookOptions<DeliveryTimeSearchQuery, DeliveryTimeSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryTimeSearchQuery, DeliveryTimeSearchQueryVariables>(DeliveryTimeSearchDocument, options);
      }
export function useDeliveryTimeSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryTimeSearchQuery, DeliveryTimeSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryTimeSearchQuery, DeliveryTimeSearchQueryVariables>(DeliveryTimeSearchDocument, options);
        }
export function useDeliveryTimeSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeliveryTimeSearchQuery, DeliveryTimeSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeliveryTimeSearchQuery, DeliveryTimeSearchQueryVariables>(DeliveryTimeSearchDocument, options);
        }
export type DeliveryTimeSearchQueryHookResult = ReturnType<typeof useDeliveryTimeSearchQuery>;
export type DeliveryTimeSearchLazyQueryHookResult = ReturnType<typeof useDeliveryTimeSearchLazyQuery>;
export type DeliveryTimeSearchSuspenseQueryHookResult = ReturnType<typeof useDeliveryTimeSearchSuspenseQuery>;
export type DeliveryTimeSearchQueryResult = Apollo.QueryResult<DeliveryTimeSearchQuery, DeliveryTimeSearchQueryVariables>;
export const GetDeliveryTimeDocument = gql`
    query GetDeliveryTime($deliveryTimeKey: Int!) {
  deliveryTimeGetSingle(deliveryTimeKey: $deliveryTimeKey) {
    ...innerDeliveryTime
  }
}
    ${InnerDeliveryTimeFragmentDoc}`;

/**
 * __useGetDeliveryTimeQuery__
 *
 * To run a query within a React component, call `useGetDeliveryTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryTimeQuery({
 *   variables: {
 *      deliveryTimeKey: // value for 'deliveryTimeKey'
 *   },
 * });
 */
export function useGetDeliveryTimeQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryTimeQuery, GetDeliveryTimeQueryVariables> & ({ variables: GetDeliveryTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryTimeQuery, GetDeliveryTimeQueryVariables>(GetDeliveryTimeDocument, options);
      }
export function useGetDeliveryTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryTimeQuery, GetDeliveryTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryTimeQuery, GetDeliveryTimeQueryVariables>(GetDeliveryTimeDocument, options);
        }
export function useGetDeliveryTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryTimeQuery, GetDeliveryTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryTimeQuery, GetDeliveryTimeQueryVariables>(GetDeliveryTimeDocument, options);
        }
export type GetDeliveryTimeQueryHookResult = ReturnType<typeof useGetDeliveryTimeQuery>;
export type GetDeliveryTimeLazyQueryHookResult = ReturnType<typeof useGetDeliveryTimeLazyQuery>;
export type GetDeliveryTimeSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryTimeSuspenseQuery>;
export type GetDeliveryTimeQueryResult = Apollo.QueryResult<GetDeliveryTimeQuery, GetDeliveryTimeQueryVariables>;
export const FileNumbersSearchDocument = gql`
    query FileNumbersSearch($search: String, $terminal: Int, $supplier: Int, $archived: Boolean) {
  fileNumberGetAll(
    where: {and: [{isArchived: {eq: $archived}}, {number: {contains: $search}}, {terminalKey: {eq: $terminal}}, {supplierKey: {eq: $supplier}}]}
    order: [{number: DESC}]
  ) {
    ...innerFileNumber
  }
}
    ${InnerFileNumberFragmentDoc}`;

/**
 * __useFileNumbersSearchQuery__
 *
 * To run a query within a React component, call `useFileNumbersSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileNumbersSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileNumbersSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      terminal: // value for 'terminal'
 *      supplier: // value for 'supplier'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useFileNumbersSearchQuery(baseOptions?: Apollo.QueryHookOptions<FileNumbersSearchQuery, FileNumbersSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileNumbersSearchQuery, FileNumbersSearchQueryVariables>(FileNumbersSearchDocument, options);
      }
export function useFileNumbersSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileNumbersSearchQuery, FileNumbersSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileNumbersSearchQuery, FileNumbersSearchQueryVariables>(FileNumbersSearchDocument, options);
        }
export function useFileNumbersSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FileNumbersSearchQuery, FileNumbersSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileNumbersSearchQuery, FileNumbersSearchQueryVariables>(FileNumbersSearchDocument, options);
        }
export type FileNumbersSearchQueryHookResult = ReturnType<typeof useFileNumbersSearchQuery>;
export type FileNumbersSearchLazyQueryHookResult = ReturnType<typeof useFileNumbersSearchLazyQuery>;
export type FileNumbersSearchSuspenseQueryHookResult = ReturnType<typeof useFileNumbersSearchSuspenseQuery>;
export type FileNumbersSearchQueryResult = Apollo.QueryResult<FileNumbersSearchQuery, FileNumbersSearchQueryVariables>;
export const GetSearchLocationsDocument = gql`
    query GetSearchLocations($searchTerm: String, $customerKey: Int, $sort: [LocationSortInput!]) {
  locationGetByCustomer(
    customerKey: $customerKey
    order: $sort
    search: $searchTerm
  ) {
    ...innerLocation
  }
}
    ${InnerLocationFragmentDoc}`;

/**
 * __useGetSearchLocationsQuery__
 *
 * To run a query within a React component, call `useGetSearchLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchLocationsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      customerKey: // value for 'customerKey'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSearchLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchLocationsQuery, GetSearchLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchLocationsQuery, GetSearchLocationsQueryVariables>(GetSearchLocationsDocument, options);
      }
export function useGetSearchLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchLocationsQuery, GetSearchLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchLocationsQuery, GetSearchLocationsQueryVariables>(GetSearchLocationsDocument, options);
        }
export function useGetSearchLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchLocationsQuery, GetSearchLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchLocationsQuery, GetSearchLocationsQueryVariables>(GetSearchLocationsDocument, options);
        }
export type GetSearchLocationsQueryHookResult = ReturnType<typeof useGetSearchLocationsQuery>;
export type GetSearchLocationsLazyQueryHookResult = ReturnType<typeof useGetSearchLocationsLazyQuery>;
export type GetSearchLocationsSuspenseQueryHookResult = ReturnType<typeof useGetSearchLocationsSuspenseQuery>;
export type GetSearchLocationsQueryResult = Apollo.QueryResult<GetSearchLocationsQuery, GetSearchLocationsQueryVariables>;
export const PrePurchaseAgreementSearchDocument = gql`
    query PrePurchaseAgreementSearch($searchTerm: String!, $terminalKey: Int, $supplierKey: Int, $activeDate: DateTime) {
  prePurchaseAgreementBySupplierTerminal(
    where: {supplierAgreement: {contains: $searchTerm}}
    terminalKey: $terminalKey
    supplierKey: $supplierKey
    order: [{supplierAgreement: ASC}]
    activeDate: $activeDate
  ) {
    ...innerPrePurchaseAgreement
  }
}
    ${InnerPrePurchaseAgreementFragmentDoc}`;

/**
 * __usePrePurchaseAgreementSearchQuery__
 *
 * To run a query within a React component, call `usePrePurchaseAgreementSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrePurchaseAgreementSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrePurchaseAgreementSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      terminalKey: // value for 'terminalKey'
 *      supplierKey: // value for 'supplierKey'
 *      activeDate: // value for 'activeDate'
 *   },
 * });
 */
export function usePrePurchaseAgreementSearchQuery(baseOptions: Apollo.QueryHookOptions<PrePurchaseAgreementSearchQuery, PrePurchaseAgreementSearchQueryVariables> & ({ variables: PrePurchaseAgreementSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrePurchaseAgreementSearchQuery, PrePurchaseAgreementSearchQueryVariables>(PrePurchaseAgreementSearchDocument, options);
      }
export function usePrePurchaseAgreementSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrePurchaseAgreementSearchQuery, PrePurchaseAgreementSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrePurchaseAgreementSearchQuery, PrePurchaseAgreementSearchQueryVariables>(PrePurchaseAgreementSearchDocument, options);
        }
export function usePrePurchaseAgreementSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrePurchaseAgreementSearchQuery, PrePurchaseAgreementSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrePurchaseAgreementSearchQuery, PrePurchaseAgreementSearchQueryVariables>(PrePurchaseAgreementSearchDocument, options);
        }
export type PrePurchaseAgreementSearchQueryHookResult = ReturnType<typeof usePrePurchaseAgreementSearchQuery>;
export type PrePurchaseAgreementSearchLazyQueryHookResult = ReturnType<typeof usePrePurchaseAgreementSearchLazyQuery>;
export type PrePurchaseAgreementSearchSuspenseQueryHookResult = ReturnType<typeof usePrePurchaseAgreementSearchSuspenseQuery>;
export type PrePurchaseAgreementSearchQueryResult = Apollo.QueryResult<PrePurchaseAgreementSearchQuery, PrePurchaseAgreementSearchQueryVariables>;
export const SalesAgreementSearchDocument = gql`
    query SalesAgreementSearch($searchTerm: String!, $locationKey: Int, $date: DateTime, $sort: [SalesAgreementSortInput!]) {
  salesAgreementByLocation(
    where: {and: [{agreementName: {contains: $searchTerm}}, {startShipDate: {lte: $date}}, {endShipDate: {gte: $date}}]}
    locationKey: $locationKey
    order: $sort
  ) {
    ...innerSalesAgreement
  }
}
    ${InnerSalesAgreementFragmentDoc}`;

/**
 * __useSalesAgreementSearchQuery__
 *
 * To run a query within a React component, call `useSalesAgreementSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesAgreementSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesAgreementSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      locationKey: // value for 'locationKey'
 *      date: // value for 'date'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSalesAgreementSearchQuery(baseOptions: Apollo.QueryHookOptions<SalesAgreementSearchQuery, SalesAgreementSearchQueryVariables> & ({ variables: SalesAgreementSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesAgreementSearchQuery, SalesAgreementSearchQueryVariables>(SalesAgreementSearchDocument, options);
      }
export function useSalesAgreementSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesAgreementSearchQuery, SalesAgreementSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesAgreementSearchQuery, SalesAgreementSearchQueryVariables>(SalesAgreementSearchDocument, options);
        }
export function useSalesAgreementSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SalesAgreementSearchQuery, SalesAgreementSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesAgreementSearchQuery, SalesAgreementSearchQueryVariables>(SalesAgreementSearchDocument, options);
        }
export type SalesAgreementSearchQueryHookResult = ReturnType<typeof useSalesAgreementSearchQuery>;
export type SalesAgreementSearchLazyQueryHookResult = ReturnType<typeof useSalesAgreementSearchLazyQuery>;
export type SalesAgreementSearchSuspenseQueryHookResult = ReturnType<typeof useSalesAgreementSearchSuspenseQuery>;
export type SalesAgreementSearchQueryResult = Apollo.QueryResult<SalesAgreementSearchQuery, SalesAgreementSearchQueryVariables>;
export const StatesSearchDocument = gql`
    query StatesSearch($search: String) {
  stateGetAll(where: {name: {contains: $search}}, order: [{name: ASC}]) {
    ...innerState
  }
}
    ${InnerStateFragmentDoc}`;

/**
 * __useStatesSearchQuery__
 *
 * To run a query within a React component, call `useStatesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatesSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useStatesSearchQuery(baseOptions?: Apollo.QueryHookOptions<StatesSearchQuery, StatesSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatesSearchQuery, StatesSearchQueryVariables>(StatesSearchDocument, options);
      }
export function useStatesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatesSearchQuery, StatesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatesSearchQuery, StatesSearchQueryVariables>(StatesSearchDocument, options);
        }
export function useStatesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatesSearchQuery, StatesSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StatesSearchQuery, StatesSearchQueryVariables>(StatesSearchDocument, options);
        }
export type StatesSearchQueryHookResult = ReturnType<typeof useStatesSearchQuery>;
export type StatesSearchLazyQueryHookResult = ReturnType<typeof useStatesSearchLazyQuery>;
export type StatesSearchSuspenseQueryHookResult = ReturnType<typeof useStatesSearchSuspenseQuery>;
export type StatesSearchQueryResult = Apollo.QueryResult<StatesSearchQuery, StatesSearchQueryVariables>;
export const GetSingleStateDocument = gql`
    query GetSingleState($key: Int!) {
  stateGetSingle(stateKey: $key) {
    ...innerState
  }
}
    ${InnerStateFragmentDoc}`;

/**
 * __useGetSingleStateQuery__
 *
 * To run a query within a React component, call `useGetSingleStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleStateQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSingleStateQuery(baseOptions: Apollo.QueryHookOptions<GetSingleStateQuery, GetSingleStateQueryVariables> & ({ variables: GetSingleStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleStateQuery, GetSingleStateQueryVariables>(GetSingleStateDocument, options);
      }
export function useGetSingleStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleStateQuery, GetSingleStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleStateQuery, GetSingleStateQueryVariables>(GetSingleStateDocument, options);
        }
export function useGetSingleStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleStateQuery, GetSingleStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleStateQuery, GetSingleStateQueryVariables>(GetSingleStateDocument, options);
        }
export type GetSingleStateQueryHookResult = ReturnType<typeof useGetSingleStateQuery>;
export type GetSingleStateLazyQueryHookResult = ReturnType<typeof useGetSingleStateLazyQuery>;
export type GetSingleStateSuspenseQueryHookResult = ReturnType<typeof useGetSingleStateSuspenseQuery>;
export type GetSingleStateQueryResult = Apollo.QueryResult<GetSingleStateQuery, GetSingleStateQueryVariables>;
export const SearchSuppliersDocument = gql`
    query SearchSuppliers($searchTerm: String, $sort: [SupplierSortInput!]) {
  supplierGetAll(
    where: {name: {contains: $searchTerm}, isArchived: {eq: false}}
    order: $sort
  ) {
    ...BasicSupplier
  }
}
    ${BasicSupplierFragmentDoc}`;

/**
 * __useSearchSuppliersQuery__
 *
 * To run a query within a React component, call `useSearchSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuppliersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
      }
export function useSearchSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
        }
export function useSearchSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
        }
export type SearchSuppliersQueryHookResult = ReturnType<typeof useSearchSuppliersQuery>;
export type SearchSuppliersLazyQueryHookResult = ReturnType<typeof useSearchSuppliersLazyQuery>;
export type SearchSuppliersSuspenseQueryHookResult = ReturnType<typeof useSearchSuppliersSuspenseQuery>;
export type SearchSuppliersQueryResult = Apollo.QueryResult<SearchSuppliersQuery, SearchSuppliersQueryVariables>;
export const TagSearchDocument = gql`
    query TagSearch($search: String) {
  tagGetAll(where: {name: {contains: $search}}, order: [{name: ASC}]) {
    ...fullTag
  }
}
    ${FullTagFragmentDoc}`;

/**
 * __useTagSearchQuery__
 *
 * To run a query within a React component, call `useTagSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTagSearchQuery(baseOptions?: Apollo.QueryHookOptions<TagSearchQuery, TagSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagSearchQuery, TagSearchQueryVariables>(TagSearchDocument, options);
      }
export function useTagSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagSearchQuery, TagSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagSearchQuery, TagSearchQueryVariables>(TagSearchDocument, options);
        }
export function useTagSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagSearchQuery, TagSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagSearchQuery, TagSearchQueryVariables>(TagSearchDocument, options);
        }
export type TagSearchQueryHookResult = ReturnType<typeof useTagSearchQuery>;
export type TagSearchLazyQueryHookResult = ReturnType<typeof useTagSearchLazyQuery>;
export type TagSearchSuspenseQueryHookResult = ReturnType<typeof useTagSearchSuspenseQuery>;
export type TagSearchQueryResult = Apollo.QueryResult<TagSearchQuery, TagSearchQueryVariables>;
export const AllTagDocument = gql`
    query AllTag($filter: TagFilterInput) {
  tagGetAll(where: $filter, order: [{name: ASC}]) {
    ...fullTag
  }
}
    ${FullTagFragmentDoc}`;

/**
 * __useAllTagQuery__
 *
 * To run a query within a React component, call `useAllTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTagQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllTagQuery(baseOptions?: Apollo.QueryHookOptions<AllTagQuery, AllTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTagQuery, AllTagQueryVariables>(AllTagDocument, options);
      }
export function useAllTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTagQuery, AllTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTagQuery, AllTagQueryVariables>(AllTagDocument, options);
        }
export function useAllTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTagQuery, AllTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTagQuery, AllTagQueryVariables>(AllTagDocument, options);
        }
export type AllTagQueryHookResult = ReturnType<typeof useAllTagQuery>;
export type AllTagLazyQueryHookResult = ReturnType<typeof useAllTagLazyQuery>;
export type AllTagSuspenseQueryHookResult = ReturnType<typeof useAllTagSuspenseQuery>;
export type AllTagQueryResult = Apollo.QueryResult<AllTagQuery, AllTagQueryVariables>;
export const GetSingleTagDocument = gql`
    query GetSingleTag($tagKey: Int!) {
  tagGetSingle(tagKey: $tagKey) {
    ...fullTag
  }
}
    ${FullTagFragmentDoc}`;

/**
 * __useGetSingleTagQuery__
 *
 * To run a query within a React component, call `useGetSingleTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleTagQuery({
 *   variables: {
 *      tagKey: // value for 'tagKey'
 *   },
 * });
 */
export function useGetSingleTagQuery(baseOptions: Apollo.QueryHookOptions<GetSingleTagQuery, GetSingleTagQueryVariables> & ({ variables: GetSingleTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleTagQuery, GetSingleTagQueryVariables>(GetSingleTagDocument, options);
      }
export function useGetSingleTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleTagQuery, GetSingleTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleTagQuery, GetSingleTagQueryVariables>(GetSingleTagDocument, options);
        }
export function useGetSingleTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleTagQuery, GetSingleTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleTagQuery, GetSingleTagQueryVariables>(GetSingleTagDocument, options);
        }
export type GetSingleTagQueryHookResult = ReturnType<typeof useGetSingleTagQuery>;
export type GetSingleTagLazyQueryHookResult = ReturnType<typeof useGetSingleTagLazyQuery>;
export type GetSingleTagSuspenseQueryHookResult = ReturnType<typeof useGetSingleTagSuspenseQuery>;
export type GetSingleTagQueryResult = Apollo.QueryResult<GetSingleTagQuery, GetSingleTagQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($tag: TagInput!) {
  tagCreate(tag: $tag) {
    tagKey
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const TermContractSearchDocument = gql`
    query TermContractSearch($search: String, $locationKey: Int, $filter: TermContractFilterInput) {
  termContractSearch(
    search: $search
    where: $filter
    locationKey: $locationKey
    order: [{name: ASC}]
  ) {
    ...innerTermContract
  }
}
    ${InnerTermContractFragmentDoc}`;

/**
 * __useTermContractSearchQuery__
 *
 * To run a query within a React component, call `useTermContractSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermContractSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermContractSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      locationKey: // value for 'locationKey'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTermContractSearchQuery(baseOptions?: Apollo.QueryHookOptions<TermContractSearchQuery, TermContractSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TermContractSearchQuery, TermContractSearchQueryVariables>(TermContractSearchDocument, options);
      }
export function useTermContractSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TermContractSearchQuery, TermContractSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TermContractSearchQuery, TermContractSearchQueryVariables>(TermContractSearchDocument, options);
        }
export function useTermContractSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TermContractSearchQuery, TermContractSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TermContractSearchQuery, TermContractSearchQueryVariables>(TermContractSearchDocument, options);
        }
export type TermContractSearchQueryHookResult = ReturnType<typeof useTermContractSearchQuery>;
export type TermContractSearchLazyQueryHookResult = ReturnType<typeof useTermContractSearchLazyQuery>;
export type TermContractSearchSuspenseQueryHookResult = ReturnType<typeof useTermContractSearchSuspenseQuery>;
export type TermContractSearchQueryResult = Apollo.QueryResult<TermContractSearchQuery, TermContractSearchQueryVariables>;
export const SearchTerminalsDocument = gql`
    query SearchTerminals($searchTerm: String, $locationKey: Int) {
  terminalSearch(
    where: {or: [{name: {contains: $searchTerm}}, {city: {contains: $searchTerm}}, {state: {contains: $searchTerm}}], and: {isArchived: {eq: false}}}
    locationKey: $locationKey
    order: [{name: ASC}]
  ) {
    ...BasicTerminal
  }
}
    ${BasicTerminalFragmentDoc}`;

/**
 * __useSearchTerminalsQuery__
 *
 * To run a query within a React component, call `useSearchTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTerminalsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      locationKey: // value for 'locationKey'
 *   },
 * });
 */
export function useSearchTerminalsQuery(baseOptions?: Apollo.QueryHookOptions<SearchTerminalsQuery, SearchTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTerminalsQuery, SearchTerminalsQueryVariables>(SearchTerminalsDocument, options);
      }
export function useSearchTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTerminalsQuery, SearchTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTerminalsQuery, SearchTerminalsQueryVariables>(SearchTerminalsDocument, options);
        }
export function useSearchTerminalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTerminalsQuery, SearchTerminalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTerminalsQuery, SearchTerminalsQueryVariables>(SearchTerminalsDocument, options);
        }
export type SearchTerminalsQueryHookResult = ReturnType<typeof useSearchTerminalsQuery>;
export type SearchTerminalsLazyQueryHookResult = ReturnType<typeof useSearchTerminalsLazyQuery>;
export type SearchTerminalsSuspenseQueryHookResult = ReturnType<typeof useSearchTerminalsSuspenseQuery>;
export type SearchTerminalsQueryResult = Apollo.QueryResult<SearchTerminalsQuery, SearchTerminalsQueryVariables>;
export const AllUserSearchDocument = gql`
    query AllUserSearch($search: String) {
  usersGetAll(
    where: {and: [{name: {contains: $search}}, {isGasPointUser: {eq: true}}]}
    order: [{name: ASC}]
    first: 1000
    after: "LTE="
  ) {
    ...allUserListing
  }
}
    ${AllUserListingFragmentDoc}`;

/**
 * __useAllUserSearchQuery__
 *
 * To run a query within a React component, call `useAllUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAllUserSearchQuery(baseOptions?: Apollo.QueryHookOptions<AllUserSearchQuery, AllUserSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserSearchQuery, AllUserSearchQueryVariables>(AllUserSearchDocument, options);
      }
export function useAllUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserSearchQuery, AllUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserSearchQuery, AllUserSearchQueryVariables>(AllUserSearchDocument, options);
        }
export function useAllUserSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUserSearchQuery, AllUserSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUserSearchQuery, AllUserSearchQueryVariables>(AllUserSearchDocument, options);
        }
export type AllUserSearchQueryHookResult = ReturnType<typeof useAllUserSearchQuery>;
export type AllUserSearchLazyQueryHookResult = ReturnType<typeof useAllUserSearchLazyQuery>;
export type AllUserSearchSuspenseQueryHookResult = ReturnType<typeof useAllUserSearchSuspenseQuery>;
export type AllUserSearchQueryResult = Apollo.QueryResult<AllUserSearchQuery, AllUserSearchQueryVariables>;
export const GetAllFuelSurchargesByCarrierKeyDocument = gql`
    query GetAllFuelSurchargesByCarrierKey($filterFuelSurcharge: FuelSurchargeFilterInput, $sort: [FuelSurchargeSortInput!], $pageSize: Int!) {
  fuelSurchargeGetAll(order: $sort, where: $filterFuelSurcharge, first: $pageSize) {
    nodes {
      carrierKey
      fuelSurchargeKey
      startDate
      endDate
      rate
    }
  }
}
    `;

/**
 * __useGetAllFuelSurchargesByCarrierKeyQuery__
 *
 * To run a query within a React component, call `useGetAllFuelSurchargesByCarrierKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFuelSurchargesByCarrierKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFuelSurchargesByCarrierKeyQuery({
 *   variables: {
 *      filterFuelSurcharge: // value for 'filterFuelSurcharge'
 *      sort: // value for 'sort'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAllFuelSurchargesByCarrierKeyQuery(baseOptions: Apollo.QueryHookOptions<GetAllFuelSurchargesByCarrierKeyQuery, GetAllFuelSurchargesByCarrierKeyQueryVariables> & ({ variables: GetAllFuelSurchargesByCarrierKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFuelSurchargesByCarrierKeyQuery, GetAllFuelSurchargesByCarrierKeyQueryVariables>(GetAllFuelSurchargesByCarrierKeyDocument, options);
      }
export function useGetAllFuelSurchargesByCarrierKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFuelSurchargesByCarrierKeyQuery, GetAllFuelSurchargesByCarrierKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFuelSurchargesByCarrierKeyQuery, GetAllFuelSurchargesByCarrierKeyQueryVariables>(GetAllFuelSurchargesByCarrierKeyDocument, options);
        }
export function useGetAllFuelSurchargesByCarrierKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFuelSurchargesByCarrierKeyQuery, GetAllFuelSurchargesByCarrierKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFuelSurchargesByCarrierKeyQuery, GetAllFuelSurchargesByCarrierKeyQueryVariables>(GetAllFuelSurchargesByCarrierKeyDocument, options);
        }
export type GetAllFuelSurchargesByCarrierKeyQueryHookResult = ReturnType<typeof useGetAllFuelSurchargesByCarrierKeyQuery>;
export type GetAllFuelSurchargesByCarrierKeyLazyQueryHookResult = ReturnType<typeof useGetAllFuelSurchargesByCarrierKeyLazyQuery>;
export type GetAllFuelSurchargesByCarrierKeySuspenseQueryHookResult = ReturnType<typeof useGetAllFuelSurchargesByCarrierKeySuspenseQuery>;
export type GetAllFuelSurchargesByCarrierKeyQueryResult = Apollo.QueryResult<GetAllFuelSurchargesByCarrierKeyQuery, GetAllFuelSurchargesByCarrierKeyQueryVariables>;
export const DeleteFuelSurchargeDocument = gql`
    mutation DeleteFuelSurcharge($id: Int!) {
  fuelSurchargeDelete(id: $id)
}
    `;
export type DeleteFuelSurchargeMutationFn = Apollo.MutationFunction<DeleteFuelSurchargeMutation, DeleteFuelSurchargeMutationVariables>;

/**
 * __useDeleteFuelSurchargeMutation__
 *
 * To run a mutation, you first call `useDeleteFuelSurchargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFuelSurchargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFuelSurchargeMutation, { data, loading, error }] = useDeleteFuelSurchargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFuelSurchargeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFuelSurchargeMutation, DeleteFuelSurchargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFuelSurchargeMutation, DeleteFuelSurchargeMutationVariables>(DeleteFuelSurchargeDocument, options);
      }
export type DeleteFuelSurchargeMutationHookResult = ReturnType<typeof useDeleteFuelSurchargeMutation>;
export type DeleteFuelSurchargeMutationResult = Apollo.MutationResult<DeleteFuelSurchargeMutation>;
export type DeleteFuelSurchargeMutationOptions = Apollo.BaseMutationOptions<DeleteFuelSurchargeMutation, DeleteFuelSurchargeMutationVariables>;
export const GetTasksCompletedAfterDocument = gql`
    query GetTasksCompletedAfter($date: DateTime!, $locationKey: Int!, $pageSize: Int!) {
  taskGetCompletedAfterDate(
    date: $date
    where: {locationKey: {eq: $locationKey}}
    order: [{taskDate: DESC}]
    first: $pageSize
  ) {
    edges {
      cursor
      node {
        ...TaskShow
      }
    }
    totalCount
  }
}
    ${TaskShowFragmentDoc}`;

/**
 * __useGetTasksCompletedAfterQuery__
 *
 * To run a query within a React component, call `useGetTasksCompletedAfterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksCompletedAfterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksCompletedAfterQuery({
 *   variables: {
 *      date: // value for 'date'
 *      locationKey: // value for 'locationKey'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetTasksCompletedAfterQuery(baseOptions: Apollo.QueryHookOptions<GetTasksCompletedAfterQuery, GetTasksCompletedAfterQueryVariables> & ({ variables: GetTasksCompletedAfterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksCompletedAfterQuery, GetTasksCompletedAfterQueryVariables>(GetTasksCompletedAfterDocument, options);
      }
export function useGetTasksCompletedAfterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksCompletedAfterQuery, GetTasksCompletedAfterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksCompletedAfterQuery, GetTasksCompletedAfterQueryVariables>(GetTasksCompletedAfterDocument, options);
        }
export function useGetTasksCompletedAfterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksCompletedAfterQuery, GetTasksCompletedAfterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksCompletedAfterQuery, GetTasksCompletedAfterQueryVariables>(GetTasksCompletedAfterDocument, options);
        }
export type GetTasksCompletedAfterQueryHookResult = ReturnType<typeof useGetTasksCompletedAfterQuery>;
export type GetTasksCompletedAfterLazyQueryHookResult = ReturnType<typeof useGetTasksCompletedAfterLazyQuery>;
export type GetTasksCompletedAfterSuspenseQueryHookResult = ReturnType<typeof useGetTasksCompletedAfterSuspenseQuery>;
export type GetTasksCompletedAfterQueryResult = Apollo.QueryResult<GetTasksCompletedAfterQuery, GetTasksCompletedAfterQueryVariables>;
export const CreateBasisTypeDocument = gql`
    mutation CreateBasisType($basisType: BasisTypeInput!) {
  basisTypeCreate(basisType: $basisType) {
    basisTypeKey
  }
}
    `;
export type CreateBasisTypeMutationFn = Apollo.MutationFunction<CreateBasisTypeMutation, CreateBasisTypeMutationVariables>;

/**
 * __useCreateBasisTypeMutation__
 *
 * To run a mutation, you first call `useCreateBasisTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBasisTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBasisTypeMutation, { data, loading, error }] = useCreateBasisTypeMutation({
 *   variables: {
 *      basisType: // value for 'basisType'
 *   },
 * });
 */
export function useCreateBasisTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateBasisTypeMutation, CreateBasisTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBasisTypeMutation, CreateBasisTypeMutationVariables>(CreateBasisTypeDocument, options);
      }
export type CreateBasisTypeMutationHookResult = ReturnType<typeof useCreateBasisTypeMutation>;
export type CreateBasisTypeMutationResult = Apollo.MutationResult<CreateBasisTypeMutation>;
export type CreateBasisTypeMutationOptions = Apollo.BaseMutationOptions<CreateBasisTypeMutation, CreateBasisTypeMutationVariables>;
export const EditBasisTypeDocument = gql`
    mutation EditBasisType($basisType: BasisTypeInput!, $id: Int!) {
  basisTypeUpdate(basisType: $basisType, id: $id) {
    basisTypeKey
  }
}
    `;
export type EditBasisTypeMutationFn = Apollo.MutationFunction<EditBasisTypeMutation, EditBasisTypeMutationVariables>;

/**
 * __useEditBasisTypeMutation__
 *
 * To run a mutation, you first call `useEditBasisTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBasisTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBasisTypeMutation, { data, loading, error }] = useEditBasisTypeMutation({
 *   variables: {
 *      basisType: // value for 'basisType'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditBasisTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditBasisTypeMutation, EditBasisTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBasisTypeMutation, EditBasisTypeMutationVariables>(EditBasisTypeDocument, options);
      }
export type EditBasisTypeMutationHookResult = ReturnType<typeof useEditBasisTypeMutation>;
export type EditBasisTypeMutationResult = Apollo.MutationResult<EditBasisTypeMutation>;
export type EditBasisTypeMutationOptions = Apollo.BaseMutationOptions<EditBasisTypeMutation, EditBasisTypeMutationVariables>;
export const AllBasisTypesDocument = gql`
    query AllBasisTypes($sortObject: [BasisTypeSortInput!], $filterObject: BasisTypeFilterInput) {
  basisTypeGetAll(order: $sortObject, where: $filterObject) {
    ...allBasisTypeListing
  }
}
    ${AllBasisTypeListingFragmentDoc}`;

/**
 * __useAllBasisTypesQuery__
 *
 * To run a query within a React component, call `useAllBasisTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBasisTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBasisTypesQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *   },
 * });
 */
export function useAllBasisTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllBasisTypesQuery, AllBasisTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBasisTypesQuery, AllBasisTypesQueryVariables>(AllBasisTypesDocument, options);
      }
export function useAllBasisTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBasisTypesQuery, AllBasisTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBasisTypesQuery, AllBasisTypesQueryVariables>(AllBasisTypesDocument, options);
        }
export function useAllBasisTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllBasisTypesQuery, AllBasisTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllBasisTypesQuery, AllBasisTypesQueryVariables>(AllBasisTypesDocument, options);
        }
export type AllBasisTypesQueryHookResult = ReturnType<typeof useAllBasisTypesQuery>;
export type AllBasisTypesLazyQueryHookResult = ReturnType<typeof useAllBasisTypesLazyQuery>;
export type AllBasisTypesSuspenseQueryHookResult = ReturnType<typeof useAllBasisTypesSuspenseQuery>;
export type AllBasisTypesQueryResult = Apollo.QueryResult<AllBasisTypesQuery, AllBasisTypesQueryVariables>;
export const DeleteBasisTypeDocument = gql`
    mutation DeleteBasisType($id: Int!) {
  basisTypeDelete(id: $id)
}
    `;
export type DeleteBasisTypeMutationFn = Apollo.MutationFunction<DeleteBasisTypeMutation, DeleteBasisTypeMutationVariables>;

/**
 * __useDeleteBasisTypeMutation__
 *
 * To run a mutation, you first call `useDeleteBasisTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBasisTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBasisTypeMutation, { data, loading, error }] = useDeleteBasisTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBasisTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBasisTypeMutation, DeleteBasisTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBasisTypeMutation, DeleteBasisTypeMutationVariables>(DeleteBasisTypeDocument, options);
      }
export type DeleteBasisTypeMutationHookResult = ReturnType<typeof useDeleteBasisTypeMutation>;
export type DeleteBasisTypeMutationResult = Apollo.MutationResult<DeleteBasisTypeMutation>;
export type DeleteBasisTypeMutationOptions = Apollo.BaseMutationOptions<DeleteBasisTypeMutation, DeleteBasisTypeMutationVariables>;
export const BasisTypePriceDetectDuplicatesDocument = gql`
    mutation BasisTypePriceDetectDuplicates {
  basisTypePriceDetectDuplicates
}
    `;
export type BasisTypePriceDetectDuplicatesMutationFn = Apollo.MutationFunction<BasisTypePriceDetectDuplicatesMutation, BasisTypePriceDetectDuplicatesMutationVariables>;

/**
 * __useBasisTypePriceDetectDuplicatesMutation__
 *
 * To run a mutation, you first call `useBasisTypePriceDetectDuplicatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasisTypePriceDetectDuplicatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basisTypePriceDetectDuplicatesMutation, { data, loading, error }] = useBasisTypePriceDetectDuplicatesMutation({
 *   variables: {
 *   },
 * });
 */
export function useBasisTypePriceDetectDuplicatesMutation(baseOptions?: Apollo.MutationHookOptions<BasisTypePriceDetectDuplicatesMutation, BasisTypePriceDetectDuplicatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BasisTypePriceDetectDuplicatesMutation, BasisTypePriceDetectDuplicatesMutationVariables>(BasisTypePriceDetectDuplicatesDocument, options);
      }
export type BasisTypePriceDetectDuplicatesMutationHookResult = ReturnType<typeof useBasisTypePriceDetectDuplicatesMutation>;
export type BasisTypePriceDetectDuplicatesMutationResult = Apollo.MutationResult<BasisTypePriceDetectDuplicatesMutation>;
export type BasisTypePriceDetectDuplicatesMutationOptions = Apollo.BaseMutationOptions<BasisTypePriceDetectDuplicatesMutation, BasisTypePriceDetectDuplicatesMutationVariables>;
export const BasisTypePriceCleanupDuplicatesDocument = gql`
    mutation BasisTypePriceCleanupDuplicates {
  basisTypePriceCleanupDuplicates
}
    `;
export type BasisTypePriceCleanupDuplicatesMutationFn = Apollo.MutationFunction<BasisTypePriceCleanupDuplicatesMutation, BasisTypePriceCleanupDuplicatesMutationVariables>;

/**
 * __useBasisTypePriceCleanupDuplicatesMutation__
 *
 * To run a mutation, you first call `useBasisTypePriceCleanupDuplicatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasisTypePriceCleanupDuplicatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basisTypePriceCleanupDuplicatesMutation, { data, loading, error }] = useBasisTypePriceCleanupDuplicatesMutation({
 *   variables: {
 *   },
 * });
 */
export function useBasisTypePriceCleanupDuplicatesMutation(baseOptions?: Apollo.MutationHookOptions<BasisTypePriceCleanupDuplicatesMutation, BasisTypePriceCleanupDuplicatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BasisTypePriceCleanupDuplicatesMutation, BasisTypePriceCleanupDuplicatesMutationVariables>(BasisTypePriceCleanupDuplicatesDocument, options);
      }
export type BasisTypePriceCleanupDuplicatesMutationHookResult = ReturnType<typeof useBasisTypePriceCleanupDuplicatesMutation>;
export type BasisTypePriceCleanupDuplicatesMutationResult = Apollo.MutationResult<BasisTypePriceCleanupDuplicatesMutation>;
export type BasisTypePriceCleanupDuplicatesMutationOptions = Apollo.BaseMutationOptions<BasisTypePriceCleanupDuplicatesMutation, BasisTypePriceCleanupDuplicatesMutationVariables>;
export const GetBasisTypePricesDocument = gql`
    query GetBasisTypePrices($sort: [BasisTypePriceSortInput!], $filter: BasisTypePriceFilterInput!) {
  basisTypePriceGetAll(order: $sort, where: $filter) {
    ...basisTypePricing
  }
}
    ${BasisTypePricingFragmentDoc}`;

/**
 * __useGetBasisTypePricesQuery__
 *
 * To run a query within a React component, call `useGetBasisTypePricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasisTypePricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasisTypePricesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBasisTypePricesQuery(baseOptions: Apollo.QueryHookOptions<GetBasisTypePricesQuery, GetBasisTypePricesQueryVariables> & ({ variables: GetBasisTypePricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasisTypePricesQuery, GetBasisTypePricesQueryVariables>(GetBasisTypePricesDocument, options);
      }
export function useGetBasisTypePricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasisTypePricesQuery, GetBasisTypePricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasisTypePricesQuery, GetBasisTypePricesQueryVariables>(GetBasisTypePricesDocument, options);
        }
export function useGetBasisTypePricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBasisTypePricesQuery, GetBasisTypePricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasisTypePricesQuery, GetBasisTypePricesQueryVariables>(GetBasisTypePricesDocument, options);
        }
export type GetBasisTypePricesQueryHookResult = ReturnType<typeof useGetBasisTypePricesQuery>;
export type GetBasisTypePricesLazyQueryHookResult = ReturnType<typeof useGetBasisTypePricesLazyQuery>;
export type GetBasisTypePricesSuspenseQueryHookResult = ReturnType<typeof useGetBasisTypePricesSuspenseQuery>;
export type GetBasisTypePricesQueryResult = Apollo.QueryResult<GetBasisTypePricesQuery, GetBasisTypePricesQueryVariables>;
export const GetSingleBasisTypeDocument = gql`
    query GetSingleBasisType($id: Int!) {
  basisTypeGetSingle(id: $id) {
    ...singleBasisType
  }
}
    ${SingleBasisTypeFragmentDoc}`;

/**
 * __useGetSingleBasisTypeQuery__
 *
 * To run a query within a React component, call `useGetSingleBasisTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBasisTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBasisTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleBasisTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSingleBasisTypeQuery, GetSingleBasisTypeQueryVariables> & ({ variables: GetSingleBasisTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleBasisTypeQuery, GetSingleBasisTypeQueryVariables>(GetSingleBasisTypeDocument, options);
      }
export function useGetSingleBasisTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleBasisTypeQuery, GetSingleBasisTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleBasisTypeQuery, GetSingleBasisTypeQueryVariables>(GetSingleBasisTypeDocument, options);
        }
export function useGetSingleBasisTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleBasisTypeQuery, GetSingleBasisTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleBasisTypeQuery, GetSingleBasisTypeQueryVariables>(GetSingleBasisTypeDocument, options);
        }
export type GetSingleBasisTypeQueryHookResult = ReturnType<typeof useGetSingleBasisTypeQuery>;
export type GetSingleBasisTypeLazyQueryHookResult = ReturnType<typeof useGetSingleBasisTypeLazyQuery>;
export type GetSingleBasisTypeSuspenseQueryHookResult = ReturnType<typeof useGetSingleBasisTypeSuspenseQuery>;
export type GetSingleBasisTypeQueryResult = Apollo.QueryResult<GetSingleBasisTypeQuery, GetSingleBasisTypeQueryVariables>;
export const CreateBasisTypePriceDocument = gql`
    mutation CreateBasisTypePrice($basisTypePrice: BasisTypePriceInput!) {
  basisTypePriceCreate(basisTypePrice: $basisTypePrice) {
    basisTypePriceKey
    price
    effectiveDate
  }
}
    `;
export type CreateBasisTypePriceMutationFn = Apollo.MutationFunction<CreateBasisTypePriceMutation, CreateBasisTypePriceMutationVariables>;

/**
 * __useCreateBasisTypePriceMutation__
 *
 * To run a mutation, you first call `useCreateBasisTypePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBasisTypePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBasisTypePriceMutation, { data, loading, error }] = useCreateBasisTypePriceMutation({
 *   variables: {
 *      basisTypePrice: // value for 'basisTypePrice'
 *   },
 * });
 */
export function useCreateBasisTypePriceMutation(baseOptions?: Apollo.MutationHookOptions<CreateBasisTypePriceMutation, CreateBasisTypePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBasisTypePriceMutation, CreateBasisTypePriceMutationVariables>(CreateBasisTypePriceDocument, options);
      }
export type CreateBasisTypePriceMutationHookResult = ReturnType<typeof useCreateBasisTypePriceMutation>;
export type CreateBasisTypePriceMutationResult = Apollo.MutationResult<CreateBasisTypePriceMutation>;
export type CreateBasisTypePriceMutationOptions = Apollo.BaseMutationOptions<CreateBasisTypePriceMutation, CreateBasisTypePriceMutationVariables>;
export const AllCarrierDocument = gql`
    query AllCarrier($sortObject: [CarrierSortInput!], $filterObject: CarrierFilterInput) {
  carrierGetAll(order: $sortObject, where: $filterObject) {
    ...carrierListing
  }
}
    ${CarrierListingFragmentDoc}`;

/**
 * __useAllCarrierQuery__
 *
 * To run a query within a React component, call `useAllCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCarrierQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *   },
 * });
 */
export function useAllCarrierQuery(baseOptions?: Apollo.QueryHookOptions<AllCarrierQuery, AllCarrierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCarrierQuery, AllCarrierQueryVariables>(AllCarrierDocument, options);
      }
export function useAllCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCarrierQuery, AllCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCarrierQuery, AllCarrierQueryVariables>(AllCarrierDocument, options);
        }
export function useAllCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCarrierQuery, AllCarrierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCarrierQuery, AllCarrierQueryVariables>(AllCarrierDocument, options);
        }
export type AllCarrierQueryHookResult = ReturnType<typeof useAllCarrierQuery>;
export type AllCarrierLazyQueryHookResult = ReturnType<typeof useAllCarrierLazyQuery>;
export type AllCarrierSuspenseQueryHookResult = ReturnType<typeof useAllCarrierSuspenseQuery>;
export type AllCarrierQueryResult = Apollo.QueryResult<AllCarrierQuery, AllCarrierQueryVariables>;
export const DeleteCarrierDocument = gql`
    mutation DeleteCarrier($id: Int!) {
  carrierDelete(id: $id)
}
    `;
export type DeleteCarrierMutationFn = Apollo.MutationFunction<DeleteCarrierMutation, DeleteCarrierMutationVariables>;

/**
 * __useDeleteCarrierMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierMutation, { data, loading, error }] = useDeleteCarrierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCarrierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierMutation, DeleteCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarrierMutation, DeleteCarrierMutationVariables>(DeleteCarrierDocument, options);
      }
export type DeleteCarrierMutationHookResult = ReturnType<typeof useDeleteCarrierMutation>;
export type DeleteCarrierMutationResult = Apollo.MutationResult<DeleteCarrierMutation>;
export type DeleteCarrierMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierMutation, DeleteCarrierMutationVariables>;
export const GetSingleCarrierRateDocument = gql`
    query GetSingleCarrierRate($key: Int!) {
  carrierRateGetSingle(id: $key) {
    ...singleCarrierRate
  }
}
    ${SingleCarrierRateFragmentDoc}`;

/**
 * __useGetSingleCarrierRateQuery__
 *
 * To run a query within a React component, call `useGetSingleCarrierRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleCarrierRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleCarrierRateQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSingleCarrierRateQuery(baseOptions: Apollo.QueryHookOptions<GetSingleCarrierRateQuery, GetSingleCarrierRateQueryVariables> & ({ variables: GetSingleCarrierRateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleCarrierRateQuery, GetSingleCarrierRateQueryVariables>(GetSingleCarrierRateDocument, options);
      }
export function useGetSingleCarrierRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleCarrierRateQuery, GetSingleCarrierRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleCarrierRateQuery, GetSingleCarrierRateQueryVariables>(GetSingleCarrierRateDocument, options);
        }
export function useGetSingleCarrierRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleCarrierRateQuery, GetSingleCarrierRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleCarrierRateQuery, GetSingleCarrierRateQueryVariables>(GetSingleCarrierRateDocument, options);
        }
export type GetSingleCarrierRateQueryHookResult = ReturnType<typeof useGetSingleCarrierRateQuery>;
export type GetSingleCarrierRateLazyQueryHookResult = ReturnType<typeof useGetSingleCarrierRateLazyQuery>;
export type GetSingleCarrierRateSuspenseQueryHookResult = ReturnType<typeof useGetSingleCarrierRateSuspenseQuery>;
export type GetSingleCarrierRateQueryResult = Apollo.QueryResult<GetSingleCarrierRateQuery, GetSingleCarrierRateQueryVariables>;
export const CreateCarrierDocument = gql`
    mutation CreateCarrier($carrier: CarrierInput!) {
  carrierCreate(carrier: $carrier) {
    carrierKey
  }
}
    `;
export type CreateCarrierMutationFn = Apollo.MutationFunction<CreateCarrierMutation, CreateCarrierMutationVariables>;

/**
 * __useCreateCarrierMutation__
 *
 * To run a mutation, you first call `useCreateCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierMutation, { data, loading, error }] = useCreateCarrierMutation({
 *   variables: {
 *      carrier: // value for 'carrier'
 *   },
 * });
 */
export function useCreateCarrierMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierMutation, CreateCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarrierMutation, CreateCarrierMutationVariables>(CreateCarrierDocument, options);
      }
export type CreateCarrierMutationHookResult = ReturnType<typeof useCreateCarrierMutation>;
export type CreateCarrierMutationResult = Apollo.MutationResult<CreateCarrierMutation>;
export type CreateCarrierMutationOptions = Apollo.BaseMutationOptions<CreateCarrierMutation, CreateCarrierMutationVariables>;
export const EditCarrierDocument = gql`
    mutation EditCarrier($carrier: CarrierInput!, $id: Int!) {
  carrierUpdate(carrier: $carrier, id: $id) {
    carrierKey
  }
}
    `;
export type EditCarrierMutationFn = Apollo.MutationFunction<EditCarrierMutation, EditCarrierMutationVariables>;

/**
 * __useEditCarrierMutation__
 *
 * To run a mutation, you first call `useEditCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCarrierMutation, { data, loading, error }] = useEditCarrierMutation({
 *   variables: {
 *      carrier: // value for 'carrier'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditCarrierMutation(baseOptions?: Apollo.MutationHookOptions<EditCarrierMutation, EditCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCarrierMutation, EditCarrierMutationVariables>(EditCarrierDocument, options);
      }
export type EditCarrierMutationHookResult = ReturnType<typeof useEditCarrierMutation>;
export type EditCarrierMutationResult = Apollo.MutationResult<EditCarrierMutation>;
export type EditCarrierMutationOptions = Apollo.BaseMutationOptions<EditCarrierMutation, EditCarrierMutationVariables>;
export const GetSingleCarrierDocument = gql`
    query GetSingleCarrier($id: Int!) {
  carrierGetSingle(id: $id) {
    ...singleCarrier
  }
}
    ${SingleCarrierFragmentDoc}`;

/**
 * __useGetSingleCarrierQuery__
 *
 * To run a query within a React component, call `useGetSingleCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleCarrierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleCarrierQuery(baseOptions: Apollo.QueryHookOptions<GetSingleCarrierQuery, GetSingleCarrierQueryVariables> & ({ variables: GetSingleCarrierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleCarrierQuery, GetSingleCarrierQueryVariables>(GetSingleCarrierDocument, options);
      }
export function useGetSingleCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleCarrierQuery, GetSingleCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleCarrierQuery, GetSingleCarrierQueryVariables>(GetSingleCarrierDocument, options);
        }
export function useGetSingleCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleCarrierQuery, GetSingleCarrierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleCarrierQuery, GetSingleCarrierQueryVariables>(GetSingleCarrierDocument, options);
        }
export type GetSingleCarrierQueryHookResult = ReturnType<typeof useGetSingleCarrierQuery>;
export type GetSingleCarrierLazyQueryHookResult = ReturnType<typeof useGetSingleCarrierLazyQuery>;
export type GetSingleCarrierSuspenseQueryHookResult = ReturnType<typeof useGetSingleCarrierSuspenseQuery>;
export type GetSingleCarrierQueryResult = Apollo.QueryResult<GetSingleCarrierQuery, GetSingleCarrierQueryVariables>;
export const GetAllContactByCarrierKeyDocument = gql`
    query GetAllContactByCarrierKey($filterContact: ContactFilterInput) {
  contactGetAll(where: $filterContact) {
    carrierKey
    contactKey
    firstName
    lastName
    phone
    email
    notes
    default
    cellPhone
    homePhone
    deleted
  }
}
    `;

/**
 * __useGetAllContactByCarrierKeyQuery__
 *
 * To run a query within a React component, call `useGetAllContactByCarrierKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactByCarrierKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactByCarrierKeyQuery({
 *   variables: {
 *      filterContact: // value for 'filterContact'
 *   },
 * });
 */
export function useGetAllContactByCarrierKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContactByCarrierKeyQuery, GetAllContactByCarrierKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactByCarrierKeyQuery, GetAllContactByCarrierKeyQueryVariables>(GetAllContactByCarrierKeyDocument, options);
      }
export function useGetAllContactByCarrierKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactByCarrierKeyQuery, GetAllContactByCarrierKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactByCarrierKeyQuery, GetAllContactByCarrierKeyQueryVariables>(GetAllContactByCarrierKeyDocument, options);
        }
export function useGetAllContactByCarrierKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContactByCarrierKeyQuery, GetAllContactByCarrierKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContactByCarrierKeyQuery, GetAllContactByCarrierKeyQueryVariables>(GetAllContactByCarrierKeyDocument, options);
        }
export type GetAllContactByCarrierKeyQueryHookResult = ReturnType<typeof useGetAllContactByCarrierKeyQuery>;
export type GetAllContactByCarrierKeyLazyQueryHookResult = ReturnType<typeof useGetAllContactByCarrierKeyLazyQuery>;
export type GetAllContactByCarrierKeySuspenseQueryHookResult = ReturnType<typeof useGetAllContactByCarrierKeySuspenseQuery>;
export type GetAllContactByCarrierKeyQueryResult = Apollo.QueryResult<GetAllContactByCarrierKeyQuery, GetAllContactByCarrierKeyQueryVariables>;
export const GetAllCarrierRateByCarrierKeyDocument = gql`
    query GetAllCarrierRateByCarrierKey($filterCarrierRate: CarrierRateFilterInput, $sort: [CarrierRateSortInput!], $pageSize: Int!) {
  carrierRateGetAll(order: $sort, where: $filterCarrierRate, first: $pageSize) {
    edges {
      cursor
      node {
        carrierKey
        carrierRateKey
        startDate
        endDate
        basePercent
        default
        fuelPercent
      }
    }
  }
}
    `;

/**
 * __useGetAllCarrierRateByCarrierKeyQuery__
 *
 * To run a query within a React component, call `useGetAllCarrierRateByCarrierKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCarrierRateByCarrierKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCarrierRateByCarrierKeyQuery({
 *   variables: {
 *      filterCarrierRate: // value for 'filterCarrierRate'
 *      sort: // value for 'sort'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAllCarrierRateByCarrierKeyQuery(baseOptions: Apollo.QueryHookOptions<GetAllCarrierRateByCarrierKeyQuery, GetAllCarrierRateByCarrierKeyQueryVariables> & ({ variables: GetAllCarrierRateByCarrierKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCarrierRateByCarrierKeyQuery, GetAllCarrierRateByCarrierKeyQueryVariables>(GetAllCarrierRateByCarrierKeyDocument, options);
      }
export function useGetAllCarrierRateByCarrierKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCarrierRateByCarrierKeyQuery, GetAllCarrierRateByCarrierKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCarrierRateByCarrierKeyQuery, GetAllCarrierRateByCarrierKeyQueryVariables>(GetAllCarrierRateByCarrierKeyDocument, options);
        }
export function useGetAllCarrierRateByCarrierKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCarrierRateByCarrierKeyQuery, GetAllCarrierRateByCarrierKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCarrierRateByCarrierKeyQuery, GetAllCarrierRateByCarrierKeyQueryVariables>(GetAllCarrierRateByCarrierKeyDocument, options);
        }
export type GetAllCarrierRateByCarrierKeyQueryHookResult = ReturnType<typeof useGetAllCarrierRateByCarrierKeyQuery>;
export type GetAllCarrierRateByCarrierKeyLazyQueryHookResult = ReturnType<typeof useGetAllCarrierRateByCarrierKeyLazyQuery>;
export type GetAllCarrierRateByCarrierKeySuspenseQueryHookResult = ReturnType<typeof useGetAllCarrierRateByCarrierKeySuspenseQuery>;
export type GetAllCarrierRateByCarrierKeyQueryResult = Apollo.QueryResult<GetAllCarrierRateByCarrierKeyQuery, GetAllCarrierRateByCarrierKeyQueryVariables>;
export const GetAllCarrierPointToPointRateByCarrierKeyDocument = gql`
    query GetAllCarrierPointToPointRateByCarrierKey($filterCarrierRate: CarrierPointToPointRateFilterInput, $sort: [CarrierPointToPointRateSortInput!]) {
  carrierPointToPointRateGetAll(order: $sort, where: $filterCarrierRate) {
    carrierPointToPointRateKey
    rate
    originCityKey
    originCity {
      name
      cityKey
      stateKey
      state {
        stateKey
        name
      }
    }
    destinationCityKey
    destinationCity {
      name
      cityKey
      stateKey
      state {
        stateKey
        name
      }
    }
    miles
    tolls
  }
}
    `;

/**
 * __useGetAllCarrierPointToPointRateByCarrierKeyQuery__
 *
 * To run a query within a React component, call `useGetAllCarrierPointToPointRateByCarrierKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCarrierPointToPointRateByCarrierKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCarrierPointToPointRateByCarrierKeyQuery({
 *   variables: {
 *      filterCarrierRate: // value for 'filterCarrierRate'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllCarrierPointToPointRateByCarrierKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCarrierPointToPointRateByCarrierKeyQuery, GetAllCarrierPointToPointRateByCarrierKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCarrierPointToPointRateByCarrierKeyQuery, GetAllCarrierPointToPointRateByCarrierKeyQueryVariables>(GetAllCarrierPointToPointRateByCarrierKeyDocument, options);
      }
export function useGetAllCarrierPointToPointRateByCarrierKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCarrierPointToPointRateByCarrierKeyQuery, GetAllCarrierPointToPointRateByCarrierKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCarrierPointToPointRateByCarrierKeyQuery, GetAllCarrierPointToPointRateByCarrierKeyQueryVariables>(GetAllCarrierPointToPointRateByCarrierKeyDocument, options);
        }
export function useGetAllCarrierPointToPointRateByCarrierKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCarrierPointToPointRateByCarrierKeyQuery, GetAllCarrierPointToPointRateByCarrierKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCarrierPointToPointRateByCarrierKeyQuery, GetAllCarrierPointToPointRateByCarrierKeyQueryVariables>(GetAllCarrierPointToPointRateByCarrierKeyDocument, options);
        }
export type GetAllCarrierPointToPointRateByCarrierKeyQueryHookResult = ReturnType<typeof useGetAllCarrierPointToPointRateByCarrierKeyQuery>;
export type GetAllCarrierPointToPointRateByCarrierKeyLazyQueryHookResult = ReturnType<typeof useGetAllCarrierPointToPointRateByCarrierKeyLazyQuery>;
export type GetAllCarrierPointToPointRateByCarrierKeySuspenseQueryHookResult = ReturnType<typeof useGetAllCarrierPointToPointRateByCarrierKeySuspenseQuery>;
export type GetAllCarrierPointToPointRateByCarrierKeyQueryResult = Apollo.QueryResult<GetAllCarrierPointToPointRateByCarrierKeyQuery, GetAllCarrierPointToPointRateByCarrierKeyQueryVariables>;
export const GetAllCarrierPointToPointRateDateSpansByCarrierKeyDocument = gql`
    query GetAllCarrierPointToPointRateDateSpansByCarrierKey($filterDateSpans: CarrierPointToPointRateDateSpanFilterInput, $sort: [CarrierPointToPointRateDateSpanSortInput!]) {
  carrierPointToPointRateDateSpanGetAll(order: $sort, where: $filterDateSpans) {
    carrierPointToPointRateDateSpanKey
    startDate
    endDate
    carrierKey
  }
}
    `;

/**
 * __useGetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery__
 *
 * To run a query within a React component, call `useGetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery({
 *   variables: {
 *      filterDateSpans: // value for 'filterDateSpans'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery, GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery, GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryVariables>(GetAllCarrierPointToPointRateDateSpansByCarrierKeyDocument, options);
      }
export function useGetAllCarrierPointToPointRateDateSpansByCarrierKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery, GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery, GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryVariables>(GetAllCarrierPointToPointRateDateSpansByCarrierKeyDocument, options);
        }
export function useGetAllCarrierPointToPointRateDateSpansByCarrierKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery, GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery, GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryVariables>(GetAllCarrierPointToPointRateDateSpansByCarrierKeyDocument, options);
        }
export type GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryHookResult = ReturnType<typeof useGetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery>;
export type GetAllCarrierPointToPointRateDateSpansByCarrierKeyLazyQueryHookResult = ReturnType<typeof useGetAllCarrierPointToPointRateDateSpansByCarrierKeyLazyQuery>;
export type GetAllCarrierPointToPointRateDateSpansByCarrierKeySuspenseQueryHookResult = ReturnType<typeof useGetAllCarrierPointToPointRateDateSpansByCarrierKeySuspenseQuery>;
export type GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryResult = Apollo.QueryResult<GetAllCarrierPointToPointRateDateSpansByCarrierKeyQuery, GetAllCarrierPointToPointRateDateSpansByCarrierKeyQueryVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: Int!) {
  contactArchive(contactKey: $id)
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const DeleteCarrierRateDocument = gql`
    mutation DeleteCarrierRate($id: Int!) {
  carrierRateDelete(id: $id)
}
    `;
export type DeleteCarrierRateMutationFn = Apollo.MutationFunction<DeleteCarrierRateMutation, DeleteCarrierRateMutationVariables>;

/**
 * __useDeleteCarrierRateMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierRateMutation, { data, loading, error }] = useDeleteCarrierRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCarrierRateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierRateMutation, DeleteCarrierRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarrierRateMutation, DeleteCarrierRateMutationVariables>(DeleteCarrierRateDocument, options);
      }
export type DeleteCarrierRateMutationHookResult = ReturnType<typeof useDeleteCarrierRateMutation>;
export type DeleteCarrierRateMutationResult = Apollo.MutationResult<DeleteCarrierRateMutation>;
export type DeleteCarrierRateMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierRateMutation, DeleteCarrierRateMutationVariables>;
export const DeleteCarrierPointToPointRateDocument = gql`
    mutation DeleteCarrierPointToPointRate($id: Int!) {
  carrierPointToPointRateDelete(id: $id)
}
    `;
export type DeleteCarrierPointToPointRateMutationFn = Apollo.MutationFunction<DeleteCarrierPointToPointRateMutation, DeleteCarrierPointToPointRateMutationVariables>;

/**
 * __useDeleteCarrierPointToPointRateMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierPointToPointRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierPointToPointRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierPointToPointRateMutation, { data, loading, error }] = useDeleteCarrierPointToPointRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCarrierPointToPointRateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierPointToPointRateMutation, DeleteCarrierPointToPointRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarrierPointToPointRateMutation, DeleteCarrierPointToPointRateMutationVariables>(DeleteCarrierPointToPointRateDocument, options);
      }
export type DeleteCarrierPointToPointRateMutationHookResult = ReturnType<typeof useDeleteCarrierPointToPointRateMutation>;
export type DeleteCarrierPointToPointRateMutationResult = Apollo.MutationResult<DeleteCarrierPointToPointRateMutation>;
export type DeleteCarrierPointToPointRateMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierPointToPointRateMutation, DeleteCarrierPointToPointRateMutationVariables>;
export const CreateContractVolumeDocument = gql`
    mutation CreateContractVolume($contractVolume: ContractVolumeInput!) {
  contractVolumeCreate(contractVolume: $contractVolume) {
    contractVolumeKey
  }
}
    `;
export type CreateContractVolumeMutationFn = Apollo.MutationFunction<CreateContractVolumeMutation, CreateContractVolumeMutationVariables>;

/**
 * __useCreateContractVolumeMutation__
 *
 * To run a mutation, you first call `useCreateContractVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractVolumeMutation, { data, loading, error }] = useCreateContractVolumeMutation({
 *   variables: {
 *      contractVolume: // value for 'contractVolume'
 *   },
 * });
 */
export function useCreateContractVolumeMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractVolumeMutation, CreateContractVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractVolumeMutation, CreateContractVolumeMutationVariables>(CreateContractVolumeDocument, options);
      }
export type CreateContractVolumeMutationHookResult = ReturnType<typeof useCreateContractVolumeMutation>;
export type CreateContractVolumeMutationResult = Apollo.MutationResult<CreateContractVolumeMutation>;
export type CreateContractVolumeMutationOptions = Apollo.BaseMutationOptions<CreateContractVolumeMutation, CreateContractVolumeMutationVariables>;
export const CreateContractVolumeTerminalDocument = gql`
    mutation CreateContractVolumeTerminal($contractVolumeTerminal: ContractVolumeTerminalInput!) {
  contractVolumeTerminalCreate(contractVolumeTerminal: $contractVolumeTerminal) {
    contractVolumeKey
  }
}
    `;
export type CreateContractVolumeTerminalMutationFn = Apollo.MutationFunction<CreateContractVolumeTerminalMutation, CreateContractVolumeTerminalMutationVariables>;

/**
 * __useCreateContractVolumeTerminalMutation__
 *
 * To run a mutation, you first call `useCreateContractVolumeTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractVolumeTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractVolumeTerminalMutation, { data, loading, error }] = useCreateContractVolumeTerminalMutation({
 *   variables: {
 *      contractVolumeTerminal: // value for 'contractVolumeTerminal'
 *   },
 * });
 */
export function useCreateContractVolumeTerminalMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractVolumeTerminalMutation, CreateContractVolumeTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractVolumeTerminalMutation, CreateContractVolumeTerminalMutationVariables>(CreateContractVolumeTerminalDocument, options);
      }
export type CreateContractVolumeTerminalMutationHookResult = ReturnType<typeof useCreateContractVolumeTerminalMutation>;
export type CreateContractVolumeTerminalMutationResult = Apollo.MutationResult<CreateContractVolumeTerminalMutation>;
export type CreateContractVolumeTerminalMutationOptions = Apollo.BaseMutationOptions<CreateContractVolumeTerminalMutation, CreateContractVolumeTerminalMutationVariables>;
export const EditContractVolumeDocument = gql`
    mutation EditContractVolume($contractVolume: ContractVolumeInput!, $id: Int!) {
  contractVolumeUpdate(contractVolume: $contractVolume, id: $id) {
    contractVolumeKey
  }
}
    `;
export type EditContractVolumeMutationFn = Apollo.MutationFunction<EditContractVolumeMutation, EditContractVolumeMutationVariables>;

/**
 * __useEditContractVolumeMutation__
 *
 * To run a mutation, you first call `useEditContractVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContractVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContractVolumeMutation, { data, loading, error }] = useEditContractVolumeMutation({
 *   variables: {
 *      contractVolume: // value for 'contractVolume'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditContractVolumeMutation(baseOptions?: Apollo.MutationHookOptions<EditContractVolumeMutation, EditContractVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContractVolumeMutation, EditContractVolumeMutationVariables>(EditContractVolumeDocument, options);
      }
export type EditContractVolumeMutationHookResult = ReturnType<typeof useEditContractVolumeMutation>;
export type EditContractVolumeMutationResult = Apollo.MutationResult<EditContractVolumeMutation>;
export type EditContractVolumeMutationOptions = Apollo.BaseMutationOptions<EditContractVolumeMutation, EditContractVolumeMutationVariables>;
export const SingleContractVolumeDocument = gql`
    query SingleContractVolume($id: Int!) {
  contractVolumeGetSingle(id: $id) {
    ...innerContractVolume
  }
}
    ${InnerContractVolumeFragmentDoc}`;

/**
 * __useSingleContractVolumeQuery__
 *
 * To run a query within a React component, call `useSingleContractVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContractVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContractVolumeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleContractVolumeQuery(baseOptions: Apollo.QueryHookOptions<SingleContractVolumeQuery, SingleContractVolumeQueryVariables> & ({ variables: SingleContractVolumeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContractVolumeQuery, SingleContractVolumeQueryVariables>(SingleContractVolumeDocument, options);
      }
export function useSingleContractVolumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContractVolumeQuery, SingleContractVolumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContractVolumeQuery, SingleContractVolumeQueryVariables>(SingleContractVolumeDocument, options);
        }
export function useSingleContractVolumeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleContractVolumeQuery, SingleContractVolumeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleContractVolumeQuery, SingleContractVolumeQueryVariables>(SingleContractVolumeDocument, options);
        }
export type SingleContractVolumeQueryHookResult = ReturnType<typeof useSingleContractVolumeQuery>;
export type SingleContractVolumeLazyQueryHookResult = ReturnType<typeof useSingleContractVolumeLazyQuery>;
export type SingleContractVolumeSuspenseQueryHookResult = ReturnType<typeof useSingleContractVolumeSuspenseQuery>;
export type SingleContractVolumeQueryResult = Apollo.QueryResult<SingleContractVolumeQuery, SingleContractVolumeQueryVariables>;
export const DeleteContractVolumeTerminalDocument = gql`
    mutation DeleteContractVolumeTerminal($id: Int!) {
  contractVolumeTerminalDelete(contractVolumeKey: $id)
}
    `;
export type DeleteContractVolumeTerminalMutationFn = Apollo.MutationFunction<DeleteContractVolumeTerminalMutation, DeleteContractVolumeTerminalMutationVariables>;

/**
 * __useDeleteContractVolumeTerminalMutation__
 *
 * To run a mutation, you first call `useDeleteContractVolumeTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractVolumeTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractVolumeTerminalMutation, { data, loading, error }] = useDeleteContractVolumeTerminalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractVolumeTerminalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractVolumeTerminalMutation, DeleteContractVolumeTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractVolumeTerminalMutation, DeleteContractVolumeTerminalMutationVariables>(DeleteContractVolumeTerminalDocument, options);
      }
export type DeleteContractVolumeTerminalMutationHookResult = ReturnType<typeof useDeleteContractVolumeTerminalMutation>;
export type DeleteContractVolumeTerminalMutationResult = Apollo.MutationResult<DeleteContractVolumeTerminalMutation>;
export type DeleteContractVolumeTerminalMutationOptions = Apollo.BaseMutationOptions<DeleteContractVolumeTerminalMutation, DeleteContractVolumeTerminalMutationVariables>;
export const AllContractVolumesDocument = gql`
    query AllContractVolumes($sortObject: [ContractVolumeSortInput!], $filterObject: ContractVolumeFilterInput, $cursor: String!, $pageSize: Int!) {
  contractVolumeGetAll(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
  ) {
    ...allContractVolumeListing
  }
}
    ${AllContractVolumeListingFragmentDoc}`;

/**
 * __useAllContractVolumesQuery__
 *
 * To run a query within a React component, call `useAllContractVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllContractVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllContractVolumesQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllContractVolumesQuery(baseOptions: Apollo.QueryHookOptions<AllContractVolumesQuery, AllContractVolumesQueryVariables> & ({ variables: AllContractVolumesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllContractVolumesQuery, AllContractVolumesQueryVariables>(AllContractVolumesDocument, options);
      }
export function useAllContractVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllContractVolumesQuery, AllContractVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllContractVolumesQuery, AllContractVolumesQueryVariables>(AllContractVolumesDocument, options);
        }
export function useAllContractVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllContractVolumesQuery, AllContractVolumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllContractVolumesQuery, AllContractVolumesQueryVariables>(AllContractVolumesDocument, options);
        }
export type AllContractVolumesQueryHookResult = ReturnType<typeof useAllContractVolumesQuery>;
export type AllContractVolumesLazyQueryHookResult = ReturnType<typeof useAllContractVolumesLazyQuery>;
export type AllContractVolumesSuspenseQueryHookResult = ReturnType<typeof useAllContractVolumesSuspenseQuery>;
export type AllContractVolumesQueryResult = Apollo.QueryResult<AllContractVolumesQuery, AllContractVolumesQueryVariables>;
export const AllFlatContractVolumesDocument = gql`
    query AllFlatContractVolumes($sort: [FlatContractVolumeSortInput!], $filter: FlatContractVolumeFilterInput, $cursor: String!, $pageSize: Int!) {
  flatContractVolumeGetAll(
    order: $sort
    where: $filter
    first: $pageSize
    after: $cursor
  ) {
    ...allFlatContractVolumeListing
  }
}
    ${AllFlatContractVolumeListingFragmentDoc}`;

/**
 * __useAllFlatContractVolumesQuery__
 *
 * To run a query within a React component, call `useAllFlatContractVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFlatContractVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFlatContractVolumesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllFlatContractVolumesQuery(baseOptions: Apollo.QueryHookOptions<AllFlatContractVolumesQuery, AllFlatContractVolumesQueryVariables> & ({ variables: AllFlatContractVolumesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFlatContractVolumesQuery, AllFlatContractVolumesQueryVariables>(AllFlatContractVolumesDocument, options);
      }
export function useAllFlatContractVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFlatContractVolumesQuery, AllFlatContractVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFlatContractVolumesQuery, AllFlatContractVolumesQueryVariables>(AllFlatContractVolumesDocument, options);
        }
export function useAllFlatContractVolumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFlatContractVolumesQuery, AllFlatContractVolumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFlatContractVolumesQuery, AllFlatContractVolumesQueryVariables>(AllFlatContractVolumesDocument, options);
        }
export type AllFlatContractVolumesQueryHookResult = ReturnType<typeof useAllFlatContractVolumesQuery>;
export type AllFlatContractVolumesLazyQueryHookResult = ReturnType<typeof useAllFlatContractVolumesLazyQuery>;
export type AllFlatContractVolumesSuspenseQueryHookResult = ReturnType<typeof useAllFlatContractVolumesSuspenseQuery>;
export type AllFlatContractVolumesQueryResult = Apollo.QueryResult<AllFlatContractVolumesQuery, AllFlatContractVolumesQueryVariables>;
export const ContractVolumeForIndexContractDocument = gql`
    query ContractVolumeForIndexContract($id: Int!) {
  contractVolumeGetByIndexContract(id: $id) {
    ...innerContractVolume
  }
}
    ${InnerContractVolumeFragmentDoc}`;

/**
 * __useContractVolumeForIndexContractQuery__
 *
 * To run a query within a React component, call `useContractVolumeForIndexContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractVolumeForIndexContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractVolumeForIndexContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractVolumeForIndexContractQuery(baseOptions: Apollo.QueryHookOptions<ContractVolumeForIndexContractQuery, ContractVolumeForIndexContractQueryVariables> & ({ variables: ContractVolumeForIndexContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractVolumeForIndexContractQuery, ContractVolumeForIndexContractQueryVariables>(ContractVolumeForIndexContractDocument, options);
      }
export function useContractVolumeForIndexContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractVolumeForIndexContractQuery, ContractVolumeForIndexContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractVolumeForIndexContractQuery, ContractVolumeForIndexContractQueryVariables>(ContractVolumeForIndexContractDocument, options);
        }
export function useContractVolumeForIndexContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractVolumeForIndexContractQuery, ContractVolumeForIndexContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractVolumeForIndexContractQuery, ContractVolumeForIndexContractQueryVariables>(ContractVolumeForIndexContractDocument, options);
        }
export type ContractVolumeForIndexContractQueryHookResult = ReturnType<typeof useContractVolumeForIndexContractQuery>;
export type ContractVolumeForIndexContractLazyQueryHookResult = ReturnType<typeof useContractVolumeForIndexContractLazyQuery>;
export type ContractVolumeForIndexContractSuspenseQueryHookResult = ReturnType<typeof useContractVolumeForIndexContractSuspenseQuery>;
export type ContractVolumeForIndexContractQueryResult = Apollo.QueryResult<ContractVolumeForIndexContractQuery, ContractVolumeForIndexContractQueryVariables>;
export const DeleteContractVolumeDocument = gql`
    mutation DeleteContractVolume($id: Int!) {
  contractVolumeDelete(id: $id)
}
    `;
export type DeleteContractVolumeMutationFn = Apollo.MutationFunction<DeleteContractVolumeMutation, DeleteContractVolumeMutationVariables>;

/**
 * __useDeleteContractVolumeMutation__
 *
 * To run a mutation, you first call `useDeleteContractVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractVolumeMutation, { data, loading, error }] = useDeleteContractVolumeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractVolumeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractVolumeMutation, DeleteContractVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractVolumeMutation, DeleteContractVolumeMutationVariables>(DeleteContractVolumeDocument, options);
      }
export type DeleteContractVolumeMutationHookResult = ReturnType<typeof useDeleteContractVolumeMutation>;
export type DeleteContractVolumeMutationResult = Apollo.MutationResult<DeleteContractVolumeMutation>;
export type DeleteContractVolumeMutationOptions = Apollo.BaseMutationOptions<DeleteContractVolumeMutation, DeleteContractVolumeMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($customer: CustomerInput!) {
  customerCreate(customer: $customer) {
    customerKey
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const EditCustomerDocument = gql`
    mutation EditCustomer($customer: CustomerInput!, $id: Int!) {
  customerUpdate(customer: $customer, id: $id) {
    customerKey
  }
}
    `;
export type EditCustomerMutationFn = Apollo.MutationFunction<EditCustomerMutation, EditCustomerMutationVariables>;

/**
 * __useEditCustomerMutation__
 *
 * To run a mutation, you first call `useEditCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomerMutation, { data, loading, error }] = useEditCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditCustomerMutation(baseOptions?: Apollo.MutationHookOptions<EditCustomerMutation, EditCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCustomerMutation, EditCustomerMutationVariables>(EditCustomerDocument, options);
      }
export type EditCustomerMutationHookResult = ReturnType<typeof useEditCustomerMutation>;
export type EditCustomerMutationResult = Apollo.MutationResult<EditCustomerMutation>;
export type EditCustomerMutationOptions = Apollo.BaseMutationOptions<EditCustomerMutation, EditCustomerMutationVariables>;
export const CreateCustomerTagDocument = gql`
    mutation CreateCustomerTag($customerTag: CustomerTagInput!) {
  customerTagCreate(customerTag: $customerTag) {
    customerKey
    tagKey
  }
}
    `;
export type CreateCustomerTagMutationFn = Apollo.MutationFunction<CreateCustomerTagMutation, CreateCustomerTagMutationVariables>;

/**
 * __useCreateCustomerTagMutation__
 *
 * To run a mutation, you first call `useCreateCustomerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerTagMutation, { data, loading, error }] = useCreateCustomerTagMutation({
 *   variables: {
 *      customerTag: // value for 'customerTag'
 *   },
 * });
 */
export function useCreateCustomerTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerTagMutation, CreateCustomerTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerTagMutation, CreateCustomerTagMutationVariables>(CreateCustomerTagDocument, options);
      }
export type CreateCustomerTagMutationHookResult = ReturnType<typeof useCreateCustomerTagMutation>;
export type CreateCustomerTagMutationResult = Apollo.MutationResult<CreateCustomerTagMutation>;
export type CreateCustomerTagMutationOptions = Apollo.BaseMutationOptions<CreateCustomerTagMutation, CreateCustomerTagMutationVariables>;
export const DeleteCustomerTagDocument = gql`
    mutation DeleteCustomerTag($customerKey: Int!, $tagKey: Int!) {
  customerTagDelete(customerKey: $customerKey, tagKey: $tagKey)
}
    `;
export type DeleteCustomerTagMutationFn = Apollo.MutationFunction<DeleteCustomerTagMutation, DeleteCustomerTagMutationVariables>;

/**
 * __useDeleteCustomerTagMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerTagMutation, { data, loading, error }] = useDeleteCustomerTagMutation({
 *   variables: {
 *      customerKey: // value for 'customerKey'
 *      tagKey: // value for 'tagKey'
 *   },
 * });
 */
export function useDeleteCustomerTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerTagMutation, DeleteCustomerTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerTagMutation, DeleteCustomerTagMutationVariables>(DeleteCustomerTagDocument, options);
      }
export type DeleteCustomerTagMutationHookResult = ReturnType<typeof useDeleteCustomerTagMutation>;
export type DeleteCustomerTagMutationResult = Apollo.MutationResult<DeleteCustomerTagMutation>;
export type DeleteCustomerTagMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerTagMutation, DeleteCustomerTagMutationVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($customerKey: Int!) {
  customerGetSingle(id: $customerKey) {
    customerKey
    name
    dbaName
    description
    creditLimit
    creditNotes
    businessType
    quickBooksName
    deliveryTimeKey
    customerTags {
      tagKey
    }
    address1
    address2
    city
    state
    zipCode
    directions
    isArchived
  }
}
    `;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      customerKey: // value for 'customerKey'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetSingleCustomerDocument = gql`
    query GetSingleCustomer($id: Int!) {
  customerGetSingle(id: $id) {
    ...singleCustomer
  }
}
    ${SingleCustomerFragmentDoc}`;

/**
 * __useGetSingleCustomerQuery__
 *
 * To run a query within a React component, call `useGetSingleCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetSingleCustomerQuery, GetSingleCustomerQueryVariables> & ({ variables: GetSingleCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleCustomerQuery, GetSingleCustomerQueryVariables>(GetSingleCustomerDocument, options);
      }
export function useGetSingleCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleCustomerQuery, GetSingleCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleCustomerQuery, GetSingleCustomerQueryVariables>(GetSingleCustomerDocument, options);
        }
export function useGetSingleCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleCustomerQuery, GetSingleCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleCustomerQuery, GetSingleCustomerQueryVariables>(GetSingleCustomerDocument, options);
        }
export type GetSingleCustomerQueryHookResult = ReturnType<typeof useGetSingleCustomerQuery>;
export type GetSingleCustomerLazyQueryHookResult = ReturnType<typeof useGetSingleCustomerLazyQuery>;
export type GetSingleCustomerSuspenseQueryHookResult = ReturnType<typeof useGetSingleCustomerSuspenseQuery>;
export type GetSingleCustomerQueryResult = Apollo.QueryResult<GetSingleCustomerQuery, GetSingleCustomerQueryVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($id: Int!) {
  locationDelete(id: $id)
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const AllCustomersDocument = gql`
    query AllCustomers($sortObject: [CustomerSortInput!], $filterObject: CustomerFilterInput, $cursor: String!, $pageSize: Int!) {
  customerGetAll(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
  ) {
    ...allCustomerListing
  }
}
    ${AllCustomerListingFragmentDoc}`;

/**
 * __useAllCustomersQuery__
 *
 * To run a query within a React component, call `useAllCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCustomersQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllCustomersQuery(baseOptions: Apollo.QueryHookOptions<AllCustomersQuery, AllCustomersQueryVariables> & ({ variables: AllCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCustomersQuery, AllCustomersQueryVariables>(AllCustomersDocument, options);
      }
export function useAllCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCustomersQuery, AllCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCustomersQuery, AllCustomersQueryVariables>(AllCustomersDocument, options);
        }
export function useAllCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCustomersQuery, AllCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCustomersQuery, AllCustomersQueryVariables>(AllCustomersDocument, options);
        }
export type AllCustomersQueryHookResult = ReturnType<typeof useAllCustomersQuery>;
export type AllCustomersLazyQueryHookResult = ReturnType<typeof useAllCustomersLazyQuery>;
export type AllCustomersSuspenseQueryHookResult = ReturnType<typeof useAllCustomersSuspenseQuery>;
export type AllCustomersQueryResult = Apollo.QueryResult<AllCustomersQuery, AllCustomersQueryVariables>;
export const AllCustomersTagDocument = gql`
    query AllCustomersTag($sortObject: [CustomerSortInput!], $filterObject: CustomerFilterInput, $cursor: String!, $pageSize: Int!, $tag: Int, $location: Int) {
  customersWithFilter(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
    tagKey: $tag
    locationKey: $location
  ) {
    ...customersWithFilterListing
  }
}
    ${CustomersWithFilterListingFragmentDoc}`;

/**
 * __useAllCustomersTagQuery__
 *
 * To run a query within a React component, call `useAllCustomersTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCustomersTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCustomersTagQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *      tag: // value for 'tag'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useAllCustomersTagQuery(baseOptions: Apollo.QueryHookOptions<AllCustomersTagQuery, AllCustomersTagQueryVariables> & ({ variables: AllCustomersTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCustomersTagQuery, AllCustomersTagQueryVariables>(AllCustomersTagDocument, options);
      }
export function useAllCustomersTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCustomersTagQuery, AllCustomersTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCustomersTagQuery, AllCustomersTagQueryVariables>(AllCustomersTagDocument, options);
        }
export function useAllCustomersTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCustomersTagQuery, AllCustomersTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCustomersTagQuery, AllCustomersTagQueryVariables>(AllCustomersTagDocument, options);
        }
export type AllCustomersTagQueryHookResult = ReturnType<typeof useAllCustomersTagQuery>;
export type AllCustomersTagLazyQueryHookResult = ReturnType<typeof useAllCustomersTagLazyQuery>;
export type AllCustomersTagSuspenseQueryHookResult = ReturnType<typeof useAllCustomersTagSuspenseQuery>;
export type AllCustomersTagQueryResult = Apollo.QueryResult<AllCustomersTagQuery, AllCustomersTagQueryVariables>;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($id: Int!) {
  customerDelete(id: $id)
}
    `;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const CreateDirectMarkupDocument = gql`
    mutation CreateDirectMarkup($directMarkup: DirectMarkupInput!) {
  directMarkupCreate(directMarkup: $directMarkup) {
    directMarkupKey
  }
}
    `;
export type CreateDirectMarkupMutationFn = Apollo.MutationFunction<CreateDirectMarkupMutation, CreateDirectMarkupMutationVariables>;

/**
 * __useCreateDirectMarkupMutation__
 *
 * To run a mutation, you first call `useCreateDirectMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectMarkupMutation, { data, loading, error }] = useCreateDirectMarkupMutation({
 *   variables: {
 *      directMarkup: // value for 'directMarkup'
 *   },
 * });
 */
export function useCreateDirectMarkupMutation(baseOptions?: Apollo.MutationHookOptions<CreateDirectMarkupMutation, CreateDirectMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDirectMarkupMutation, CreateDirectMarkupMutationVariables>(CreateDirectMarkupDocument, options);
      }
export type CreateDirectMarkupMutationHookResult = ReturnType<typeof useCreateDirectMarkupMutation>;
export type CreateDirectMarkupMutationResult = Apollo.MutationResult<CreateDirectMarkupMutation>;
export type CreateDirectMarkupMutationOptions = Apollo.BaseMutationOptions<CreateDirectMarkupMutation, CreateDirectMarkupMutationVariables>;
export const EditDirectMarkupDocument = gql`
    mutation EditDirectMarkup($directMarkup: DirectMarkupInput!, $id: Int!) {
  directMarkupUpdate(directMarkupKey: $id, directMarkup: $directMarkup) {
    directMarkupKey
  }
}
    `;
export type EditDirectMarkupMutationFn = Apollo.MutationFunction<EditDirectMarkupMutation, EditDirectMarkupMutationVariables>;

/**
 * __useEditDirectMarkupMutation__
 *
 * To run a mutation, you first call `useEditDirectMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDirectMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDirectMarkupMutation, { data, loading, error }] = useEditDirectMarkupMutation({
 *   variables: {
 *      directMarkup: // value for 'directMarkup'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditDirectMarkupMutation(baseOptions?: Apollo.MutationHookOptions<EditDirectMarkupMutation, EditDirectMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDirectMarkupMutation, EditDirectMarkupMutationVariables>(EditDirectMarkupDocument, options);
      }
export type EditDirectMarkupMutationHookResult = ReturnType<typeof useEditDirectMarkupMutation>;
export type EditDirectMarkupMutationResult = Apollo.MutationResult<EditDirectMarkupMutation>;
export type EditDirectMarkupMutationOptions = Apollo.BaseMutationOptions<EditDirectMarkupMutation, EditDirectMarkupMutationVariables>;
export const GetSingleDirectMarkupDocument = gql`
    query GetSingleDirectMarkup($id: Int!) {
  directMarkupGetSingle(id: $id) {
    ...innerDirectMarkup
  }
}
    ${InnerDirectMarkupFragmentDoc}`;

/**
 * __useGetSingleDirectMarkupQuery__
 *
 * To run a query within a React component, call `useGetSingleDirectMarkupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleDirectMarkupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleDirectMarkupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleDirectMarkupQuery(baseOptions: Apollo.QueryHookOptions<GetSingleDirectMarkupQuery, GetSingleDirectMarkupQueryVariables> & ({ variables: GetSingleDirectMarkupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleDirectMarkupQuery, GetSingleDirectMarkupQueryVariables>(GetSingleDirectMarkupDocument, options);
      }
export function useGetSingleDirectMarkupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleDirectMarkupQuery, GetSingleDirectMarkupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleDirectMarkupQuery, GetSingleDirectMarkupQueryVariables>(GetSingleDirectMarkupDocument, options);
        }
export function useGetSingleDirectMarkupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleDirectMarkupQuery, GetSingleDirectMarkupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleDirectMarkupQuery, GetSingleDirectMarkupQueryVariables>(GetSingleDirectMarkupDocument, options);
        }
export type GetSingleDirectMarkupQueryHookResult = ReturnType<typeof useGetSingleDirectMarkupQuery>;
export type GetSingleDirectMarkupLazyQueryHookResult = ReturnType<typeof useGetSingleDirectMarkupLazyQuery>;
export type GetSingleDirectMarkupSuspenseQueryHookResult = ReturnType<typeof useGetSingleDirectMarkupSuspenseQuery>;
export type GetSingleDirectMarkupQueryResult = Apollo.QueryResult<GetSingleDirectMarkupQuery, GetSingleDirectMarkupQueryVariables>;
export const AllDirectMarkupsDocument = gql`
    query AllDirectMarkups {
  directMarkupGetAll {
    ...allDirectMarkupListing
  }
}
    ${AllDirectMarkupListingFragmentDoc}`;

/**
 * __useAllDirectMarkupsQuery__
 *
 * To run a query within a React component, call `useAllDirectMarkupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDirectMarkupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDirectMarkupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDirectMarkupsQuery(baseOptions?: Apollo.QueryHookOptions<AllDirectMarkupsQuery, AllDirectMarkupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDirectMarkupsQuery, AllDirectMarkupsQueryVariables>(AllDirectMarkupsDocument, options);
      }
export function useAllDirectMarkupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDirectMarkupsQuery, AllDirectMarkupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDirectMarkupsQuery, AllDirectMarkupsQueryVariables>(AllDirectMarkupsDocument, options);
        }
export function useAllDirectMarkupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDirectMarkupsQuery, AllDirectMarkupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDirectMarkupsQuery, AllDirectMarkupsQueryVariables>(AllDirectMarkupsDocument, options);
        }
export type AllDirectMarkupsQueryHookResult = ReturnType<typeof useAllDirectMarkupsQuery>;
export type AllDirectMarkupsLazyQueryHookResult = ReturnType<typeof useAllDirectMarkupsLazyQuery>;
export type AllDirectMarkupsSuspenseQueryHookResult = ReturnType<typeof useAllDirectMarkupsSuspenseQuery>;
export type AllDirectMarkupsQueryResult = Apollo.QueryResult<AllDirectMarkupsQuery, AllDirectMarkupsQueryVariables>;
export const AllFlatDirectMarkupsDocument = gql`
    query AllFlatDirectMarkups($sort: [FlatDirectMarkupSortInput!], $filter: FlatDirectMarkupFilterInput!) {
  flatDirectMarkupGetAll(order: $sort, where: $filter) {
    ...allFlatDirectMarkupListing
  }
}
    ${AllFlatDirectMarkupListingFragmentDoc}`;

/**
 * __useAllFlatDirectMarkupsQuery__
 *
 * To run a query within a React component, call `useAllFlatDirectMarkupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFlatDirectMarkupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFlatDirectMarkupsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllFlatDirectMarkupsQuery(baseOptions: Apollo.QueryHookOptions<AllFlatDirectMarkupsQuery, AllFlatDirectMarkupsQueryVariables> & ({ variables: AllFlatDirectMarkupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFlatDirectMarkupsQuery, AllFlatDirectMarkupsQueryVariables>(AllFlatDirectMarkupsDocument, options);
      }
export function useAllFlatDirectMarkupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFlatDirectMarkupsQuery, AllFlatDirectMarkupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFlatDirectMarkupsQuery, AllFlatDirectMarkupsQueryVariables>(AllFlatDirectMarkupsDocument, options);
        }
export function useAllFlatDirectMarkupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFlatDirectMarkupsQuery, AllFlatDirectMarkupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFlatDirectMarkupsQuery, AllFlatDirectMarkupsQueryVariables>(AllFlatDirectMarkupsDocument, options);
        }
export type AllFlatDirectMarkupsQueryHookResult = ReturnType<typeof useAllFlatDirectMarkupsQuery>;
export type AllFlatDirectMarkupsLazyQueryHookResult = ReturnType<typeof useAllFlatDirectMarkupsLazyQuery>;
export type AllFlatDirectMarkupsSuspenseQueryHookResult = ReturnType<typeof useAllFlatDirectMarkupsSuspenseQuery>;
export type AllFlatDirectMarkupsQueryResult = Apollo.QueryResult<AllFlatDirectMarkupsQuery, AllFlatDirectMarkupsQueryVariables>;
export const DeleteDirectMarkupDocument = gql`
    mutation DeleteDirectMarkup($id: Int!) {
  directMarkupDelete(id: $id)
}
    `;
export type DeleteDirectMarkupMutationFn = Apollo.MutationFunction<DeleteDirectMarkupMutation, DeleteDirectMarkupMutationVariables>;

/**
 * __useDeleteDirectMarkupMutation__
 *
 * To run a mutation, you first call `useDeleteDirectMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDirectMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDirectMarkupMutation, { data, loading, error }] = useDeleteDirectMarkupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDirectMarkupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDirectMarkupMutation, DeleteDirectMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDirectMarkupMutation, DeleteDirectMarkupMutationVariables>(DeleteDirectMarkupDocument, options);
      }
export type DeleteDirectMarkupMutationHookResult = ReturnType<typeof useDeleteDirectMarkupMutation>;
export type DeleteDirectMarkupMutationResult = Apollo.MutationResult<DeleteDirectMarkupMutation>;
export type DeleteDirectMarkupMutationOptions = Apollo.BaseMutationOptions<DeleteDirectMarkupMutation, DeleteDirectMarkupMutationVariables>;
export const CreateFileNumberDocument = gql`
    mutation CreateFileNumber($fileNumber: FileNumberInput!) {
  fileNumberCreate(fileNumber: $fileNumber) {
    fileNumberKey
  }
}
    `;
export type CreateFileNumberMutationFn = Apollo.MutationFunction<CreateFileNumberMutation, CreateFileNumberMutationVariables>;

/**
 * __useCreateFileNumberMutation__
 *
 * To run a mutation, you first call `useCreateFileNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileNumberMutation, { data, loading, error }] = useCreateFileNumberMutation({
 *   variables: {
 *      fileNumber: // value for 'fileNumber'
 *   },
 * });
 */
export function useCreateFileNumberMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileNumberMutation, CreateFileNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileNumberMutation, CreateFileNumberMutationVariables>(CreateFileNumberDocument, options);
      }
export type CreateFileNumberMutationHookResult = ReturnType<typeof useCreateFileNumberMutation>;
export type CreateFileNumberMutationResult = Apollo.MutationResult<CreateFileNumberMutation>;
export type CreateFileNumberMutationOptions = Apollo.BaseMutationOptions<CreateFileNumberMutation, CreateFileNumberMutationVariables>;
export const EditFileNumberDocument = gql`
    mutation EditFileNumber($fileNumber: FileNumberInput!, $id: Int!) {
  fileNumberUpdate(fileNumberKey: $id, fileNumber: $fileNumber) {
    fileNumberKey
  }
}
    `;
export type EditFileNumberMutationFn = Apollo.MutationFunction<EditFileNumberMutation, EditFileNumberMutationVariables>;

/**
 * __useEditFileNumberMutation__
 *
 * To run a mutation, you first call `useEditFileNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFileNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFileNumberMutation, { data, loading, error }] = useEditFileNumberMutation({
 *   variables: {
 *      fileNumber: // value for 'fileNumber'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditFileNumberMutation(baseOptions?: Apollo.MutationHookOptions<EditFileNumberMutation, EditFileNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFileNumberMutation, EditFileNumberMutationVariables>(EditFileNumberDocument, options);
      }
export type EditFileNumberMutationHookResult = ReturnType<typeof useEditFileNumberMutation>;
export type EditFileNumberMutationResult = Apollo.MutationResult<EditFileNumberMutation>;
export type EditFileNumberMutationOptions = Apollo.BaseMutationOptions<EditFileNumberMutation, EditFileNumberMutationVariables>;
export const DeleteFileNumberDocument = gql`
    mutation DeleteFileNumber($fileNumberKey: Int!) {
  fileNumberDelete(fileNumberKey: $fileNumberKey)
}
    `;
export type DeleteFileNumberMutationFn = Apollo.MutationFunction<DeleteFileNumberMutation, DeleteFileNumberMutationVariables>;

/**
 * __useDeleteFileNumberMutation__
 *
 * To run a mutation, you first call `useDeleteFileNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileNumberMutation, { data, loading, error }] = useDeleteFileNumberMutation({
 *   variables: {
 *      fileNumberKey: // value for 'fileNumberKey'
 *   },
 * });
 */
export function useDeleteFileNumberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileNumberMutation, DeleteFileNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileNumberMutation, DeleteFileNumberMutationVariables>(DeleteFileNumberDocument, options);
      }
export type DeleteFileNumberMutationHookResult = ReturnType<typeof useDeleteFileNumberMutation>;
export type DeleteFileNumberMutationResult = Apollo.MutationResult<DeleteFileNumberMutation>;
export type DeleteFileNumberMutationOptions = Apollo.BaseMutationOptions<DeleteFileNumberMutation, DeleteFileNumberMutationVariables>;
export const GetSingleFileNumberDocument = gql`
    query GetSingleFileNumber($key: Int!) {
  fileNumberGetSingle(fileNumberKey: $key) {
    ...innerFileNumber
  }
}
    ${InnerFileNumberFragmentDoc}`;

/**
 * __useGetSingleFileNumberQuery__
 *
 * To run a query within a React component, call `useGetSingleFileNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleFileNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleFileNumberQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSingleFileNumberQuery(baseOptions: Apollo.QueryHookOptions<GetSingleFileNumberQuery, GetSingleFileNumberQueryVariables> & ({ variables: GetSingleFileNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleFileNumberQuery, GetSingleFileNumberQueryVariables>(GetSingleFileNumberDocument, options);
      }
export function useGetSingleFileNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleFileNumberQuery, GetSingleFileNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleFileNumberQuery, GetSingleFileNumberQueryVariables>(GetSingleFileNumberDocument, options);
        }
export function useGetSingleFileNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleFileNumberQuery, GetSingleFileNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleFileNumberQuery, GetSingleFileNumberQueryVariables>(GetSingleFileNumberDocument, options);
        }
export type GetSingleFileNumberQueryHookResult = ReturnType<typeof useGetSingleFileNumberQuery>;
export type GetSingleFileNumberLazyQueryHookResult = ReturnType<typeof useGetSingleFileNumberLazyQuery>;
export type GetSingleFileNumberSuspenseQueryHookResult = ReturnType<typeof useGetSingleFileNumberSuspenseQuery>;
export type GetSingleFileNumberQueryResult = Apollo.QueryResult<GetSingleFileNumberQuery, GetSingleFileNumberQueryVariables>;
export const AllFileNumbersDocument = gql`
    query AllFileNumbers($filter: FileNumberFilterInput, $sort: [FileNumberSortInput!]) {
  fileNumberGetAll(where: $filter, order: $sort) {
    ...allFileNumberListing
  }
}
    ${AllFileNumberListingFragmentDoc}`;

/**
 * __useAllFileNumbersQuery__
 *
 * To run a query within a React component, call `useAllFileNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFileNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFileNumbersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAllFileNumbersQuery(baseOptions?: Apollo.QueryHookOptions<AllFileNumbersQuery, AllFileNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFileNumbersQuery, AllFileNumbersQueryVariables>(AllFileNumbersDocument, options);
      }
export function useAllFileNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFileNumbersQuery, AllFileNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFileNumbersQuery, AllFileNumbersQueryVariables>(AllFileNumbersDocument, options);
        }
export function useAllFileNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFileNumbersQuery, AllFileNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFileNumbersQuery, AllFileNumbersQueryVariables>(AllFileNumbersDocument, options);
        }
export type AllFileNumbersQueryHookResult = ReturnType<typeof useAllFileNumbersQuery>;
export type AllFileNumbersLazyQueryHookResult = ReturnType<typeof useAllFileNumbersLazyQuery>;
export type AllFileNumbersSuspenseQueryHookResult = ReturnType<typeof useAllFileNumbersSuspenseQuery>;
export type AllFileNumbersQueryResult = Apollo.QueryResult<AllFileNumbersQuery, AllFileNumbersQueryVariables>;
export const GetAllFlatFileNumbersDocument = gql`
    query GetAllFlatFileNumbers($sort: [FlatFileNumberSortInput!], $filter: FlatFileNumberFilterInput) {
  flatFileNumberGetAll(order: $sort, where: $filter) {
    ...FlatFileNumberListing
  }
}
    ${FlatFileNumberListingFragmentDoc}`;

/**
 * __useGetAllFlatFileNumbersQuery__
 *
 * To run a query within a React component, call `useGetAllFlatFileNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFlatFileNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFlatFileNumbersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllFlatFileNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFlatFileNumbersQuery, GetAllFlatFileNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFlatFileNumbersQuery, GetAllFlatFileNumbersQueryVariables>(GetAllFlatFileNumbersDocument, options);
      }
export function useGetAllFlatFileNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFlatFileNumbersQuery, GetAllFlatFileNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFlatFileNumbersQuery, GetAllFlatFileNumbersQueryVariables>(GetAllFlatFileNumbersDocument, options);
        }
export function useGetAllFlatFileNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFlatFileNumbersQuery, GetAllFlatFileNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFlatFileNumbersQuery, GetAllFlatFileNumbersQueryVariables>(GetAllFlatFileNumbersDocument, options);
        }
export type GetAllFlatFileNumbersQueryHookResult = ReturnType<typeof useGetAllFlatFileNumbersQuery>;
export type GetAllFlatFileNumbersLazyQueryHookResult = ReturnType<typeof useGetAllFlatFileNumbersLazyQuery>;
export type GetAllFlatFileNumbersSuspenseQueryHookResult = ReturnType<typeof useGetAllFlatFileNumbersSuspenseQuery>;
export type GetAllFlatFileNumbersQueryResult = Apollo.QueryResult<GetAllFlatFileNumbersQuery, GetAllFlatFileNumbersQueryVariables>;
export const GetHomeScreenTasksDocument = gql`
    query GetHomeScreenTasks($endOfDayDate: DateTime!) {
  taskGetAll(
    where: {and: [{isComplete: {eq: false}}, {taskDate: {lt: $endOfDayDate}}]}
    order: [{taskDate: ASC}]
  ) {
    ...DisplayTask
  }
}
    ${DisplayTaskFragmentDoc}`;

/**
 * __useGetHomeScreenTasksQuery__
 *
 * To run a query within a React component, call `useGetHomeScreenTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeScreenTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeScreenTasksQuery({
 *   variables: {
 *      endOfDayDate: // value for 'endOfDayDate'
 *   },
 * });
 */
export function useGetHomeScreenTasksQuery(baseOptions: Apollo.QueryHookOptions<GetHomeScreenTasksQuery, GetHomeScreenTasksQueryVariables> & ({ variables: GetHomeScreenTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeScreenTasksQuery, GetHomeScreenTasksQueryVariables>(GetHomeScreenTasksDocument, options);
      }
export function useGetHomeScreenTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeScreenTasksQuery, GetHomeScreenTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeScreenTasksQuery, GetHomeScreenTasksQueryVariables>(GetHomeScreenTasksDocument, options);
        }
export function useGetHomeScreenTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHomeScreenTasksQuery, GetHomeScreenTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeScreenTasksQuery, GetHomeScreenTasksQueryVariables>(GetHomeScreenTasksDocument, options);
        }
export type GetHomeScreenTasksQueryHookResult = ReturnType<typeof useGetHomeScreenTasksQuery>;
export type GetHomeScreenTasksLazyQueryHookResult = ReturnType<typeof useGetHomeScreenTasksLazyQuery>;
export type GetHomeScreenTasksSuspenseQueryHookResult = ReturnType<typeof useGetHomeScreenTasksSuspenseQuery>;
export type GetHomeScreenTasksQueryResult = Apollo.QueryResult<GetHomeScreenTasksQuery, GetHomeScreenTasksQueryVariables>;
export const CreateIndexContractDocument = gql`
    mutation CreateIndexContract($indexContract: IndexContractInput!) {
  indexContractCreate(indexContract: $indexContract) {
    indexContractKey
  }
}
    `;
export type CreateIndexContractMutationFn = Apollo.MutationFunction<CreateIndexContractMutation, CreateIndexContractMutationVariables>;

/**
 * __useCreateIndexContractMutation__
 *
 * To run a mutation, you first call `useCreateIndexContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndexContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndexContractMutation, { data, loading, error }] = useCreateIndexContractMutation({
 *   variables: {
 *      indexContract: // value for 'indexContract'
 *   },
 * });
 */
export function useCreateIndexContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndexContractMutation, CreateIndexContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndexContractMutation, CreateIndexContractMutationVariables>(CreateIndexContractDocument, options);
      }
export type CreateIndexContractMutationHookResult = ReturnType<typeof useCreateIndexContractMutation>;
export type CreateIndexContractMutationResult = Apollo.MutationResult<CreateIndexContractMutation>;
export type CreateIndexContractMutationOptions = Apollo.BaseMutationOptions<CreateIndexContractMutation, CreateIndexContractMutationVariables>;
export const EditIndexContractDocument = gql`
    mutation EditIndexContract($indexContract: IndexContractInput!, $id: Int!) {
  indexContractUpdate(id: $id, indexContract: $indexContract) {
    indexContractKey
  }
}
    `;
export type EditIndexContractMutationFn = Apollo.MutationFunction<EditIndexContractMutation, EditIndexContractMutationVariables>;

/**
 * __useEditIndexContractMutation__
 *
 * To run a mutation, you first call `useEditIndexContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIndexContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIndexContractMutation, { data, loading, error }] = useEditIndexContractMutation({
 *   variables: {
 *      indexContract: // value for 'indexContract'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditIndexContractMutation(baseOptions?: Apollo.MutationHookOptions<EditIndexContractMutation, EditIndexContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIndexContractMutation, EditIndexContractMutationVariables>(EditIndexContractDocument, options);
      }
export type EditIndexContractMutationHookResult = ReturnType<typeof useEditIndexContractMutation>;
export type EditIndexContractMutationResult = Apollo.MutationResult<EditIndexContractMutation>;
export type EditIndexContractMutationOptions = Apollo.BaseMutationOptions<EditIndexContractMutation, EditIndexContractMutationVariables>;
export const GetSingleIndexContractDocument = gql`
    query GetSingleIndexContract($id: Int!) {
  indexContractGetSingle(indexContractKey: $id) {
    ...singleIndexContract
  }
}
    ${SingleIndexContractFragmentDoc}`;

/**
 * __useGetSingleIndexContractQuery__
 *
 * To run a query within a React component, call `useGetSingleIndexContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleIndexContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleIndexContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleIndexContractQuery(baseOptions: Apollo.QueryHookOptions<GetSingleIndexContractQuery, GetSingleIndexContractQueryVariables> & ({ variables: GetSingleIndexContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleIndexContractQuery, GetSingleIndexContractQueryVariables>(GetSingleIndexContractDocument, options);
      }
export function useGetSingleIndexContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleIndexContractQuery, GetSingleIndexContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleIndexContractQuery, GetSingleIndexContractQueryVariables>(GetSingleIndexContractDocument, options);
        }
export function useGetSingleIndexContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleIndexContractQuery, GetSingleIndexContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleIndexContractQuery, GetSingleIndexContractQueryVariables>(GetSingleIndexContractDocument, options);
        }
export type GetSingleIndexContractQueryHookResult = ReturnType<typeof useGetSingleIndexContractQuery>;
export type GetSingleIndexContractLazyQueryHookResult = ReturnType<typeof useGetSingleIndexContractLazyQuery>;
export type GetSingleIndexContractSuspenseQueryHookResult = ReturnType<typeof useGetSingleIndexContractSuspenseQuery>;
export type GetSingleIndexContractQueryResult = Apollo.QueryResult<GetSingleIndexContractQuery, GetSingleIndexContractQueryVariables>;
export const GetAllIndexContractsDocument = gql`
    query GetAllIndexContracts($sortObject: [IndexContractSortInput!], $filterObject: IndexContractFilterInput) {
  indexContractsGetAll(order: $sortObject, where: $filterObject) {
    ...IndexContractListing
  }
}
    ${IndexContractListingFragmentDoc}`;

/**
 * __useGetAllIndexContractsQuery__
 *
 * To run a query within a React component, call `useGetAllIndexContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIndexContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIndexContractsQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *   },
 * });
 */
export function useGetAllIndexContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllIndexContractsQuery, GetAllIndexContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllIndexContractsQuery, GetAllIndexContractsQueryVariables>(GetAllIndexContractsDocument, options);
      }
export function useGetAllIndexContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllIndexContractsQuery, GetAllIndexContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllIndexContractsQuery, GetAllIndexContractsQueryVariables>(GetAllIndexContractsDocument, options);
        }
export function useGetAllIndexContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllIndexContractsQuery, GetAllIndexContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllIndexContractsQuery, GetAllIndexContractsQueryVariables>(GetAllIndexContractsDocument, options);
        }
export type GetAllIndexContractsQueryHookResult = ReturnType<typeof useGetAllIndexContractsQuery>;
export type GetAllIndexContractsLazyQueryHookResult = ReturnType<typeof useGetAllIndexContractsLazyQuery>;
export type GetAllIndexContractsSuspenseQueryHookResult = ReturnType<typeof useGetAllIndexContractsSuspenseQuery>;
export type GetAllIndexContractsQueryResult = Apollo.QueryResult<GetAllIndexContractsQuery, GetAllIndexContractsQueryVariables>;
export const GetAllFlatIndexContractsDocument = gql`
    query GetAllFlatIndexContracts($sort: [FlatIndexContractSortInput!], $filter: FlatIndexContractFilterInput) {
  flatIndexContractGetAll(order: $sort, where: $filter) {
    ...FlatIndexContractListing
  }
}
    ${FlatIndexContractListingFragmentDoc}`;

/**
 * __useGetAllFlatIndexContractsQuery__
 *
 * To run a query within a React component, call `useGetAllFlatIndexContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFlatIndexContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFlatIndexContractsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllFlatIndexContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFlatIndexContractsQuery, GetAllFlatIndexContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFlatIndexContractsQuery, GetAllFlatIndexContractsQueryVariables>(GetAllFlatIndexContractsDocument, options);
      }
export function useGetAllFlatIndexContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFlatIndexContractsQuery, GetAllFlatIndexContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFlatIndexContractsQuery, GetAllFlatIndexContractsQueryVariables>(GetAllFlatIndexContractsDocument, options);
        }
export function useGetAllFlatIndexContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFlatIndexContractsQuery, GetAllFlatIndexContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFlatIndexContractsQuery, GetAllFlatIndexContractsQueryVariables>(GetAllFlatIndexContractsDocument, options);
        }
export type GetAllFlatIndexContractsQueryHookResult = ReturnType<typeof useGetAllFlatIndexContractsQuery>;
export type GetAllFlatIndexContractsLazyQueryHookResult = ReturnType<typeof useGetAllFlatIndexContractsLazyQuery>;
export type GetAllFlatIndexContractsSuspenseQueryHookResult = ReturnType<typeof useGetAllFlatIndexContractsSuspenseQuery>;
export type GetAllFlatIndexContractsQueryResult = Apollo.QueryResult<GetAllFlatIndexContractsQuery, GetAllFlatIndexContractsQueryVariables>;
export const DeleteIndexContractDocument = gql`
    mutation DeleteIndexContract($id: Int!) {
  indexContractDelete(id: $id)
}
    `;
export type DeleteIndexContractMutationFn = Apollo.MutationFunction<DeleteIndexContractMutation, DeleteIndexContractMutationVariables>;

/**
 * __useDeleteIndexContractMutation__
 *
 * To run a mutation, you first call `useDeleteIndexContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndexContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndexContractMutation, { data, loading, error }] = useDeleteIndexContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndexContractMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndexContractMutation, DeleteIndexContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndexContractMutation, DeleteIndexContractMutationVariables>(DeleteIndexContractDocument, options);
      }
export type DeleteIndexContractMutationHookResult = ReturnType<typeof useDeleteIndexContractMutation>;
export type DeleteIndexContractMutationResult = Apollo.MutationResult<DeleteIndexContractMutation>;
export type DeleteIndexContractMutationOptions = Apollo.BaseMutationOptions<DeleteIndexContractMutation, DeleteIndexContractMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($location: LocationInput!) {
  locationCreate(location: $location) {
    locationKey
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const CreateLocationTagDocument = gql`
    mutation CreateLocationTag($locationTag: LocationTagInput!) {
  locationTagCreate(locationTag: $locationTag) {
    locationKey
    tagKey
  }
}
    `;
export type CreateLocationTagMutationFn = Apollo.MutationFunction<CreateLocationTagMutation, CreateLocationTagMutationVariables>;

/**
 * __useCreateLocationTagMutation__
 *
 * To run a mutation, you first call `useCreateLocationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationTagMutation, { data, loading, error }] = useCreateLocationTagMutation({
 *   variables: {
 *      locationTag: // value for 'locationTag'
 *   },
 * });
 */
export function useCreateLocationTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationTagMutation, CreateLocationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationTagMutation, CreateLocationTagMutationVariables>(CreateLocationTagDocument, options);
      }
export type CreateLocationTagMutationHookResult = ReturnType<typeof useCreateLocationTagMutation>;
export type CreateLocationTagMutationResult = Apollo.MutationResult<CreateLocationTagMutation>;
export type CreateLocationTagMutationOptions = Apollo.BaseMutationOptions<CreateLocationTagMutation, CreateLocationTagMutationVariables>;
export const DeleteLocationTagDocument = gql`
    mutation DeleteLocationTag($locationKey: Int!, $tagKey: Int!) {
  locationTagDelete(locationKey: $locationKey, tagKey: $tagKey)
}
    `;
export type DeleteLocationTagMutationFn = Apollo.MutationFunction<DeleteLocationTagMutation, DeleteLocationTagMutationVariables>;

/**
 * __useDeleteLocationTagMutation__
 *
 * To run a mutation, you first call `useDeleteLocationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationTagMutation, { data, loading, error }] = useDeleteLocationTagMutation({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      tagKey: // value for 'tagKey'
 *   },
 * });
 */
export function useDeleteLocationTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationTagMutation, DeleteLocationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationTagMutation, DeleteLocationTagMutationVariables>(DeleteLocationTagDocument, options);
      }
export type DeleteLocationTagMutationHookResult = ReturnType<typeof useDeleteLocationTagMutation>;
export type DeleteLocationTagMutationResult = Apollo.MutationResult<DeleteLocationTagMutation>;
export type DeleteLocationTagMutationOptions = Apollo.BaseMutationOptions<DeleteLocationTagMutation, DeleteLocationTagMutationVariables>;
export const EditLocationDocument = gql`
    mutation EditLocation($location: LocationInput!, $id: Int!) {
  locationUpdate(location: $location, id: $id) {
    locationKey
  }
}
    `;
export type EditLocationMutationFn = Apollo.MutationFunction<EditLocationMutation, EditLocationMutationVariables>;

/**
 * __useEditLocationMutation__
 *
 * To run a mutation, you first call `useEditLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLocationMutation, { data, loading, error }] = useEditLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditLocationMutation(baseOptions?: Apollo.MutationHookOptions<EditLocationMutation, EditLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLocationMutation, EditLocationMutationVariables>(EditLocationDocument, options);
      }
export type EditLocationMutationHookResult = ReturnType<typeof useEditLocationMutation>;
export type EditLocationMutationResult = Apollo.MutationResult<EditLocationMutation>;
export type EditLocationMutationOptions = Apollo.BaseMutationOptions<EditLocationMutation, EditLocationMutationVariables>;
export const RemoveTerminalFromLocationDocument = gql`
    mutation RemoveTerminalFromLocation($locationKey: Int!, $terminalKey: Int!) {
  locationRemoveTerminal(locationKey: $locationKey, terminalKey: $terminalKey)
}
    `;
export type RemoveTerminalFromLocationMutationFn = Apollo.MutationFunction<RemoveTerminalFromLocationMutation, RemoveTerminalFromLocationMutationVariables>;

/**
 * __useRemoveTerminalFromLocationMutation__
 *
 * To run a mutation, you first call `useRemoveTerminalFromLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTerminalFromLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTerminalFromLocationMutation, { data, loading, error }] = useRemoveTerminalFromLocationMutation({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      terminalKey: // value for 'terminalKey'
 *   },
 * });
 */
export function useRemoveTerminalFromLocationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTerminalFromLocationMutation, RemoveTerminalFromLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTerminalFromLocationMutation, RemoveTerminalFromLocationMutationVariables>(RemoveTerminalFromLocationDocument, options);
      }
export type RemoveTerminalFromLocationMutationHookResult = ReturnType<typeof useRemoveTerminalFromLocationMutation>;
export type RemoveTerminalFromLocationMutationResult = Apollo.MutationResult<RemoveTerminalFromLocationMutation>;
export type RemoveTerminalFromLocationMutationOptions = Apollo.BaseMutationOptions<RemoveTerminalFromLocationMutation, RemoveTerminalFromLocationMutationVariables>;
export const GetSingleLocationDocument = gql`
    query GetSingleLocation($locationKey: Int!) {
  locationGetSingle(locationKey: $locationKey) {
    ...SingleLocationFragment
  }
}
    ${SingleLocationFragmentFragmentDoc}`;

/**
 * __useGetSingleLocationQuery__
 *
 * To run a query within a React component, call `useGetSingleLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleLocationQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *   },
 * });
 */
export function useGetSingleLocationQuery(baseOptions: Apollo.QueryHookOptions<GetSingleLocationQuery, GetSingleLocationQueryVariables> & ({ variables: GetSingleLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleLocationQuery, GetSingleLocationQueryVariables>(GetSingleLocationDocument, options);
      }
export function useGetSingleLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleLocationQuery, GetSingleLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleLocationQuery, GetSingleLocationQueryVariables>(GetSingleLocationDocument, options);
        }
export function useGetSingleLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleLocationQuery, GetSingleLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleLocationQuery, GetSingleLocationQueryVariables>(GetSingleLocationDocument, options);
        }
export type GetSingleLocationQueryHookResult = ReturnType<typeof useGetSingleLocationQuery>;
export type GetSingleLocationLazyQueryHookResult = ReturnType<typeof useGetSingleLocationLazyQuery>;
export type GetSingleLocationSuspenseQueryHookResult = ReturnType<typeof useGetSingleLocationSuspenseQuery>;
export type GetSingleLocationQueryResult = Apollo.QueryResult<GetSingleLocationQuery, GetSingleLocationQueryVariables>;
export const AddContactToLocationDocument = gql`
    mutation AddContactToLocation($locationKey: Int!, $contactKey: Int!, $default: Boolean!) {
  addContactToLocation(
    contactKey: $contactKey
    locationKey: $locationKey
    defaultContact: $default
  )
}
    `;
export type AddContactToLocationMutationFn = Apollo.MutationFunction<AddContactToLocationMutation, AddContactToLocationMutationVariables>;

/**
 * __useAddContactToLocationMutation__
 *
 * To run a mutation, you first call `useAddContactToLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactToLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactToLocationMutation, { data, loading, error }] = useAddContactToLocationMutation({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      contactKey: // value for 'contactKey'
 *      default: // value for 'default'
 *   },
 * });
 */
export function useAddContactToLocationMutation(baseOptions?: Apollo.MutationHookOptions<AddContactToLocationMutation, AddContactToLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactToLocationMutation, AddContactToLocationMutationVariables>(AddContactToLocationDocument, options);
      }
export type AddContactToLocationMutationHookResult = ReturnType<typeof useAddContactToLocationMutation>;
export type AddContactToLocationMutationResult = Apollo.MutationResult<AddContactToLocationMutation>;
export type AddContactToLocationMutationOptions = Apollo.BaseMutationOptions<AddContactToLocationMutation, AddContactToLocationMutationVariables>;
export const DefaultContactLocationDocument = gql`
    mutation DefaultContactLocation($locationKey: Int!, $contactKey: Int!, $def: Boolean!) {
  defaultContactLocation(
    locationKey: $locationKey
    contactKey: $contactKey
    def: $def
  )
}
    `;
export type DefaultContactLocationMutationFn = Apollo.MutationFunction<DefaultContactLocationMutation, DefaultContactLocationMutationVariables>;

/**
 * __useDefaultContactLocationMutation__
 *
 * To run a mutation, you first call `useDefaultContactLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefaultContactLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defaultContactLocationMutation, { data, loading, error }] = useDefaultContactLocationMutation({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      contactKey: // value for 'contactKey'
 *      def: // value for 'def'
 *   },
 * });
 */
export function useDefaultContactLocationMutation(baseOptions?: Apollo.MutationHookOptions<DefaultContactLocationMutation, DefaultContactLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DefaultContactLocationMutation, DefaultContactLocationMutationVariables>(DefaultContactLocationDocument, options);
      }
export type DefaultContactLocationMutationHookResult = ReturnType<typeof useDefaultContactLocationMutation>;
export type DefaultContactLocationMutationResult = Apollo.MutationResult<DefaultContactLocationMutation>;
export type DefaultContactLocationMutationOptions = Apollo.BaseMutationOptions<DefaultContactLocationMutation, DefaultContactLocationMutationVariables>;
export const UnlinkContactFromLocationDocument = gql`
    mutation UnlinkContactFromLocation($locationKey: Int!, $contactKey: Int!) {
  unlinkContactFromLocation(locationKey: $locationKey, contactKey: $contactKey)
}
    `;
export type UnlinkContactFromLocationMutationFn = Apollo.MutationFunction<UnlinkContactFromLocationMutation, UnlinkContactFromLocationMutationVariables>;

/**
 * __useUnlinkContactFromLocationMutation__
 *
 * To run a mutation, you first call `useUnlinkContactFromLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkContactFromLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkContactFromLocationMutation, { data, loading, error }] = useUnlinkContactFromLocationMutation({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      contactKey: // value for 'contactKey'
 *   },
 * });
 */
export function useUnlinkContactFromLocationMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkContactFromLocationMutation, UnlinkContactFromLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkContactFromLocationMutation, UnlinkContactFromLocationMutationVariables>(UnlinkContactFromLocationDocument, options);
      }
export type UnlinkContactFromLocationMutationHookResult = ReturnType<typeof useUnlinkContactFromLocationMutation>;
export type UnlinkContactFromLocationMutationResult = Apollo.MutationResult<UnlinkContactFromLocationMutation>;
export type UnlinkContactFromLocationMutationOptions = Apollo.BaseMutationOptions<UnlinkContactFromLocationMutation, UnlinkContactFromLocationMutationVariables>;
export const LatestOrderDocument = gql`
    query LatestOrder($locationKey: Int!) {
  orderGetAll(
    order: [{deliveryDate: DESC}]
    where: {locationKey: {eq: $locationKey}}
    after: "LTE="
    first: 1
  ) {
    ...orderGetAllListing
  }
}
    ${OrderGetAllListingFragmentDoc}`;

/**
 * __useLatestOrderQuery__
 *
 * To run a query within a React component, call `useLatestOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestOrderQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *   },
 * });
 */
export function useLatestOrderQuery(baseOptions: Apollo.QueryHookOptions<LatestOrderQuery, LatestOrderQueryVariables> & ({ variables: LatestOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestOrderQuery, LatestOrderQueryVariables>(LatestOrderDocument, options);
      }
export function useLatestOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestOrderQuery, LatestOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestOrderQuery, LatestOrderQueryVariables>(LatestOrderDocument, options);
        }
export function useLatestOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestOrderQuery, LatestOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestOrderQuery, LatestOrderQueryVariables>(LatestOrderDocument, options);
        }
export type LatestOrderQueryHookResult = ReturnType<typeof useLatestOrderQuery>;
export type LatestOrderLazyQueryHookResult = ReturnType<typeof useLatestOrderLazyQuery>;
export type LatestOrderSuspenseQueryHookResult = ReturnType<typeof useLatestOrderSuspenseQuery>;
export type LatestOrderQueryResult = Apollo.QueryResult<LatestOrderQuery, LatestOrderQueryVariables>;
export const DeleteTankDocument = gql`
    mutation DeleteTank($tankKey: Int!) {
  tankDelete(tankKey: $tankKey)
}
    `;
export type DeleteTankMutationFn = Apollo.MutationFunction<DeleteTankMutation, DeleteTankMutationVariables>;

/**
 * __useDeleteTankMutation__
 *
 * To run a mutation, you first call `useDeleteTankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTankMutation, { data, loading, error }] = useDeleteTankMutation({
 *   variables: {
 *      tankKey: // value for 'tankKey'
 *   },
 * });
 */
export function useDeleteTankMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTankMutation, DeleteTankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTankMutation, DeleteTankMutationVariables>(DeleteTankDocument, options);
      }
export type DeleteTankMutationHookResult = ReturnType<typeof useDeleteTankMutation>;
export type DeleteTankMutationResult = Apollo.MutationResult<DeleteTankMutation>;
export type DeleteTankMutationOptions = Apollo.BaseMutationOptions<DeleteTankMutation, DeleteTankMutationVariables>;
export const AllLocationsDocument = gql`
    query AllLocations($sortObject: [LocationSortInput!], $filterObject: LocationFilterInput, $cursor: String!, $pageSize: Int!) {
  locationGetAll(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
  ) {
    ...allLocationListing
  }
}
    ${AllLocationListingFragmentDoc}`;

/**
 * __useAllLocationsQuery__
 *
 * To run a query within a React component, call `useAllLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationsQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllLocationsQuery(baseOptions: Apollo.QueryHookOptions<AllLocationsQuery, AllLocationsQueryVariables> & ({ variables: AllLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLocationsQuery, AllLocationsQueryVariables>(AllLocationsDocument, options);
      }
export function useAllLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLocationsQuery, AllLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLocationsQuery, AllLocationsQueryVariables>(AllLocationsDocument, options);
        }
export function useAllLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllLocationsQuery, AllLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllLocationsQuery, AllLocationsQueryVariables>(AllLocationsDocument, options);
        }
export type AllLocationsQueryHookResult = ReturnType<typeof useAllLocationsQuery>;
export type AllLocationsLazyQueryHookResult = ReturnType<typeof useAllLocationsLazyQuery>;
export type AllLocationsSuspenseQueryHookResult = ReturnType<typeof useAllLocationsSuspenseQuery>;
export type AllLocationsQueryResult = Apollo.QueryResult<AllLocationsQuery, AllLocationsQueryVariables>;
export const MassMarkupDocument = gql`
    mutation MassMarkup($markupAmount: Float!, $currentMarkup: Float!) {
  massMarkup(markupAmount: $markupAmount, currentMarkup: $currentMarkup)
}
    `;
export type MassMarkupMutationFn = Apollo.MutationFunction<MassMarkupMutation, MassMarkupMutationVariables>;

/**
 * __useMassMarkupMutation__
 *
 * To run a mutation, you first call `useMassMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massMarkupMutation, { data, loading, error }] = useMassMarkupMutation({
 *   variables: {
 *      markupAmount: // value for 'markupAmount'
 *      currentMarkup: // value for 'currentMarkup'
 *   },
 * });
 */
export function useMassMarkupMutation(baseOptions?: Apollo.MutationHookOptions<MassMarkupMutation, MassMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassMarkupMutation, MassMarkupMutationVariables>(MassMarkupDocument, options);
      }
export type MassMarkupMutationHookResult = ReturnType<typeof useMassMarkupMutation>;
export type MassMarkupMutationResult = Apollo.MutationResult<MassMarkupMutation>;
export type MassMarkupMutationOptions = Apollo.BaseMutationOptions<MassMarkupMutation, MassMarkupMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($order: OrderInput!, $copy: Boolean) {
  orderCreate(order: $order, copy: $copy) {
    orderKey
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *      copy: // value for 'copy'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const GetPricingPostingDocument = gql`
    query GetPricingPosting($locationKey: Int!, $postingKey: Int!, $pricingDate: DateTime!, $salesAgreementKey: Int) {
  pricingPostingGet(
    locationKey: $locationKey
    postingKey: $postingKey
    pricingDate: $pricingDate
    salesAgreementKey: $salesAgreementKey
  ) {
    ...pricingListing
  }
}
    ${PricingListingFragmentDoc}`;

/**
 * __useGetPricingPostingQuery__
 *
 * To run a query within a React component, call `useGetPricingPostingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingPostingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingPostingQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      postingKey: // value for 'postingKey'
 *      pricingDate: // value for 'pricingDate'
 *      salesAgreementKey: // value for 'salesAgreementKey'
 *   },
 * });
 */
export function useGetPricingPostingQuery(baseOptions: Apollo.QueryHookOptions<GetPricingPostingQuery, GetPricingPostingQueryVariables> & ({ variables: GetPricingPostingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingPostingQuery, GetPricingPostingQueryVariables>(GetPricingPostingDocument, options);
      }
export function useGetPricingPostingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingPostingQuery, GetPricingPostingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingPostingQuery, GetPricingPostingQueryVariables>(GetPricingPostingDocument, options);
        }
export function useGetPricingPostingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricingPostingQuery, GetPricingPostingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPricingPostingQuery, GetPricingPostingQueryVariables>(GetPricingPostingDocument, options);
        }
export type GetPricingPostingQueryHookResult = ReturnType<typeof useGetPricingPostingQuery>;
export type GetPricingPostingLazyQueryHookResult = ReturnType<typeof useGetPricingPostingLazyQuery>;
export type GetPricingPostingSuspenseQueryHookResult = ReturnType<typeof useGetPricingPostingSuspenseQuery>;
export type GetPricingPostingQueryResult = Apollo.QueryResult<GetPricingPostingQuery, GetPricingPostingQueryVariables>;
export const GetPricingIndexContractDocument = gql`
    query GetPricingIndexContract($locationKey: Int!, $indexContractKey: Int!, $pricingDate: DateTime!, $salesAgreementKey: Int) {
  pricingIndexContractGet(
    locationKey: $locationKey
    indexContractKey: $indexContractKey
    pricingDate: $pricingDate
    salesAgreementKey: $salesAgreementKey
  ) {
    ...pricingListing
  }
}
    ${PricingListingFragmentDoc}`;

/**
 * __useGetPricingIndexContractQuery__
 *
 * To run a query within a React component, call `useGetPricingIndexContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingIndexContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingIndexContractQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      indexContractKey: // value for 'indexContractKey'
 *      pricingDate: // value for 'pricingDate'
 *      salesAgreementKey: // value for 'salesAgreementKey'
 *   },
 * });
 */
export function useGetPricingIndexContractQuery(baseOptions: Apollo.QueryHookOptions<GetPricingIndexContractQuery, GetPricingIndexContractQueryVariables> & ({ variables: GetPricingIndexContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingIndexContractQuery, GetPricingIndexContractQueryVariables>(GetPricingIndexContractDocument, options);
      }
export function useGetPricingIndexContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingIndexContractQuery, GetPricingIndexContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingIndexContractQuery, GetPricingIndexContractQueryVariables>(GetPricingIndexContractDocument, options);
        }
export function useGetPricingIndexContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricingIndexContractQuery, GetPricingIndexContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPricingIndexContractQuery, GetPricingIndexContractQueryVariables>(GetPricingIndexContractDocument, options);
        }
export type GetPricingIndexContractQueryHookResult = ReturnType<typeof useGetPricingIndexContractQuery>;
export type GetPricingIndexContractLazyQueryHookResult = ReturnType<typeof useGetPricingIndexContractLazyQuery>;
export type GetPricingIndexContractSuspenseQueryHookResult = ReturnType<typeof useGetPricingIndexContractSuspenseQuery>;
export type GetPricingIndexContractQueryResult = Apollo.QueryResult<GetPricingIndexContractQuery, GetPricingIndexContractQueryVariables>;
export const GetPricingPrePurchaseAgreementDocument = gql`
    query GetPricingPrePurchaseAgreement($locationKey: Int!, $prePurchaseAgreementKey: Int!, $pricingDate: DateTime!, $salesAgreementKey: Int) {
  pricingPrePurchaseAgreementGet(
    locationKey: $locationKey
    prePurchaseAgreementKey: $prePurchaseAgreementKey
    pricingDate: $pricingDate
    salesAgreementKey: $salesAgreementKey
  ) {
    ...pricingListing
  }
}
    ${PricingListingFragmentDoc}`;

/**
 * __useGetPricingPrePurchaseAgreementQuery__
 *
 * To run a query within a React component, call `useGetPricingPrePurchaseAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingPrePurchaseAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingPrePurchaseAgreementQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      prePurchaseAgreementKey: // value for 'prePurchaseAgreementKey'
 *      pricingDate: // value for 'pricingDate'
 *      salesAgreementKey: // value for 'salesAgreementKey'
 *   },
 * });
 */
export function useGetPricingPrePurchaseAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetPricingPrePurchaseAgreementQuery, GetPricingPrePurchaseAgreementQueryVariables> & ({ variables: GetPricingPrePurchaseAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingPrePurchaseAgreementQuery, GetPricingPrePurchaseAgreementQueryVariables>(GetPricingPrePurchaseAgreementDocument, options);
      }
export function useGetPricingPrePurchaseAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingPrePurchaseAgreementQuery, GetPricingPrePurchaseAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingPrePurchaseAgreementQuery, GetPricingPrePurchaseAgreementQueryVariables>(GetPricingPrePurchaseAgreementDocument, options);
        }
export function useGetPricingPrePurchaseAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricingPrePurchaseAgreementQuery, GetPricingPrePurchaseAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPricingPrePurchaseAgreementQuery, GetPricingPrePurchaseAgreementQueryVariables>(GetPricingPrePurchaseAgreementDocument, options);
        }
export type GetPricingPrePurchaseAgreementQueryHookResult = ReturnType<typeof useGetPricingPrePurchaseAgreementQuery>;
export type GetPricingPrePurchaseAgreementLazyQueryHookResult = ReturnType<typeof useGetPricingPrePurchaseAgreementLazyQuery>;
export type GetPricingPrePurchaseAgreementSuspenseQueryHookResult = ReturnType<typeof useGetPricingPrePurchaseAgreementSuspenseQuery>;
export type GetPricingPrePurchaseAgreementQueryResult = Apollo.QueryResult<GetPricingPrePurchaseAgreementQuery, GetPricingPrePurchaseAgreementQueryVariables>;
export const GetPricingSalesAgreementDocument = gql`
    query GetPricingSalesAgreement($locationKey: Int!, $salesAgreementKey: Int!, $pricingDate: DateTime!) {
  pricingSalesAgreementGet(
    locationKey: $locationKey
    salesAgreementKey: $salesAgreementKey
    pricingDate: $pricingDate
  ) {
    ...pricingListing
  }
}
    ${PricingListingFragmentDoc}`;

/**
 * __useGetPricingSalesAgreementQuery__
 *
 * To run a query within a React component, call `useGetPricingSalesAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingSalesAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingSalesAgreementQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      salesAgreementKey: // value for 'salesAgreementKey'
 *      pricingDate: // value for 'pricingDate'
 *   },
 * });
 */
export function useGetPricingSalesAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetPricingSalesAgreementQuery, GetPricingSalesAgreementQueryVariables> & ({ variables: GetPricingSalesAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingSalesAgreementQuery, GetPricingSalesAgreementQueryVariables>(GetPricingSalesAgreementDocument, options);
      }
export function useGetPricingSalesAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingSalesAgreementQuery, GetPricingSalesAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingSalesAgreementQuery, GetPricingSalesAgreementQueryVariables>(GetPricingSalesAgreementDocument, options);
        }
export function useGetPricingSalesAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricingSalesAgreementQuery, GetPricingSalesAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPricingSalesAgreementQuery, GetPricingSalesAgreementQueryVariables>(GetPricingSalesAgreementDocument, options);
        }
export type GetPricingSalesAgreementQueryHookResult = ReturnType<typeof useGetPricingSalesAgreementQuery>;
export type GetPricingSalesAgreementLazyQueryHookResult = ReturnType<typeof useGetPricingSalesAgreementLazyQuery>;
export type GetPricingSalesAgreementSuspenseQueryHookResult = ReturnType<typeof useGetPricingSalesAgreementSuspenseQuery>;
export type GetPricingSalesAgreementQueryResult = Apollo.QueryResult<GetPricingSalesAgreementQuery, GetPricingSalesAgreementQueryVariables>;
export const GetFreightForOrderDocument = gql`
    query GetFreightForOrder($carrierKey: Int!, $pricingDate: DateTime!, $mileage: Int!, $terminalKey: Int!, $locationKey: Int!) {
  freightForOrderGet(
    carrierKey: $carrierKey
    pricingDate: $pricingDate
    mileage: $mileage
    terminalKey: $terminalKey
    locationKey: $locationKey
  ) {
    carrierRateKey
    rateType
    ratePerGallon
    toll
  }
}
    `;

/**
 * __useGetFreightForOrderQuery__
 *
 * To run a query within a React component, call `useGetFreightForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreightForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreightForOrderQuery({
 *   variables: {
 *      carrierKey: // value for 'carrierKey'
 *      pricingDate: // value for 'pricingDate'
 *      mileage: // value for 'mileage'
 *      terminalKey: // value for 'terminalKey'
 *      locationKey: // value for 'locationKey'
 *   },
 * });
 */
export function useGetFreightForOrderQuery(baseOptions: Apollo.QueryHookOptions<GetFreightForOrderQuery, GetFreightForOrderQueryVariables> & ({ variables: GetFreightForOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreightForOrderQuery, GetFreightForOrderQueryVariables>(GetFreightForOrderDocument, options);
      }
export function useGetFreightForOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreightForOrderQuery, GetFreightForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreightForOrderQuery, GetFreightForOrderQueryVariables>(GetFreightForOrderDocument, options);
        }
export function useGetFreightForOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFreightForOrderQuery, GetFreightForOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFreightForOrderQuery, GetFreightForOrderQueryVariables>(GetFreightForOrderDocument, options);
        }
export type GetFreightForOrderQueryHookResult = ReturnType<typeof useGetFreightForOrderQuery>;
export type GetFreightForOrderLazyQueryHookResult = ReturnType<typeof useGetFreightForOrderLazyQuery>;
export type GetFreightForOrderSuspenseQueryHookResult = ReturnType<typeof useGetFreightForOrderSuspenseQuery>;
export type GetFreightForOrderQueryResult = Apollo.QueryResult<GetFreightForOrderQuery, GetFreightForOrderQueryVariables>;
export const GetStateTaxesForOrderDocument = gql`
    query GetStateTaxesForOrder($state: String, $pricingDate: DateTime!) {
  stateTaxGetForStateOnDate(state: $state, date: $pricingDate) {
    stateTaxKey
    amount
    stateTaxType
  }
}
    `;

/**
 * __useGetStateTaxesForOrderQuery__
 *
 * To run a query within a React component, call `useGetStateTaxesForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateTaxesForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateTaxesForOrderQuery({
 *   variables: {
 *      state: // value for 'state'
 *      pricingDate: // value for 'pricingDate'
 *   },
 * });
 */
export function useGetStateTaxesForOrderQuery(baseOptions: Apollo.QueryHookOptions<GetStateTaxesForOrderQuery, GetStateTaxesForOrderQueryVariables> & ({ variables: GetStateTaxesForOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateTaxesForOrderQuery, GetStateTaxesForOrderQueryVariables>(GetStateTaxesForOrderDocument, options);
      }
export function useGetStateTaxesForOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateTaxesForOrderQuery, GetStateTaxesForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateTaxesForOrderQuery, GetStateTaxesForOrderQueryVariables>(GetStateTaxesForOrderDocument, options);
        }
export function useGetStateTaxesForOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStateTaxesForOrderQuery, GetStateTaxesForOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStateTaxesForOrderQuery, GetStateTaxesForOrderQueryVariables>(GetStateTaxesForOrderDocument, options);
        }
export type GetStateTaxesForOrderQueryHookResult = ReturnType<typeof useGetStateTaxesForOrderQuery>;
export type GetStateTaxesForOrderLazyQueryHookResult = ReturnType<typeof useGetStateTaxesForOrderLazyQuery>;
export type GetStateTaxesForOrderSuspenseQueryHookResult = ReturnType<typeof useGetStateTaxesForOrderSuspenseQuery>;
export type GetStateTaxesForOrderQueryResult = Apollo.QueryResult<GetStateTaxesForOrderQuery, GetStateTaxesForOrderQueryVariables>;
export const GetStateTaxesForLocationDocument = gql`
    query GetStateTaxesForLocation($locationKey: Int!, $pricingDate: DateTime!) {
  stateTaxGetForLocationOnDate(locationKey: $locationKey, date: $pricingDate) {
    stateTaxKey
    amount
    stateTaxType
  }
}
    `;

/**
 * __useGetStateTaxesForLocationQuery__
 *
 * To run a query within a React component, call `useGetStateTaxesForLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateTaxesForLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateTaxesForLocationQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      pricingDate: // value for 'pricingDate'
 *   },
 * });
 */
export function useGetStateTaxesForLocationQuery(baseOptions: Apollo.QueryHookOptions<GetStateTaxesForLocationQuery, GetStateTaxesForLocationQueryVariables> & ({ variables: GetStateTaxesForLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateTaxesForLocationQuery, GetStateTaxesForLocationQueryVariables>(GetStateTaxesForLocationDocument, options);
      }
export function useGetStateTaxesForLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateTaxesForLocationQuery, GetStateTaxesForLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateTaxesForLocationQuery, GetStateTaxesForLocationQueryVariables>(GetStateTaxesForLocationDocument, options);
        }
export function useGetStateTaxesForLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStateTaxesForLocationQuery, GetStateTaxesForLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStateTaxesForLocationQuery, GetStateTaxesForLocationQueryVariables>(GetStateTaxesForLocationDocument, options);
        }
export type GetStateTaxesForLocationQueryHookResult = ReturnType<typeof useGetStateTaxesForLocationQuery>;
export type GetStateTaxesForLocationLazyQueryHookResult = ReturnType<typeof useGetStateTaxesForLocationLazyQuery>;
export type GetStateTaxesForLocationSuspenseQueryHookResult = ReturnType<typeof useGetStateTaxesForLocationSuspenseQuery>;
export type GetStateTaxesForLocationQueryResult = Apollo.QueryResult<GetStateTaxesForLocationQuery, GetStateTaxesForLocationQueryVariables>;
export const GetLocationSingleForOrderCreationDocument = gql`
    query GetLocationSingleForOrderCreation($locationKey: Int!) {
  locationGetSingle(locationKey: $locationKey) {
    isFobCustomer
    customer {
      deliveryTimeKey
    }
  }
}
    `;

/**
 * __useGetLocationSingleForOrderCreationQuery__
 *
 * To run a query within a React component, call `useGetLocationSingleForOrderCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSingleForOrderCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSingleForOrderCreationQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *   },
 * });
 */
export function useGetLocationSingleForOrderCreationQuery(baseOptions: Apollo.QueryHookOptions<GetLocationSingleForOrderCreationQuery, GetLocationSingleForOrderCreationQueryVariables> & ({ variables: GetLocationSingleForOrderCreationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationSingleForOrderCreationQuery, GetLocationSingleForOrderCreationQueryVariables>(GetLocationSingleForOrderCreationDocument, options);
      }
export function useGetLocationSingleForOrderCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSingleForOrderCreationQuery, GetLocationSingleForOrderCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationSingleForOrderCreationQuery, GetLocationSingleForOrderCreationQueryVariables>(GetLocationSingleForOrderCreationDocument, options);
        }
export function useGetLocationSingleForOrderCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationSingleForOrderCreationQuery, GetLocationSingleForOrderCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationSingleForOrderCreationQuery, GetLocationSingleForOrderCreationQueryVariables>(GetLocationSingleForOrderCreationDocument, options);
        }
export type GetLocationSingleForOrderCreationQueryHookResult = ReturnType<typeof useGetLocationSingleForOrderCreationQuery>;
export type GetLocationSingleForOrderCreationLazyQueryHookResult = ReturnType<typeof useGetLocationSingleForOrderCreationLazyQuery>;
export type GetLocationSingleForOrderCreationSuspenseQueryHookResult = ReturnType<typeof useGetLocationSingleForOrderCreationSuspenseQuery>;
export type GetLocationSingleForOrderCreationQueryResult = Apollo.QueryResult<GetLocationSingleForOrderCreationQuery, GetLocationSingleForOrderCreationQueryVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($order: OrderInput!, $id: Int!) {
  orderUpdate(order: $order, id: $id) {
    orderKey
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($id: Int!) {
  orderDelete(id: $id)
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const DispatchOrderDocument = gql`
    mutation DispatchOrder($id: Int!) {
  orderDispatch(id: $id, sendEmail: false) {
    ...singleOrder
  }
}
    ${SingleOrderFragmentDoc}`;
export type DispatchOrderMutationFn = Apollo.MutationFunction<DispatchOrderMutation, DispatchOrderMutationVariables>;

/**
 * __useDispatchOrderMutation__
 *
 * To run a mutation, you first call `useDispatchOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchOrderMutation, { data, loading, error }] = useDispatchOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDispatchOrderMutation(baseOptions?: Apollo.MutationHookOptions<DispatchOrderMutation, DispatchOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispatchOrderMutation, DispatchOrderMutationVariables>(DispatchOrderDocument, options);
      }
export type DispatchOrderMutationHookResult = ReturnType<typeof useDispatchOrderMutation>;
export type DispatchOrderMutationResult = Apollo.MutationResult<DispatchOrderMutation>;
export type DispatchOrderMutationOptions = Apollo.BaseMutationOptions<DispatchOrderMutation, DispatchOrderMutationVariables>;
export const ReadyForInvoicingOrderDocument = gql`
    mutation ReadyForInvoicingOrder($orderKey: Int!) {
  orderReadyForInvoicing(orderKey: $orderKey)
}
    `;
export type ReadyForInvoicingOrderMutationFn = Apollo.MutationFunction<ReadyForInvoicingOrderMutation, ReadyForInvoicingOrderMutationVariables>;

/**
 * __useReadyForInvoicingOrderMutation__
 *
 * To run a mutation, you first call `useReadyForInvoicingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadyForInvoicingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readyForInvoicingOrderMutation, { data, loading, error }] = useReadyForInvoicingOrderMutation({
 *   variables: {
 *      orderKey: // value for 'orderKey'
 *   },
 * });
 */
export function useReadyForInvoicingOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReadyForInvoicingOrderMutation, ReadyForInvoicingOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadyForInvoicingOrderMutation, ReadyForInvoicingOrderMutationVariables>(ReadyForInvoicingOrderDocument, options);
      }
export type ReadyForInvoicingOrderMutationHookResult = ReturnType<typeof useReadyForInvoicingOrderMutation>;
export type ReadyForInvoicingOrderMutationResult = Apollo.MutationResult<ReadyForInvoicingOrderMutation>;
export type ReadyForInvoicingOrderMutationOptions = Apollo.BaseMutationOptions<ReadyForInvoicingOrderMutation, ReadyForInvoicingOrderMutationVariables>;
export const CloseOrderDocument = gql`
    mutation CloseOrder($id: Int!, $quickbooks: Boolean!) {
  orderClose(id: $id, sendToQuickbooks: $quickbooks) {
    ...singleOrder
  }
}
    ${SingleOrderFragmentDoc}`;
export type CloseOrderMutationFn = Apollo.MutationFunction<CloseOrderMutation, CloseOrderMutationVariables>;

/**
 * __useCloseOrderMutation__
 *
 * To run a mutation, you first call `useCloseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeOrderMutation, { data, loading, error }] = useCloseOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quickbooks: // value for 'quickbooks'
 *   },
 * });
 */
export function useCloseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CloseOrderMutation, CloseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseOrderMutation, CloseOrderMutationVariables>(CloseOrderDocument, options);
      }
export type CloseOrderMutationHookResult = ReturnType<typeof useCloseOrderMutation>;
export type CloseOrderMutationResult = Apollo.MutationResult<CloseOrderMutation>;
export type CloseOrderMutationOptions = Apollo.BaseMutationOptions<CloseOrderMutation, CloseOrderMutationVariables>;
export const SendBackToDispatchedOrderDocument = gql`
    mutation SendBackToDispatchedOrder($id: Int!) {
  orderSendBackToDispatch(id: $id)
}
    `;
export type SendBackToDispatchedOrderMutationFn = Apollo.MutationFunction<SendBackToDispatchedOrderMutation, SendBackToDispatchedOrderMutationVariables>;

/**
 * __useSendBackToDispatchedOrderMutation__
 *
 * To run a mutation, you first call `useSendBackToDispatchedOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBackToDispatchedOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBackToDispatchedOrderMutation, { data, loading, error }] = useSendBackToDispatchedOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendBackToDispatchedOrderMutation(baseOptions?: Apollo.MutationHookOptions<SendBackToDispatchedOrderMutation, SendBackToDispatchedOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBackToDispatchedOrderMutation, SendBackToDispatchedOrderMutationVariables>(SendBackToDispatchedOrderDocument, options);
      }
export type SendBackToDispatchedOrderMutationHookResult = ReturnType<typeof useSendBackToDispatchedOrderMutation>;
export type SendBackToDispatchedOrderMutationResult = Apollo.MutationResult<SendBackToDispatchedOrderMutation>;
export type SendBackToDispatchedOrderMutationOptions = Apollo.BaseMutationOptions<SendBackToDispatchedOrderMutation, SendBackToDispatchedOrderMutationVariables>;
export const GetSingleOrderDocument = gql`
    query GetSingleOrder($id: Int!) {
  orderGetSingle(id: $id) {
    ...singleOrder
  }
}
    ${SingleOrderFragmentDoc}`;

/**
 * __useGetSingleOrderQuery__
 *
 * To run a query within a React component, call `useGetSingleOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleOrderQuery(baseOptions: Apollo.QueryHookOptions<GetSingleOrderQuery, GetSingleOrderQueryVariables> & ({ variables: GetSingleOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleOrderQuery, GetSingleOrderQueryVariables>(GetSingleOrderDocument, options);
      }
export function useGetSingleOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleOrderQuery, GetSingleOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleOrderQuery, GetSingleOrderQueryVariables>(GetSingleOrderDocument, options);
        }
export function useGetSingleOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleOrderQuery, GetSingleOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleOrderQuery, GetSingleOrderQueryVariables>(GetSingleOrderDocument, options);
        }
export type GetSingleOrderQueryHookResult = ReturnType<typeof useGetSingleOrderQuery>;
export type GetSingleOrderLazyQueryHookResult = ReturnType<typeof useGetSingleOrderLazyQuery>;
export type GetSingleOrderSuspenseQueryHookResult = ReturnType<typeof useGetSingleOrderSuspenseQuery>;
export type GetSingleOrderQueryResult = Apollo.QueryResult<GetSingleOrderQuery, GetSingleOrderQueryVariables>;
export const RefreshOrderPricingDocument = gql`
    mutation RefreshOrderPricing($orderKey: Int!, $date: DateTime!, $pKey: Int, $icKey: Int, $ppaKey: Int, $saKey: Int, $termContractKey: Int) {
  orderRedoPricing(
    orderKey: $orderKey
    date: $date
    postingKey: $pKey
    icKey: $icKey
    ppaKey: $ppaKey
    saKey: $saKey
    termContractKey: $termContractKey
  )
}
    `;
export type RefreshOrderPricingMutationFn = Apollo.MutationFunction<RefreshOrderPricingMutation, RefreshOrderPricingMutationVariables>;

/**
 * __useRefreshOrderPricingMutation__
 *
 * To run a mutation, you first call `useRefreshOrderPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshOrderPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshOrderPricingMutation, { data, loading, error }] = useRefreshOrderPricingMutation({
 *   variables: {
 *      orderKey: // value for 'orderKey'
 *      date: // value for 'date'
 *      pKey: // value for 'pKey'
 *      icKey: // value for 'icKey'
 *      ppaKey: // value for 'ppaKey'
 *      saKey: // value for 'saKey'
 *      termContractKey: // value for 'termContractKey'
 *   },
 * });
 */
export function useRefreshOrderPricingMutation(baseOptions?: Apollo.MutationHookOptions<RefreshOrderPricingMutation, RefreshOrderPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshOrderPricingMutation, RefreshOrderPricingMutationVariables>(RefreshOrderPricingDocument, options);
      }
export type RefreshOrderPricingMutationHookResult = ReturnType<typeof useRefreshOrderPricingMutation>;
export type RefreshOrderPricingMutationResult = Apollo.MutationResult<RefreshOrderPricingMutation>;
export type RefreshOrderPricingMutationOptions = Apollo.BaseMutationOptions<RefreshOrderPricingMutation, RefreshOrderPricingMutationVariables>;
export const AllOrdersDocument = gql`
    query AllOrders($sortObject: [OrderSortInput!], $filterObject: OrderFilterInput, $cursor: String!, $pageSize: Int!) {
  orderGetAll(
    order: $sortObject
    where: $filterObject
    after: $cursor
    first: $pageSize
  ) {
    ...orderGetAllListing
  }
}
    ${OrderGetAllListingFragmentDoc}`;

/**
 * __useAllOrdersQuery__
 *
 * To run a query within a React component, call `useAllOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrdersQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllOrdersQuery(baseOptions: Apollo.QueryHookOptions<AllOrdersQuery, AllOrdersQueryVariables> & ({ variables: AllOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllOrdersQuery, AllOrdersQueryVariables>(AllOrdersDocument, options);
      }
export function useAllOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllOrdersQuery, AllOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllOrdersQuery, AllOrdersQueryVariables>(AllOrdersDocument, options);
        }
export function useAllOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllOrdersQuery, AllOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllOrdersQuery, AllOrdersQueryVariables>(AllOrdersDocument, options);
        }
export type AllOrdersQueryHookResult = ReturnType<typeof useAllOrdersQuery>;
export type AllOrdersLazyQueryHookResult = ReturnType<typeof useAllOrdersLazyQuery>;
export type AllOrdersSuspenseQueryHookResult = ReturnType<typeof useAllOrdersSuspenseQuery>;
export type AllOrdersQueryResult = Apollo.QueryResult<AllOrdersQuery, AllOrdersQueryVariables>;
export const DashboardOrderDocument = gql`
    query DashboardOrder($notPaidOrders: Boolean, $sortObject: [OrderSortInput!], $filterObject: OrderFilterInput, $cursor: String!, $pageSize: Int!, $status: OrderStatus!, $customer: String, $terminal: String, $carrier: String, $supplier: String, $customSort: String, $customOrder: String) {
  orderDashboard(
    notPaidOrders: $notPaidOrders
    order: $sortObject
    where: $filterObject
    after: $cursor
    first: $pageSize
    status: $status
    customer: $customer
    terminal: $terminal
    carrier: $carrier
    supplier: $supplier
    sort: $customSort
    sortDirection: $customOrder
  ) {
    ...orderDashboardListing
  }
}
    ${OrderDashboardListingFragmentDoc}`;

/**
 * __useDashboardOrderQuery__
 *
 * To run a query within a React component, call `useDashboardOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardOrderQuery({
 *   variables: {
 *      notPaidOrders: // value for 'notPaidOrders'
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *      status: // value for 'status'
 *      customer: // value for 'customer'
 *      terminal: // value for 'terminal'
 *      carrier: // value for 'carrier'
 *      supplier: // value for 'supplier'
 *      customSort: // value for 'customSort'
 *      customOrder: // value for 'customOrder'
 *   },
 * });
 */
export function useDashboardOrderQuery(baseOptions: Apollo.QueryHookOptions<DashboardOrderQuery, DashboardOrderQueryVariables> & ({ variables: DashboardOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardOrderQuery, DashboardOrderQueryVariables>(DashboardOrderDocument, options);
      }
export function useDashboardOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardOrderQuery, DashboardOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardOrderQuery, DashboardOrderQueryVariables>(DashboardOrderDocument, options);
        }
export function useDashboardOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardOrderQuery, DashboardOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardOrderQuery, DashboardOrderQueryVariables>(DashboardOrderDocument, options);
        }
export type DashboardOrderQueryHookResult = ReturnType<typeof useDashboardOrderQuery>;
export type DashboardOrderLazyQueryHookResult = ReturnType<typeof useDashboardOrderLazyQuery>;
export type DashboardOrderSuspenseQueryHookResult = ReturnType<typeof useDashboardOrderSuspenseQuery>;
export type DashboardOrderQueryResult = Apollo.QueryResult<DashboardOrderQuery, DashboardOrderQueryVariables>;
export const OrderBulkCloseDocument = gql`
    mutation orderBulkClose($ids: [Int!], $sendToQB: Boolean!) {
  orderBulkClose(ids: $ids, sendToQuickbooks: $sendToQB)
}
    `;
export type OrderBulkCloseMutationFn = Apollo.MutationFunction<OrderBulkCloseMutation, OrderBulkCloseMutationVariables>;

/**
 * __useOrderBulkCloseMutation__
 *
 * To run a mutation, you first call `useOrderBulkCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderBulkCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderBulkCloseMutation, { data, loading, error }] = useOrderBulkCloseMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      sendToQB: // value for 'sendToQB'
 *   },
 * });
 */
export function useOrderBulkCloseMutation(baseOptions?: Apollo.MutationHookOptions<OrderBulkCloseMutation, OrderBulkCloseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderBulkCloseMutation, OrderBulkCloseMutationVariables>(OrderBulkCloseDocument, options);
      }
export type OrderBulkCloseMutationHookResult = ReturnType<typeof useOrderBulkCloseMutation>;
export type OrderBulkCloseMutationResult = Apollo.MutationResult<OrderBulkCloseMutation>;
export type OrderBulkCloseMutationOptions = Apollo.BaseMutationOptions<OrderBulkCloseMutation, OrderBulkCloseMutationVariables>;
export const OrderCarrierPaidDocument = gql`
    mutation orderCarrierPaid($orderKey: Int!) {
  orderMarkCarrierPaid(orderKey: $orderKey)
}
    `;
export type OrderCarrierPaidMutationFn = Apollo.MutationFunction<OrderCarrierPaidMutation, OrderCarrierPaidMutationVariables>;

/**
 * __useOrderCarrierPaidMutation__
 *
 * To run a mutation, you first call `useOrderCarrierPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCarrierPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCarrierPaidMutation, { data, loading, error }] = useOrderCarrierPaidMutation({
 *   variables: {
 *      orderKey: // value for 'orderKey'
 *   },
 * });
 */
export function useOrderCarrierPaidMutation(baseOptions?: Apollo.MutationHookOptions<OrderCarrierPaidMutation, OrderCarrierPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCarrierPaidMutation, OrderCarrierPaidMutationVariables>(OrderCarrierPaidDocument, options);
      }
export type OrderCarrierPaidMutationHookResult = ReturnType<typeof useOrderCarrierPaidMutation>;
export type OrderCarrierPaidMutationResult = Apollo.MutationResult<OrderCarrierPaidMutation>;
export type OrderCarrierPaidMutationOptions = Apollo.BaseMutationOptions<OrderCarrierPaidMutation, OrderCarrierPaidMutationVariables>;
export const OrderCarrierAllPaidDocument = gql`
    mutation orderCarrierAllPaid($carrierKey: Int!, $date: DateTime!) {
  orderMarkAllCarrierPaid(carrierKey: $carrierKey, date: $date)
}
    `;
export type OrderCarrierAllPaidMutationFn = Apollo.MutationFunction<OrderCarrierAllPaidMutation, OrderCarrierAllPaidMutationVariables>;

/**
 * __useOrderCarrierAllPaidMutation__
 *
 * To run a mutation, you first call `useOrderCarrierAllPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCarrierAllPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCarrierAllPaidMutation, { data, loading, error }] = useOrderCarrierAllPaidMutation({
 *   variables: {
 *      carrierKey: // value for 'carrierKey'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOrderCarrierAllPaidMutation(baseOptions?: Apollo.MutationHookOptions<OrderCarrierAllPaidMutation, OrderCarrierAllPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCarrierAllPaidMutation, OrderCarrierAllPaidMutationVariables>(OrderCarrierAllPaidDocument, options);
      }
export type OrderCarrierAllPaidMutationHookResult = ReturnType<typeof useOrderCarrierAllPaidMutation>;
export type OrderCarrierAllPaidMutationResult = Apollo.MutationResult<OrderCarrierAllPaidMutation>;
export type OrderCarrierAllPaidMutationOptions = Apollo.BaseMutationOptions<OrderCarrierAllPaidMutation, OrderCarrierAllPaidMutationVariables>;
export const OrderSupplierPaidDocument = gql`
    mutation orderSupplierPaid($orderKey: Int!) {
  orderMarkSupplierPaid(orderKey: $orderKey)
}
    `;
export type OrderSupplierPaidMutationFn = Apollo.MutationFunction<OrderSupplierPaidMutation, OrderSupplierPaidMutationVariables>;

/**
 * __useOrderSupplierPaidMutation__
 *
 * To run a mutation, you first call `useOrderSupplierPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSupplierPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSupplierPaidMutation, { data, loading, error }] = useOrderSupplierPaidMutation({
 *   variables: {
 *      orderKey: // value for 'orderKey'
 *   },
 * });
 */
export function useOrderSupplierPaidMutation(baseOptions?: Apollo.MutationHookOptions<OrderSupplierPaidMutation, OrderSupplierPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSupplierPaidMutation, OrderSupplierPaidMutationVariables>(OrderSupplierPaidDocument, options);
      }
export type OrderSupplierPaidMutationHookResult = ReturnType<typeof useOrderSupplierPaidMutation>;
export type OrderSupplierPaidMutationResult = Apollo.MutationResult<OrderSupplierPaidMutation>;
export type OrderSupplierPaidMutationOptions = Apollo.BaseMutationOptions<OrderSupplierPaidMutation, OrderSupplierPaidMutationVariables>;
export const OrderSupplierAllPaidDocument = gql`
    mutation orderSupplierAllPaid($supplierKey: Int!, $date: DateTime!) {
  orderMarkAllSupplierPaid(supplierKey: $supplierKey, date: $date)
}
    `;
export type OrderSupplierAllPaidMutationFn = Apollo.MutationFunction<OrderSupplierAllPaidMutation, OrderSupplierAllPaidMutationVariables>;

/**
 * __useOrderSupplierAllPaidMutation__
 *
 * To run a mutation, you first call `useOrderSupplierAllPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSupplierAllPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSupplierAllPaidMutation, { data, loading, error }] = useOrderSupplierAllPaidMutation({
 *   variables: {
 *      supplierKey: // value for 'supplierKey'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOrderSupplierAllPaidMutation(baseOptions?: Apollo.MutationHookOptions<OrderSupplierAllPaidMutation, OrderSupplierAllPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSupplierAllPaidMutation, OrderSupplierAllPaidMutationVariables>(OrderSupplierAllPaidDocument, options);
      }
export type OrderSupplierAllPaidMutationHookResult = ReturnType<typeof useOrderSupplierAllPaidMutation>;
export type OrderSupplierAllPaidMutationResult = Apollo.MutationResult<OrderSupplierAllPaidMutation>;
export type OrderSupplierAllPaidMutationOptions = Apollo.BaseMutationOptions<OrderSupplierAllPaidMutation, OrderSupplierAllPaidMutationVariables>;
export const OrderBolAndGallonsDocument = gql`
    mutation orderBolAndGallons($orderKey: Int!, $manifest: String!, $gallons: Int!, $close: Boolean!) {
  orderUpdateBolAndGallons(
    orderKey: $orderKey
    manifest: $manifest
    actualGallons: $gallons
    close: $close
  )
}
    `;
export type OrderBolAndGallonsMutationFn = Apollo.MutationFunction<OrderBolAndGallonsMutation, OrderBolAndGallonsMutationVariables>;

/**
 * __useOrderBolAndGallonsMutation__
 *
 * To run a mutation, you first call `useOrderBolAndGallonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderBolAndGallonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderBolAndGallonsMutation, { data, loading, error }] = useOrderBolAndGallonsMutation({
 *   variables: {
 *      orderKey: // value for 'orderKey'
 *      manifest: // value for 'manifest'
 *      gallons: // value for 'gallons'
 *      close: // value for 'close'
 *   },
 * });
 */
export function useOrderBolAndGallonsMutation(baseOptions?: Apollo.MutationHookOptions<OrderBolAndGallonsMutation, OrderBolAndGallonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderBolAndGallonsMutation, OrderBolAndGallonsMutationVariables>(OrderBolAndGallonsDocument, options);
      }
export type OrderBolAndGallonsMutationHookResult = ReturnType<typeof useOrderBolAndGallonsMutation>;
export type OrderBolAndGallonsMutationResult = Apollo.MutationResult<OrderBolAndGallonsMutation>;
export type OrderBolAndGallonsMutationOptions = Apollo.BaseMutationOptions<OrderBolAndGallonsMutation, OrderBolAndGallonsMutationVariables>;
export const AllPatCostDocument = gql`
    query AllPatCost($sortObject: [PatCostSortInput!], $filterObject: PatCostFilterInput) {
  patCostGetAll(order: $sortObject, where: $filterObject) {
    ...innerPatCost
  }
}
    ${InnerPatCostFragmentDoc}`;

/**
 * __useAllPatCostQuery__
 *
 * To run a query within a React component, call `useAllPatCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPatCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPatCostQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *   },
 * });
 */
export function useAllPatCostQuery(baseOptions?: Apollo.QueryHookOptions<AllPatCostQuery, AllPatCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPatCostQuery, AllPatCostQueryVariables>(AllPatCostDocument, options);
      }
export function useAllPatCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPatCostQuery, AllPatCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPatCostQuery, AllPatCostQueryVariables>(AllPatCostDocument, options);
        }
export function useAllPatCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPatCostQuery, AllPatCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPatCostQuery, AllPatCostQueryVariables>(AllPatCostDocument, options);
        }
export type AllPatCostQueryHookResult = ReturnType<typeof useAllPatCostQuery>;
export type AllPatCostLazyQueryHookResult = ReturnType<typeof useAllPatCostLazyQuery>;
export type AllPatCostSuspenseQueryHookResult = ReturnType<typeof useAllPatCostSuspenseQuery>;
export type AllPatCostQueryResult = Apollo.QueryResult<AllPatCostQuery, AllPatCostQueryVariables>;
export const DeletePatCostDocument = gql`
    mutation DeletePatCost($id: Int!) {
  patCostDelete(id: $id)
}
    `;
export type DeletePatCostMutationFn = Apollo.MutationFunction<DeletePatCostMutation, DeletePatCostMutationVariables>;

/**
 * __useDeletePatCostMutation__
 *
 * To run a mutation, you first call `useDeletePatCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatCostMutation, { data, loading, error }] = useDeletePatCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePatCostMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatCostMutation, DeletePatCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatCostMutation, DeletePatCostMutationVariables>(DeletePatCostDocument, options);
      }
export type DeletePatCostMutationHookResult = ReturnType<typeof useDeletePatCostMutation>;
export type DeletePatCostMutationResult = Apollo.MutationResult<DeletePatCostMutation>;
export type DeletePatCostMutationOptions = Apollo.BaseMutationOptions<DeletePatCostMutation, DeletePatCostMutationVariables>;
export const CreatePatCostDocument = gql`
    mutation CreatePatCost($patCost: PatCostInput!) {
  patCostCreate(patCost: $patCost) {
    patCostKey
  }
}
    `;
export type CreatePatCostMutationFn = Apollo.MutationFunction<CreatePatCostMutation, CreatePatCostMutationVariables>;

/**
 * __useCreatePatCostMutation__
 *
 * To run a mutation, you first call `useCreatePatCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatCostMutation, { data, loading, error }] = useCreatePatCostMutation({
 *   variables: {
 *      patCost: // value for 'patCost'
 *   },
 * });
 */
export function useCreatePatCostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatCostMutation, CreatePatCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatCostMutation, CreatePatCostMutationVariables>(CreatePatCostDocument, options);
      }
export type CreatePatCostMutationHookResult = ReturnType<typeof useCreatePatCostMutation>;
export type CreatePatCostMutationResult = Apollo.MutationResult<CreatePatCostMutation>;
export type CreatePatCostMutationOptions = Apollo.BaseMutationOptions<CreatePatCostMutation, CreatePatCostMutationVariables>;
export const CreatePostingDocument = gql`
    mutation CreatePosting($posting: PostingInput!) {
  postingCreate(posting: $posting) {
    postingKey
  }
}
    `;
export type CreatePostingMutationFn = Apollo.MutationFunction<CreatePostingMutation, CreatePostingMutationVariables>;

/**
 * __useCreatePostingMutation__
 *
 * To run a mutation, you first call `useCreatePostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostingMutation, { data, loading, error }] = useCreatePostingMutation({
 *   variables: {
 *      posting: // value for 'posting'
 *   },
 * });
 */
export function useCreatePostingMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostingMutation, CreatePostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostingMutation, CreatePostingMutationVariables>(CreatePostingDocument, options);
      }
export type CreatePostingMutationHookResult = ReturnType<typeof useCreatePostingMutation>;
export type CreatePostingMutationResult = Apollo.MutationResult<CreatePostingMutation>;
export type CreatePostingMutationOptions = Apollo.BaseMutationOptions<CreatePostingMutation, CreatePostingMutationVariables>;
export const ValidatePostingCreateDocument = gql`
    query ValidatePostingCreate($supplierKey: Int!, $terminalKey: Int!, $effectiveDate: DateTime!) {
  postingValidateCreate(
    supplierKey: $supplierKey
    terminalKey: $terminalKey
    effectiveDate: $effectiveDate
  ) {
    isValid
    errorMessage
    validationType
    suggestedResolution
    canAutoResolve
    conflictingPostings {
      postingKey
      cost
      effectiveDate
      supplier {
        name
      }
      terminal {
        name
      }
    }
  }
}
    `;

/**
 * __useValidatePostingCreateQuery__
 *
 * To run a query within a React component, call `useValidatePostingCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePostingCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePostingCreateQuery({
 *   variables: {
 *      supplierKey: // value for 'supplierKey'
 *      terminalKey: // value for 'terminalKey'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useValidatePostingCreateQuery(baseOptions: Apollo.QueryHookOptions<ValidatePostingCreateQuery, ValidatePostingCreateQueryVariables> & ({ variables: ValidatePostingCreateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePostingCreateQuery, ValidatePostingCreateQueryVariables>(ValidatePostingCreateDocument, options);
      }
export function useValidatePostingCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePostingCreateQuery, ValidatePostingCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePostingCreateQuery, ValidatePostingCreateQueryVariables>(ValidatePostingCreateDocument, options);
        }
export function useValidatePostingCreateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidatePostingCreateQuery, ValidatePostingCreateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidatePostingCreateQuery, ValidatePostingCreateQueryVariables>(ValidatePostingCreateDocument, options);
        }
export type ValidatePostingCreateQueryHookResult = ReturnType<typeof useValidatePostingCreateQuery>;
export type ValidatePostingCreateLazyQueryHookResult = ReturnType<typeof useValidatePostingCreateLazyQuery>;
export type ValidatePostingCreateSuspenseQueryHookResult = ReturnType<typeof useValidatePostingCreateSuspenseQuery>;
export type ValidatePostingCreateQueryResult = Apollo.QueryResult<ValidatePostingCreateQuery, ValidatePostingCreateQueryVariables>;
export const GetRelatedPostingsDocument = gql`
    query GetRelatedPostings($supplierKey: Int!, $terminalKey: Int!) {
  postingGetAll(
    where: {and: [{supplierKey: {eq: $supplierKey}}, {terminalKey: {eq: $terminalKey}}]}
    order: {effectiveDate: DESC}
    first: 5
  ) {
    nodes {
      postingKey
      cost
      effectiveDate
      supplier {
        name
      }
      terminal {
        name
      }
    }
  }
}
    `;

/**
 * __useGetRelatedPostingsQuery__
 *
 * To run a query within a React component, call `useGetRelatedPostingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedPostingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedPostingsQuery({
 *   variables: {
 *      supplierKey: // value for 'supplierKey'
 *      terminalKey: // value for 'terminalKey'
 *   },
 * });
 */
export function useGetRelatedPostingsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedPostingsQuery, GetRelatedPostingsQueryVariables> & ({ variables: GetRelatedPostingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedPostingsQuery, GetRelatedPostingsQueryVariables>(GetRelatedPostingsDocument, options);
      }
export function useGetRelatedPostingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedPostingsQuery, GetRelatedPostingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedPostingsQuery, GetRelatedPostingsQueryVariables>(GetRelatedPostingsDocument, options);
        }
export function useGetRelatedPostingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRelatedPostingsQuery, GetRelatedPostingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRelatedPostingsQuery, GetRelatedPostingsQueryVariables>(GetRelatedPostingsDocument, options);
        }
export type GetRelatedPostingsQueryHookResult = ReturnType<typeof useGetRelatedPostingsQuery>;
export type GetRelatedPostingsLazyQueryHookResult = ReturnType<typeof useGetRelatedPostingsLazyQuery>;
export type GetRelatedPostingsSuspenseQueryHookResult = ReturnType<typeof useGetRelatedPostingsSuspenseQuery>;
export type GetRelatedPostingsQueryResult = Apollo.QueryResult<GetRelatedPostingsQuery, GetRelatedPostingsQueryVariables>;
export const PostingReplaceExistingDocument = gql`
    mutation PostingReplaceExisting($posting: PostingInput!, $existingPostingKey: Int!) {
  postingReplaceExisting(
    posting: $posting
    existingPostingKey: $existingPostingKey
  ) {
    postingKey
  }
}
    `;
export type PostingReplaceExistingMutationFn = Apollo.MutationFunction<PostingReplaceExistingMutation, PostingReplaceExistingMutationVariables>;

/**
 * __usePostingReplaceExistingMutation__
 *
 * To run a mutation, you first call `usePostingReplaceExistingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingReplaceExistingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingReplaceExistingMutation, { data, loading, error }] = usePostingReplaceExistingMutation({
 *   variables: {
 *      posting: // value for 'posting'
 *      existingPostingKey: // value for 'existingPostingKey'
 *   },
 * });
 */
export function usePostingReplaceExistingMutation(baseOptions?: Apollo.MutationHookOptions<PostingReplaceExistingMutation, PostingReplaceExistingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingReplaceExistingMutation, PostingReplaceExistingMutationVariables>(PostingReplaceExistingDocument, options);
      }
export type PostingReplaceExistingMutationHookResult = ReturnType<typeof usePostingReplaceExistingMutation>;
export type PostingReplaceExistingMutationResult = Apollo.MutationResult<PostingReplaceExistingMutation>;
export type PostingReplaceExistingMutationOptions = Apollo.BaseMutationOptions<PostingReplaceExistingMutation, PostingReplaceExistingMutationVariables>;
export const GetSinglePostingDocument = gql`
    query GetSinglePosting($id: Int!) {
  postingGetSingle(id: $id) {
    ...postingInfo
  }
}
    ${PostingInfoFragmentDoc}`;

/**
 * __useGetSinglePostingQuery__
 *
 * To run a query within a React component, call `useGetSinglePostingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSinglePostingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSinglePostingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSinglePostingQuery(baseOptions: Apollo.QueryHookOptions<GetSinglePostingQuery, GetSinglePostingQueryVariables> & ({ variables: GetSinglePostingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSinglePostingQuery, GetSinglePostingQueryVariables>(GetSinglePostingDocument, options);
      }
export function useGetSinglePostingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSinglePostingQuery, GetSinglePostingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSinglePostingQuery, GetSinglePostingQueryVariables>(GetSinglePostingDocument, options);
        }
export function useGetSinglePostingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSinglePostingQuery, GetSinglePostingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSinglePostingQuery, GetSinglePostingQueryVariables>(GetSinglePostingDocument, options);
        }
export type GetSinglePostingQueryHookResult = ReturnType<typeof useGetSinglePostingQuery>;
export type GetSinglePostingLazyQueryHookResult = ReturnType<typeof useGetSinglePostingLazyQuery>;
export type GetSinglePostingSuspenseQueryHookResult = ReturnType<typeof useGetSinglePostingSuspenseQuery>;
export type GetSinglePostingQueryResult = Apollo.QueryResult<GetSinglePostingQuery, GetSinglePostingQueryVariables>;
export const PostingPriceGetHistoryDocument = gql`
    query PostingPriceGetHistory($postingKey: Int!) {
  postingPriceGetHistory(postingKey: $postingKey) {
    ...postingPriceInfo
  }
}
    ${PostingPriceInfoFragmentDoc}`;

/**
 * __usePostingPriceGetHistoryQuery__
 *
 * To run a query within a React component, call `usePostingPriceGetHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostingPriceGetHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostingPriceGetHistoryQuery({
 *   variables: {
 *      postingKey: // value for 'postingKey'
 *   },
 * });
 */
export function usePostingPriceGetHistoryQuery(baseOptions: Apollo.QueryHookOptions<PostingPriceGetHistoryQuery, PostingPriceGetHistoryQueryVariables> & ({ variables: PostingPriceGetHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostingPriceGetHistoryQuery, PostingPriceGetHistoryQueryVariables>(PostingPriceGetHistoryDocument, options);
      }
export function usePostingPriceGetHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostingPriceGetHistoryQuery, PostingPriceGetHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostingPriceGetHistoryQuery, PostingPriceGetHistoryQueryVariables>(PostingPriceGetHistoryDocument, options);
        }
export function usePostingPriceGetHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostingPriceGetHistoryQuery, PostingPriceGetHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostingPriceGetHistoryQuery, PostingPriceGetHistoryQueryVariables>(PostingPriceGetHistoryDocument, options);
        }
export type PostingPriceGetHistoryQueryHookResult = ReturnType<typeof usePostingPriceGetHistoryQuery>;
export type PostingPriceGetHistoryLazyQueryHookResult = ReturnType<typeof usePostingPriceGetHistoryLazyQuery>;
export type PostingPriceGetHistorySuspenseQueryHookResult = ReturnType<typeof usePostingPriceGetHistorySuspenseQuery>;
export type PostingPriceGetHistoryQueryResult = Apollo.QueryResult<PostingPriceGetHistoryQuery, PostingPriceGetHistoryQueryVariables>;
export const PostingPriceCreateOrUpdateDocument = gql`
    mutation PostingPriceCreateOrUpdate($postingPrice: PostingPriceCreateOrUpdateInput!) {
  postingPriceCreateOrUpdate(postingPrice: $postingPrice) {
    ...postingPriceInfo
  }
}
    ${PostingPriceInfoFragmentDoc}`;
export type PostingPriceCreateOrUpdateMutationFn = Apollo.MutationFunction<PostingPriceCreateOrUpdateMutation, PostingPriceCreateOrUpdateMutationVariables>;

/**
 * __usePostingPriceCreateOrUpdateMutation__
 *
 * To run a mutation, you first call `usePostingPriceCreateOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingPriceCreateOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingPriceCreateOrUpdateMutation, { data, loading, error }] = usePostingPriceCreateOrUpdateMutation({
 *   variables: {
 *      postingPrice: // value for 'postingPrice'
 *   },
 * });
 */
export function usePostingPriceCreateOrUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PostingPriceCreateOrUpdateMutation, PostingPriceCreateOrUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingPriceCreateOrUpdateMutation, PostingPriceCreateOrUpdateMutationVariables>(PostingPriceCreateOrUpdateDocument, options);
      }
export type PostingPriceCreateOrUpdateMutationHookResult = ReturnType<typeof usePostingPriceCreateOrUpdateMutation>;
export type PostingPriceCreateOrUpdateMutationResult = Apollo.MutationResult<PostingPriceCreateOrUpdateMutation>;
export type PostingPriceCreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<PostingPriceCreateOrUpdateMutation, PostingPriceCreateOrUpdateMutationVariables>;
export const PostingPriceDeleteDocument = gql`
    mutation PostingPriceDelete($id: Int!) {
  postingPriceDelete(id: $id)
}
    `;
export type PostingPriceDeleteMutationFn = Apollo.MutationFunction<PostingPriceDeleteMutation, PostingPriceDeleteMutationVariables>;

/**
 * __usePostingPriceDeleteMutation__
 *
 * To run a mutation, you first call `usePostingPriceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingPriceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingPriceDeleteMutation, { data, loading, error }] = usePostingPriceDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostingPriceDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PostingPriceDeleteMutation, PostingPriceDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingPriceDeleteMutation, PostingPriceDeleteMutationVariables>(PostingPriceDeleteDocument, options);
      }
export type PostingPriceDeleteMutationHookResult = ReturnType<typeof usePostingPriceDeleteMutation>;
export type PostingPriceDeleteMutationResult = Apollo.MutationResult<PostingPriceDeleteMutation>;
export type PostingPriceDeleteMutationOptions = Apollo.BaseMutationOptions<PostingPriceDeleteMutation, PostingPriceDeleteMutationVariables>;
export const PostingToggleArchivedDocument = gql`
    mutation PostingToggleArchived($postingKey: Int!) {
  postingToggleArchived(postingKey: $postingKey)
}
    `;
export type PostingToggleArchivedMutationFn = Apollo.MutationFunction<PostingToggleArchivedMutation, PostingToggleArchivedMutationVariables>;

/**
 * __usePostingToggleArchivedMutation__
 *
 * To run a mutation, you first call `usePostingToggleArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingToggleArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingToggleArchivedMutation, { data, loading, error }] = usePostingToggleArchivedMutation({
 *   variables: {
 *      postingKey: // value for 'postingKey'
 *   },
 * });
 */
export function usePostingToggleArchivedMutation(baseOptions?: Apollo.MutationHookOptions<PostingToggleArchivedMutation, PostingToggleArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingToggleArchivedMutation, PostingToggleArchivedMutationVariables>(PostingToggleArchivedDocument, options);
      }
export type PostingToggleArchivedMutationHookResult = ReturnType<typeof usePostingToggleArchivedMutation>;
export type PostingToggleArchivedMutationResult = Apollo.MutationResult<PostingToggleArchivedMutation>;
export type PostingToggleArchivedMutationOptions = Apollo.BaseMutationOptions<PostingToggleArchivedMutation, PostingToggleArchivedMutationVariables>;
export const PostingSetArchivedDocument = gql`
    mutation PostingSetArchived($postingKey: Int!, $isArchived: Boolean!) {
  postingSetArchived(postingKey: $postingKey, isArchived: $isArchived)
}
    `;
export type PostingSetArchivedMutationFn = Apollo.MutationFunction<PostingSetArchivedMutation, PostingSetArchivedMutationVariables>;

/**
 * __usePostingSetArchivedMutation__
 *
 * To run a mutation, you first call `usePostingSetArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostingSetArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postingSetArchivedMutation, { data, loading, error }] = usePostingSetArchivedMutation({
 *   variables: {
 *      postingKey: // value for 'postingKey'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function usePostingSetArchivedMutation(baseOptions?: Apollo.MutationHookOptions<PostingSetArchivedMutation, PostingSetArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostingSetArchivedMutation, PostingSetArchivedMutationVariables>(PostingSetArchivedDocument, options);
      }
export type PostingSetArchivedMutationHookResult = ReturnType<typeof usePostingSetArchivedMutation>;
export type PostingSetArchivedMutationResult = Apollo.MutationResult<PostingSetArchivedMutation>;
export type PostingSetArchivedMutationOptions = Apollo.BaseMutationOptions<PostingSetArchivedMutation, PostingSetArchivedMutationVariables>;
export const AllPostingsDocument = gql`
    query AllPostings($sortObject: [PostingSortInput!], $filterObject: PostingFilterInput, $cursor: String!, $pageSize: Int!) {
  postingGetAll(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
  ) {
    ...AllPostingListing
  }
}
    ${AllPostingListingFragmentDoc}`;

/**
 * __useAllPostingsQuery__
 *
 * To run a query within a React component, call `useAllPostingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPostingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPostingsQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllPostingsQuery(baseOptions: Apollo.QueryHookOptions<AllPostingsQuery, AllPostingsQueryVariables> & ({ variables: AllPostingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPostingsQuery, AllPostingsQueryVariables>(AllPostingsDocument, options);
      }
export function useAllPostingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPostingsQuery, AllPostingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPostingsQuery, AllPostingsQueryVariables>(AllPostingsDocument, options);
        }
export function useAllPostingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPostingsQuery, AllPostingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPostingsQuery, AllPostingsQueryVariables>(AllPostingsDocument, options);
        }
export type AllPostingsQueryHookResult = ReturnType<typeof useAllPostingsQuery>;
export type AllPostingsLazyQueryHookResult = ReturnType<typeof useAllPostingsLazyQuery>;
export type AllPostingsSuspenseQueryHookResult = ReturnType<typeof useAllPostingsSuspenseQuery>;
export type AllPostingsQueryResult = Apollo.QueryResult<AllPostingsQuery, AllPostingsQueryVariables>;
export const AllFlatPostingsDocument = gql`
    query AllFlatPostings($sort: [FlatPostingSortInput!], $filter: FlatPostingFilterInput, $cursor: String!, $pageSize: Int!, $showExpired: Boolean!) {
  flatPostingGetAll(
    order: $sort
    where: $filter
    first: $pageSize
    after: $cursor
    showExpired: $showExpired
  ) {
    ...AllFlatPostingListing
  }
}
    ${AllFlatPostingListingFragmentDoc}`;

/**
 * __useAllFlatPostingsQuery__
 *
 * To run a query within a React component, call `useAllFlatPostingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFlatPostingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFlatPostingsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *      showExpired: // value for 'showExpired'
 *   },
 * });
 */
export function useAllFlatPostingsQuery(baseOptions: Apollo.QueryHookOptions<AllFlatPostingsQuery, AllFlatPostingsQueryVariables> & ({ variables: AllFlatPostingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFlatPostingsQuery, AllFlatPostingsQueryVariables>(AllFlatPostingsDocument, options);
      }
export function useAllFlatPostingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFlatPostingsQuery, AllFlatPostingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFlatPostingsQuery, AllFlatPostingsQueryVariables>(AllFlatPostingsDocument, options);
        }
export function useAllFlatPostingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFlatPostingsQuery, AllFlatPostingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFlatPostingsQuery, AllFlatPostingsQueryVariables>(AllFlatPostingsDocument, options);
        }
export type AllFlatPostingsQueryHookResult = ReturnType<typeof useAllFlatPostingsQuery>;
export type AllFlatPostingsLazyQueryHookResult = ReturnType<typeof useAllFlatPostingsLazyQuery>;
export type AllFlatPostingsSuspenseQueryHookResult = ReturnType<typeof useAllFlatPostingsSuspenseQuery>;
export type AllFlatPostingsQueryResult = Apollo.QueryResult<AllFlatPostingsQuery, AllFlatPostingsQueryVariables>;
export const DeletePostingDocument = gql`
    mutation DeletePosting($id: Int!) {
  postingDelete(id: $id)
}
    `;
export type DeletePostingMutationFn = Apollo.MutationFunction<DeletePostingMutation, DeletePostingMutationVariables>;

/**
 * __useDeletePostingMutation__
 *
 * To run a mutation, you first call `useDeletePostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostingMutation, { data, loading, error }] = useDeletePostingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostingMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostingMutation, DeletePostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostingMutation, DeletePostingMutationVariables>(DeletePostingDocument, options);
      }
export type DeletePostingMutationHookResult = ReturnType<typeof useDeletePostingMutation>;
export type DeletePostingMutationResult = Apollo.MutationResult<DeletePostingMutation>;
export type DeletePostingMutationOptions = Apollo.BaseMutationOptions<DeletePostingMutation, DeletePostingMutationVariables>;
export const TogglePostingArchivedDocument = gql`
    mutation TogglePostingArchived($postingKey: Int!) {
  postingToggleArchived(postingKey: $postingKey)
}
    `;
export type TogglePostingArchivedMutationFn = Apollo.MutationFunction<TogglePostingArchivedMutation, TogglePostingArchivedMutationVariables>;

/**
 * __useTogglePostingArchivedMutation__
 *
 * To run a mutation, you first call `useTogglePostingArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePostingArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePostingArchivedMutation, { data, loading, error }] = useTogglePostingArchivedMutation({
 *   variables: {
 *      postingKey: // value for 'postingKey'
 *   },
 * });
 */
export function useTogglePostingArchivedMutation(baseOptions?: Apollo.MutationHookOptions<TogglePostingArchivedMutation, TogglePostingArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePostingArchivedMutation, TogglePostingArchivedMutationVariables>(TogglePostingArchivedDocument, options);
      }
export type TogglePostingArchivedMutationHookResult = ReturnType<typeof useTogglePostingArchivedMutation>;
export type TogglePostingArchivedMutationResult = Apollo.MutationResult<TogglePostingArchivedMutation>;
export type TogglePostingArchivedMutationOptions = Apollo.BaseMutationOptions<TogglePostingArchivedMutation, TogglePostingArchivedMutationVariables>;
export const CreatePrePurchaseAgreementDocument = gql`
    mutation CreatePrePurchaseAgreement($prePurchaseAgreement: PrePurchaseAgreementInput!) {
  prePurchaseAgreementCreate(prePurchaseAgreement: $prePurchaseAgreement) {
    prePurchaseAgreementKey
  }
}
    `;
export type CreatePrePurchaseAgreementMutationFn = Apollo.MutationFunction<CreatePrePurchaseAgreementMutation, CreatePrePurchaseAgreementMutationVariables>;

/**
 * __useCreatePrePurchaseAgreementMutation__
 *
 * To run a mutation, you first call `useCreatePrePurchaseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrePurchaseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrePurchaseAgreementMutation, { data, loading, error }] = useCreatePrePurchaseAgreementMutation({
 *   variables: {
 *      prePurchaseAgreement: // value for 'prePurchaseAgreement'
 *   },
 * });
 */
export function useCreatePrePurchaseAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrePurchaseAgreementMutation, CreatePrePurchaseAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrePurchaseAgreementMutation, CreatePrePurchaseAgreementMutationVariables>(CreatePrePurchaseAgreementDocument, options);
      }
export type CreatePrePurchaseAgreementMutationHookResult = ReturnType<typeof useCreatePrePurchaseAgreementMutation>;
export type CreatePrePurchaseAgreementMutationResult = Apollo.MutationResult<CreatePrePurchaseAgreementMutation>;
export type CreatePrePurchaseAgreementMutationOptions = Apollo.BaseMutationOptions<CreatePrePurchaseAgreementMutation, CreatePrePurchaseAgreementMutationVariables>;
export const DeletePrePurchaseAgreementSalesAgreementByPrePurchaseDocument = gql`
    mutation DeletePrePurchaseAgreementSalesAgreementByPrePurchase($id: Int!) {
  prePurchaseAgreementSalesAgreementDeleteByPrePurchase(id: $id)
}
    `;
export type DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationFn = Apollo.MutationFunction<DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation, DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationVariables>;

/**
 * __useDeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation__
 *
 * To run a mutation, you first call `useDeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation, { data, loading, error }] = useDeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation, DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation, DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationVariables>(DeletePrePurchaseAgreementSalesAgreementByPrePurchaseDocument, options);
      }
export type DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationHookResult = ReturnType<typeof useDeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation>;
export type DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationResult = Apollo.MutationResult<DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation>;
export type DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationOptions = Apollo.BaseMutationOptions<DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutation, DeletePrePurchaseAgreementSalesAgreementByPrePurchaseMutationVariables>;
export const EditPrePurchaseAgreementDocument = gql`
    mutation EditPrePurchaseAgreement($prePurchaseAgreement: PrePurchaseAgreementInput!, $id: Int!) {
  prePurchaseAgreementUpdate(prePurchaseAgreement: $prePurchaseAgreement, id: $id) {
    prePurchaseAgreementKey
  }
}
    `;
export type EditPrePurchaseAgreementMutationFn = Apollo.MutationFunction<EditPrePurchaseAgreementMutation, EditPrePurchaseAgreementMutationVariables>;

/**
 * __useEditPrePurchaseAgreementMutation__
 *
 * To run a mutation, you first call `useEditPrePurchaseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPrePurchaseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPrePurchaseAgreementMutation, { data, loading, error }] = useEditPrePurchaseAgreementMutation({
 *   variables: {
 *      prePurchaseAgreement: // value for 'prePurchaseAgreement'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditPrePurchaseAgreementMutation(baseOptions?: Apollo.MutationHookOptions<EditPrePurchaseAgreementMutation, EditPrePurchaseAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPrePurchaseAgreementMutation, EditPrePurchaseAgreementMutationVariables>(EditPrePurchaseAgreementDocument, options);
      }
export type EditPrePurchaseAgreementMutationHookResult = ReturnType<typeof useEditPrePurchaseAgreementMutation>;
export type EditPrePurchaseAgreementMutationResult = Apollo.MutationResult<EditPrePurchaseAgreementMutation>;
export type EditPrePurchaseAgreementMutationOptions = Apollo.BaseMutationOptions<EditPrePurchaseAgreementMutation, EditPrePurchaseAgreementMutationVariables>;
export const GetSinglePrePurchaseAgreementDocument = gql`
    query GetSinglePrePurchaseAgreement($prePurchaseAgreementKey: Int!) {
  prePurchaseAgreementGetSingle(prePurchaseAgreementKey: $prePurchaseAgreementKey) {
    ...singlePrePurchaseAgreement
  }
}
    ${SinglePrePurchaseAgreementFragmentDoc}`;

/**
 * __useGetSinglePrePurchaseAgreementQuery__
 *
 * To run a query within a React component, call `useGetSinglePrePurchaseAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSinglePrePurchaseAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSinglePrePurchaseAgreementQuery({
 *   variables: {
 *      prePurchaseAgreementKey: // value for 'prePurchaseAgreementKey'
 *   },
 * });
 */
export function useGetSinglePrePurchaseAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetSinglePrePurchaseAgreementQuery, GetSinglePrePurchaseAgreementQueryVariables> & ({ variables: GetSinglePrePurchaseAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSinglePrePurchaseAgreementQuery, GetSinglePrePurchaseAgreementQueryVariables>(GetSinglePrePurchaseAgreementDocument, options);
      }
export function useGetSinglePrePurchaseAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSinglePrePurchaseAgreementQuery, GetSinglePrePurchaseAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSinglePrePurchaseAgreementQuery, GetSinglePrePurchaseAgreementQueryVariables>(GetSinglePrePurchaseAgreementDocument, options);
        }
export function useGetSinglePrePurchaseAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSinglePrePurchaseAgreementQuery, GetSinglePrePurchaseAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSinglePrePurchaseAgreementQuery, GetSinglePrePurchaseAgreementQueryVariables>(GetSinglePrePurchaseAgreementDocument, options);
        }
export type GetSinglePrePurchaseAgreementQueryHookResult = ReturnType<typeof useGetSinglePrePurchaseAgreementQuery>;
export type GetSinglePrePurchaseAgreementLazyQueryHookResult = ReturnType<typeof useGetSinglePrePurchaseAgreementLazyQuery>;
export type GetSinglePrePurchaseAgreementSuspenseQueryHookResult = ReturnType<typeof useGetSinglePrePurchaseAgreementSuspenseQuery>;
export type GetSinglePrePurchaseAgreementQueryResult = Apollo.QueryResult<GetSinglePrePurchaseAgreementQuery, GetSinglePrePurchaseAgreementQueryVariables>;
export const AllPrePurchaseAgreementDocument = gql`
    query AllPrePurchaseAgreement($sortObject: [PrePurchaseAgreementSortInput!], $filterObject: PrePurchaseAgreementFilterInput, $cursor: String!, $pageSize: Int!) {
  prePurchaseAgreementGetAll(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
  ) {
    ...allPrePurchaseAgreementListing
  }
}
    ${AllPrePurchaseAgreementListingFragmentDoc}`;

/**
 * __useAllPrePurchaseAgreementQuery__
 *
 * To run a query within a React component, call `useAllPrePurchaseAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPrePurchaseAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPrePurchaseAgreementQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllPrePurchaseAgreementQuery(baseOptions: Apollo.QueryHookOptions<AllPrePurchaseAgreementQuery, AllPrePurchaseAgreementQueryVariables> & ({ variables: AllPrePurchaseAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPrePurchaseAgreementQuery, AllPrePurchaseAgreementQueryVariables>(AllPrePurchaseAgreementDocument, options);
      }
export function useAllPrePurchaseAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPrePurchaseAgreementQuery, AllPrePurchaseAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPrePurchaseAgreementQuery, AllPrePurchaseAgreementQueryVariables>(AllPrePurchaseAgreementDocument, options);
        }
export function useAllPrePurchaseAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPrePurchaseAgreementQuery, AllPrePurchaseAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPrePurchaseAgreementQuery, AllPrePurchaseAgreementQueryVariables>(AllPrePurchaseAgreementDocument, options);
        }
export type AllPrePurchaseAgreementQueryHookResult = ReturnType<typeof useAllPrePurchaseAgreementQuery>;
export type AllPrePurchaseAgreementLazyQueryHookResult = ReturnType<typeof useAllPrePurchaseAgreementLazyQuery>;
export type AllPrePurchaseAgreementSuspenseQueryHookResult = ReturnType<typeof useAllPrePurchaseAgreementSuspenseQuery>;
export type AllPrePurchaseAgreementQueryResult = Apollo.QueryResult<AllPrePurchaseAgreementQuery, AllPrePurchaseAgreementQueryVariables>;
export const AllFlatPrePurchaseAgreementDocument = gql`
    query AllFlatPrePurchaseAgreement($sort: [FlatPrePurchaseAgreementSortInput!], $filter: FlatPrePurchaseAgreementFilterInput, $cursor: String!, $pageSize: Int!) {
  flatPrePurchaseAgreementGetAll(
    order: $sort
    where: $filter
    first: $pageSize
    after: $cursor
  ) {
    ...allFlatPrePurchaseAgreementListing
  }
}
    ${AllFlatPrePurchaseAgreementListingFragmentDoc}`;

/**
 * __useAllFlatPrePurchaseAgreementQuery__
 *
 * To run a query within a React component, call `useAllFlatPrePurchaseAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFlatPrePurchaseAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFlatPrePurchaseAgreementQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllFlatPrePurchaseAgreementQuery(baseOptions: Apollo.QueryHookOptions<AllFlatPrePurchaseAgreementQuery, AllFlatPrePurchaseAgreementQueryVariables> & ({ variables: AllFlatPrePurchaseAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFlatPrePurchaseAgreementQuery, AllFlatPrePurchaseAgreementQueryVariables>(AllFlatPrePurchaseAgreementDocument, options);
      }
export function useAllFlatPrePurchaseAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFlatPrePurchaseAgreementQuery, AllFlatPrePurchaseAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFlatPrePurchaseAgreementQuery, AllFlatPrePurchaseAgreementQueryVariables>(AllFlatPrePurchaseAgreementDocument, options);
        }
export function useAllFlatPrePurchaseAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFlatPrePurchaseAgreementQuery, AllFlatPrePurchaseAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFlatPrePurchaseAgreementQuery, AllFlatPrePurchaseAgreementQueryVariables>(AllFlatPrePurchaseAgreementDocument, options);
        }
export type AllFlatPrePurchaseAgreementQueryHookResult = ReturnType<typeof useAllFlatPrePurchaseAgreementQuery>;
export type AllFlatPrePurchaseAgreementLazyQueryHookResult = ReturnType<typeof useAllFlatPrePurchaseAgreementLazyQuery>;
export type AllFlatPrePurchaseAgreementSuspenseQueryHookResult = ReturnType<typeof useAllFlatPrePurchaseAgreementSuspenseQuery>;
export type AllFlatPrePurchaseAgreementQueryResult = Apollo.QueryResult<AllFlatPrePurchaseAgreementQuery, AllFlatPrePurchaseAgreementQueryVariables>;
export const DeletePrePurchaseAgreementDocument = gql`
    mutation DeletePrePurchaseAgreement($id: Int!) {
  prePurchaseAgreementDelete(id: $id)
}
    `;
export type DeletePrePurchaseAgreementMutationFn = Apollo.MutationFunction<DeletePrePurchaseAgreementMutation, DeletePrePurchaseAgreementMutationVariables>;

/**
 * __useDeletePrePurchaseAgreementMutation__
 *
 * To run a mutation, you first call `useDeletePrePurchaseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrePurchaseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrePurchaseAgreementMutation, { data, loading, error }] = useDeletePrePurchaseAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePrePurchaseAgreementMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrePurchaseAgreementMutation, DeletePrePurchaseAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrePurchaseAgreementMutation, DeletePrePurchaseAgreementMutationVariables>(DeletePrePurchaseAgreementDocument, options);
      }
export type DeletePrePurchaseAgreementMutationHookResult = ReturnType<typeof useDeletePrePurchaseAgreementMutation>;
export type DeletePrePurchaseAgreementMutationResult = Apollo.MutationResult<DeletePrePurchaseAgreementMutation>;
export type DeletePrePurchaseAgreementMutationOptions = Apollo.BaseMutationOptions<DeletePrePurchaseAgreementMutation, DeletePrePurchaseAgreementMutationVariables>;
export const QuickbooksAuthorizationDocument = gql`
    query QuickbooksAuthorization {
  quickBooksAuthorizationUrl
}
    `;

/**
 * __useQuickbooksAuthorizationQuery__
 *
 * To run a query within a React component, call `useQuickbooksAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbooksAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbooksAuthorizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuickbooksAuthorizationQuery(baseOptions?: Apollo.QueryHookOptions<QuickbooksAuthorizationQuery, QuickbooksAuthorizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickbooksAuthorizationQuery, QuickbooksAuthorizationQueryVariables>(QuickbooksAuthorizationDocument, options);
      }
export function useQuickbooksAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickbooksAuthorizationQuery, QuickbooksAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickbooksAuthorizationQuery, QuickbooksAuthorizationQueryVariables>(QuickbooksAuthorizationDocument, options);
        }
export function useQuickbooksAuthorizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickbooksAuthorizationQuery, QuickbooksAuthorizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickbooksAuthorizationQuery, QuickbooksAuthorizationQueryVariables>(QuickbooksAuthorizationDocument, options);
        }
export type QuickbooksAuthorizationQueryHookResult = ReturnType<typeof useQuickbooksAuthorizationQuery>;
export type QuickbooksAuthorizationLazyQueryHookResult = ReturnType<typeof useQuickbooksAuthorizationLazyQuery>;
export type QuickbooksAuthorizationSuspenseQueryHookResult = ReturnType<typeof useQuickbooksAuthorizationSuspenseQuery>;
export type QuickbooksAuthorizationQueryResult = Apollo.QueryResult<QuickbooksAuthorizationQuery, QuickbooksAuthorizationQueryVariables>;
export const QuickBooksTokenExchangeDocument = gql`
    mutation QuickBooksTokenExchange($authCode: String!, $realmId: String!) {
  quickBooksTokenExchange(authCode: $authCode, realmId: $realmId)
}
    `;
export type QuickBooksTokenExchangeMutationFn = Apollo.MutationFunction<QuickBooksTokenExchangeMutation, QuickBooksTokenExchangeMutationVariables>;

/**
 * __useQuickBooksTokenExchangeMutation__
 *
 * To run a mutation, you first call `useQuickBooksTokenExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuickBooksTokenExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quickBooksTokenExchangeMutation, { data, loading, error }] = useQuickBooksTokenExchangeMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      realmId: // value for 'realmId'
 *   },
 * });
 */
export function useQuickBooksTokenExchangeMutation(baseOptions?: Apollo.MutationHookOptions<QuickBooksTokenExchangeMutation, QuickBooksTokenExchangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuickBooksTokenExchangeMutation, QuickBooksTokenExchangeMutationVariables>(QuickBooksTokenExchangeDocument, options);
      }
export type QuickBooksTokenExchangeMutationHookResult = ReturnType<typeof useQuickBooksTokenExchangeMutation>;
export type QuickBooksTokenExchangeMutationResult = Apollo.MutationResult<QuickBooksTokenExchangeMutation>;
export type QuickBooksTokenExchangeMutationOptions = Apollo.BaseMutationOptions<QuickBooksTokenExchangeMutation, QuickBooksTokenExchangeMutationVariables>;
export const AllGallonsByStateDocument = gql`
    query AllGallonsByState($sort: [DispatchedShippedOrderSortInput!], $filter: DispatchedShippedOrderFilterInput, $startDate: DateTime!, $endDate: DateTime!) {
  dispatchedShippedOrdersReport(
    order: $sort
    where: $filter
    endDate: $endDate
    startDate: $startDate
  ) {
    ...gallonsByState
  }
}
    ${GallonsByStateFragmentDoc}`;

/**
 * __useAllGallonsByStateQuery__
 *
 * To run a query within a React component, call `useAllGallonsByStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGallonsByStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGallonsByStateQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAllGallonsByStateQuery(baseOptions: Apollo.QueryHookOptions<AllGallonsByStateQuery, AllGallonsByStateQueryVariables> & ({ variables: AllGallonsByStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGallonsByStateQuery, AllGallonsByStateQueryVariables>(AllGallonsByStateDocument, options);
      }
export function useAllGallonsByStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGallonsByStateQuery, AllGallonsByStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGallonsByStateQuery, AllGallonsByStateQueryVariables>(AllGallonsByStateDocument, options);
        }
export function useAllGallonsByStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllGallonsByStateQuery, AllGallonsByStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllGallonsByStateQuery, AllGallonsByStateQueryVariables>(AllGallonsByStateDocument, options);
        }
export type AllGallonsByStateQueryHookResult = ReturnType<typeof useAllGallonsByStateQuery>;
export type AllGallonsByStateLazyQueryHookResult = ReturnType<typeof useAllGallonsByStateLazyQuery>;
export type AllGallonsByStateSuspenseQueryHookResult = ReturnType<typeof useAllGallonsByStateSuspenseQuery>;
export type AllGallonsByStateQueryResult = Apollo.QueryResult<AllGallonsByStateQuery, AllGallonsByStateQueryVariables>;
export const MonthlyContractReportDocument = gql`
    query MonthlyContractReport($startDate: DateTime!, $filter: MonthlyCVReportFilterInput, $sort: [MonthlyCVReportSortInput!]) {
  monthlyCVReport(startDate: $startDate, where: $filter, order: $sort) {
    ...monthlyCvReportListing
  }
}
    ${MonthlyCvReportListingFragmentDoc}`;

/**
 * __useMonthlyContractReportQuery__
 *
 * To run a query within a React component, call `useMonthlyContractReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyContractReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyContractReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMonthlyContractReportQuery(baseOptions: Apollo.QueryHookOptions<MonthlyContractReportQuery, MonthlyContractReportQueryVariables> & ({ variables: MonthlyContractReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthlyContractReportQuery, MonthlyContractReportQueryVariables>(MonthlyContractReportDocument, options);
      }
export function useMonthlyContractReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyContractReportQuery, MonthlyContractReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthlyContractReportQuery, MonthlyContractReportQueryVariables>(MonthlyContractReportDocument, options);
        }
export function useMonthlyContractReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MonthlyContractReportQuery, MonthlyContractReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MonthlyContractReportQuery, MonthlyContractReportQueryVariables>(MonthlyContractReportDocument, options);
        }
export type MonthlyContractReportQueryHookResult = ReturnType<typeof useMonthlyContractReportQuery>;
export type MonthlyContractReportLazyQueryHookResult = ReturnType<typeof useMonthlyContractReportLazyQuery>;
export type MonthlyContractReportSuspenseQueryHookResult = ReturnType<typeof useMonthlyContractReportSuspenseQuery>;
export type MonthlyContractReportQueryResult = Apollo.QueryResult<MonthlyContractReportQuery, MonthlyContractReportQueryVariables>;
export const AllShippedDispatchedOrdersDocument = gql`
    query AllShippedDispatchedOrders($sort: [DispatchedShippedOrderSortInput!], $filter: DispatchedShippedOrderFilterInput, $startDate: DateTime!, $endDate: DateTime!) {
  dispatchedShippedOrdersReport(
    order: $sort
    where: $filter
    startDate: $startDate
    endDate: $endDate
  ) {
    ...dispatchedShippedOrders
  }
}
    ${DispatchedShippedOrdersFragmentDoc}`;

/**
 * __useAllShippedDispatchedOrdersQuery__
 *
 * To run a query within a React component, call `useAllShippedDispatchedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShippedDispatchedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllShippedDispatchedOrdersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAllShippedDispatchedOrdersQuery(baseOptions: Apollo.QueryHookOptions<AllShippedDispatchedOrdersQuery, AllShippedDispatchedOrdersQueryVariables> & ({ variables: AllShippedDispatchedOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllShippedDispatchedOrdersQuery, AllShippedDispatchedOrdersQueryVariables>(AllShippedDispatchedOrdersDocument, options);
      }
export function useAllShippedDispatchedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllShippedDispatchedOrdersQuery, AllShippedDispatchedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllShippedDispatchedOrdersQuery, AllShippedDispatchedOrdersQueryVariables>(AllShippedDispatchedOrdersDocument, options);
        }
export function useAllShippedDispatchedOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllShippedDispatchedOrdersQuery, AllShippedDispatchedOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllShippedDispatchedOrdersQuery, AllShippedDispatchedOrdersQueryVariables>(AllShippedDispatchedOrdersDocument, options);
        }
export type AllShippedDispatchedOrdersQueryHookResult = ReturnType<typeof useAllShippedDispatchedOrdersQuery>;
export type AllShippedDispatchedOrdersLazyQueryHookResult = ReturnType<typeof useAllShippedDispatchedOrdersLazyQuery>;
export type AllShippedDispatchedOrdersSuspenseQueryHookResult = ReturnType<typeof useAllShippedDispatchedOrdersSuspenseQuery>;
export type AllShippedDispatchedOrdersQueryResult = Apollo.QueryResult<AllShippedDispatchedOrdersQuery, AllShippedDispatchedOrdersQueryVariables>;
export const AllShippedDispatchedOrderDetailsDocument = gql`
    query AllShippedDispatchedOrderDetails($sort: [DispatchedShippedOrderSortInput!], $filter: DispatchedShippedOrderFilterInput, $startDate: DateTime!, $endDate: DateTime!) {
  dispatchedShippedOrdersReport(
    order: $sort
    where: $filter
    startDate: $startDate
    endDate: $endDate
  ) {
    ...shippedDispatchedOrderDetails
  }
}
    ${ShippedDispatchedOrderDetailsFragmentDoc}`;

/**
 * __useAllShippedDispatchedOrderDetailsQuery__
 *
 * To run a query within a React component, call `useAllShippedDispatchedOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShippedDispatchedOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllShippedDispatchedOrderDetailsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAllShippedDispatchedOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<AllShippedDispatchedOrderDetailsQuery, AllShippedDispatchedOrderDetailsQueryVariables> & ({ variables: AllShippedDispatchedOrderDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllShippedDispatchedOrderDetailsQuery, AllShippedDispatchedOrderDetailsQueryVariables>(AllShippedDispatchedOrderDetailsDocument, options);
      }
export function useAllShippedDispatchedOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllShippedDispatchedOrderDetailsQuery, AllShippedDispatchedOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllShippedDispatchedOrderDetailsQuery, AllShippedDispatchedOrderDetailsQueryVariables>(AllShippedDispatchedOrderDetailsDocument, options);
        }
export function useAllShippedDispatchedOrderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllShippedDispatchedOrderDetailsQuery, AllShippedDispatchedOrderDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllShippedDispatchedOrderDetailsQuery, AllShippedDispatchedOrderDetailsQueryVariables>(AllShippedDispatchedOrderDetailsDocument, options);
        }
export type AllShippedDispatchedOrderDetailsQueryHookResult = ReturnType<typeof useAllShippedDispatchedOrderDetailsQuery>;
export type AllShippedDispatchedOrderDetailsLazyQueryHookResult = ReturnType<typeof useAllShippedDispatchedOrderDetailsLazyQuery>;
export type AllShippedDispatchedOrderDetailsSuspenseQueryHookResult = ReturnType<typeof useAllShippedDispatchedOrderDetailsSuspenseQuery>;
export type AllShippedDispatchedOrderDetailsQueryResult = Apollo.QueryResult<AllShippedDispatchedOrderDetailsQuery, AllShippedDispatchedOrderDetailsQueryVariables>;
export const AllTasksByDateDocument = gql`
    query AllTasksByDate($sort: [TaskReportSortInput!], $filter: TaskReportFilterInput, $startDate: DateTime!, $endDate: DateTime!) {
  tasksByDate(
    order: $sort
    where: $filter
    startDate: $startDate
    endDate: $endDate
  ) {
    ...taskReportListing
  }
}
    ${TaskReportListingFragmentDoc}`;

/**
 * __useAllTasksByDateQuery__
 *
 * To run a query within a React component, call `useAllTasksByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTasksByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTasksByDateQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAllTasksByDateQuery(baseOptions: Apollo.QueryHookOptions<AllTasksByDateQuery, AllTasksByDateQueryVariables> & ({ variables: AllTasksByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTasksByDateQuery, AllTasksByDateQueryVariables>(AllTasksByDateDocument, options);
      }
export function useAllTasksByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTasksByDateQuery, AllTasksByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTasksByDateQuery, AllTasksByDateQueryVariables>(AllTasksByDateDocument, options);
        }
export function useAllTasksByDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTasksByDateQuery, AllTasksByDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTasksByDateQuery, AllTasksByDateQueryVariables>(AllTasksByDateDocument, options);
        }
export type AllTasksByDateQueryHookResult = ReturnType<typeof useAllTasksByDateQuery>;
export type AllTasksByDateLazyQueryHookResult = ReturnType<typeof useAllTasksByDateLazyQuery>;
export type AllTasksByDateSuspenseQueryHookResult = ReturnType<typeof useAllTasksByDateSuspenseQuery>;
export type AllTasksByDateQueryResult = Apollo.QueryResult<AllTasksByDateQuery, AllTasksByDateQueryVariables>;
export const CreateSalesAgreementDocument = gql`
    mutation CreateSalesAgreement($salesAgreement: SalesAgreementInput!) {
  salesAgreementCreate(salesAgreement: $salesAgreement) {
    salesAgreementKey
  }
}
    `;
export type CreateSalesAgreementMutationFn = Apollo.MutationFunction<CreateSalesAgreementMutation, CreateSalesAgreementMutationVariables>;

/**
 * __useCreateSalesAgreementMutation__
 *
 * To run a mutation, you first call `useCreateSalesAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesAgreementMutation, { data, loading, error }] = useCreateSalesAgreementMutation({
 *   variables: {
 *      salesAgreement: // value for 'salesAgreement'
 *   },
 * });
 */
export function useCreateSalesAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalesAgreementMutation, CreateSalesAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalesAgreementMutation, CreateSalesAgreementMutationVariables>(CreateSalesAgreementDocument, options);
      }
export type CreateSalesAgreementMutationHookResult = ReturnType<typeof useCreateSalesAgreementMutation>;
export type CreateSalesAgreementMutationResult = Apollo.MutationResult<CreateSalesAgreementMutation>;
export type CreateSalesAgreementMutationOptions = Apollo.BaseMutationOptions<CreateSalesAgreementMutation, CreateSalesAgreementMutationVariables>;
export const CreateSalesAgreementLocationDocument = gql`
    mutation CreateSalesAgreementLocation($salesAgreementLocation: SalesAgreementLocationInput!) {
  salesAgreementLocationCreate(salesAgreementLocation: $salesAgreementLocation) {
    salesAgreementKey
    locationKey
  }
}
    `;
export type CreateSalesAgreementLocationMutationFn = Apollo.MutationFunction<CreateSalesAgreementLocationMutation, CreateSalesAgreementLocationMutationVariables>;

/**
 * __useCreateSalesAgreementLocationMutation__
 *
 * To run a mutation, you first call `useCreateSalesAgreementLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesAgreementLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesAgreementLocationMutation, { data, loading, error }] = useCreateSalesAgreementLocationMutation({
 *   variables: {
 *      salesAgreementLocation: // value for 'salesAgreementLocation'
 *   },
 * });
 */
export function useCreateSalesAgreementLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalesAgreementLocationMutation, CreateSalesAgreementLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalesAgreementLocationMutation, CreateSalesAgreementLocationMutationVariables>(CreateSalesAgreementLocationDocument, options);
      }
export type CreateSalesAgreementLocationMutationHookResult = ReturnType<typeof useCreateSalesAgreementLocationMutation>;
export type CreateSalesAgreementLocationMutationResult = Apollo.MutationResult<CreateSalesAgreementLocationMutation>;
export type CreateSalesAgreementLocationMutationOptions = Apollo.BaseMutationOptions<CreateSalesAgreementLocationMutation, CreateSalesAgreementLocationMutationVariables>;
export const EditSalesAgreementDocument = gql`
    mutation EditSalesAgreement($salesAgreement: SalesAgreementInput!, $id: Int!) {
  salesAgreementUpdate(salesAgreement: $salesAgreement, id: $id) {
    salesAgreementKey
  }
}
    `;
export type EditSalesAgreementMutationFn = Apollo.MutationFunction<EditSalesAgreementMutation, EditSalesAgreementMutationVariables>;

/**
 * __useEditSalesAgreementMutation__
 *
 * To run a mutation, you first call `useEditSalesAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSalesAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSalesAgreementMutation, { data, loading, error }] = useEditSalesAgreementMutation({
 *   variables: {
 *      salesAgreement: // value for 'salesAgreement'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditSalesAgreementMutation(baseOptions?: Apollo.MutationHookOptions<EditSalesAgreementMutation, EditSalesAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSalesAgreementMutation, EditSalesAgreementMutationVariables>(EditSalesAgreementDocument, options);
      }
export type EditSalesAgreementMutationHookResult = ReturnType<typeof useEditSalesAgreementMutation>;
export type EditSalesAgreementMutationResult = Apollo.MutationResult<EditSalesAgreementMutation>;
export type EditSalesAgreementMutationOptions = Apollo.BaseMutationOptions<EditSalesAgreementMutation, EditSalesAgreementMutationVariables>;
export const DeleteSalesAgreementLocationDocument = gql`
    mutation DeleteSalesAgreementLocation($id: Int!) {
  salesAgreementLocationDeleteBySalesAgreementKey(salesAgreementKey: $id)
}
    `;
export type DeleteSalesAgreementLocationMutationFn = Apollo.MutationFunction<DeleteSalesAgreementLocationMutation, DeleteSalesAgreementLocationMutationVariables>;

/**
 * __useDeleteSalesAgreementLocationMutation__
 *
 * To run a mutation, you first call `useDeleteSalesAgreementLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesAgreementLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesAgreementLocationMutation, { data, loading, error }] = useDeleteSalesAgreementLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSalesAgreementLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesAgreementLocationMutation, DeleteSalesAgreementLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesAgreementLocationMutation, DeleteSalesAgreementLocationMutationVariables>(DeleteSalesAgreementLocationDocument, options);
      }
export type DeleteSalesAgreementLocationMutationHookResult = ReturnType<typeof useDeleteSalesAgreementLocationMutation>;
export type DeleteSalesAgreementLocationMutationResult = Apollo.MutationResult<DeleteSalesAgreementLocationMutation>;
export type DeleteSalesAgreementLocationMutationOptions = Apollo.BaseMutationOptions<DeleteSalesAgreementLocationMutation, DeleteSalesAgreementLocationMutationVariables>;
export const DeleteSalesAgreementDocument = gql`
    mutation DeleteSalesAgreement($id: Int!) {
  salesAgreementDelete(id: $id)
}
    `;
export type DeleteSalesAgreementMutationFn = Apollo.MutationFunction<DeleteSalesAgreementMutation, DeleteSalesAgreementMutationVariables>;

/**
 * __useDeleteSalesAgreementMutation__
 *
 * To run a mutation, you first call `useDeleteSalesAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesAgreementMutation, { data, loading, error }] = useDeleteSalesAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSalesAgreementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesAgreementMutation, DeleteSalesAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesAgreementMutation, DeleteSalesAgreementMutationVariables>(DeleteSalesAgreementDocument, options);
      }
export type DeleteSalesAgreementMutationHookResult = ReturnType<typeof useDeleteSalesAgreementMutation>;
export type DeleteSalesAgreementMutationResult = Apollo.MutationResult<DeleteSalesAgreementMutation>;
export type DeleteSalesAgreementMutationOptions = Apollo.BaseMutationOptions<DeleteSalesAgreementMutation, DeleteSalesAgreementMutationVariables>;
export const DeleteLinkedSalesAgreementsDocument = gql`
    mutation DeleteLinkedSalesAgreements($id: Int!) {
  linkedSalesAgreementDelete(id: $id)
}
    `;
export type DeleteLinkedSalesAgreementsMutationFn = Apollo.MutationFunction<DeleteLinkedSalesAgreementsMutation, DeleteLinkedSalesAgreementsMutationVariables>;

/**
 * __useDeleteLinkedSalesAgreementsMutation__
 *
 * To run a mutation, you first call `useDeleteLinkedSalesAgreementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLinkedSalesAgreementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLinkedSalesAgreementsMutation, { data, loading, error }] = useDeleteLinkedSalesAgreementsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLinkedSalesAgreementsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLinkedSalesAgreementsMutation, DeleteLinkedSalesAgreementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLinkedSalesAgreementsMutation, DeleteLinkedSalesAgreementsMutationVariables>(DeleteLinkedSalesAgreementsDocument, options);
      }
export type DeleteLinkedSalesAgreementsMutationHookResult = ReturnType<typeof useDeleteLinkedSalesAgreementsMutation>;
export type DeleteLinkedSalesAgreementsMutationResult = Apollo.MutationResult<DeleteLinkedSalesAgreementsMutation>;
export type DeleteLinkedSalesAgreementsMutationOptions = Apollo.BaseMutationOptions<DeleteLinkedSalesAgreementsMutation, DeleteLinkedSalesAgreementsMutationVariables>;
export const CreateLinkedSalesAgreementDocument = gql`
    mutation CreateLinkedSalesAgreement($linkedSalesAgreement: LinkedSalesAgreementInput!) {
  linkedSalesAgreementCreate(linkedSalesAgreement: $linkedSalesAgreement) {
    relatedToSalesAgreementKey
    relatedFromSalesAgreementKey
  }
}
    `;
export type CreateLinkedSalesAgreementMutationFn = Apollo.MutationFunction<CreateLinkedSalesAgreementMutation, CreateLinkedSalesAgreementMutationVariables>;

/**
 * __useCreateLinkedSalesAgreementMutation__
 *
 * To run a mutation, you first call `useCreateLinkedSalesAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkedSalesAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkedSalesAgreementMutation, { data, loading, error }] = useCreateLinkedSalesAgreementMutation({
 *   variables: {
 *      linkedSalesAgreement: // value for 'linkedSalesAgreement'
 *   },
 * });
 */
export function useCreateLinkedSalesAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkedSalesAgreementMutation, CreateLinkedSalesAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkedSalesAgreementMutation, CreateLinkedSalesAgreementMutationVariables>(CreateLinkedSalesAgreementDocument, options);
      }
export type CreateLinkedSalesAgreementMutationHookResult = ReturnType<typeof useCreateLinkedSalesAgreementMutation>;
export type CreateLinkedSalesAgreementMutationResult = Apollo.MutationResult<CreateLinkedSalesAgreementMutation>;
export type CreateLinkedSalesAgreementMutationOptions = Apollo.BaseMutationOptions<CreateLinkedSalesAgreementMutation, CreateLinkedSalesAgreementMutationVariables>;
export const DeletePrePurchaseAgreementSalesAgreementDocument = gql`
    mutation DeletePrePurchaseAgreementSalesAgreement($id: Int!) {
  prePurchaseAgreementSalesAgreementDelete(id: $id)
}
    `;
export type DeletePrePurchaseAgreementSalesAgreementMutationFn = Apollo.MutationFunction<DeletePrePurchaseAgreementSalesAgreementMutation, DeletePrePurchaseAgreementSalesAgreementMutationVariables>;

/**
 * __useDeletePrePurchaseAgreementSalesAgreementMutation__
 *
 * To run a mutation, you first call `useDeletePrePurchaseAgreementSalesAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrePurchaseAgreementSalesAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrePurchaseAgreementSalesAgreementMutation, { data, loading, error }] = useDeletePrePurchaseAgreementSalesAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePrePurchaseAgreementSalesAgreementMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrePurchaseAgreementSalesAgreementMutation, DeletePrePurchaseAgreementSalesAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrePurchaseAgreementSalesAgreementMutation, DeletePrePurchaseAgreementSalesAgreementMutationVariables>(DeletePrePurchaseAgreementSalesAgreementDocument, options);
      }
export type DeletePrePurchaseAgreementSalesAgreementMutationHookResult = ReturnType<typeof useDeletePrePurchaseAgreementSalesAgreementMutation>;
export type DeletePrePurchaseAgreementSalesAgreementMutationResult = Apollo.MutationResult<DeletePrePurchaseAgreementSalesAgreementMutation>;
export type DeletePrePurchaseAgreementSalesAgreementMutationOptions = Apollo.BaseMutationOptions<DeletePrePurchaseAgreementSalesAgreementMutation, DeletePrePurchaseAgreementSalesAgreementMutationVariables>;
export const CreatePrePurchaseAgreementSalesAgreementDocument = gql`
    mutation CreatePrePurchaseAgreementSalesAgreement($ppasa: PrePurchaseAgreementSalesAgreementInput!) {
  prePurchaseAgreementSalesAgreementCreate(
    prePurchaseAgreementSalesAgreement: $ppasa
  ) {
    prePurchaseAgreementKey
    salesAgreementKey
  }
}
    `;
export type CreatePrePurchaseAgreementSalesAgreementMutationFn = Apollo.MutationFunction<CreatePrePurchaseAgreementSalesAgreementMutation, CreatePrePurchaseAgreementSalesAgreementMutationVariables>;

/**
 * __useCreatePrePurchaseAgreementSalesAgreementMutation__
 *
 * To run a mutation, you first call `useCreatePrePurchaseAgreementSalesAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrePurchaseAgreementSalesAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrePurchaseAgreementSalesAgreementMutation, { data, loading, error }] = useCreatePrePurchaseAgreementSalesAgreementMutation({
 *   variables: {
 *      ppasa: // value for 'ppasa'
 *   },
 * });
 */
export function useCreatePrePurchaseAgreementSalesAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrePurchaseAgreementSalesAgreementMutation, CreatePrePurchaseAgreementSalesAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrePurchaseAgreementSalesAgreementMutation, CreatePrePurchaseAgreementSalesAgreementMutationVariables>(CreatePrePurchaseAgreementSalesAgreementDocument, options);
      }
export type CreatePrePurchaseAgreementSalesAgreementMutationHookResult = ReturnType<typeof useCreatePrePurchaseAgreementSalesAgreementMutation>;
export type CreatePrePurchaseAgreementSalesAgreementMutationResult = Apollo.MutationResult<CreatePrePurchaseAgreementSalesAgreementMutation>;
export type CreatePrePurchaseAgreementSalesAgreementMutationOptions = Apollo.BaseMutationOptions<CreatePrePurchaseAgreementSalesAgreementMutation, CreatePrePurchaseAgreementSalesAgreementMutationVariables>;
export const CreateTermContractSalesAgreementDocument = gql`
    mutation CreateTermContractSalesAgreement($tcsa: TermContractSalesAgreementInput!) {
  termContractSalesAgreementCreate(termContractSalesAgreement: $tcsa) {
    termContractKey
    salesAgreementKey
  }
}
    `;
export type CreateTermContractSalesAgreementMutationFn = Apollo.MutationFunction<CreateTermContractSalesAgreementMutation, CreateTermContractSalesAgreementMutationVariables>;

/**
 * __useCreateTermContractSalesAgreementMutation__
 *
 * To run a mutation, you first call `useCreateTermContractSalesAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermContractSalesAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermContractSalesAgreementMutation, { data, loading, error }] = useCreateTermContractSalesAgreementMutation({
 *   variables: {
 *      tcsa: // value for 'tcsa'
 *   },
 * });
 */
export function useCreateTermContractSalesAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermContractSalesAgreementMutation, CreateTermContractSalesAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTermContractSalesAgreementMutation, CreateTermContractSalesAgreementMutationVariables>(CreateTermContractSalesAgreementDocument, options);
      }
export type CreateTermContractSalesAgreementMutationHookResult = ReturnType<typeof useCreateTermContractSalesAgreementMutation>;
export type CreateTermContractSalesAgreementMutationResult = Apollo.MutationResult<CreateTermContractSalesAgreementMutation>;
export type CreateTermContractSalesAgreementMutationOptions = Apollo.BaseMutationOptions<CreateTermContractSalesAgreementMutation, CreateTermContractSalesAgreementMutationVariables>;
export const DeleteTermContractSalesAgreementsDocument = gql`
    mutation DeleteTermContractSalesAgreements($salesAgreementKey: Int!) {
  termContractSalesAgreementDelete(salesAgreementKey: $salesAgreementKey)
}
    `;
export type DeleteTermContractSalesAgreementsMutationFn = Apollo.MutationFunction<DeleteTermContractSalesAgreementsMutation, DeleteTermContractSalesAgreementsMutationVariables>;

/**
 * __useDeleteTermContractSalesAgreementsMutation__
 *
 * To run a mutation, you first call `useDeleteTermContractSalesAgreementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTermContractSalesAgreementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTermContractSalesAgreementsMutation, { data, loading, error }] = useDeleteTermContractSalesAgreementsMutation({
 *   variables: {
 *      salesAgreementKey: // value for 'salesAgreementKey'
 *   },
 * });
 */
export function useDeleteTermContractSalesAgreementsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTermContractSalesAgreementsMutation, DeleteTermContractSalesAgreementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTermContractSalesAgreementsMutation, DeleteTermContractSalesAgreementsMutationVariables>(DeleteTermContractSalesAgreementsDocument, options);
      }
export type DeleteTermContractSalesAgreementsMutationHookResult = ReturnType<typeof useDeleteTermContractSalesAgreementsMutation>;
export type DeleteTermContractSalesAgreementsMutationResult = Apollo.MutationResult<DeleteTermContractSalesAgreementsMutation>;
export type DeleteTermContractSalesAgreementsMutationOptions = Apollo.BaseMutationOptions<DeleteTermContractSalesAgreementsMutation, DeleteTermContractSalesAgreementsMutationVariables>;
export const GetSingleSalesAgreementDocument = gql`
    query GetSingleSalesAgreement($id: Int!) {
  salesAgreementGetSingle(id: $id) {
    ...salesAgreementListing
  }
}
    ${SalesAgreementListingFragmentDoc}`;

/**
 * __useGetSingleSalesAgreementQuery__
 *
 * To run a query within a React component, call `useGetSingleSalesAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleSalesAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleSalesAgreementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleSalesAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetSingleSalesAgreementQuery, GetSingleSalesAgreementQueryVariables> & ({ variables: GetSingleSalesAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleSalesAgreementQuery, GetSingleSalesAgreementQueryVariables>(GetSingleSalesAgreementDocument, options);
      }
export function useGetSingleSalesAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleSalesAgreementQuery, GetSingleSalesAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleSalesAgreementQuery, GetSingleSalesAgreementQueryVariables>(GetSingleSalesAgreementDocument, options);
        }
export function useGetSingleSalesAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleSalesAgreementQuery, GetSingleSalesAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleSalesAgreementQuery, GetSingleSalesAgreementQueryVariables>(GetSingleSalesAgreementDocument, options);
        }
export type GetSingleSalesAgreementQueryHookResult = ReturnType<typeof useGetSingleSalesAgreementQuery>;
export type GetSingleSalesAgreementLazyQueryHookResult = ReturnType<typeof useGetSingleSalesAgreementLazyQuery>;
export type GetSingleSalesAgreementSuspenseQueryHookResult = ReturnType<typeof useGetSingleSalesAgreementSuspenseQuery>;
export type GetSingleSalesAgreementQueryResult = Apollo.QueryResult<GetSingleSalesAgreementQuery, GetSingleSalesAgreementQueryVariables>;
export const AllSalesAgreementDocument = gql`
    query AllSalesAgreement($sortObject: [SalesAgreementSortInput!], $filterObject: SalesAgreementFilterInput, $cursor: String!, $pageSize: Int!) {
  salesAgreementGetAll(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
  ) {
    ...allSalesAgreementListing
  }
}
    ${AllSalesAgreementListingFragmentDoc}`;

/**
 * __useAllSalesAgreementQuery__
 *
 * To run a query within a React component, call `useAllSalesAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSalesAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSalesAgreementQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllSalesAgreementQuery(baseOptions: Apollo.QueryHookOptions<AllSalesAgreementQuery, AllSalesAgreementQueryVariables> & ({ variables: AllSalesAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSalesAgreementQuery, AllSalesAgreementQueryVariables>(AllSalesAgreementDocument, options);
      }
export function useAllSalesAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSalesAgreementQuery, AllSalesAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSalesAgreementQuery, AllSalesAgreementQueryVariables>(AllSalesAgreementDocument, options);
        }
export function useAllSalesAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSalesAgreementQuery, AllSalesAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSalesAgreementQuery, AllSalesAgreementQueryVariables>(AllSalesAgreementDocument, options);
        }
export type AllSalesAgreementQueryHookResult = ReturnType<typeof useAllSalesAgreementQuery>;
export type AllSalesAgreementLazyQueryHookResult = ReturnType<typeof useAllSalesAgreementLazyQuery>;
export type AllSalesAgreementSuspenseQueryHookResult = ReturnType<typeof useAllSalesAgreementSuspenseQuery>;
export type AllSalesAgreementQueryResult = Apollo.QueryResult<AllSalesAgreementQuery, AllSalesAgreementQueryVariables>;
export const AllFlatSalesAgreementDocument = gql`
    query AllFlatSalesAgreement($sort: [FlatSalesAgreementSortInput!], $filter: FlatSalesAgreementFilterInput, $cursor: String!, $pageSize: Int!) {
  flatSalesAgreementGetAll(
    order: $sort
    where: $filter
    first: $pageSize
    after: $cursor
  ) {
    ...allFlatSalesAgreementListing
  }
}
    ${AllFlatSalesAgreementListingFragmentDoc}`;

/**
 * __useAllFlatSalesAgreementQuery__
 *
 * To run a query within a React component, call `useAllFlatSalesAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFlatSalesAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFlatSalesAgreementQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllFlatSalesAgreementQuery(baseOptions: Apollo.QueryHookOptions<AllFlatSalesAgreementQuery, AllFlatSalesAgreementQueryVariables> & ({ variables: AllFlatSalesAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFlatSalesAgreementQuery, AllFlatSalesAgreementQueryVariables>(AllFlatSalesAgreementDocument, options);
      }
export function useAllFlatSalesAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFlatSalesAgreementQuery, AllFlatSalesAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFlatSalesAgreementQuery, AllFlatSalesAgreementQueryVariables>(AllFlatSalesAgreementDocument, options);
        }
export function useAllFlatSalesAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFlatSalesAgreementQuery, AllFlatSalesAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFlatSalesAgreementQuery, AllFlatSalesAgreementQueryVariables>(AllFlatSalesAgreementDocument, options);
        }
export type AllFlatSalesAgreementQueryHookResult = ReturnType<typeof useAllFlatSalesAgreementQuery>;
export type AllFlatSalesAgreementLazyQueryHookResult = ReturnType<typeof useAllFlatSalesAgreementLazyQuery>;
export type AllFlatSalesAgreementSuspenseQueryHookResult = ReturnType<typeof useAllFlatSalesAgreementSuspenseQuery>;
export type AllFlatSalesAgreementQueryResult = Apollo.QueryResult<AllFlatSalesAgreementQuery, AllFlatSalesAgreementQueryVariables>;
export const AllStateTaxDocument = gql`
    query AllStateTax($sortObject: [StateTaxSortInput!], $filterObject: StateTaxFilterInput) {
  stateTaxGetAll(order: $sortObject, where: $filterObject) {
    ...innerStateTax
  }
}
    ${InnerStateTaxFragmentDoc}`;

/**
 * __useAllStateTaxQuery__
 *
 * To run a query within a React component, call `useAllStateTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStateTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStateTaxQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *   },
 * });
 */
export function useAllStateTaxQuery(baseOptions?: Apollo.QueryHookOptions<AllStateTaxQuery, AllStateTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStateTaxQuery, AllStateTaxQueryVariables>(AllStateTaxDocument, options);
      }
export function useAllStateTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStateTaxQuery, AllStateTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStateTaxQuery, AllStateTaxQueryVariables>(AllStateTaxDocument, options);
        }
export function useAllStateTaxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStateTaxQuery, AllStateTaxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStateTaxQuery, AllStateTaxQueryVariables>(AllStateTaxDocument, options);
        }
export type AllStateTaxQueryHookResult = ReturnType<typeof useAllStateTaxQuery>;
export type AllStateTaxLazyQueryHookResult = ReturnType<typeof useAllStateTaxLazyQuery>;
export type AllStateTaxSuspenseQueryHookResult = ReturnType<typeof useAllStateTaxSuspenseQuery>;
export type AllStateTaxQueryResult = Apollo.QueryResult<AllStateTaxQuery, AllStateTaxQueryVariables>;
export const DeleteStateTaxDocument = gql`
    mutation DeleteStateTax($key: Int!) {
  stateTaxDelete(id: $key)
}
    `;
export type DeleteStateTaxMutationFn = Apollo.MutationFunction<DeleteStateTaxMutation, DeleteStateTaxMutationVariables>;

/**
 * __useDeleteStateTaxMutation__
 *
 * To run a mutation, you first call `useDeleteStateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStateTaxMutation, { data, loading, error }] = useDeleteStateTaxMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteStateTaxMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStateTaxMutation, DeleteStateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStateTaxMutation, DeleteStateTaxMutationVariables>(DeleteStateTaxDocument, options);
      }
export type DeleteStateTaxMutationHookResult = ReturnType<typeof useDeleteStateTaxMutation>;
export type DeleteStateTaxMutationResult = Apollo.MutationResult<DeleteStateTaxMutation>;
export type DeleteStateTaxMutationOptions = Apollo.BaseMutationOptions<DeleteStateTaxMutation, DeleteStateTaxMutationVariables>;
export const CreateSupplierDocument = gql`
    mutation CreateSupplier($supplier: SupplierInput!) {
  supplierCreate(supplier: $supplier) {
    supplierKey
  }
}
    `;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;

/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      supplier: // value for 'supplier'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, options);
      }
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const EditSupplierDocument = gql`
    mutation EditSupplier($supplier: SupplierInput!, $id: Int!) {
  supplierUpdate(supplier: $supplier, id: $id) {
    supplierKey
  }
}
    `;
export type EditSupplierMutationFn = Apollo.MutationFunction<EditSupplierMutation, EditSupplierMutationVariables>;

/**
 * __useEditSupplierMutation__
 *
 * To run a mutation, you first call `useEditSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSupplierMutation, { data, loading, error }] = useEditSupplierMutation({
 *   variables: {
 *      supplier: // value for 'supplier'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditSupplierMutation(baseOptions?: Apollo.MutationHookOptions<EditSupplierMutation, EditSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSupplierMutation, EditSupplierMutationVariables>(EditSupplierDocument, options);
      }
export type EditSupplierMutationHookResult = ReturnType<typeof useEditSupplierMutation>;
export type EditSupplierMutationResult = Apollo.MutationResult<EditSupplierMutation>;
export type EditSupplierMutationOptions = Apollo.BaseMutationOptions<EditSupplierMutation, EditSupplierMutationVariables>;
export const GetSingleSupplierDocument = gql`
    query GetSingleSupplier($id: Int!) {
  supplierGetSingle(id: $id) {
    ...singleSupplier
  }
}
    ${SingleSupplierFragmentDoc}`;

/**
 * __useGetSingleSupplierQuery__
 *
 * To run a query within a React component, call `useGetSingleSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleSupplierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleSupplierQuery(baseOptions: Apollo.QueryHookOptions<GetSingleSupplierQuery, GetSingleSupplierQueryVariables> & ({ variables: GetSingleSupplierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleSupplierQuery, GetSingleSupplierQueryVariables>(GetSingleSupplierDocument, options);
      }
export function useGetSingleSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleSupplierQuery, GetSingleSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleSupplierQuery, GetSingleSupplierQueryVariables>(GetSingleSupplierDocument, options);
        }
export function useGetSingleSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleSupplierQuery, GetSingleSupplierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleSupplierQuery, GetSingleSupplierQueryVariables>(GetSingleSupplierDocument, options);
        }
export type GetSingleSupplierQueryHookResult = ReturnType<typeof useGetSingleSupplierQuery>;
export type GetSingleSupplierLazyQueryHookResult = ReturnType<typeof useGetSingleSupplierLazyQuery>;
export type GetSingleSupplierSuspenseQueryHookResult = ReturnType<typeof useGetSingleSupplierSuspenseQuery>;
export type GetSingleSupplierQueryResult = Apollo.QueryResult<GetSingleSupplierQuery, GetSingleSupplierQueryVariables>;
export const GetAllContactBySupplierKeyDocument = gql`
    query GetAllContactBySupplierKey($filterContact: ContactFilterInput) {
  contactGetAll(where: $filterContact) {
    supplierKey
    contactKey
    firstName
    lastName
    phone
    email
    notes
    default
    cellPhone
    homePhone
    deleted
  }
}
    `;

/**
 * __useGetAllContactBySupplierKeyQuery__
 *
 * To run a query within a React component, call `useGetAllContactBySupplierKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactBySupplierKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactBySupplierKeyQuery({
 *   variables: {
 *      filterContact: // value for 'filterContact'
 *   },
 * });
 */
export function useGetAllContactBySupplierKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContactBySupplierKeyQuery, GetAllContactBySupplierKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactBySupplierKeyQuery, GetAllContactBySupplierKeyQueryVariables>(GetAllContactBySupplierKeyDocument, options);
      }
export function useGetAllContactBySupplierKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactBySupplierKeyQuery, GetAllContactBySupplierKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactBySupplierKeyQuery, GetAllContactBySupplierKeyQueryVariables>(GetAllContactBySupplierKeyDocument, options);
        }
export function useGetAllContactBySupplierKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContactBySupplierKeyQuery, GetAllContactBySupplierKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContactBySupplierKeyQuery, GetAllContactBySupplierKeyQueryVariables>(GetAllContactBySupplierKeyDocument, options);
        }
export type GetAllContactBySupplierKeyQueryHookResult = ReturnType<typeof useGetAllContactBySupplierKeyQuery>;
export type GetAllContactBySupplierKeyLazyQueryHookResult = ReturnType<typeof useGetAllContactBySupplierKeyLazyQuery>;
export type GetAllContactBySupplierKeySuspenseQueryHookResult = ReturnType<typeof useGetAllContactBySupplierKeySuspenseQuery>;
export type GetAllContactBySupplierKeyQueryResult = Apollo.QueryResult<GetAllContactBySupplierKeyQuery, GetAllContactBySupplierKeyQueryVariables>;
export const PostingsForSupplierDocument = gql`
    query PostingsForSupplier($supplierKey: Int!, $sort: [PostingSortInput!]) {
  postingGetAll(where: {supplierKey: {eq: $supplierKey}}, order: $sort) {
    ...AllPostingListing
  }
}
    ${AllPostingListingFragmentDoc}`;

/**
 * __usePostingsForSupplierQuery__
 *
 * To run a query within a React component, call `usePostingsForSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostingsForSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostingsForSupplierQuery({
 *   variables: {
 *      supplierKey: // value for 'supplierKey'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePostingsForSupplierQuery(baseOptions: Apollo.QueryHookOptions<PostingsForSupplierQuery, PostingsForSupplierQueryVariables> & ({ variables: PostingsForSupplierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostingsForSupplierQuery, PostingsForSupplierQueryVariables>(PostingsForSupplierDocument, options);
      }
export function usePostingsForSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostingsForSupplierQuery, PostingsForSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostingsForSupplierQuery, PostingsForSupplierQueryVariables>(PostingsForSupplierDocument, options);
        }
export function usePostingsForSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostingsForSupplierQuery, PostingsForSupplierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostingsForSupplierQuery, PostingsForSupplierQueryVariables>(PostingsForSupplierDocument, options);
        }
export type PostingsForSupplierQueryHookResult = ReturnType<typeof usePostingsForSupplierQuery>;
export type PostingsForSupplierLazyQueryHookResult = ReturnType<typeof usePostingsForSupplierLazyQuery>;
export type PostingsForSupplierSuspenseQueryHookResult = ReturnType<typeof usePostingsForSupplierSuspenseQuery>;
export type PostingsForSupplierQueryResult = Apollo.QueryResult<PostingsForSupplierQuery, PostingsForSupplierQueryVariables>;
export const MostRecentPostingsForSupplierDocument = gql`
    query MostRecentPostingsForSupplier($supplierKey: Int!) {
  postingsGetAllForSupplierMostRecent(supplierKey: $supplierKey) {
    postingKey
    supplierKey
    supplier {
      name
    }
    terminalKey
    terminal {
      name
    }
    cost
    effectiveDate
    postingPrices {
      postingPriceKey
      cost
      effectiveDate
      effectiveEndDate
    }
    currentPrice {
      postingPriceKey
      cost
      effectiveDate
      effectiveEndDate
    }
    futurePrice {
      postingPriceKey
      cost
      effectiveDate
      effectiveEndDate
    }
  }
}
    `;

/**
 * __useMostRecentPostingsForSupplierQuery__
 *
 * To run a query within a React component, call `useMostRecentPostingsForSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentPostingsForSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentPostingsForSupplierQuery({
 *   variables: {
 *      supplierKey: // value for 'supplierKey'
 *   },
 * });
 */
export function useMostRecentPostingsForSupplierQuery(baseOptions: Apollo.QueryHookOptions<MostRecentPostingsForSupplierQuery, MostRecentPostingsForSupplierQueryVariables> & ({ variables: MostRecentPostingsForSupplierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MostRecentPostingsForSupplierQuery, MostRecentPostingsForSupplierQueryVariables>(MostRecentPostingsForSupplierDocument, options);
      }
export function useMostRecentPostingsForSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MostRecentPostingsForSupplierQuery, MostRecentPostingsForSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MostRecentPostingsForSupplierQuery, MostRecentPostingsForSupplierQueryVariables>(MostRecentPostingsForSupplierDocument, options);
        }
export function useMostRecentPostingsForSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MostRecentPostingsForSupplierQuery, MostRecentPostingsForSupplierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MostRecentPostingsForSupplierQuery, MostRecentPostingsForSupplierQueryVariables>(MostRecentPostingsForSupplierDocument, options);
        }
export type MostRecentPostingsForSupplierQueryHookResult = ReturnType<typeof useMostRecentPostingsForSupplierQuery>;
export type MostRecentPostingsForSupplierLazyQueryHookResult = ReturnType<typeof useMostRecentPostingsForSupplierLazyQuery>;
export type MostRecentPostingsForSupplierSuspenseQueryHookResult = ReturnType<typeof useMostRecentPostingsForSupplierSuspenseQuery>;
export type MostRecentPostingsForSupplierQueryResult = Apollo.QueryResult<MostRecentPostingsForSupplierQuery, MostRecentPostingsForSupplierQueryVariables>;
export const AllSupplierDocument = gql`
    query AllSupplier($sortObject: [SupplierSortInput!], $filterObject: SupplierFilterInput) {
  supplierGetAll(order: $sortObject, where: $filterObject) {
    ...allSupplierListing
  }
}
    ${AllSupplierListingFragmentDoc}`;

/**
 * __useAllSupplierQuery__
 *
 * To run a query within a React component, call `useAllSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSupplierQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *   },
 * });
 */
export function useAllSupplierQuery(baseOptions?: Apollo.QueryHookOptions<AllSupplierQuery, AllSupplierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSupplierQuery, AllSupplierQueryVariables>(AllSupplierDocument, options);
      }
export function useAllSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSupplierQuery, AllSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSupplierQuery, AllSupplierQueryVariables>(AllSupplierDocument, options);
        }
export function useAllSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSupplierQuery, AllSupplierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSupplierQuery, AllSupplierQueryVariables>(AllSupplierDocument, options);
        }
export type AllSupplierQueryHookResult = ReturnType<typeof useAllSupplierQuery>;
export type AllSupplierLazyQueryHookResult = ReturnType<typeof useAllSupplierLazyQuery>;
export type AllSupplierSuspenseQueryHookResult = ReturnType<typeof useAllSupplierSuspenseQuery>;
export type AllSupplierQueryResult = Apollo.QueryResult<AllSupplierQuery, AllSupplierQueryVariables>;
export const DeleteSupplierDocument = gql`
    mutation DeleteSupplier($id: Int!) {
  supplierDelete(id: $id)
}
    `;
export type DeleteSupplierMutationFn = Apollo.MutationFunction<DeleteSupplierMutation, DeleteSupplierMutationVariables>;

/**
 * __useDeleteSupplierMutation__
 *
 * To run a mutation, you first call `useDeleteSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplierMutation, { data, loading, error }] = useDeleteSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSupplierMutation, DeleteSupplierMutationVariables>(DeleteSupplierDocument, options);
      }
export type DeleteSupplierMutationHookResult = ReturnType<typeof useDeleteSupplierMutation>;
export type DeleteSupplierMutationResult = Apollo.MutationResult<DeleteSupplierMutation>;
export type DeleteSupplierMutationOptions = Apollo.BaseMutationOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>;
export const CreateSwapDealDocument = gql`
    mutation CreateSwapDeal($swapDeal: SwapDealInput!) {
  swapDealCreate(swapDeal: $swapDeal) {
    swapDealKey
  }
}
    `;
export type CreateSwapDealMutationFn = Apollo.MutationFunction<CreateSwapDealMutation, CreateSwapDealMutationVariables>;

/**
 * __useCreateSwapDealMutation__
 *
 * To run a mutation, you first call `useCreateSwapDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSwapDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSwapDealMutation, { data, loading, error }] = useCreateSwapDealMutation({
 *   variables: {
 *      swapDeal: // value for 'swapDeal'
 *   },
 * });
 */
export function useCreateSwapDealMutation(baseOptions?: Apollo.MutationHookOptions<CreateSwapDealMutation, CreateSwapDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSwapDealMutation, CreateSwapDealMutationVariables>(CreateSwapDealDocument, options);
      }
export type CreateSwapDealMutationHookResult = ReturnType<typeof useCreateSwapDealMutation>;
export type CreateSwapDealMutationResult = Apollo.MutationResult<CreateSwapDealMutation>;
export type CreateSwapDealMutationOptions = Apollo.BaseMutationOptions<CreateSwapDealMutation, CreateSwapDealMutationVariables>;
export const CreateSwapDealSalesAgreementDocument = gql`
    mutation CreateSwapDealSalesAgreement($sdsa: SwapDealSalesAgreementInput!) {
  swapDealSalesAgreementCreate(swapDealSalesAgreement: $sdsa) {
    swapDealKey
    salesAgreementKey
  }
}
    `;
export type CreateSwapDealSalesAgreementMutationFn = Apollo.MutationFunction<CreateSwapDealSalesAgreementMutation, CreateSwapDealSalesAgreementMutationVariables>;

/**
 * __useCreateSwapDealSalesAgreementMutation__
 *
 * To run a mutation, you first call `useCreateSwapDealSalesAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSwapDealSalesAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSwapDealSalesAgreementMutation, { data, loading, error }] = useCreateSwapDealSalesAgreementMutation({
 *   variables: {
 *      sdsa: // value for 'sdsa'
 *   },
 * });
 */
export function useCreateSwapDealSalesAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateSwapDealSalesAgreementMutation, CreateSwapDealSalesAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSwapDealSalesAgreementMutation, CreateSwapDealSalesAgreementMutationVariables>(CreateSwapDealSalesAgreementDocument, options);
      }
export type CreateSwapDealSalesAgreementMutationHookResult = ReturnType<typeof useCreateSwapDealSalesAgreementMutation>;
export type CreateSwapDealSalesAgreementMutationResult = Apollo.MutationResult<CreateSwapDealSalesAgreementMutation>;
export type CreateSwapDealSalesAgreementMutationOptions = Apollo.BaseMutationOptions<CreateSwapDealSalesAgreementMutation, CreateSwapDealSalesAgreementMutationVariables>;
export const GetSingleSwapDealDocument = gql`
    query GetSingleSwapDeal($id: Int!) {
  swapDealGetSingle(id: $id) {
    ...singleSwapDeal
  }
}
    ${SingleSwapDealFragmentDoc}`;

/**
 * __useGetSingleSwapDealQuery__
 *
 * To run a query within a React component, call `useGetSingleSwapDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleSwapDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleSwapDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleSwapDealQuery(baseOptions: Apollo.QueryHookOptions<GetSingleSwapDealQuery, GetSingleSwapDealQueryVariables> & ({ variables: GetSingleSwapDealQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleSwapDealQuery, GetSingleSwapDealQueryVariables>(GetSingleSwapDealDocument, options);
      }
export function useGetSingleSwapDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleSwapDealQuery, GetSingleSwapDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleSwapDealQuery, GetSingleSwapDealQueryVariables>(GetSingleSwapDealDocument, options);
        }
export function useGetSingleSwapDealSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleSwapDealQuery, GetSingleSwapDealQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleSwapDealQuery, GetSingleSwapDealQueryVariables>(GetSingleSwapDealDocument, options);
        }
export type GetSingleSwapDealQueryHookResult = ReturnType<typeof useGetSingleSwapDealQuery>;
export type GetSingleSwapDealLazyQueryHookResult = ReturnType<typeof useGetSingleSwapDealLazyQuery>;
export type GetSingleSwapDealSuspenseQueryHookResult = ReturnType<typeof useGetSingleSwapDealSuspenseQuery>;
export type GetSingleSwapDealQueryResult = Apollo.QueryResult<GetSingleSwapDealQuery, GetSingleSwapDealQueryVariables>;
export const EditSwapDealDocument = gql`
    mutation EditSwapDeal($swapDeal: SwapDealInput!, $id: Int!) {
  swapDealUpdate(swapDeal: $swapDeal, swapDealKey: $id) {
    swapDealKey
  }
}
    `;
export type EditSwapDealMutationFn = Apollo.MutationFunction<EditSwapDealMutation, EditSwapDealMutationVariables>;

/**
 * __useEditSwapDealMutation__
 *
 * To run a mutation, you first call `useEditSwapDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSwapDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSwapDealMutation, { data, loading, error }] = useEditSwapDealMutation({
 *   variables: {
 *      swapDeal: // value for 'swapDeal'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditSwapDealMutation(baseOptions?: Apollo.MutationHookOptions<EditSwapDealMutation, EditSwapDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSwapDealMutation, EditSwapDealMutationVariables>(EditSwapDealDocument, options);
      }
export type EditSwapDealMutationHookResult = ReturnType<typeof useEditSwapDealMutation>;
export type EditSwapDealMutationResult = Apollo.MutationResult<EditSwapDealMutation>;
export type EditSwapDealMutationOptions = Apollo.BaseMutationOptions<EditSwapDealMutation, EditSwapDealMutationVariables>;
export const DeleteSwapDealSalesAgreementBySwapDealDocument = gql`
    mutation DeleteSwapDealSalesAgreementBySwapDeal($id: Int!) {
  swapDealSalesAgreementDeleteBySwapDeal(id: $id)
}
    `;
export type DeleteSwapDealSalesAgreementBySwapDealMutationFn = Apollo.MutationFunction<DeleteSwapDealSalesAgreementBySwapDealMutation, DeleteSwapDealSalesAgreementBySwapDealMutationVariables>;

/**
 * __useDeleteSwapDealSalesAgreementBySwapDealMutation__
 *
 * To run a mutation, you first call `useDeleteSwapDealSalesAgreementBySwapDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSwapDealSalesAgreementBySwapDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSwapDealSalesAgreementBySwapDealMutation, { data, loading, error }] = useDeleteSwapDealSalesAgreementBySwapDealMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSwapDealSalesAgreementBySwapDealMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSwapDealSalesAgreementBySwapDealMutation, DeleteSwapDealSalesAgreementBySwapDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSwapDealSalesAgreementBySwapDealMutation, DeleteSwapDealSalesAgreementBySwapDealMutationVariables>(DeleteSwapDealSalesAgreementBySwapDealDocument, options);
      }
export type DeleteSwapDealSalesAgreementBySwapDealMutationHookResult = ReturnType<typeof useDeleteSwapDealSalesAgreementBySwapDealMutation>;
export type DeleteSwapDealSalesAgreementBySwapDealMutationResult = Apollo.MutationResult<DeleteSwapDealSalesAgreementBySwapDealMutation>;
export type DeleteSwapDealSalesAgreementBySwapDealMutationOptions = Apollo.BaseMutationOptions<DeleteSwapDealSalesAgreementBySwapDealMutation, DeleteSwapDealSalesAgreementBySwapDealMutationVariables>;
export const AllSwapDealDocument = gql`
    query AllSwapDeal($sort: [FlatSwapDealSortInput!], $filter: FlatSwapDealFilterInput) {
  flatSwapDealGetAll(order: $sort, where: $filter) {
    ...innerFlatSwapDeal
  }
}
    ${InnerFlatSwapDealFragmentDoc}`;

/**
 * __useAllSwapDealQuery__
 *
 * To run a query within a React component, call `useAllSwapDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSwapDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSwapDealQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllSwapDealQuery(baseOptions?: Apollo.QueryHookOptions<AllSwapDealQuery, AllSwapDealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSwapDealQuery, AllSwapDealQueryVariables>(AllSwapDealDocument, options);
      }
export function useAllSwapDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSwapDealQuery, AllSwapDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSwapDealQuery, AllSwapDealQueryVariables>(AllSwapDealDocument, options);
        }
export function useAllSwapDealSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSwapDealQuery, AllSwapDealQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSwapDealQuery, AllSwapDealQueryVariables>(AllSwapDealDocument, options);
        }
export type AllSwapDealQueryHookResult = ReturnType<typeof useAllSwapDealQuery>;
export type AllSwapDealLazyQueryHookResult = ReturnType<typeof useAllSwapDealLazyQuery>;
export type AllSwapDealSuspenseQueryHookResult = ReturnType<typeof useAllSwapDealSuspenseQuery>;
export type AllSwapDealQueryResult = Apollo.QueryResult<AllSwapDealQuery, AllSwapDealQueryVariables>;
export const DeleteSwapDealDocument = gql`
    mutation DeleteSwapDeal($key: Int!) {
  swapDealDelete(swapDealKey: $key)
}
    `;
export type DeleteSwapDealMutationFn = Apollo.MutationFunction<DeleteSwapDealMutation, DeleteSwapDealMutationVariables>;

/**
 * __useDeleteSwapDealMutation__
 *
 * To run a mutation, you first call `useDeleteSwapDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSwapDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSwapDealMutation, { data, loading, error }] = useDeleteSwapDealMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteSwapDealMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSwapDealMutation, DeleteSwapDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSwapDealMutation, DeleteSwapDealMutationVariables>(DeleteSwapDealDocument, options);
      }
export type DeleteSwapDealMutationHookResult = ReturnType<typeof useDeleteSwapDealMutation>;
export type DeleteSwapDealMutationResult = Apollo.MutationResult<DeleteSwapDealMutation>;
export type DeleteSwapDealMutationOptions = Apollo.BaseMutationOptions<DeleteSwapDealMutation, DeleteSwapDealMutationVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($task: TaskInput!) {
  taskCreate(task: $task) {
    taskKey
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateFutureTaskDocument = gql`
    mutation CreateFutureTask($task: TaskInput!) {
  taskCreateFuture(task: $task) {
    taskKey
  }
}
    `;
export type CreateFutureTaskMutationFn = Apollo.MutationFunction<CreateFutureTaskMutation, CreateFutureTaskMutationVariables>;

/**
 * __useCreateFutureTaskMutation__
 *
 * To run a mutation, you first call `useCreateFutureTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFutureTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFutureTaskMutation, { data, loading, error }] = useCreateFutureTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useCreateFutureTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateFutureTaskMutation, CreateFutureTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFutureTaskMutation, CreateFutureTaskMutationVariables>(CreateFutureTaskDocument, options);
      }
export type CreateFutureTaskMutationHookResult = ReturnType<typeof useCreateFutureTaskMutation>;
export type CreateFutureTaskMutationResult = Apollo.MutationResult<CreateFutureTaskMutation>;
export type CreateFutureTaskMutationOptions = Apollo.BaseMutationOptions<CreateFutureTaskMutation, CreateFutureTaskMutationVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    userName
    name
    isAdminUser
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetSingleTaskDocument = gql`
    query GetSingleTask($taskKey: Int!) {
  taskGetSingle(id: $taskKey) {
    ...TaskShow
  }
}
    ${TaskShowFragmentDoc}`;

/**
 * __useGetSingleTaskQuery__
 *
 * To run a query within a React component, call `useGetSingleTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleTaskQuery({
 *   variables: {
 *      taskKey: // value for 'taskKey'
 *   },
 * });
 */
export function useGetSingleTaskQuery(baseOptions: Apollo.QueryHookOptions<GetSingleTaskQuery, GetSingleTaskQueryVariables> & ({ variables: GetSingleTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleTaskQuery, GetSingleTaskQueryVariables>(GetSingleTaskDocument, options);
      }
export function useGetSingleTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleTaskQuery, GetSingleTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleTaskQuery, GetSingleTaskQueryVariables>(GetSingleTaskDocument, options);
        }
export function useGetSingleTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleTaskQuery, GetSingleTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleTaskQuery, GetSingleTaskQueryVariables>(GetSingleTaskDocument, options);
        }
export type GetSingleTaskQueryHookResult = ReturnType<typeof useGetSingleTaskQuery>;
export type GetSingleTaskLazyQueryHookResult = ReturnType<typeof useGetSingleTaskLazyQuery>;
export type GetSingleTaskSuspenseQueryHookResult = ReturnType<typeof useGetSingleTaskSuspenseQuery>;
export type GetSingleTaskQueryResult = Apollo.QueryResult<GetSingleTaskQuery, GetSingleTaskQueryVariables>;
export const GetCompletedTasksForLocationDocument = gql`
    query GetCompletedTasksForLocation($locationKey: Int!, $date: DateTime) {
  taskGetAll(
    where: {and: [{isComplete: {eq: true}}, {locationKey: {eq: $locationKey}}, {taskDate: {gt: $date}}]}
  ) {
    ...TaskShow
  }
}
    ${TaskShowFragmentDoc}`;

/**
 * __useGetCompletedTasksForLocationQuery__
 *
 * To run a query within a React component, call `useGetCompletedTasksForLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedTasksForLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedTasksForLocationQuery({
 *   variables: {
 *      locationKey: // value for 'locationKey'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetCompletedTasksForLocationQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedTasksForLocationQuery, GetCompletedTasksForLocationQueryVariables> & ({ variables: GetCompletedTasksForLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedTasksForLocationQuery, GetCompletedTasksForLocationQueryVariables>(GetCompletedTasksForLocationDocument, options);
      }
export function useGetCompletedTasksForLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedTasksForLocationQuery, GetCompletedTasksForLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedTasksForLocationQuery, GetCompletedTasksForLocationQueryVariables>(GetCompletedTasksForLocationDocument, options);
        }
export function useGetCompletedTasksForLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedTasksForLocationQuery, GetCompletedTasksForLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedTasksForLocationQuery, GetCompletedTasksForLocationQueryVariables>(GetCompletedTasksForLocationDocument, options);
        }
export type GetCompletedTasksForLocationQueryHookResult = ReturnType<typeof useGetCompletedTasksForLocationQuery>;
export type GetCompletedTasksForLocationLazyQueryHookResult = ReturnType<typeof useGetCompletedTasksForLocationLazyQuery>;
export type GetCompletedTasksForLocationSuspenseQueryHookResult = ReturnType<typeof useGetCompletedTasksForLocationSuspenseQuery>;
export type GetCompletedTasksForLocationQueryResult = Apollo.QueryResult<GetCompletedTasksForLocationQuery, GetCompletedTasksForLocationQueryVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($task: TaskInput!, $taskKey: Int!) {
  taskUpdate(task: $task, taskKey: $taskKey) {
    taskKey
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *      taskKey: // value for 'taskKey'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const CreateTaskAndUpdateTaskDocument = gql`
    mutation CreateTaskAndUpdateTask($newTask: TaskInput!, $task: TaskInput!, $currentTaskKey: Int!) {
  taskUpdate(task: $task, taskKey: $currentTaskKey) {
    taskKey
  }
  taskCreate(task: $newTask) {
    taskKey
  }
}
    `;
export type CreateTaskAndUpdateTaskMutationFn = Apollo.MutationFunction<CreateTaskAndUpdateTaskMutation, CreateTaskAndUpdateTaskMutationVariables>;

/**
 * __useCreateTaskAndUpdateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskAndUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskAndUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskAndUpdateTaskMutation, { data, loading, error }] = useCreateTaskAndUpdateTaskMutation({
 *   variables: {
 *      newTask: // value for 'newTask'
 *      task: // value for 'task'
 *      currentTaskKey: // value for 'currentTaskKey'
 *   },
 * });
 */
export function useCreateTaskAndUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskAndUpdateTaskMutation, CreateTaskAndUpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskAndUpdateTaskMutation, CreateTaskAndUpdateTaskMutationVariables>(CreateTaskAndUpdateTaskDocument, options);
      }
export type CreateTaskAndUpdateTaskMutationHookResult = ReturnType<typeof useCreateTaskAndUpdateTaskMutation>;
export type CreateTaskAndUpdateTaskMutationResult = Apollo.MutationResult<CreateTaskAndUpdateTaskMutation>;
export type CreateTaskAndUpdateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskAndUpdateTaskMutation, CreateTaskAndUpdateTaskMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($id: Int!) {
  taskDelete(id: $id)
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const CreateTermContractDocument = gql`
    mutation CreateTermContract($termContract: TermContractInput!) {
  termContractCreate(termContract: $termContract) {
    termContractKey
  }
}
    `;
export type CreateTermContractMutationFn = Apollo.MutationFunction<CreateTermContractMutation, CreateTermContractMutationVariables>;

/**
 * __useCreateTermContractMutation__
 *
 * To run a mutation, you first call `useCreateTermContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermContractMutation, { data, loading, error }] = useCreateTermContractMutation({
 *   variables: {
 *      termContract: // value for 'termContract'
 *   },
 * });
 */
export function useCreateTermContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermContractMutation, CreateTermContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTermContractMutation, CreateTermContractMutationVariables>(CreateTermContractDocument, options);
      }
export type CreateTermContractMutationHookResult = ReturnType<typeof useCreateTermContractMutation>;
export type CreateTermContractMutationResult = Apollo.MutationResult<CreateTermContractMutation>;
export type CreateTermContractMutationOptions = Apollo.BaseMutationOptions<CreateTermContractMutation, CreateTermContractMutationVariables>;
export const CreateTermContractLocationDocument = gql`
    mutation CreateTermContractLocation($termContractLocation: TermContractLocationInput!) {
  termContractLocationCreate(termContractLocation: $termContractLocation) {
    termContractKey
    locationKey
  }
}
    `;
export type CreateTermContractLocationMutationFn = Apollo.MutationFunction<CreateTermContractLocationMutation, CreateTermContractLocationMutationVariables>;

/**
 * __useCreateTermContractLocationMutation__
 *
 * To run a mutation, you first call `useCreateTermContractLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermContractLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermContractLocationMutation, { data, loading, error }] = useCreateTermContractLocationMutation({
 *   variables: {
 *      termContractLocation: // value for 'termContractLocation'
 *   },
 * });
 */
export function useCreateTermContractLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermContractLocationMutation, CreateTermContractLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTermContractLocationMutation, CreateTermContractLocationMutationVariables>(CreateTermContractLocationDocument, options);
      }
export type CreateTermContractLocationMutationHookResult = ReturnType<typeof useCreateTermContractLocationMutation>;
export type CreateTermContractLocationMutationResult = Apollo.MutationResult<CreateTermContractLocationMutation>;
export type CreateTermContractLocationMutationOptions = Apollo.BaseMutationOptions<CreateTermContractLocationMutation, CreateTermContractLocationMutationVariables>;
export const CreateTermContractTerminalDocument = gql`
    mutation CreateTermContractTerminal($termContractTerminal: TermContractTerminalInput!) {
  termContractTerminalCreate(termContractTerminal: $termContractTerminal) {
    termContractKey
    terminalKey
  }
}
    `;
export type CreateTermContractTerminalMutationFn = Apollo.MutationFunction<CreateTermContractTerminalMutation, CreateTermContractTerminalMutationVariables>;

/**
 * __useCreateTermContractTerminalMutation__
 *
 * To run a mutation, you first call `useCreateTermContractTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermContractTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermContractTerminalMutation, { data, loading, error }] = useCreateTermContractTerminalMutation({
 *   variables: {
 *      termContractTerminal: // value for 'termContractTerminal'
 *   },
 * });
 */
export function useCreateTermContractTerminalMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermContractTerminalMutation, CreateTermContractTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTermContractTerminalMutation, CreateTermContractTerminalMutationVariables>(CreateTermContractTerminalDocument, options);
      }
export type CreateTermContractTerminalMutationHookResult = ReturnType<typeof useCreateTermContractTerminalMutation>;
export type CreateTermContractTerminalMutationResult = Apollo.MutationResult<CreateTermContractTerminalMutation>;
export type CreateTermContractTerminalMutationOptions = Apollo.BaseMutationOptions<CreateTermContractTerminalMutation, CreateTermContractTerminalMutationVariables>;
export const CreateTermContractSupplierDocument = gql`
    mutation CreateTermContractSupplier($termContractSupplier: TermContractSupplierInput!) {
  termContractSupplierCreate(termContractSupplier: $termContractSupplier) {
    termContractKey
    supplierKey
  }
}
    `;
export type CreateTermContractSupplierMutationFn = Apollo.MutationFunction<CreateTermContractSupplierMutation, CreateTermContractSupplierMutationVariables>;

/**
 * __useCreateTermContractSupplierMutation__
 *
 * To run a mutation, you first call `useCreateTermContractSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermContractSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermContractSupplierMutation, { data, loading, error }] = useCreateTermContractSupplierMutation({
 *   variables: {
 *      termContractSupplier: // value for 'termContractSupplier'
 *   },
 * });
 */
export function useCreateTermContractSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermContractSupplierMutation, CreateTermContractSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTermContractSupplierMutation, CreateTermContractSupplierMutationVariables>(CreateTermContractSupplierDocument, options);
      }
export type CreateTermContractSupplierMutationHookResult = ReturnType<typeof useCreateTermContractSupplierMutation>;
export type CreateTermContractSupplierMutationResult = Apollo.MutationResult<CreateTermContractSupplierMutation>;
export type CreateTermContractSupplierMutationOptions = Apollo.BaseMutationOptions<CreateTermContractSupplierMutation, CreateTermContractSupplierMutationVariables>;
export const EditTermContractDocument = gql`
    mutation EditTermContract($termContract: TermContractInput!, $key: Int!) {
  termContractUpdate(termContract: $termContract, termContractKey: $key) {
    termContractKey
  }
}
    `;
export type EditTermContractMutationFn = Apollo.MutationFunction<EditTermContractMutation, EditTermContractMutationVariables>;

/**
 * __useEditTermContractMutation__
 *
 * To run a mutation, you first call `useEditTermContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTermContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTermContractMutation, { data, loading, error }] = useEditTermContractMutation({
 *   variables: {
 *      termContract: // value for 'termContract'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useEditTermContractMutation(baseOptions?: Apollo.MutationHookOptions<EditTermContractMutation, EditTermContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTermContractMutation, EditTermContractMutationVariables>(EditTermContractDocument, options);
      }
export type EditTermContractMutationHookResult = ReturnType<typeof useEditTermContractMutation>;
export type EditTermContractMutationResult = Apollo.MutationResult<EditTermContractMutation>;
export type EditTermContractMutationOptions = Apollo.BaseMutationOptions<EditTermContractMutation, EditTermContractMutationVariables>;
export const SingleTermContractDocument = gql`
    query SingleTermContract($key: Int!) {
  termContractGetSingle(termContractKey: $key) {
    ...AllTermContract
  }
}
    ${AllTermContractFragmentDoc}`;

/**
 * __useSingleTermContractQuery__
 *
 * To run a query within a React component, call `useSingleTermContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTermContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTermContractQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useSingleTermContractQuery(baseOptions: Apollo.QueryHookOptions<SingleTermContractQuery, SingleTermContractQueryVariables> & ({ variables: SingleTermContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTermContractQuery, SingleTermContractQueryVariables>(SingleTermContractDocument, options);
      }
export function useSingleTermContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTermContractQuery, SingleTermContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTermContractQuery, SingleTermContractQueryVariables>(SingleTermContractDocument, options);
        }
export function useSingleTermContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleTermContractQuery, SingleTermContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleTermContractQuery, SingleTermContractQueryVariables>(SingleTermContractDocument, options);
        }
export type SingleTermContractQueryHookResult = ReturnType<typeof useSingleTermContractQuery>;
export type SingleTermContractLazyQueryHookResult = ReturnType<typeof useSingleTermContractLazyQuery>;
export type SingleTermContractSuspenseQueryHookResult = ReturnType<typeof useSingleTermContractSuspenseQuery>;
export type SingleTermContractQueryResult = Apollo.QueryResult<SingleTermContractQuery, SingleTermContractQueryVariables>;
export const SingleSearchTermContractDocument = gql`
    query SingleSearchTermContract($key: Int!) {
  termContractGetSingle(termContractKey: $key) {
    ...innerTermContract
  }
}
    ${InnerTermContractFragmentDoc}`;

/**
 * __useSingleSearchTermContractQuery__
 *
 * To run a query within a React component, call `useSingleSearchTermContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleSearchTermContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleSearchTermContractQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useSingleSearchTermContractQuery(baseOptions: Apollo.QueryHookOptions<SingleSearchTermContractQuery, SingleSearchTermContractQueryVariables> & ({ variables: SingleSearchTermContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleSearchTermContractQuery, SingleSearchTermContractQueryVariables>(SingleSearchTermContractDocument, options);
      }
export function useSingleSearchTermContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleSearchTermContractQuery, SingleSearchTermContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleSearchTermContractQuery, SingleSearchTermContractQueryVariables>(SingleSearchTermContractDocument, options);
        }
export function useSingleSearchTermContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleSearchTermContractQuery, SingleSearchTermContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleSearchTermContractQuery, SingleSearchTermContractQueryVariables>(SingleSearchTermContractDocument, options);
        }
export type SingleSearchTermContractQueryHookResult = ReturnType<typeof useSingleSearchTermContractQuery>;
export type SingleSearchTermContractLazyQueryHookResult = ReturnType<typeof useSingleSearchTermContractLazyQuery>;
export type SingleSearchTermContractSuspenseQueryHookResult = ReturnType<typeof useSingleSearchTermContractSuspenseQuery>;
export type SingleSearchTermContractQueryResult = Apollo.QueryResult<SingleSearchTermContractQuery, SingleSearchTermContractQueryVariables>;
export const DeleteTermContractLocationDocument = gql`
    mutation DeleteTermContractLocation($key: Int!) {
  termContractLocationDelete(termContractKey: $key)
}
    `;
export type DeleteTermContractLocationMutationFn = Apollo.MutationFunction<DeleteTermContractLocationMutation, DeleteTermContractLocationMutationVariables>;

/**
 * __useDeleteTermContractLocationMutation__
 *
 * To run a mutation, you first call `useDeleteTermContractLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTermContractLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTermContractLocationMutation, { data, loading, error }] = useDeleteTermContractLocationMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteTermContractLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTermContractLocationMutation, DeleteTermContractLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTermContractLocationMutation, DeleteTermContractLocationMutationVariables>(DeleteTermContractLocationDocument, options);
      }
export type DeleteTermContractLocationMutationHookResult = ReturnType<typeof useDeleteTermContractLocationMutation>;
export type DeleteTermContractLocationMutationResult = Apollo.MutationResult<DeleteTermContractLocationMutation>;
export type DeleteTermContractLocationMutationOptions = Apollo.BaseMutationOptions<DeleteTermContractLocationMutation, DeleteTermContractLocationMutationVariables>;
export const DeleteTermContractTerminalDocument = gql`
    mutation DeleteTermContractTerminal($key: Int!) {
  termContractTerminalDelete(termContractKey: $key)
}
    `;
export type DeleteTermContractTerminalMutationFn = Apollo.MutationFunction<DeleteTermContractTerminalMutation, DeleteTermContractTerminalMutationVariables>;

/**
 * __useDeleteTermContractTerminalMutation__
 *
 * To run a mutation, you first call `useDeleteTermContractTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTermContractTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTermContractTerminalMutation, { data, loading, error }] = useDeleteTermContractTerminalMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteTermContractTerminalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTermContractTerminalMutation, DeleteTermContractTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTermContractTerminalMutation, DeleteTermContractTerminalMutationVariables>(DeleteTermContractTerminalDocument, options);
      }
export type DeleteTermContractTerminalMutationHookResult = ReturnType<typeof useDeleteTermContractTerminalMutation>;
export type DeleteTermContractTerminalMutationResult = Apollo.MutationResult<DeleteTermContractTerminalMutation>;
export type DeleteTermContractTerminalMutationOptions = Apollo.BaseMutationOptions<DeleteTermContractTerminalMutation, DeleteTermContractTerminalMutationVariables>;
export const DeleteTermContractSupplierDocument = gql`
    mutation DeleteTermContractSupplier($key: Int!) {
  termContractSupplierDelete(termContractKey: $key)
}
    `;
export type DeleteTermContractSupplierMutationFn = Apollo.MutationFunction<DeleteTermContractSupplierMutation, DeleteTermContractSupplierMutationVariables>;

/**
 * __useDeleteTermContractSupplierMutation__
 *
 * To run a mutation, you first call `useDeleteTermContractSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTermContractSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTermContractSupplierMutation, { data, loading, error }] = useDeleteTermContractSupplierMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteTermContractSupplierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTermContractSupplierMutation, DeleteTermContractSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTermContractSupplierMutation, DeleteTermContractSupplierMutationVariables>(DeleteTermContractSupplierDocument, options);
      }
export type DeleteTermContractSupplierMutationHookResult = ReturnType<typeof useDeleteTermContractSupplierMutation>;
export type DeleteTermContractSupplierMutationResult = Apollo.MutationResult<DeleteTermContractSupplierMutation>;
export type DeleteTermContractSupplierMutationOptions = Apollo.BaseMutationOptions<DeleteTermContractSupplierMutation, DeleteTermContractSupplierMutationVariables>;
export const AllTermContractDocument = gql`
    query AllTermContract($sort: [TermContractSortInput!], $filter: TermContractFilterInput, $cursor: String!, $pageSize: Int!) {
  termContractGetAll(
    order: $sort
    where: $filter
    first: $pageSize
    after: $cursor
  ) {
    ...allTermContractListing
  }
}
    ${AllTermContractListingFragmentDoc}`;

/**
 * __useAllTermContractQuery__
 *
 * To run a query within a React component, call `useAllTermContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTermContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTermContractQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllTermContractQuery(baseOptions: Apollo.QueryHookOptions<AllTermContractQuery, AllTermContractQueryVariables> & ({ variables: AllTermContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTermContractQuery, AllTermContractQueryVariables>(AllTermContractDocument, options);
      }
export function useAllTermContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTermContractQuery, AllTermContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTermContractQuery, AllTermContractQueryVariables>(AllTermContractDocument, options);
        }
export function useAllTermContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTermContractQuery, AllTermContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTermContractQuery, AllTermContractQueryVariables>(AllTermContractDocument, options);
        }
export type AllTermContractQueryHookResult = ReturnType<typeof useAllTermContractQuery>;
export type AllTermContractLazyQueryHookResult = ReturnType<typeof useAllTermContractLazyQuery>;
export type AllTermContractSuspenseQueryHookResult = ReturnType<typeof useAllTermContractSuspenseQuery>;
export type AllTermContractQueryResult = Apollo.QueryResult<AllTermContractQuery, AllTermContractQueryVariables>;
export const DeleteTermContractDocument = gql`
    mutation DeleteTermContract($key: Int!) {
  termContractDelete(termContractKey: $key)
}
    `;
export type DeleteTermContractMutationFn = Apollo.MutationFunction<DeleteTermContractMutation, DeleteTermContractMutationVariables>;

/**
 * __useDeleteTermContractMutation__
 *
 * To run a mutation, you first call `useDeleteTermContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTermContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTermContractMutation, { data, loading, error }] = useDeleteTermContractMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteTermContractMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTermContractMutation, DeleteTermContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTermContractMutation, DeleteTermContractMutationVariables>(DeleteTermContractDocument, options);
      }
export type DeleteTermContractMutationHookResult = ReturnType<typeof useDeleteTermContractMutation>;
export type DeleteTermContractMutationResult = Apollo.MutationResult<DeleteTermContractMutation>;
export type DeleteTermContractMutationOptions = Apollo.BaseMutationOptions<DeleteTermContractMutation, DeleteTermContractMutationVariables>;
export const CreateTerminalDocument = gql`
    mutation CreateTerminal($terminal: TerminalInput!) {
  terminalCreate(terminal: $terminal) {
    terminalKey
  }
}
    `;
export type CreateTerminalMutationFn = Apollo.MutationFunction<CreateTerminalMutation, CreateTerminalMutationVariables>;

/**
 * __useCreateTerminalMutation__
 *
 * To run a mutation, you first call `useCreateTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTerminalMutation, { data, loading, error }] = useCreateTerminalMutation({
 *   variables: {
 *      terminal: // value for 'terminal'
 *   },
 * });
 */
export function useCreateTerminalMutation(baseOptions?: Apollo.MutationHookOptions<CreateTerminalMutation, CreateTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTerminalMutation, CreateTerminalMutationVariables>(CreateTerminalDocument, options);
      }
export type CreateTerminalMutationHookResult = ReturnType<typeof useCreateTerminalMutation>;
export type CreateTerminalMutationResult = Apollo.MutationResult<CreateTerminalMutation>;
export type CreateTerminalMutationOptions = Apollo.BaseMutationOptions<CreateTerminalMutation, CreateTerminalMutationVariables>;
export const EditTerminalDocument = gql`
    mutation EditTerminal($terminal: TerminalInput!, $id: Int!) {
  terminalUpdate(terminal: $terminal, id: $id) {
    terminalKey
  }
}
    `;
export type EditTerminalMutationFn = Apollo.MutationFunction<EditTerminalMutation, EditTerminalMutationVariables>;

/**
 * __useEditTerminalMutation__
 *
 * To run a mutation, you first call `useEditTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTerminalMutation, { data, loading, error }] = useEditTerminalMutation({
 *   variables: {
 *      terminal: // value for 'terminal'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditTerminalMutation(baseOptions?: Apollo.MutationHookOptions<EditTerminalMutation, EditTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTerminalMutation, EditTerminalMutationVariables>(EditTerminalDocument, options);
      }
export type EditTerminalMutationHookResult = ReturnType<typeof useEditTerminalMutation>;
export type EditTerminalMutationResult = Apollo.MutationResult<EditTerminalMutation>;
export type EditTerminalMutationOptions = Apollo.BaseMutationOptions<EditTerminalMutation, EditTerminalMutationVariables>;
export const AllTerminalDocument = gql`
    query AllTerminal($sortObject: [TerminalSortInput!], $filterObject: TerminalFilterInput, $cursor: String!, $pageSize: Int!) {
  terminalGetAll(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
  ) {
    ...allTerminalListing
  }
}
    ${AllTerminalListingFragmentDoc}`;

/**
 * __useAllTerminalQuery__
 *
 * To run a query within a React component, call `useAllTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTerminalQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllTerminalQuery(baseOptions: Apollo.QueryHookOptions<AllTerminalQuery, AllTerminalQueryVariables> & ({ variables: AllTerminalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTerminalQuery, AllTerminalQueryVariables>(AllTerminalDocument, options);
      }
export function useAllTerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTerminalQuery, AllTerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTerminalQuery, AllTerminalQueryVariables>(AllTerminalDocument, options);
        }
export function useAllTerminalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTerminalQuery, AllTerminalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTerminalQuery, AllTerminalQueryVariables>(AllTerminalDocument, options);
        }
export type AllTerminalQueryHookResult = ReturnType<typeof useAllTerminalQuery>;
export type AllTerminalLazyQueryHookResult = ReturnType<typeof useAllTerminalLazyQuery>;
export type AllTerminalSuspenseQueryHookResult = ReturnType<typeof useAllTerminalSuspenseQuery>;
export type AllTerminalQueryResult = Apollo.QueryResult<AllTerminalQuery, AllTerminalQueryVariables>;
export const DeleteTerminalDocument = gql`
    mutation DeleteTerminal($id: Int!) {
  terminalDelete(id: $id)
}
    `;
export type DeleteTerminalMutationFn = Apollo.MutationFunction<DeleteTerminalMutation, DeleteTerminalMutationVariables>;

/**
 * __useDeleteTerminalMutation__
 *
 * To run a mutation, you first call `useDeleteTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTerminalMutation, { data, loading, error }] = useDeleteTerminalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTerminalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTerminalMutation, DeleteTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTerminalMutation, DeleteTerminalMutationVariables>(DeleteTerminalDocument, options);
      }
export type DeleteTerminalMutationHookResult = ReturnType<typeof useDeleteTerminalMutation>;
export type DeleteTerminalMutationResult = Apollo.MutationResult<DeleteTerminalMutation>;
export type DeleteTerminalMutationOptions = Apollo.BaseMutationOptions<DeleteTerminalMutation, DeleteTerminalMutationVariables>;
export const ArchiveTerminalDocument = gql`
    mutation ArchiveTerminal($id: Int!) {
  terminalArchive(id: $id) {
    terminalKey
  }
}
    `;
export type ArchiveTerminalMutationFn = Apollo.MutationFunction<ArchiveTerminalMutation, ArchiveTerminalMutationVariables>;

/**
 * __useArchiveTerminalMutation__
 *
 * To run a mutation, you first call `useArchiveTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTerminalMutation, { data, loading, error }] = useArchiveTerminalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveTerminalMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTerminalMutation, ArchiveTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTerminalMutation, ArchiveTerminalMutationVariables>(ArchiveTerminalDocument, options);
      }
export type ArchiveTerminalMutationHookResult = ReturnType<typeof useArchiveTerminalMutation>;
export type ArchiveTerminalMutationResult = Apollo.MutationResult<ArchiveTerminalMutation>;
export type ArchiveTerminalMutationOptions = Apollo.BaseMutationOptions<ArchiveTerminalMutation, ArchiveTerminalMutationVariables>;
export const GetSingleTerminalDocument = gql`
    query GetSingleTerminal($id: Int!) {
  terminalGetSingle(id: $id) {
    ...singleTerminal
  }
}
    ${SingleTerminalFragmentDoc}`;

/**
 * __useGetSingleTerminalQuery__
 *
 * To run a query within a React component, call `useGetSingleTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleTerminalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleTerminalQuery(baseOptions: Apollo.QueryHookOptions<GetSingleTerminalQuery, GetSingleTerminalQueryVariables> & ({ variables: GetSingleTerminalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleTerminalQuery, GetSingleTerminalQueryVariables>(GetSingleTerminalDocument, options);
      }
export function useGetSingleTerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleTerminalQuery, GetSingleTerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleTerminalQuery, GetSingleTerminalQueryVariables>(GetSingleTerminalDocument, options);
        }
export function useGetSingleTerminalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleTerminalQuery, GetSingleTerminalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleTerminalQuery, GetSingleTerminalQueryVariables>(GetSingleTerminalDocument, options);
        }
export type GetSingleTerminalQueryHookResult = ReturnType<typeof useGetSingleTerminalQuery>;
export type GetSingleTerminalLazyQueryHookResult = ReturnType<typeof useGetSingleTerminalLazyQuery>;
export type GetSingleTerminalSuspenseQueryHookResult = ReturnType<typeof useGetSingleTerminalSuspenseQuery>;
export type GetSingleTerminalQueryResult = Apollo.QueryResult<GetSingleTerminalQuery, GetSingleTerminalQueryVariables>;
export const GetAllContactByTerminalKeyDocument = gql`
    query GetAllContactByTerminalKey($filterContact: ContactFilterInput) {
  contactGetAll(where: $filterContact) {
    terminalKey
    contactKey
    firstName
    lastName
    phone
    email
    notes
    default
    cellPhone
    homePhone
    deleted
  }
}
    `;

/**
 * __useGetAllContactByTerminalKeyQuery__
 *
 * To run a query within a React component, call `useGetAllContactByTerminalKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactByTerminalKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactByTerminalKeyQuery({
 *   variables: {
 *      filterContact: // value for 'filterContact'
 *   },
 * });
 */
export function useGetAllContactByTerminalKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContactByTerminalKeyQuery, GetAllContactByTerminalKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactByTerminalKeyQuery, GetAllContactByTerminalKeyQueryVariables>(GetAllContactByTerminalKeyDocument, options);
      }
export function useGetAllContactByTerminalKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactByTerminalKeyQuery, GetAllContactByTerminalKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactByTerminalKeyQuery, GetAllContactByTerminalKeyQueryVariables>(GetAllContactByTerminalKeyDocument, options);
        }
export function useGetAllContactByTerminalKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllContactByTerminalKeyQuery, GetAllContactByTerminalKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllContactByTerminalKeyQuery, GetAllContactByTerminalKeyQueryVariables>(GetAllContactByTerminalKeyDocument, options);
        }
export type GetAllContactByTerminalKeyQueryHookResult = ReturnType<typeof useGetAllContactByTerminalKeyQuery>;
export type GetAllContactByTerminalKeyLazyQueryHookResult = ReturnType<typeof useGetAllContactByTerminalKeyLazyQuery>;
export type GetAllContactByTerminalKeySuspenseQueryHookResult = ReturnType<typeof useGetAllContactByTerminalKeySuspenseQuery>;
export type GetAllContactByTerminalKeyQueryResult = Apollo.QueryResult<GetAllContactByTerminalKeyQuery, GetAllContactByTerminalKeyQueryVariables>;
export const GetAllIndexContractsByTerminalKeyDocument = gql`
    query GetAllIndexContractsByTerminalKey($terminalKey: Int!) {
  indexContractsGetAll(
    where: {terminalKey: {eq: $terminalKey}}
    order: [{effectiveDate: DESC}]
  ) {
    indexContractKey
    supplier {
      name
    }
    effectiveDate
  }
}
    `;

/**
 * __useGetAllIndexContractsByTerminalKeyQuery__
 *
 * To run a query within a React component, call `useGetAllIndexContractsByTerminalKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIndexContractsByTerminalKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIndexContractsByTerminalKeyQuery({
 *   variables: {
 *      terminalKey: // value for 'terminalKey'
 *   },
 * });
 */
export function useGetAllIndexContractsByTerminalKeyQuery(baseOptions: Apollo.QueryHookOptions<GetAllIndexContractsByTerminalKeyQuery, GetAllIndexContractsByTerminalKeyQueryVariables> & ({ variables: GetAllIndexContractsByTerminalKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllIndexContractsByTerminalKeyQuery, GetAllIndexContractsByTerminalKeyQueryVariables>(GetAllIndexContractsByTerminalKeyDocument, options);
      }
export function useGetAllIndexContractsByTerminalKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllIndexContractsByTerminalKeyQuery, GetAllIndexContractsByTerminalKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllIndexContractsByTerminalKeyQuery, GetAllIndexContractsByTerminalKeyQueryVariables>(GetAllIndexContractsByTerminalKeyDocument, options);
        }
export function useGetAllIndexContractsByTerminalKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllIndexContractsByTerminalKeyQuery, GetAllIndexContractsByTerminalKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllIndexContractsByTerminalKeyQuery, GetAllIndexContractsByTerminalKeyQueryVariables>(GetAllIndexContractsByTerminalKeyDocument, options);
        }
export type GetAllIndexContractsByTerminalKeyQueryHookResult = ReturnType<typeof useGetAllIndexContractsByTerminalKeyQuery>;
export type GetAllIndexContractsByTerminalKeyLazyQueryHookResult = ReturnType<typeof useGetAllIndexContractsByTerminalKeyLazyQuery>;
export type GetAllIndexContractsByTerminalKeySuspenseQueryHookResult = ReturnType<typeof useGetAllIndexContractsByTerminalKeySuspenseQuery>;
export type GetAllIndexContractsByTerminalKeyQueryResult = Apollo.QueryResult<GetAllIndexContractsByTerminalKeyQuery, GetAllIndexContractsByTerminalKeyQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($user: UserInput!, $password: String!, $carriers: [Int!]) {
  userCreate(user: $user, password: $password, carriers: $carriers) {
    ...SingleUserFragment
  }
}
    ${SingleUserFragmentFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *      password: // value for 'password'
 *      carriers: // value for 'carriers'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const GetUserDocument = gql`
    query GetUser($userKey: Int!) {
  userGetSingle(userKey: $userKey) {
    ...innerUser
  }
}
    ${InnerUserFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userKey: // value for 'userKey'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const EditUserDocument = gql`
    mutation EditUser($user: UserInput!, $email: String, $newPassword: String, $carriers: [Int!], $customers: [Int!], $locations: [Int!], $states: [Int!], $disabledCustomers: [Int!], $disabledLocations: [Int!]) {
  userUpdate(
    user: $user
    newEmail: $email
    newPassword: $newPassword
    carriers: $carriers
    customers: $customers
    locations: $locations
    states: $states
    customerExclusions: $disabledCustomers
    locationExclusions: $disabledLocations
  ) {
    ...innerUser
  }
}
    ${InnerUserFragmentDoc}`;
export type EditUserMutationFn = Apollo.MutationFunction<EditUserMutation, EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *      email: // value for 'email'
 *      newPassword: // value for 'newPassword'
 *      carriers: // value for 'carriers'
 *      customers: // value for 'customers'
 *      locations: // value for 'locations'
 *      states: // value for 'states'
 *      disabledCustomers: // value for 'disabledCustomers'
 *      disabledLocations: // value for 'disabledLocations'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<EditUserMutation, EditUserMutationVariables>;
export const AllUsersDocument = gql`
    query AllUsers($sortObject: [UserSortInput!], $filterObject: UserFilterInput, $cursor: String!, $pageSize: Int!) {
  usersGetAll(
    order: $sortObject
    where: $filterObject
    first: $pageSize
    after: $cursor
  ) {
    ...allUserListing
  }
}
    ${AllUserListingFragmentDoc}`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *      sortObject: // value for 'sortObject'
 *      filterObject: // value for 'filterObject'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions: Apollo.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables> & ({ variables: AllUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export function useAllUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersSuspenseQueryHookResult = ReturnType<typeof useAllUsersSuspenseQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($email: String!) {
  userDelete(email: $email)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;